export const Learnsets: {[k: string]: ModdedLearnsetData} = {
	bulbasaur: {
		inherit: true,
		learnset: {
			amnesia: ["4E"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["4E", "3E"],
			curse: ["4E", "3E"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["4L27", "3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			grasswhistle: ["4E", "3E"],
			growl: ["4L3", "3L4", "3S1"],
			growth: ["4L25", "3L32", "3S0"],
			hiddenpower: ["4M", "3M"],
			ingrain: ["4E"],
			knockoff: ["4T"],
			leafstorm: ["4E"],
			leechseed: ["4L7", "3L7", "3S1"],
			lightscreen: ["4E", "3E"],
			magicalleaf: ["4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["4E"],
			petaldance: ["4E", "3E"],
			poisonpowder: ["4L13", "3L15"],
			protect: ["4M", "3M"],
			razorleaf: ["4L19", "3L20"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			safeguard: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T", "4L37"],
			skullbash: ["4E", "3E"],
			sleeppowder: ["4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M", "3L46", "3S0"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L21", "3L25", "3S0"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L33", "3L39", "3S0"],
			tackle: ["4L1", "3L1", "3S1"],
			takedown: ["4L15"],
			toxic: ["4M", "3M"],
			vinewhip: ["4L9", "3L10", "3S1"],
			worryseed: ["4T", "4L31"],
		},
	},
	ivysaur: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["4L31", "3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			growth: ["4L28", "3L38"],
			hiddenpower: ["4M", "3M"],
			knockoff: ["4T"],
			leechseed: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonpowder: ["4L13", "3L15"],
			protect: ["4M", "3M"],
			razorleaf: ["4L20", "3L22"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L44", "3M", "3L56"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L23", "3L29"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L39", "3L47"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L15"],
			toxic: ["4M", "3M"],
			vinewhip: ["4L9", "3L10"],
			worryseed: ["4T", "4L36"],
		},
	},
	venusaur: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["4L31", "3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frenzyplant: ["4T", "3T"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			growth: ["4L28", "3L41"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			knockoff: ["4T"],
			leechseed: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			petaldance: ["4L32"],
			poisonpowder: ["4L13", "3L15"],
			protect: ["4M", "3M"],
			razorleaf: ["4L20", "3L22"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L53", "3M", "3L65"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L23", "3L29"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L45", "3L53"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L15"],
			toxic: ["4M", "3M"],
			vinewhip: ["4L1", "3L1"],
			worryseed: ["4T", "4L39"],
		},
	},
	charmander: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4E", "3E"],
			attract: ["4M", "3M"],
			beatup: ["4E", "3E"],
			bellydrum: ["4E", "3E"],
			bite: ["4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["4E"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4M", "3M"],
			dragondance: ["4E", "3E"],
			dragonrage: ["4L16", "3L43"],
			dragonrush: ["4E"],
			dynamicpunch: ["3T"],
			ember: ["4L7", "3L7", "3S0"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4L25"],
			firepunch: ["4T", "3T"],
			firespin: ["4L37", "3L49"],
			flamethrower: ["4M", "4L34", "3M", "3L31"],
			flareblitz: ["4E"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["4L1", "3L1", "3S0"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "4S1", "4S2", "4S3", "4S5", "3M"],
			howl: ["4S1", "4S2", "4S3", "4S5"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["4E", "3L13"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4E", "3E"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			quickattack: ["4S1", "4S2", "4S3", "4S5"],
			rage: ["3L19"],
			rest: ["4M", "3M"],
			return: ["4M", "4S1", "4S2", "4S3", "4S5", "3M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			scaryface: ["4L19", "3L25"],
			scratch: ["4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			slash: ["4L28", "3L37"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["4L10", "3L13"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "4E", "3T", "3E"],
			thunderpunch: ["4T"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	charmeleon: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4M", "3M"],
			dragonrage: ["4L17", "3L48"],
			dynamicpunch: ["3T"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4L28"],
			firepunch: ["4T", "3T"],
			firespin: ["4L43", "3L55"],
			flamethrower: ["4M", "4L39", "3M", "3L34"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["3L13"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			rage: ["3L20"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			scaryface: ["4L21", "3L27"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			slash: ["4L32", "3L41"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["4L10", "3L13"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			thunderpunch: ["4T"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	charizard: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			airslash: ["4L1"],
			attract: ["4M", "3M"],
			blastburn: ["4T", "3T"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4M", "4L1", "3M"],
			dragonpulse: ["4M"],
			dragonrage: ["4L17", "3L54", "3S0"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4L28"],
			firepunch: ["4T", "3T"],
			firespin: ["4L49", "3L64", "3S0"],
			flamethrower: ["4M", "4L42", "3M", "3L34"],
			flareblitz: ["4L66"],
			fling: ["4M"],
			fly: ["4M", "3M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T", "4L59", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			rage: ["3L20"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			roost: ["4M"],
			scaryface: ["4L21", "3L27"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M", "4L1"],
			slash: ["4L32", "3L44", "3S0"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["4L1", "3L1"],
			snore: ["4T", "3T"],
			solarbeam: ["4M"],
			steelwing: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			thunderpunch: ["4T"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			willowisp: ["4M"],
			wingattack: ["4L36", "3L36", "3S0"],
		},
	},
	squirtle: {
		inherit: true,
		learnset: {
			aquajet: ["4E"],
			aquaring: ["4E"],
			aquatail: ["4T", "4L28"],
			attract: ["4M", "3M"],
			bite: ["4L16", "3L18"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			brine: ["4M"],
			bubble: ["4L7", "3L7", "3S0"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4E"],
			flail: ["4E", "3E"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			gyroball: ["4M"],
			hail: ["4M", "3M"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L37", "3L47"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L34"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrorcoat: ["4E", "3E"],
			mist: ["4E", "3E"],
			muddywater: ["4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			protect: ["4M", "4L22", "3M", "3L28"],
			raindance: ["4M", "4L34", "3M", "3L33"],
			rapidspin: ["4L19", "3L23"],
			refresh: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			skullbash: ["4L31", "3L40"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			tailwhip: ["4L4", "3L4", "3S0"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L13", "3L13"],
			waterpulse: ["4M", "4L25", "3M"],
			withdraw: ["4L10", "3L10", "3S0"],
			yawn: ["4E", "3E"],
			zenheadbutt: ["4T"],
		},
	},
	wartortle: {
		inherit: true,
		learnset: {
			aquatail: ["4T", "4L32"],
			attract: ["4M", "3M"],
			bite: ["4L16", "3L19"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			brine: ["4M"],
			bubble: ["4L1", "3L1"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gyroball: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L44", "3L53"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L40"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "4L24", "3M", "3L31"],
			raindance: ["4M", "4L40", "3M", "3L37"],
			rapidspin: ["4L20", "3L25"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			skullbash: ["4L36", "3L45"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L13", "3L13"],
			waterpulse: ["4M", "4L28", "3M"],
			withdraw: ["4L10", "3L10"],
			zenheadbutt: ["4T"],
		},
	},
	blastoise: {
		inherit: true,
		learnset: {
			aquatail: ["4T", "4L32"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bite: ["4L16", "3L19"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			brine: ["4M"],
			bubble: ["4L1", "3L1"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flashcannon: ["4M", "4L1"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydrocannon: ["4T", "3T"],
			hydropump: ["4L53", "3L68", "3S0"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L46"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "4L24", "3M", "3L31", "3S0"],
			raindance: ["4M", "4L46", "3M", "3L42", "3S0"],
			rapidspin: ["4L20", "3L25"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			signalbeam: ["4T"],
			skullbash: ["4L39", "3L55", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L13", "3L13"],
			waterpulse: ["4M", "4L28", "3M"],
			withdraw: ["4L1", "3L1"],
			zenheadbutt: ["4T"],
		},
	},
	caterpie: {
		inherit: true,
		learnset: {
			bugbite: ["4L15"],
			snore: ["4T"],
			stringshot: ["4L1", "3L1"],
			tackle: ["4L1", "3L1"],
		},
	},
	metapod: {
		inherit: true,
		learnset: {
			harden: ["4L1", "3L1"],
			irondefense: ["4T"],
		},
	},
	butterfree: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M", "3S0"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			bugbuzz: ["4L40"],
			captivate: ["4M", "4L36"],
			confusion: ["4L1", "3L1"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			gust: ["4L16", "3L28"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			mimic: ["3T"],
			morningsun: ["3S0"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			poisonpowder: ["4L12", "3L13"],
			protect: ["4M", "3M"],
			psybeam: ["4L24", "3L34"],
			psychic: ["4M", "3M", "3S0"],
			psychup: ["4M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			safeguard: ["4M", "4L34", "3M", "3L40"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M", "4L28", "3L47"],
			skillswap: ["4M", "3M"],
			sleeppowder: ["4L12", "3L15", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stunspore: ["4L12", "3L14"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L18", "3L18"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4L30"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4L22", "3L23"],
		},
	},
	weedle: {
		inherit: true,
		learnset: {
			bugbite: ["4L15"],
			poisonsting: ["4L1", "3L1"],
			stringshot: ["4L1", "3L1"],
		},
	},
	kakuna: {
		inherit: true,
		learnset: {
			harden: ["4L1", "3L1"],
			irondefense: ["4T"],
		},
	},
	beedrill: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L31", "3L40"],
			aircutter: ["4T"],
			assurance: ["4L34"],
			attract: ["4M", "3M"],
			batonpass: ["3S0"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endeavor: ["4T", "4L40", "3L45"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			flash: ["4M"],
			focusenergy: ["4L13", "3L15"],
			frustration: ["4M", "3M"],
			furyattack: ["4L1", "3L1"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			knockoff: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["4M"],
			pinmissile: ["4L28", "3L35"],
			poisonjab: ["4M", "4L37"],
			protect: ["4M", "3M"],
			pursuit: ["4L22", "3L30"],
			rage: ["4L19", "3L25"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M", "3S0"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T", "3S0"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L25"],
			twineedle: ["4L16", "3L20", "3S0"],
			uturn: ["4M"],
			xscissor: ["4M"],
		},
	},
	pidgey: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L29", "3L39"],
			aircutter: ["4T", "4E", "3E"],
			airslash: ["4L49", "4E"],
			attract: ["4M", "3M"],
			bravebird: ["4E"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			featherdance: ["4L25", "3L31"],
			feintattack: ["4E", "3E"],
			fly: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			gust: ["4L9", "3L9"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["4L45", "3L47"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			quickattack: ["4L13", "3L13"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M", "4L37"],
			sandattack: ["4L5", "3L5"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "4E", "3M", "3E"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwind: ["4L41"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L21"],
			uproar: ["4T", "4E"],
			uturn: ["4M"],
			whirlwind: ["4L17", "3L19"],
			wingattack: ["4L33", "3L25"],
		},
	},
	pidgeotto: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L32", "3L43"],
			aircutter: ["4T"],
			airslash: ["4L57"],
			attract: ["4M", "3M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			featherdance: ["4L27", "3L34", "3S0"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gust: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["4L52", "3L52"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L13", "3L13"],
			raindance: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M", "4L42"],
			sandattack: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M", "3S0"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwind: ["4L47"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L22"],
			uproar: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4L17", "3L20"],
			wingattack: ["4L37", "3L27", "3S0"],
		},
	},
	pidgeot: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L32", "3L48"],
			aircutter: ["4T"],
			airslash: ["4L62"],
			attract: ["4M", "3M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			featherdance: ["4L27", "3L34"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gust: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["4L56", "3L62"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M", "4L44"],
			sandattack: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwind: ["4L50"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L22"],
			uproar: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4L17", "3L20"],
			wingattack: ["4L38", "3L27"],
		},
	},
	rattata: {
		inherit: true,
		learnset: {
			assurance: ["4L25"],
			attract: ["4M", "3M"],
			bite: ["4L10", "4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["4E", "3T", "3E"],
			crunch: ["4L22"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L31", "3T"],
			doubleteam: ["4M", "3M"],
			endeavor: ["4T", "4L34", "3L41"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flamewheel: ["4E", "3E"],
			focusenergy: ["4L7", "3L20"],
			frustration: ["4M", "3M"],
			furyswipes: ["4E", "3E"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperfang: ["4L16", "3L13"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T", "4E"],
			mefirst: ["4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4L13", "3L27"],
			quickattack: ["4L4", "3L7"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4E", "3E"],
			rocksmash: ["4M", "3M"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L19"],
			sunnyday: ["4M", "3M"],
			superfang: ["4L28", "3L34"],
			swagger: ["4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4E", "3E"],
			uturn: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	raticate: {
		inherit: true,
		learnset: {
			assurance: ["4L29"],
			attract: ["4M", "3M"],
			bite: ["4L10"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			crunch: ["4L24"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L39", "3T"],
			doubleteam: ["4M", "3M"],
			endeavor: ["4T", "4L44", "3L50"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			focusenergy: ["4L1"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hyperfang: ["4L16", "3L13", "3S0"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4L13", "3L30"],
			quickattack: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			scaryface: ["4L20", "3L20", "3S0"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L19"],
			sunnyday: ["4M", "3M"],
			superfang: ["4L34", "3L40", "3S0"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "4L1"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			uturn: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	spearow: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L17", "3M", "3L25", "3S0"],
			agility: ["4L25", "3L43"],
			aircutter: ["4T"],
			assurance: ["4L29"],
			astonish: ["4E", "3E"],
			attract: ["4M", "3M"],
			batonpass: ["3S0"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drillpeck: ["4L37", "3L37"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4E", "3E", "3S0"],
			feintattack: ["4E", "3E"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L9", "3L13"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			leer: ["4L5", "3L7", "3S0"],
			mimic: ["3T"],
			mirrormove: ["4L21", "3L31"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["4L1", "3L1"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4L13", "3L19"],
			quickattack: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M", "4L33"],
			scaryface: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			skyattack: ["4E", "3T", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			triattack: ["4E", "3E"],
			twister: ["4T"],
			uproar: ["4E"],
			uturn: ["4M"],
			whirlwind: ["4E"],
		},
	},
	fearow: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L17", "3M"],
			agility: ["4L29", "3L47"],
			aircutter: ["4T"],
			assurance: ["4L35"],
			attract: ["4M", "3M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drillpeck: ["4L47", "3L40"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L1", "3L1"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mirrormove: ["4L23", "3L32"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["4L1", "3L1"],
			pluck: ["4M", "4L1"],
			protect: ["4M", "3M"],
			pursuit: ["4L13", "3L26"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M", "4L41"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
		},
	},
	ekans: {
		inherit: true,
		learnset: {
			acid: ["4L20", "3L32"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			beatup: ["4E", "3E"],
			bite: ["4L9", "3L13", "3S0"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			darkpulse: ["4M"],
			dig: ["4M", "3M"],
			disable: ["4E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T", "4L33"],
			gigadrain: ["4M", "3M"],
			glare: ["4L12", "3L20"],
			gunkshot: ["4T", "4L41"],
			haze: ["4L36", "3L44"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1", "3S0", "3S1"],
			mimic: ["3T"],
			mudbomb: ["4L28"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonfang: ["4E", "3E"],
			poisonjab: ["4M"],
			poisonsting: ["4L4", "3L8", "3S0", "3S1"],
			poisontail: ["4E"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocktomb: ["4M"],
			scaryface: ["4E"],
			screech: ["4L17", "3L25"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slam: ["4E", "3E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T", "4E", "3E"],
			spitup: ["4L25", "3L37"],
			stockpile: ["4L25", "3L37"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L25", "3L37"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			wrap: ["4L1", "3L1", "3S0", "3S1"],
		},
	},
	arbok: {
		inherit: true,
		learnset: {
			acid: ["4L20", "3L38"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			crunch: ["4L22"],
			darkpulse: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firefang: ["4L1"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T", "4L42"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			glare: ["4L12", "3L20", "3S0"],
			gunkshot: ["4T", "4L56"],
			haze: ["4L48", "3L56"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icefang: ["4L1"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudbomb: ["4L34"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			poisonsting: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocktomb: ["4M"],
			screech: ["4L17", "3L28"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M", "3S0"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			spitup: ["4L28", "3L46"],
			stockpile: ["4L28", "3L46"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L28", "3L46"],
			thief: ["4M", "3M"],
			thunderfang: ["4L1"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			wrap: ["4L1", "3L1"],
		},
	},
	pichu: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bide: ["4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["4E", "4S5", "3E"],
			chargebeam: ["4M"],
			charm: ["4L1", "3L1", "3S0", "3S1", "3S2", "3S3"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleslap: ["4E", "3E"],
			doubleteam: ["4M", "3M"],
			encore: ["4E", "3E"],
			endeavor: ["4S5"],
			endure: ["4M", "4S5", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4E"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			followme: ["3S3"],
			frustration: ["4M", "3M"],
			grassknot: ["4M", "4S4"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "3M"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L18"],
			naturalgift: ["4M"],
			present: ["4E", "3E"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "4S4", "3M"],
			reversal: ["4E", "3E"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			surf: ["3S0"],
			swagger: ["4M", "3T"],
			sweetkiss: ["4L13", "3L11"],
			swift: ["4T", "3T"],
			tailwhip: ["4L5", "3L6"],
			teeterdance: ["3S2"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "4S4", "3M"],
			thunderpunch: ["4E"],
			thundershock: ["4L1", "3L1", "3S0", "3S1", "3S2", "3S3"],
			thunderwave: ["4M", "4L10", "3T", "3L8"],
			tickle: ["4E"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			volttackle: ["4E", "4S4", "4S5", "3E"],
			wish: ["4E", "3E", "3S1"],
		},
	},
	pichuspikyeared: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L1"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T", "4S0"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			nastyplot: ["4L18"],
			naturalgift: ["4M"],
			painsplit: ["4S0"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			swagger: ["4M", "4S0"],
			sweetkiss: ["4L13"],
			swift: ["4T"],
			tailwhip: ["4L5"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thundershock: ["4L1"],
			thunderwave: ["4M", "4L10"],
			toxic: ["4M"],
			uproar: ["4T"],
			volttackle: ["4S0"],
		},
	},
	pikachu: {
		inherit: true,
		learnset: {
			agility: ["4L34", "3L33", "3S0", "3S8"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			discharge: ["4L37"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L18", "4S13", "3M", "3L15"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feint: ["4L29"],
			flash: ["4M", "4S13", "3M"],
			fling: ["4M"],
			fly: ["3S2", "3S4", "3S6"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			grassknot: ["4M", "4S13"],
			growl: ["4L1", "3L1", "3S1", "3S2", "3S3", "3S4", "3S5", "3S10"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "4S21", "3M"],
			knockoff: ["4T"],
			lastresort: ["4S18"],
			lightscreen: ["4M", "4L42", "4S11", "3M", "3L50", "3S0", "3S6", "3S7", "3S8"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			present: ["4S12", "4S15", "4S17", "4S18", "4S20", "4S22"],
			protect: ["4M", "4S14", "4S16", "3M"],
			quickattack: ["4L13", "4S11", "4S12", "4S15", "4S17", "4S18", "4S20", "4S21", "4S22", "3L11"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4S19", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			slam: ["4L21", "3L20"],
			sleeptalk: ["4M", "4S19", "3T"],
			snore: ["4T", "4S19", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4S9", "4S11", "4S14", "4S16", "3S3", "3S5", "3S7"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["4L5", "4S9", "4S12", "4S15", "4S17", "4S20", "4S22", "3L6", "3S1", "3S2", "3S3", "3S4", "3S10"],
			thunder: ["4M", "4L45", "4S14", "4S16", "3M", "3L41", "3S0", "3S6", "3S7", "3S8"],
			thunderbolt: ["4M", "4L26", "4S11", "4S13", "4S18", "4S21", "3M", "3L26", "3S0", "3S6", "3S7", "3S8"],
			thunderpunch: ["4T", "3T"],
			thundershock: ["4L1", "4S12", "4S15", "4S20", "4S22", "3L1", "3S1", "3S5", "3S10"],
			thunderwave: ["4M", "4L10", "4S9", "4S17", "3T", "3L8", "3S1", "3S2", "3S3", "3S4", "3S5", "3S10"],
			toxic: ["4M", "3M"],
			volttackle: ["4S9", "4S21"],
			yawn: ["4S19"],
		},
	},
	raichu: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lightscreen: ["4M", "3M"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "4L1", "3M", "3L1"],
			thunderpunch: ["4T", "3T"],
			thundershock: ["4L1", "3L1"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
		},
	},
	sandshrew: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E"],
			crushclaw: ["4E", "3E"],
			cut: ["4M", "3M"],
			defensecurl: ["4L3", "3T", "3L6", "3S0"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L25", "3T"],
			furyswipes: ["4L19", "3L37"],
			gyroball: ["4M", "4L33"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			metalclaw: ["4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4E"],
			poisonjab: ["4M"],
			poisonsting: ["4L9", "3L17", "3S0"],
			protect: ["4M", "3M"],
			rapidspin: ["4L13", "4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L21", "3T"],
			safeguard: ["4E", "3E"],
			sandattack: ["4L7", "3L11", "3S0"],
			sandstorm: ["4M", "4L37", "3M", "3L53"],
			sandtomb: ["4L27", "3L45"],
			scratch: ["4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			slash: ["4L31", "3L23"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L15", "3T", "3L30"],
			swordsdance: ["4M", "4E", "3T", "3E"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			xscissor: ["4M"],
		},
	},
	sandslash: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crushclaw: ["4L22"],
			cut: ["4M", "3M"],
			defensecurl: ["4L1", "3T", "3L1"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L28", "3T"],
			furyswipes: ["4L19", "3L42"],
			gigaimpact: ["4M"],
			gyroball: ["4M", "4L45"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["4M"],
			poisonsting: ["4L9", "3L17"],
			protect: ["4M", "3M"],
			rapidspin: ["4L13"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L21", "3T"],
			sandattack: ["4L1", "3L1"],
			sandstorm: ["4M", "4L52", "3M", "3L62"],
			sandtomb: ["4L33", "3L52"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			slash: ["4L40", "3L24"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L15", "3T", "3L33"],
			swordsdance: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			xscissor: ["4M"],
		},
	},
	nidoranf: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			beatup: ["4E", "3E"],
			bite: ["4L21", "3L20"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M", "4L43"],
			charm: ["4E", "3E"],
			counter: ["4E", "3T", "3E"],
			crunch: ["4L37", "3L47"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			disable: ["4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["4L9", "3L12"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flatter: ["4L33", "3L38"],
			focusenergy: ["4E", "3E"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L19", "3L30"],
			growl: ["4L1", "3L1"],
			helpinghand: ["4T", "4L25", "3L23"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonfang: ["4L45"],
			poisonjab: ["4M"],
			poisonsting: ["4L13", "3L17"],
			protect: ["4M", "3M"],
			pursuit: ["4E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4E", "3E"],
			swagger: ["4M", "3T"],
			tailwhip: ["4L7", "3L8"],
			takedown: ["4E", "3E"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L31"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidorina: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bite: ["4L23", "3L22"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M", "4L50"],
			counter: ["3T"],
			crunch: ["4L43", "3L53"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["4L9", "3L12"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flatter: ["4L38", "3L43"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L20", "3L34"],
			growl: ["4L1", "3L1"],
			helpinghand: ["4T", "4L28", "3L26"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonfang: ["4L58"],
			poisonjab: ["4M"],
			poisonsting: ["4L13", "3L18"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tailwhip: ["4L7", "3L8"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L35"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidoqueen: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4L23", "3T", "3L22"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["4L1", "3L1"],
			doubleteam: ["4M", "3M"],
			dragonpulse: ["4M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T", "4L43"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			poisonjab: ["4M"],
			poisonsting: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T", "4L58", "3L43"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tailwhip: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidoranm: {
		inherit: true,
		learnset: {
			amnesia: ["4E", "3E"],
			attract: ["4M", "3M"],
			beatup: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M", "4L43"],
			confusion: ["4E", "3E"],
			counter: ["4E", "3T", "3E"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			disable: ["4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["4L9", "3L12"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flatter: ["4L33", "3L38"],
			focusenergy: ["4L7", "3L8"],
			frustration: ["4M", "3M"],
			furyattack: ["4L19", "3L30"],
			helpinghand: ["4T", "4L25", "3L23"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["4L21", "3L20"],
			horndrill: ["4L45", "3L47"],
			icebeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			peck: ["4L1", "3L1"],
			poisonjab: ["4M", "4L37"],
			poisonsting: ["4L13", "3L17"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4E"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4E", "3E"],
			swagger: ["4M", "3T"],
			takedown: ["4E", "3E"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L31"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidorino: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M", "4L50"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["4L9", "3L12"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flatter: ["4L38", "3L43"],
			focusenergy: ["4L7", "3L8"],
			frustration: ["4M", "3M"],
			furyattack: ["4L20", "3L34"],
			helpinghand: ["4T", "4L28", "3L26"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["4L23", "3L22"],
			horndrill: ["4L58", "3L53"],
			icebeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			peck: ["4L1", "3L1"],
			poisonjab: ["4M", "4L43"],
			poisonsting: ["4L13", "3L18"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L35"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidoking: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["4L1", "3L1"],
			doubleteam: ["4M", "3M"],
			dragonpulse: ["4M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T", "4L43"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			megahorn: ["4L58", "3L43"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			peck: ["4L1", "3L1"],
			poisonjab: ["4M"],
			poisonsting: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thrash: ["4L23", "3L22"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	cleffa: {
		inherit: true,
		learnset: {
			amnesia: ["4E", "3E"],
			attract: ["4M", "3M"],
			bellydrum: ["4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["4L1", "3L1"],
			copycat: ["4L13"],
			counter: ["3T"],
			covet: ["4E"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			encore: ["4L4", "3L4"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			faketears: ["4E"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lightscreen: ["4M", "3M"],
			magicalleaf: ["4L16", "3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["4E", "3T", "3E"],
			mimic: ["4E", "3T", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			pound: ["4L1", "3L1"],
			present: ["4E", "3E"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["4L7", "3L8"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["4M", "3M"],
			splash: ["4E", "3E"],
			substitute: ["4M", "4E", "3T", "3E"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetkiss: ["4L10", "3L13"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			wish: ["4E", "3E"],
			zenheadbutt: ["4T"],
		},
	},
	clefairy: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			cosmicpower: ["4L25", "3L33"],
			counter: ["3T"],
			defensecurl: ["4L13", "3T", "3L25"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["4L10", "3L13"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			encore: ["4L4", "3L5"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			followme: ["4L16", "3L17"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			gravity: ["4L34"],
			growl: ["4L1", "3L1"],
			healingwish: ["4L46"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["4M", "4L40", "3M", "3L41"],
			luckychant: ["4L28"],
			megakick: ["3T"],
			megapunch: ["3T"],
			meteormash: ["4L43", "3L45"],
			metronome: ["4L31", "3T", "3L29"],
			mimic: ["3T"],
			minimize: ["4L19", "3L21"],
			moonlight: ["4L37", "3L37"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["4L7", "3L9"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			wakeupslap: ["4L22"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T"],
		},
	},
	clefable: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["4L1", "3L1"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["4L1", "3T", "3L1"],
			mimic: ["3T"],
			minimize: ["4L1", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T"],
		},
	},
	vulpix: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M", "4L37"],
			charm: ["3S1"],
			confuseray: ["4L17", "3L21"],
			darkpulse: ["4M"],
			dig: ["4M", "3M", "3S1"],
			disable: ["4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			ember: ["4L1", "3L1", "3S1"],
			endure: ["4M", "3T"],
			energyball: ["4E"],
			extrasensory: ["4L44", "4E"],
			facade: ["4M", "3M"],
			feintattack: ["4E", "3E"],
			fireblast: ["4M", "4L47", "3M"],
			firespin: ["4L34", "3L41"],
			flail: ["4E", "3E"],
			flamethrower: ["4M", "4L24", "3M", "3L29"],
			flareblitz: ["4E"],
			frustration: ["4M", "3M"],
			grudge: ["4L41", "3L37"],
			heatwave: ["4T", "4E", "3E", "3S1"],
			hiddenpower: ["4M", "3M"],
			howl: ["4E", "3E"],
			hypnosis: ["4E", "3E"],
			imprison: ["4L21", "3L25"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["4M", "3M"],
			payback: ["4M", "4L31"],
			protect: ["4M", "3M"],
			psychup: ["4M", "4E", "3E"],
			quickattack: ["4L11", "3L13", "3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L7", "3M", "3L9", "3S0"],
			safeguard: ["4M", "4L27", "3M", "3L33"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T", "4E", "3E"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["4L4", "3L5", "3S0"],
			toxic: ["4M", "3M"],
			willowisp: ["4M", "4L14", "3L17", "3S0"],
			zenheadbutt: ["4T"],
		},
	},
	ninetales: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M"],
			captivate: ["4M"],
			confuseray: ["4L1", "3L1"],
			darkpulse: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firespin: ["3L45"],
			flamethrower: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			nastyplot: ["4L1"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["4M", "3M"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M"],
			quickattack: ["4L1", "3L1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			safeguard: ["4M", "4L1", "3M", "3L1"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	igglybuff: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			captivate: ["4M"],
			charm: ["4L1", "3L1", "3S0"],
			copycat: ["4L17"],
			counter: ["3T"],
			covet: ["4E"],
			defensecurl: ["4L5", "3T", "3L4", "3S0"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			faketears: ["4E", "3E"],
			feintattack: ["4E", "3E"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			gravity: ["4E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icywind: ["4T", "3T"],
			lastresort: ["4T", "4E"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			perishsong: ["4E", "3E"],
			pound: ["4L9", "3L9"],
			present: ["4E", "3E"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["4L1", "3L1", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetkiss: ["4L13", "3L14"],
			thunderwave: ["4M", "3T"],
			tickle: ["3S0"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			wish: ["4E", "3E"],
		},
	},
	jigglypuff: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4L29", "3T", "3L34"],
			bounce: ["4T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			defensecurl: ["4L5", "3T", "3L4"],
			dig: ["4M", "3M"],
			disable: ["4L13", "3L14"],
			doubleedge: ["4L49", "3T", "3L49"],
			doubleslap: ["4L21", "3L24"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			gyroball: ["4M", "4L33"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hypervoice: ["4L45", "3L44"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["4L41", "3T", "3L39"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			pound: ["4L9", "3L9"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "4L25", "3M", "3L29"],
			return: ["4M", "3M"],
			rollout: ["4T", "4L17", "3T", "3L19"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			wakeupslap: ["4L37"],
			waterpulse: ["4M", "3M"],
		},
	},
	wigglytuff: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			defensecurl: ["4L1", "3T", "3L1"],
			dig: ["4M", "3M"],
			disable: ["4L1", "3L1"],
			doubleedge: ["3T"],
			doubleslap: ["4L1", "3L1"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gyroball: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	zubat: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T", "4L25", "3L31"],
			airslash: ["4L41"],
			astonish: ["4L9", "3L6"],
			attract: ["4M", "3M"],
			bite: ["4L13", "3L16"],
			bravebird: ["4E"],
			captivate: ["4M"],
			confuseray: ["4L21", "3L26"],
			curse: ["4E", "3E"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4E", "3E"],
			fly: ["4M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gust: ["4E", "3E"],
			haze: ["4L37", "3L46"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4E"],
			leechlife: ["4L1", "3L1"],
			meanlook: ["4L29", "3L36"],
			mimic: ["3T"],
			nastyplot: ["4E"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["4M"],
			pluck: ["4M"],
			poisonfang: ["4L33", "3L41"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			quickattack: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L5", "3L6"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4E", "3E"],
			wingattack: ["4L17", "3L21"],
			zenheadbutt: ["4T", "4E"],
		},
	},
	golbat: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T", "4L27", "3L35"],
			airslash: ["4L51"],
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bite: ["4L13", "3L16"],
			captivate: ["4M"],
			confuseray: ["4L21", "3L28"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fly: ["4M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			haze: ["4L45", "3L56"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leechlife: ["4L1", "3L1"],
			meanlook: ["4L33", "3L42"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["4M"],
			pluck: ["4M"],
			poisonfang: ["4L39", "3L49"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			screech: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L1", "3L1"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["4M"],
			wingattack: ["4L17", "3L21"],
			zenheadbutt: ["4T"],
		},
	},
	crobat: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T", "4L27", "3L35"],
			airslash: ["4L51", "4S0"],
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bite: ["4L13", "3L16"],
			captivate: ["4M"],
			confuseray: ["4L21", "3L28"],
			crosspoison: ["4L1"],
			darkpulse: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			haze: ["4L45", "3L56"],
			heatwave: ["4T", "4S0"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leechlife: ["4L1", "3L1"],
			meanlook: ["4L33", "3L42"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["4M"],
			pluck: ["4M"],
			poisonfang: ["4L39", "3L49"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			screech: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "4S0", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superfang: ["4S0"],
			supersonic: ["4L1", "3L1"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["4M"],
			wingattack: ["4L17", "3L21"],
			xscissor: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	oddish: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1", "3S1"],
			acid: ["4L9", "3L23", "3S0"],
			attract: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["4E", "3E"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "4L37", "3M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			ingrain: ["4E", "3E"],
			leechseed: ["3S1"],
			luckychant: ["4L25"],
			megadrain: ["4L21"],
			mimic: ["3T"],
			moonlight: ["4L33", "3L32"],
			naturalgift: ["4M", "4L29"],
			petaldance: ["4L41", "3L39"],
			poisonpowder: ["4L13", "3L14", "3S0"],
			protect: ["4M", "3M"],
			razorleaf: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["4L17", "3L18", "3S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stunspore: ["4L15", "3L16", "3S0"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L5", "3L7"],
			swordsdance: ["4M", "4E", "3T", "3E"],
			synthesis: ["4T", "4E", "3E"],
			tickle: ["4E"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
		},
	},
	gloom: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1"],
			acid: ["4L1", "3L24", "3S0"],
			attract: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "4L47", "3M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			luckychant: ["4L29"],
			megadrain: ["4L23"],
			mimic: ["3T"],
			moonlight: ["4L41", "3L35", "3S0"],
			naturalgift: ["4M", "4L35"],
			petaldance: ["4L53", "3L44", "3S0"],
			poisonpowder: ["4L13", "3L1"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["4L17", "3L18", "3S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stunspore: ["4L15", "3L16"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L1", "3L1"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
		},
	},
	vileplume: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			aromatherapy: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			megadrain: ["4L1", "3L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			petaldance: ["4L53", "3L44"],
			poisonpowder: ["4L1"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L65", "3M"],
			stunspore: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
		},
	},
	bellossom: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			attract: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leafblade: ["4L1"],
			leafstorm: ["4L53"],
			magicalleaf: ["4L23", "3L1"],
			megadrain: ["4L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			petaldance: ["3L44"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M", "3L55"],
			stunspore: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4L1", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L1", "3L1"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			worryseed: ["4T"],
		},
	},
	paras: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aromatherapy: ["4L38", "3L49"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M"],
			bugbite: ["4E"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E"],
			crosspoison: ["4E"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4E", "3E", "3S0"],
			flail: ["4E", "3E"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "4L33", "3M", "3L43"],
			grassknot: ["4M"],
			growth: ["4L27", "3L37"],
			hiddenpower: ["4M", "3M"],
			knockoff: ["4T"],
			leechlife: ["4L11", "3L19"],
			lightscreen: ["4E", "3E"],
			metalclaw: ["4E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["4L6", "3L13"],
			protect: ["4M", "3M"],
			psybeam: ["4E", "3E"],
			pursuit: ["4E", "3E"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slash: ["4L22", "3L31", "3S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spore: ["4L17", "3L25", "3S0"],
			stunspore: ["4L6", "3L7"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4E", "3E"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
			xscissor: ["4M", "4L43"],
		},
	},
	parasect: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aromatherapy: ["4L47", "3L59"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crosspoison: ["4L1"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "4L39", "3M", "3L51"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growth: ["4L30", "3L43"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			knockoff: ["4T"],
			leechlife: ["4L1", "3L19"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slash: ["4L22", "3L35"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spore: ["4L17", "3L27"],
			stunspore: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
			xscissor: ["4M", "4L55"],
		},
	},
	venonat: {
		inherit: true,
		learnset: {
			agility: ["4E"],
			attract: ["4M", "3M"],
			batonpass: ["4E", "3E"],
			bugbite: ["4E"],
			captivate: ["4M"],
			confusion: ["4L11", "3L17"],
			disable: ["4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			foresight: ["4L1", "3L1"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "4E", "3M", "3E"],
			hiddenpower: ["4M", "3M"],
			leechlife: ["4L17", "3L25"],
			mimic: ["3T"],
			morningsun: ["4E"],
			naturalgift: ["4M"],
			poisonfang: ["4L41"],
			poisonpowder: ["4L13", "3L20"],
			protect: ["4M", "3M"],
			psybeam: ["4L25", "3L33"],
			psychic: ["4M", "4L47", "3M", "3L41"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T", "4L35", "4E", "3E"],
			skillswap: ["4M", "3M"],
			sleeppowder: ["4L29", "3L36"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stunspore: ["4L23", "3L28"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L5", "3L9"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4E"],
			zenheadbutt: ["4T", "4L37"],
		},
	},
	venomoth: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			bugbuzz: ["4L59"],
			captivate: ["4M"],
			confusion: ["4L11", "3L17"],
			defog: ["4M"],
			disable: ["4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			foresight: ["4L1", "3L1"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			gust: ["4L31", "3L31"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leechlife: ["4L17", "3L25"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonfang: ["4L47"],
			poisonpowder: ["4L13", "3L20"],
			protect: ["4M", "3M"],
			psybeam: ["4L25", "3L36"],
			psychic: ["4M", "4L55", "3M", "3L52", "3S0"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T", "4L37"],
			silverwind: ["4M", "4L1", "3L1", "3S0"],
			skillswap: ["4M", "3M"],
			sleeppowder: ["4L29", "3L42"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stunspore: ["4L23", "3L28"],
			substitute: ["4M", "3T", "3S0"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L1", "3L1"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
			zenheadbutt: ["4T", "4L41"],
		},
	},
	diglett: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4E", "3E"],
			astonish: ["4L7", "4E"],
			attract: ["4M", "3M"],
			beatup: ["4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			dig: ["4M", "4L18", "3M", "3L17"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T", "4L26"],
			earthquake: ["4M", "4L37", "3M", "3L41"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4E", "3E"],
			fissure: ["4L40", "3L49"],
			frustration: ["4M", "3M"],
			furyswipes: ["3L21"],
			growl: ["4L4", "3L5"],
			hiddenpower: ["4M", "3M"],
			magnitude: ["4L12", "3L9"],
			mimic: ["3T"],
			mudbomb: ["4L29", "4E"],
			mudslap: ["4T", "4L15", "3T", "3L25"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandattack: ["4L1", "3L1"],
			sandstorm: ["4M"],
			scratch: ["4L1", "3L1"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			slash: ["4L34", "3L33"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L23"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4E", "3E"],
		},
	},
	dugtrio: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			astonish: ["4L7"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["3S0"],
			cut: ["4M", "3M"],
			dig: ["4M", "4L18", "3M", "3L17"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T", "4L28"],
			earthquake: ["4M", "4L45", "3M", "3L51", "3S0"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fissure: ["4L50", "3L64"],
			frustration: ["4M", "3M"],
			furyswipes: ["3L21"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			magnitude: ["4L12", "3L9"],
			mimic: ["3T"],
			mudbomb: ["4L33"],
			mudslap: ["4T", "4L15", "3T", "3L25"],
			naturalgift: ["4M"],
			nightslash: ["4L1"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandattack: ["4L1", "3L1"],
			sandstorm: ["4M", "3S0"],
			sandtomb: ["4L26", "3L26"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			slash: ["4L40", "3L38"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L23"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			triattack: ["4L1", "3L1", "3S0"],
		},
	},
	meowth: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			amnesia: ["4E", "3E"],
			assist: ["4E", "4S5", "3E"],
			assurance: ["4L41"],
			attract: ["4M", "3M"],
			bite: ["4L6", "4S4", "3L10", "3S2", "3S3"],
			bodyslam: ["3T"],
			captivate: ["4M", "4L46"],
			charm: ["4E", "3E"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4L9", "4S4", "4S5", "3L43"],
			feint: ["4L54"],
			feintattack: ["4L22", "3L25"],
			flail: ["4E"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L14", "4S4", "3L36"],
			growl: ["4L1", "3L1", "3S0", "3S1", "3S2"],
			gunkshot: ["4T"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4E", "3E"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L38"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["4L49"],
			odorsleuth: ["4E"],
			payback: ["4M"],
			payday: ["4L30", "4S5", "3L18", "3S3"],
			petaldance: ["3S0"],
			protect: ["4M", "3M"],
			psychup: ["4M", "4E", "3T", "3E"],
			punishment: ["4E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			scratch: ["4L1", "4S5", "3L1", "3S0", "3S1", "3S2"],
			screech: ["4L17", "4S4", "3L31"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sing: ["3S3"],
			slash: ["4L33", "3L40", "3S3"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T", "4E", "3E"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T", "3L45"],
			swift: ["4T", "3T"],
			taunt: ["4M", "4L25", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
		},
	},
	persian: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			assurance: ["4L49"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1"],
			bodyslam: ["3T"],
			captivate: ["4M", "4L56"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4L1", "3L55"],
			feint: ["4L68"],
			feintattack: ["4L22", "3L25"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L14", "3L42"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			gunkshot: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L44"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["4L61"],
			payback: ["4M"],
			payday: ["3L18"],
			powergem: ["4L32"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			screech: ["4L17", "3L34"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slash: ["4L37", "3L49"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T", "3L61"],
			swift: ["4T", "3T"],
			switcheroo: ["4L1"],
			taunt: ["4M", "4L25", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
		},
	},
	psyduck: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			amnesia: ["4L44"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			brine: ["4M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4E"],
			confusion: ["4L18", "3L16", "3S0"],
			counter: ["3T"],
			crosschop: ["4E", "3E"],
			dig: ["4M", "3M"],
			disable: ["4L14", "3L10", "3S0"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L27", "3L40"],
			futuresight: ["4E", "3E"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L48", "3L50"],
			hypnosis: ["4E", "3E"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lightscreen: ["4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S1"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psybeam: ["4E", "3E"],
			psychic: ["4M", "4E", "3E"],
			psychup: ["4M", "4L35", "3T", "3L31"],
			raindance: ["4M", "3M"],
			refresh: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			scratch: ["4L1", "3L1", "3S1"],
			screech: ["4L31", "3L23", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["4L5", "3L5", "3S0", "3S1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L9"],
			waterpulse: ["4M", "4L22", "3M"],
			watersport: ["4L1", "3L1", "3S1"],
			worryseed: ["4T"],
			yawn: ["4E"],
			zenheadbutt: ["4T", "4L40"],
		},
	},
	golduck: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			amnesia: ["4L50"],
			aquajet: ["4L1"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M", "3S0"],
			brine: ["4M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confusion: ["4L18", "3L16"],
			counter: ["3T"],
			dig: ["4M", "3M"],
			disable: ["4L14", "3L1"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L27", "3L44"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L56", "3L58"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M"],
			psychup: ["4M", "4L37", "3T", "3L31", "3S0"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			screech: ["4L31", "3L23"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M", "3S0"],
			watergun: ["4L1"],
			waterpulse: ["4M", "4L22", "3M"],
			watersport: ["4L1", "3L1"],
			worryseed: ["4T"],
			zenheadbutt: ["4T", "4L44"],
		},
	},
	mankey: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			assurance: ["4L25"],
			attract: ["4M", "3M"],
			beatup: ["4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			closecombat: ["4L49", "4E"],
			counter: ["4E", "3T", "3E"],
			covet: ["4L1"],
			crosschop: ["4L37", "3L31"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L21"],
			focuspunch: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L9", "3L16"],
			gunkshot: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			karatechop: ["4L13", "3L11"],
			leer: ["4L1", "3L1"],
			lowkick: ["4L1", "3L6"],
			meditate: ["4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			overheat: ["4M", "3M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["3T"],
			punishment: ["4L45"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4E", "3E"],
			reversal: ["4E", "3E"],
			rockclimb: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			screech: ["4L21", "3L41"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["4L17", "3T", "3L26"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["4E", "3E"],
			snore: ["3T"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L33", "3T", "3L36"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thrash: ["4L41", "3L46"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			uturn: ["4M"],
			vacuumwave: ["4T"],
		},
	},
	primeape: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			assurance: ["4L25"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			closecombat: ["4L59"],
			counter: ["3T"],
			crosschop: ["4L41", "3L35", "3S0"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			fling: ["4M", "4L1"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L21", "3S0"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L9", "3L16"],
			gigaimpact: ["4M"],
			gunkshot: ["4T"],
			helpinghand: ["4T", "3S0"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			karatechop: ["4L13", "3L11"],
			leer: ["4L1", "3L1"],
			lowkick: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			overheat: ["4M", "3M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["3T"],
			punishment: ["4L53"],
			rage: ["4L28", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["3S0"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			screech: ["4L21", "3L53"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["4L17", "3T", "3L26"],
			sleeptalk: ["4M", "3T"],
			snore: ["3T"],
			spite: ["4T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L35", "3T", "3L44"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thrash: ["4L47", "3L62"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			uturn: ["4M"],
			vacuumwave: ["4T"],
		},
	},
	growlithe: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L39", "3L43"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1", "3S1", "3S2"],
			bodyslam: ["4E", "3T", "3E"],
			captivate: ["4M"],
			charm: ["3S2"],
			crunch: ["4L42", "4E", "3E"],
			dig: ["4M", "3M"],
			doubleedge: ["4E", "3T"],
			doubleteam: ["4M", "3M"],
			ember: ["4L6", "3L7", "3S1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4L28"],
			firespin: ["4E", "3E"],
			flamethrower: ["4M", "4L34", "3M", "3L49", "3S2"],
			flamewheel: ["4L20", "3L31", "3S0"],
			flareblitz: ["4L48", "4E"],
			frustration: ["4M", "3M"],
			heatwave: ["4T", "4L45", "4E", "3E"],
			helpinghand: ["4T", "4L17", "3L37"],
			hiddenpower: ["4M", "3M"],
			howl: ["4E", "3E"],
			irontail: ["4M", "3M"],
			leer: ["4L9", "3L13", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["4L14", "3L19", "3S0"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4L25"],
			roar: ["4M", "4L1", "3M", "3L1", "3S1"],
			rocksmash: ["4M", "3M"],
			safeguard: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["4L31", "3L25", "3S0", "3S2"],
			thief: ["4M", "3M"],
			thrash: ["4E", "3E"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	arcanine: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			crunch: ["4S0"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonpulse: ["4M"],
			ember: ["3L1"],
			endure: ["4M", "3T"],
			extremespeed: ["4L39", "4S0", "3L49"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4L1"],
			flamethrower: ["4M", "3M"],
			flareblitz: ["4S0"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["4L1", "3L1"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L1", "3M", "3L1"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			thunderfang: ["4L1", "4S0"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	poliwag: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bellydrum: ["4L31", "3L37"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4L21", "3T", "3L31"],
			bubble: ["4L5", "3L1", "3S0"],
			bubblebeam: ["4L25", "4E", "3E"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["4L15", "3L19"],
			doubleteam: ["4M", "3M"],
			endeavor: ["4E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			haze: ["4E", "3E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L38", "3L43"],
			hypnosis: ["4L8", "3L7"],
			iceball: ["4E", "3E"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mindreader: ["4E", "3E"],
			mist: ["4E", "3E"],
			mudbomb: ["4L41"],
			mudshot: ["4L28", "4E"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			raindance: ["4M", "4L18", "3M", "3L25"],
			refresh: ["4E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["4E", "3E"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetkiss: ["3S0"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			wakeupslap: ["4L35"],
			waterfall: ["4M", "3M"],
			watergun: ["4L11", "3L13"],
			waterpulse: ["4M", "3M"],
			watersport: ["4L1", "4E", "3E"],
		},
	},
	poliwhirl: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bellydrum: ["4L37", "3L43"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4L21", "3T", "3L35"],
			brickbreak: ["4M", "3M"],
			bubble: ["4L1", "3L1"],
			bubblebeam: ["4L27"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["4L15", "3L19"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L48", "3L51"],
			hypnosis: ["4L1", "3L1"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudbomb: ["4L53"],
			mudshot: ["4L32"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			raindance: ["4M", "4L18", "3M", "3L27"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			wakeupslap: ["4L43"],
			waterfall: ["4M", "3M"],
			watergun: ["4L11", "3L1"],
			waterpulse: ["4M", "3M"],
			watersport: ["4L1"],
		},
	},
	poliwrath: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M", "3S0"],
			bubblebeam: ["4L1"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["4L1", "3L1"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["4L43", "3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			helpinghand: ["4T", "3S0"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["3S0"],
			hyperbeam: ["4M", "3M"],
			hypnosis: ["4L1", "3L1"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["4L53", "3L51"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			raindance: ["4M", "3M", "3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			submission: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
			waterfall: ["4M", "3M"],
			watergun: ["3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	politoed: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T", "4L37"],
			brickbreak: ["4M", "3M"],
			bubblebeam: ["4L1"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["4L1", "3L1"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypervoice: ["4L48"],
			hypnosis: ["4L1", "3L1"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			perishsong: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "4L27", "3T", "3L51"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	abra: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			barrier: ["4E", "3E"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["4M"],
			encore: ["4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "4E", "3T", "3E"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			guardswap: ["4E"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "4E", "3T", "3E"],
			irontail: ["4M", "3M"],
			knockoff: ["4T", "4E", "3E"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powertrick: ["4E"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			teleport: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "4E", "3T", "3E"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	kadabra: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L1"],
			counter: ["3T"],
			disable: ["4L18", "3L18"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L42", "3L30"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			kinesis: ["4L1", "3L1"],
			knockoff: ["4T"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["4L22"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psybeam: ["4L24", "3L21"],
			psychic: ["4M", "4L40", "3M", "3L36"],
			psychocut: ["4L34"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recover: ["4L30", "3L25"],
			recycle: ["4M"],
			reflect: ["4M", "4L28", "3M", "3L23"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roleplay: ["4L36", "3L33"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			teleport: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T", "4L46", "3L43"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	alakazam: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "4L36", "3M", "3L33", "3S0"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L1"],
			counter: ["3T"],
			disable: ["4L18", "3L18"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L42", "3L30", "3S0"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			kinesis: ["4L1", "3L1"],
			knockoff: ["4T"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["4L22"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psybeam: ["4L24", "3L21"],
			psychic: ["4M", "4L40", "3M", "3L36", "3S0"],
			psychocut: ["4L34"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recover: ["4L30", "3L25"],
			recycle: ["4M"],
			reflect: ["4M", "4L28", "3M", "3L23"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			teleport: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T", "4L46", "3L43", "3S0"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	machop: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			bulletpunch: ["4E"],
			captivate: ["4M"],
			closecombat: ["4E"],
			counter: ["4E", "3T", "3E"],
			crosschop: ["4L37", "3L40"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["4L46", "3T", "3L49"],
			earthquake: ["4M", "3M"],
			encore: ["4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "4E", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L7", "3L7"],
			focuspunch: ["4M", "3M"],
			foresight: ["4L13", "3L22"],
			frustration: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "4E", "3T"],
			karatechop: ["4L10", "3L13"],
			leer: ["4L1", "3L1"],
			lightscreen: ["4E", "3E"],
			lowkick: ["4L1", "3L1"],
			meditate: ["4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4L22", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollingkick: ["4E", "3E"],
			scaryface: ["4L43", "3L43"],
			secretpower: ["4M", "3M"],
			seismictoss: ["4L19", "3T", "3L19"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["4E", "3E"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			submission: ["4L31", "3L37"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "4E", "3T"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["4L25", "3L31"],
			wakeupslap: ["4L34"],
		},
	},
	machoke: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crosschop: ["4L40", "3L46"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["4L51", "3T", "3L59"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			foresight: ["4L13", "3L22"],
			frustration: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			karatechop: ["4L10", "3L13"],
			leer: ["4L1", "3L1"],
			lowkick: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4L22", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			scaryface: ["4L44", "3L51"],
			secretpower: ["4M", "3M"],
			seismictoss: ["4L19", "3T", "3L19"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			submission: ["4L32", "3L41"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["4L25", "3L33"],
			wakeupslap: ["4L36"],
		},
	},
	machamp: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crosschop: ["4L40", "3L46"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["4L51", "3T", "3L59"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			foresight: ["4L13", "3L22", "3S0"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			karatechop: ["4L10", "3L13"],
			leer: ["4L1", "3L1"],
			lowkick: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4L22", "3L25", "3S0"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			scaryface: ["4L44", "3L51"],
			secretpower: ["4M", "3M"],
			seismictoss: ["4L19", "3T", "3L19", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			submission: ["4L32", "3L41"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["4L25", "3L33", "3S0"],
			wakeupslap: ["4L36"],
		},
	},
	bellsprout: {
		inherit: true,
		learnset: {
			acid: ["4L23", "3L23"],
			attract: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			encore: ["4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T", "4L35"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			growth: ["4L7", "3L6", "3S1"],
			hiddenpower: ["4M", "3M"],
			ingrain: ["4E", "3E"],
			knockoff: ["4T", "4L27"],
			leechlife: ["4E", "3E"],
			magicalleaf: ["4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["4L15", "3L17"],
			protect: ["4M", "3M"],
			razorleaf: ["4L39", "3L37"],
			reflect: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slam: ["4L41", "3L45"],
			sleeppowder: ["4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stunspore: ["4L17", "3L19"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L29", "3L30"],
			swordsdance: ["4M", "4E", "3T", "3E"],
			synthesis: ["4T", "4E", "3E"],
			teeterdance: ["3S0"],
			thief: ["4M", "3M"],
			tickle: ["4E"],
			toxic: ["4M", "3M"],
			vinewhip: ["4L1", "3L1", "3S0", "3S1"],
			worryseed: ["4T", "4E"],
			wrap: ["4L11", "3L11"],
			wringout: ["4L47"],
		},
	},
	weepinbell: {
		inherit: true,
		learnset: {
			acid: ["4L23", "3L24"],
			attract: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T", "4L35"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			growth: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			knockoff: ["4T", "4L27"],
			magicalleaf: ["3S0"],
			mimic: ["3T"],
			morningsun: ["3S0"],
			naturalgift: ["4M"],
			poisonpowder: ["4L15", "3L17"],
			protect: ["4M", "3M"],
			razorleaf: ["4L39", "3L42"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slam: ["4L41", "3L54"],
			sleeppowder: ["4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M", "3S0"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stunspore: ["4L17", "3L19"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L29", "3L33", "3S0"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			vinewhip: ["4L1", "3L1"],
			worryseed: ["4T"],
			wrap: ["4L1", "3L1"],
			wringout: ["4L47"],
		},
	},
	victreebel: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			knockoff: ["4T"],
			leafblade: ["4L47"],
			leafstorm: ["4L47"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			razorleaf: ["4L1", "3L1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spitup: ["4L1", "3L1"],
			stockpile: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L1", "3L1"],
			sweetscent: ["4L1", "3L1"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			vinewhip: ["4L1", "3L1"],
			worryseed: ["4T"],
		},
	},
	tentacool: {
		inherit: true,
		learnset: {
			acid: ["4L12", "3L19"],
			acupressure: ["4E"],
			attract: ["4M", "3M"],
			aurorabeam: ["4E", "3E"],
			barrier: ["4L26", "3L36"],
			blizzard: ["4M", "3M"],
			brine: ["4M"],
			bubblebeam: ["4L19", "3L25"],
			captivate: ["4M"],
			confuseray: ["4E", "3E"],
			constrict: ["4L8", "3L12"],
			cut: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			hail: ["4M", "3M"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L40", "3L49"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T", "4E"],
			mimic: ["3T"],
			mirrorcoat: ["4E", "3E"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M", "4L33"],
			poisonsting: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rapidspin: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4E", "3E"],
			screech: ["4L36", "3L43"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			supersonic: ["4L5", "3L6"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L15"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "4L29", "3M"],
			wrap: ["4L22", "3L30"],
			wringout: ["4L43"],
		},
	},
	tentacruel: {
		inherit: true,
		learnset: {
			acid: ["4L12", "3L19"],
			attract: ["4M", "3M"],
			barrier: ["4L26", "3L38"],
			blizzard: ["4M", "3M"],
			brine: ["4M"],
			bubblebeam: ["4L19", "3L25"],
			captivate: ["4M"],
			constrict: ["4L1", "3L1"],
			cut: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L49", "3L55"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M", "4L36"],
			poisonsting: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			screech: ["4L42", "3L47"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			supersonic: ["4L1", "3L1"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L15"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "4L29", "3M"],
			wrap: ["4L22", "3L30"],
			wringout: ["4L55"],
		},
	},
	geodude: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			block: ["4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["4L1", "3T", "3L1"],
			dig: ["4M", "3M"],
			doubleedge: ["4L36", "3T", "3L46"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L29", "3M", "3L36"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L32", "3T", "3L41"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flail: ["4E"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gyroball: ["4M"],
			hammerarm: ["4E"],
			hiddenpower: ["4M", "3M"],
			magnitude: ["4L15", "3L16"],
			megapunch: ["4E", "3T", "3E"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L4", "3L6"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockblast: ["4L25", "3L31"],
			rockclimb: ["4M"],
			rockpolish: ["4M", "4L8"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L11", "3L11"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L22", "3T", "3L26"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["4L18", "3T", "3L21"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L39"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			thunderpunch: ["4T"],
			toxic: ["4M", "3M"],
		},
	},
	graveler: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["4L1", "3T", "3L1"],
			dig: ["4M", "3M"],
			doubleedge: ["4L44", "3T", "3L62"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L33", "3M", "3L45"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L38", "3T", "3L53"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gyroball: ["4M"],
			hiddenpower: ["4M", "3M"],
			magnitude: ["4L15", "3L16"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockblast: ["4L27", "3L37"],
			rockclimb: ["4M"],
			rockpolish: ["4M", "4L1"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L11", "3L1"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L22", "3T", "3L29"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["4L18", "3T", "3L21"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L49"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			thunderpunch: ["4T"],
			toxic: ["4M", "3M"],
		},
	},
	golem: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["4L1", "3T", "3L1"],
			dig: ["4M", "3M"],
			doubleedge: ["4L44", "3T", "3L62"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L33", "3M", "3L45"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L38", "3T", "3L53"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			gyroball: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ironhead: ["4T"],
			magnitude: ["4L15", "3L16"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockblast: ["4L27", "3L37"],
			rockclimb: ["4M"],
			rockpolish: ["4M", "4L1"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L11", "3L1"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L22", "3T", "3L29"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["4L18", "3T", "3L21"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L49"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			thunderpunch: ["4T"],
			toxic: ["4M", "3M"],
		},
	},
	ponyta: {
		inherit: true,
		learnset: {
			agility: ["4L33", "3L38"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T", "4L42", "3L45"],
			captivate: ["4M"],
			charm: ["4E", "3E"],
			doubleedge: ["4E", "3T", "3E"],
			doublekick: ["4E", "3E"],
			doubleteam: ["4M", "3M"],
			ember: ["4L10", "3L14"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "4L37", "3M", "3L53"],
			firespin: ["4L24", "3L25"],
			flamethrower: ["4M", "3M"],
			flamewheel: ["4L15", "4E", "3E"],
			flareblitz: ["4L46"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L5"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			horndrill: ["4E"],
			hypnosis: ["4E", "3E"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			quickattack: ["3L1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stomp: ["4L19", "3L19"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L6", "3L9"],
			takedown: ["4L28", "3L31"],
			thrash: ["4E", "3E"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	rapidash: {
		inherit: true,
		learnset: {
			agility: ["4L33", "3L38"],
			attract: ["4M", "3M"],
			batonpass: ["3S0"],
			bodyslam: ["3T"],
			bounce: ["4T", "4L47", "3L50"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "4L37", "3M", "3L63"],
			firespin: ["4L24", "3L25"],
			flamethrower: ["4M", "3M", "3S0"],
			flamewheel: ["4L15"],
			flareblitz: ["4L56"],
			frustration: ["4M", "3M"],
			furyattack: ["4L40", "3L40"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			megahorn: ["4L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			poisonjab: ["4M", "4L1"],
			protect: ["4M", "3M"],
			quickattack: ["4L1", "3L1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M", "3S0"],
			stomp: ["4L19", "3L19"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M", "3S0"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["3L1"],
			tailwhip: ["4L1", "3L1"],
			takedown: ["4L28", "3L31"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	slowpoke: {
		inherit: true,
		learnset: {
			amnesia: ["4L43", "3L36"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			bellydrum: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			block: ["4E"],
			bodyslam: ["3T"],
			brine: ["4M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L15", "3L17", "3S0"],
			curse: ["4L1", "3L1", "3S1"],
			dig: ["4M", "3M"],
			disable: ["4L20", "3L24", "3S0"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4E", "3E"],
			grassknot: ["4M"],
			growl: ["4L6", "3L6", "3S1"],
			hail: ["4M", "3M"],
			headbutt: ["4L25", "3L29", "3S0"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M"],
			mefirst: ["4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L48", "3M", "3L40"],
			psychup: ["4M", "4L57", "3T", "3L47"],
			raindance: ["4M", "4L53", "3M"],
			recycle: ["4M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "4E", "3M", "3E"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			slackoff: ["4L39"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			snore: ["4T", "4E", "3T", "3E"],
			stomp: ["4E", "3E"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S1"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			watergun: ["4L11", "3L13", "3S0"],
			waterpulse: ["4M", "4L29", "3M"],
			yawn: ["4L1", "3L1", "3S1"],
			zenheadbutt: ["4T", "4L34", "4E"],
		},
	},
	slowbro: {
		inherit: true,
		learnset: {
			amnesia: ["4L47", "3L36"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			brine: ["4M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L15", "3L17"],
			counter: ["3T"],
			curse: ["4L1", "3L1"],
			dig: ["4M", "3M"],
			disable: ["4L20", "3L24"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "3M"],
			headbutt: ["4L25", "3L29"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L54", "3M", "3L44"],
			psychup: ["4M", "4L67", "3T", "3L55"],
			raindance: ["4M", "4L61", "3M"],
			recycle: ["4M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			slackoff: ["4L41"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			watergun: ["4L11", "3L13"],
			waterpulse: ["4M", "4L29", "3M"],
			withdraw: ["4L37", "3L37"],
			yawn: ["4L1", "3L1"],
			zenheadbutt: ["4T", "4L34"],
		},
	},
	slowking: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			brine: ["4M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L15", "3L17"],
			counter: ["3T"],
			curse: ["4L1", "3L1"],
			dig: ["4M", "3M"],
			disable: ["4L20", "3L24"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L6", "3L6"],
			hail: ["4M", "3M"],
			headbutt: ["4L25", "3L29"],
			hiddenpower: ["4M", "4L1", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L39"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powergem: ["4L1"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L48", "3M", "3L40"],
			psychup: ["4M", "4L57", "3T", "3L47"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "4L43", "3T", "3L36"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			trumpcard: ["4L53"],
			watergun: ["4L11", "3L13"],
			waterpulse: ["4M", "4L29", "3M"],
			yawn: ["4L1", "3L1"],
			zenheadbutt: ["4T", "4L34"],
		},
	},
	magnemite: {
		inherit: true,
		learnset: {
			chargebeam: ["4M"],
			discharge: ["4L38"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			gyroball: ["4M", "4L49"],
			hiddenpower: ["4M", "3M"],
			irondefense: ["4T"],
			lightscreen: ["4M"],
			lockon: ["4L27", "3L32"],
			magnetbomb: ["4L30"],
			magnetrise: ["4T", "4L46"],
			metalsound: ["4L1", "3L1"],
			mimic: ["3T"],
			mirrorshot: ["4L43"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			screech: ["4L33", "3L44"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			sonicboom: ["4L14", "3L16"],
			spark: ["4L22", "3L26"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L11", "3L11"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T", "3L38"],
			tackle: ["4L1", "3L1"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thundershock: ["4L6", "3L6"],
			thunderwave: ["4M", "4L17", "3T", "3L21"],
			toxic: ["4M", "3M"],
			zapcannon: ["4L54", "3L50"],
		},
	},
	magneton: {
		inherit: true,
		learnset: {
			chargebeam: ["4M"],
			discharge: ["4L40"],
			doubleedge: ["3T", "3S0"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M", "4L54"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irondefense: ["4T"],
			lightscreen: ["4M"],
			lockon: ["4L27", "3L35"],
			magnetbomb: ["4L30"],
			magnetrise: ["4T", "4L50"],
			metalsound: ["4L1", "3L1"],
			mimic: ["3T"],
			mirrorshot: ["4L46"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M"],
			raindance: ["4M", "3M", "3S0"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			screech: ["4L34", "3L53"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			sonicboom: ["4L14", "3L16"],
			spark: ["4L22", "3L26"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L1", "3L1"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thunder: ["4M", "3M", "3S0"],
			thunderbolt: ["4M", "3M"],
			thundershock: ["4L1", "3L1"],
			thunderwave: ["4M", "4L17", "3T", "3L21"],
			toxic: ["4M", "3M"],
			triattack: ["4L1", "3L44"],
			zapcannon: ["4L60", "3L62"],
		},
	},
	magnezone: {
		inherit: true,
		learnset: {
			barrier: ["4L1"],
			chargebeam: ["4M"],
			discharge: ["4L40"],
			doubleteam: ["4M"],
			endure: ["4M"],
			explosion: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			flashcannon: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			gyroball: ["4M", "4L54"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			lightscreen: ["4M"],
			lockon: ["4L27"],
			magnetbomb: ["4L30"],
			magnetrise: ["4T", "4L50"],
			metalsound: ["4L1"],
			mirrorcoat: ["4L1"],
			mirrorshot: ["4L46"],
			naturalgift: ["4M"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			screech: ["4L34"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			sonicboom: ["4L14"],
			spark: ["4L22"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			supersonic: ["4L1"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thundershock: ["4L1"],
			thunderwave: ["4M", "4L17"],
			toxic: ["4M"],
			zapcannon: ["4L60"],
		},
	},
	farfetchd: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L13", "3M", "3S1"],
			agility: ["4L31", "3L36"],
			aircutter: ["4T", "4L21"],
			airslash: ["4L37"],
			attract: ["4M", "3M"],
			batonpass: ["3S1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			covet: ["4E"],
			curse: ["4E", "3E"],
			cut: ["4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4L43", "3L46"],
			featherdance: ["4E", "3E"],
			feint: ["4L43"],
			flail: ["4E", "3E"],
			fly: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			furyattack: ["4L7", "3L16"],
			furycutter: ["4T", "4L1", "3L26"],
			gust: ["4E", "3E"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T", "4L9", "3L21"],
			lastresort: ["4T"],
			leer: ["4L1", "3L11"],
			mimic: ["3T"],
			mirrormove: ["4E", "3E"],
			mudslap: ["4T", "4E", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4L33", "4E"],
			ominouswind: ["4T"],
			peck: ["4L1", "3L1"],
			pluck: ["4M"],
			poisonjab: ["4M", "4L1"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			quickattack: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			sandattack: ["4L1", "3L6"],
			secretpower: ["4M", "3M"],
			slash: ["4L19", "3L41", "3S1"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "4E", "3M", "3E"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "4L25", "3T", "3L31", "3S1"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["4M"],
			wish: ["3S0"],
			yawn: ["3S0"],
		},
	},
	doduo: {
		inherit: true,
		learnset: {
			acupressure: ["4L28"],
			aerialace: ["4M", "3M"],
			agility: ["4L37", "3L45"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bravebird: ["4E"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doublehit: ["4L32"],
			doubleteam: ["4M", "3M"],
			drillpeck: ["4L41", "3L37"],
			endeavor: ["4T", "4L46", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4E", "3E"],
			flail: ["4E", "3E"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L14", "3L13"],
			growl: ["4L1", "3L1"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			knockoff: ["4T"],
			mimic: ["3T"],
			mirrormove: ["4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			peck: ["4L1", "3L1"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4L19", "3L9"],
			quickattack: ["4L5", "4E", "3E"],
			rage: ["4L10", "3L25"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4E", "3E"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			triattack: ["3L21"],
			uproar: ["4T", "4L23", "3L33"],
		},
	},
	dodrio: {
		inherit: true,
		learnset: {
			acupressure: ["4L28"],
			aerialace: ["4M", "3M"],
			agility: ["4L41", "3L60", "3S0"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			batonpass: ["3S0"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drillpeck: ["4L47", "3L47", "3S0"],
			endeavor: ["4T", "4L54"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L14", "3L1"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			knockoff: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			peck: ["4L1", "3L1"],
			pluck: ["4M", "4L1"],
			protect: ["4M", "3M"],
			pursuit: ["4L19", "3L1"],
			quickattack: ["4L1"],
			rage: ["4L1", "3L25"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			triattack: ["4L34", "3L21", "3S0"],
			uproar: ["4T", "4L23", "3L38"],
		},
	},
	seel: {
		inherit: true,
		learnset: {
			aquajet: ["4L31"],
			aquaring: ["4L23"],
			aquatail: ["4T", "4L43"],
			attract: ["4M", "3M"],
			aurorabeam: ["4L27", "3L21"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M", "4L33"],
			captivate: ["4M"],
			disable: ["4E", "3E"],
			dive: ["4T", "4L41", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			encore: ["4L13", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4E", "3E"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			growl: ["4L3", "3L9"],
			hail: ["4M", "3M"],
			headbutt: ["4L1", "3L1"],
			helpinghand: ["3S0"],
			hiddenpower: ["4M", "3M"],
			horndrill: ["4E", "3E"],
			icebeam: ["4M", "4L47", "3M", "3L41", "3S0"],
			iceshard: ["4L17"],
			iciclespear: ["4E", "3E"],
			icywind: ["4T", "4L11", "3T", "3L17"],
			lick: ["4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			perishsong: ["4E", "3E"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L21", "3M", "3L29"],
			return: ["4M", "3M"],
			safeguard: ["4M", "4L51", "3M", "3L49", "3S0"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T", "4E"],
			slam: ["4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M", "3S0"],
			swagger: ["4M", "3T"],
			takedown: ["4L37", "3L37"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["4L7"],
		},
	},
	dewgong: {
		inherit: true,
		learnset: {
			aquajet: ["4L31"],
			aquaring: ["4L23"],
			aquatail: ["4T", "4L43"],
			attract: ["4M", "3M"],
			aurorabeam: ["4L27", "3L1"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M", "4L33"],
			captivate: ["4M"],
			dive: ["4T", "4L41", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			encore: ["4L13"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "3M"],
			headbutt: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "4L47", "3M", "3L51"],
			iceshard: ["4L17"],
			icywind: ["4T", "4L1", "3T", "3L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L21", "3M", "3L29"],
			return: ["4M", "3M"],
			safeguard: ["4M", "4L51", "3M", "3L64"],
			secretpower: ["4M", "3M"],
			sheercold: ["4L34", "3L34"],
			signalbeam: ["4T", "4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			takedown: ["4L37", "3L42"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	grimer: {
		inherit: true,
		learnset: {
			acidarmor: ["4L39", "3L34"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			curse: ["4E", "3E"],
			dig: ["4M", "3M"],
			disable: ["4L12", "3L8"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4E", "3T", "3E"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M", "4L28"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gunkshot: ["4T", "4L44"],
			harden: ["4L4", "3L4"],
			haze: ["4E", "3E"],
			helpinghand: ["3S0"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			imprison: ["4E", "3E"],
			lick: ["4E", "3E"],
			meanlook: ["4E", "3E"],
			memento: ["4L49", "3L53"],
			mimic: ["3T"],
			minimize: ["4L17", "3L19", "3S0"],
			mudbomb: ["4L23"],
			mudslap: ["4T", "4L7", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisongas: ["4L1", "3L1"],
			poisonjab: ["4M"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocktomb: ["4M", "3M"],
			screech: ["4L33", "3L26"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M"],
			shadowpunch: ["4E", "3E", "3S0"],
			shadowsneak: ["4E"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["4L20", "3L13"],
			sludgebomb: ["4M", "4L36", "3M", "3L43", "3S0"],
			snore: ["4T", "3T"],
			spitup: ["4E"],
			stockpile: ["4E"],
			strength: ["4M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4E"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
		},
	},
	muk: {
		inherit: true,
		learnset: {
			acidarmor: ["4L44", "3L34"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			darkpulse: ["4M"],
			dig: ["4M", "3M"],
			disable: ["4L12", "3L8"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M", "4L28"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			gunkshot: ["4T", "4L54"],
			harden: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			memento: ["4L65", "3L61"],
			mimic: ["3T"],
			minimize: ["4L17", "3L19"],
			mudbomb: ["4L23"],
			mudslap: ["4T", "4L1", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisongas: ["4L1", "3L1"],
			poisonjab: ["4M"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			screech: ["4L33", "3L26"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["4L20", "3L13"],
			sludgebomb: ["4M", "4L36", "3M", "3L47"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
		},
	},
	shellder: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			aurorabeam: ["4L32", "3L17", "3S0", "3S2"],
			barrier: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			brine: ["4M", "4L44"],
			bubblebeam: ["4E", "3E"],
			captivate: ["4M"],
			clamp: ["4L25", "3L41"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "4L49", "3M", "3L49"],
			iceshard: ["4L28"],
			iciclespear: ["4L13", "4E", "3L8", "3E", "3S0", "3S1"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L40"],
			leer: ["4L20", "3L33"],
			mimic: ["3T"],
			mudshot: ["4E"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M", "4L16", "3M", "3L25"],
			raindance: ["4M", "3M"],
			rapidspin: ["4E", "3E"],
			refresh: ["3S2"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			supersonic: ["4L8", "3L9", "3S0"],
			surf: ["4M", "3M", "3S2"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S1"],
			takedown: ["4E", "3E", "3S2"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4L37"],
			withdraw: ["4L4", "3L1", "3S0", "3S1"],
		},
	},
	cloyster: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			aurorabeam: ["4L1", "3L1"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			brine: ["4M"],
			captivate: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "4L1", "3M", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikecannon: ["4L40", "3L41"],
			spikes: ["4L28", "3L33"],
			substitute: ["4M", "3T"],
			supersonic: ["4L1", "3L1"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L1"],
			waterpulse: ["4M", "3M"],
			withdraw: ["4L1", "3L1"],
		},
	},
	gastly: {
		inherit: true,
		learnset: {
			astonish: ["4E", "3E"],
			attract: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L19", "3L21"],
			curse: ["4L12", "3L13"],
			darkpulse: ["4M", "4L36"],
			destinybond: ["4L40", "3L33"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "4L33", "3T", "3L28"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			explosion: ["4M", "4E", "3T", "3E"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "4E"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			grudge: ["4E", "3E"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L1", "3L1"],
			icepunch: ["4T", "4E"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lick: ["4L1", "3L1"],
			meanlook: ["4L8", "3L13"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["4L43", "3T", "3L41"],
			nightshade: ["4L15", "3L16"],
			ominouswind: ["4T"],
			payback: ["4M", "4L26"],
			perishsong: ["4E", "3E"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			psywave: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "4L29", "3M", "3L36"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T", "4L5", "3L8"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L22"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "4E"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T"],
			willowisp: ["4M", "4E", "3E"],
		},
	},
	haunter: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L19", "3L21"],
			curse: ["4L12", "3L13"],
			darkpulse: ["4M", "4L44"],
			destinybond: ["4L50", "3L39"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "4L39", "3T", "3L31"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L1", "3L1"],
			icepunch: ["4T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lick: ["4L1", "3L1"],
			meanlook: ["4L8", "3L13"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["4L55", "3T", "3L53"],
			nightshade: ["4L15", "3L16"],
			ominouswind: ["4T"],
			payback: ["4M", "4L28"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "4L33", "3M", "3L45"],
			shadowclaw: ["4M"],
			shadowpunch: ["4L25", "3L25"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T", "4L1", "3L1"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L22"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T"],
			willowisp: ["4M"],
		},
	},
	gengar: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L19", "3L21", "3S0"],
			counter: ["3T"],
			curse: ["4L12", "3L13", "3S0"],
			darkpulse: ["4M", "4L44"],
			destinybond: ["4L50", "3L39"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "4L39", "3T", "3L31"],
			dynamicpunch: ["3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypnosis: ["4L1", "3L1"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lick: ["4L1", "3L1"],
			meanlook: ["4L8", "3L13"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["4L55", "3T", "3L53"],
			nightshade: ["4L15", "3L16", "3S0"],
			ominouswind: ["4T"],
			payback: ["4M", "4L28"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "4L33", "3M", "3L45"],
			shadowclaw: ["4M"],
			shadowpunch: ["4L25", "3L25"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T", "4L1", "3L1", "3S0"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L22"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T"],
			willowisp: ["4M"],
		},
	},
	onix: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			bind: ["4L1", "3L8"],
			block: ["4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			curse: ["4L38"],
			defensecurl: ["4E"],
			dig: ["4M", "3M"],
			doubleedge: ["4L46", "3T", "3L56"],
			doubleteam: ["4M", "3M"],
			dragonbreath: ["4L33", "3L30"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4E", "3T", "3E"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			gyroball: ["4M"],
			harden: ["4L1", "3L19"],
			hiddenpower: ["4M", "3M"],
			ironhead: ["4T"],
			irontail: ["4M", "4L38", "3M", "3L45"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L1"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			rage: ["4L14", "3L23"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockblast: ["4E"],
			rockclimb: ["4M"],
			rockpolish: ["4M", "4L30"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L9", "3L12"],
			rocktomb: ["4M", "4L17", "3M"],
			rollout: ["4T", "4E"],
			sandstorm: ["4M", "4L22", "3M", "3L33"],
			sandtomb: ["4L41", "3L49"],
			screech: ["4L6", "3L1"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			slam: ["4L25", "3L37"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L49"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
		},
	},
	steelix: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			bind: ["4L1", "3L8"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			crunch: ["4L41", "3L49"],
			curse: ["4L38"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L46", "3T", "3L56"],
			doubleteam: ["4M", "3M"],
			dragonbreath: ["4L33", "3L30"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			firefang: ["4L1"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M"],
			harden: ["4L1", "3L19"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icefang: ["4L1"],
			ironhead: ["4T"],
			irontail: ["4M", "4L38", "3M", "3L45"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L1"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M"],
			rage: ["4L14", "3L23"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["4M", "4L30"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L9", "3L12"],
			rocktomb: ["4M", "4L17", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "4L22", "3M", "3L33"],
			screech: ["4L6", "3L1"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			slam: ["4L25", "3L37"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L49"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			thunderfang: ["4L1"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
		},
	},
	drowzee: {
		inherit: true,
		learnset: {
			assist: ["4E", "3E"],
			attract: ["4M", "3M"],
			barrier: ["4E", "3E"],
			bellydrum: ["3S0"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L9", "3L11"],
			counter: ["3T"],
			disable: ["4L7", "3L7"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "4E", "3T", "3E"],
			flash: ["4M", "3M"],
			flatter: ["4E"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L53", "3L45"],
			grassknot: ["4M"],
			headbutt: ["4L15", "3L17"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L1", "3L1"],
			icepunch: ["4T", "4E", "3T", "3E"],
			lightscreen: ["4M", "3M"],
			meditate: ["4L21", "3L27"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			nastyplot: ["4L43", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poisongas: ["4L18", "3L21"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psybeam: ["4L26"],
			psychic: ["4M", "4L40", "3M", "3L31"],
			psychocut: ["4E"],
			psychup: ["4M", "4L29", "3T", "3L37"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roleplay: ["4E", "3E"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L37", "3T", "3L41"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "4E", "3T", "3E"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			wish: ["3S0"],
			zenheadbutt: ["4T", "4L50"],
		},
	},
	hypno: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			batonpass: ["3S0"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L1", "3L1"],
			counter: ["3T"],
			disable: ["4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L69", "3L57"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			headbutt: ["4L15", "3L17"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypnosis: ["4L1", "3L1"],
			icepunch: ["4T", "3T"],
			lightscreen: ["4M", "3M"],
			meditate: ["4L21", "3L29", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			nastyplot: ["4L55"],
			naturalgift: ["4M"],
			nightmare: ["4L1", "3T", "3L1"],
			poisongas: ["4L18", "3L21"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psybeam: ["4L28"],
			psychic: ["4M", "4L50", "3M", "3L35", "3S0"],
			psychup: ["4M", "4L33", "3T", "3L43"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M", "3S0"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L45", "3T", "3L49"],
			switcheroo: ["4L1"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			zenheadbutt: ["4T", "4L64"],
		},
	},
	krabby: {
		inherit: true,
		learnset: {
			amnesia: ["4E", "3E"],
			ancientpower: ["4T", "4E"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M"],
			brine: ["4M", "4L39"],
			bubble: ["4L1", "3L1"],
			bubblebeam: ["4L15"],
			captivate: ["4M"],
			crabhammer: ["4L41", "3L45"],
			cut: ["4M", "3M"],
			dig: ["4M", "4E", "3M", "3E"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			flail: ["4L45", "4E", "3L49", "3E"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			guillotine: ["4L31", "3L34"],
			hail: ["4M", "3M"],
			harden: ["4L11", "3L16"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T", "4E", "3E"],
			leer: ["4L9", "3L5"],
			metalclaw: ["4L21"],
			mimic: ["3T"],
			mudshot: ["4L19", "3L23"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L1"],
			naturalgift: ["4M"],
			protect: ["4M", "4L29", "3M", "3L38"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			slam: ["4L35", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stomp: ["4L25", "3L27"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "4E", "3T", "3E"],
			thief: ["4M", "3M"],
			tickle: ["4E"],
			toxic: ["4M", "3M"],
			visegrip: ["4L5", "3L12"],
			waterpulse: ["4M", "3M"],
			xscissor: ["4M"],
		},
	},
	kingler: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M"],
			brine: ["4M", "4L51"],
			bubble: ["4L1", "3L1"],
			bubblebeam: ["4L15"],
			captivate: ["4M"],
			crabhammer: ["4L56", "3L57"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			flail: ["4L63", "3L65"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			guillotine: ["4L37", "3L38"],
			hail: ["4M", "3M"],
			harden: ["4L11", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			leer: ["4L9", "3L1"],
			metalclaw: ["4L21", "3L1"],
			mimic: ["3T"],
			mudshot: ["4L19", "3L23"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L1"],
			naturalgift: ["4M"],
			protect: ["4M", "4L32", "3M", "3L42"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			slam: ["4L44"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stomp: ["4L25", "3L27"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			visegrip: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			xscissor: ["4M"],
		},
	},
	voltorb: {
		inherit: true,
		learnset: {
			charge: ["4L1", "3L1"],
			chargebeam: ["4M", "4L26"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L43", "3T", "3L46"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gyroball: ["4M", "4L40"],
			hiddenpower: ["4M", "3M"],
			lightscreen: ["4M", "4L22", "3M", "3L37"],
			magnetrise: ["4T", "4L36"],
			mimic: ["3T"],
			mirrorcoat: ["4L47", "3L49", "3S0"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "4L15", "3T", "3L32"],
			screech: ["4L19", "3L8"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["4L29", "3T", "3L27"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			sonicboom: ["4L8", "3L15"],
			spark: ["4L12", "3L21", "3S0"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L33", "3T", "3L42", "3S0"],
			tackle: ["4L5", "3L1"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
		},
	},
	electrode: {
		inherit: true,
		learnset: {
			charge: ["4L1", "3L1"],
			chargebeam: ["4M", "4L26"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L51", "3T", "3L54"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M", "4L46"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			lightscreen: ["4M", "4L22", "3M", "3L41"],
			magnetrise: ["4T", "4L40"],
			mimic: ["3T"],
			mirrorcoat: ["4L57", "3L59"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "4L15", "3T", "3L34"],
			screech: ["4L19", "3L1"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["4L29", "3T", "3L27"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			sonicboom: ["4L1", "3L1"],
			spark: ["4L1", "3L21"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L35", "3T", "3L48"],
			tackle: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
		},
	},
	exeggcute: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4E", "3E"],
			attract: ["4M", "3M"],
			barrage: ["4L1", "3L1"],
			bulletseed: ["4M", "4L17", "3M"],
			captivate: ["4M"],
			confusion: ["4L27", "3L19"],
			curse: ["4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L1", "3L1"],
			ingrain: ["4E", "3E"],
			leafstorm: ["4E"],
			leechseed: ["4L11", "3L13"],
			lightscreen: ["4M", "3M"],
			luckychant: ["4E"],
			mimic: ["3T"],
			moonlight: ["4E", "3E"],
			naturalgift: ["4M", "4L37"],
			naturepower: ["4E"],
			nightmare: ["3T"],
			poisonpowder: ["4L21", "3L31"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L47", "3M"],
			psychup: ["4M", "4E", "3T", "3E"],
			reflect: ["4M", "4L7", "4E", "3M", "3L7", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			skillswap: ["4M", "3M"],
			sleeppowder: ["4L23", "3L37"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L43", "3M", "3L43"],
			strength: ["4M", "3M"],
			stunspore: ["4L19", "3L25"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["3S0"],
			swordsdance: ["4M"],
			synthesis: ["4T", "4E", "3E"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trickroom: ["4M"],
			uproar: ["4T", "4L1", "3L1"],
			wish: ["3S0"],
			worryseed: ["4T", "4L33"],
		},
	},
	exeggutor: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "3S0"],
			attract: ["4M", "3M"],
			barrage: ["4L1", "3L1"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			eggbomb: ["4L27", "3L31"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypnosis: ["4L1", "3L1", "3S0"],
			leafstorm: ["4L47"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M", "3S0"],
			psychup: ["4M", "3T"],
			reflect: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T", "4L1"],
			selfdestruct: ["3T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stomp: ["4L1", "3L19"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M"],
			synthesis: ["4T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trickroom: ["4M"],
			woodhammer: ["4L37"],
			worryseed: ["4T"],
			zenheadbutt: ["4T"],
		},
	},
	cubone: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4E", "3E"],
			attract: ["4M", "3M"],
			bellydrum: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			boneclub: ["4L7", "3L9"],
			bonemerang: ["4L21", "3L25"],
			bonerush: ["4L37", "3L41"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L43", "3T", "3L45"],
			doublekick: ["4E"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T", "4L41"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4L27", "3L33"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M", "4L33"],
			focusenergy: ["4L17", "3L21"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T"],
			growl: ["4L1", "3L1"],
			headbutt: ["4L11", "3L13"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			ironhead: ["4E"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			leer: ["4L13", "3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			perishsong: ["4E", "3E"],
			protect: ["4M", "3M"],
			rage: ["4L23", "3L29"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			skullbash: ["4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "4E", "3T", "3E"],
			tailwhip: ["4L3", "3L5"],
			thief: ["4M", "3M"],
			thrash: ["4L31", "3L37"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	marowak: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			boneclub: ["4L1", "3L1"],
			bonemerang: ["4L21", "3L25"],
			bonerush: ["4L43", "3L53"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L53", "3T", "3L61"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M", "3S0"],
			endeavor: ["4T", "4L49"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4L27", "3L39"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M", "4L37"],
			focusblast: ["4M"],
			focusenergy: ["4L17", "3L21"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			headbutt: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			leer: ["4L13", "3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			rage: ["4L23", "3L32"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T", "3S0"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sing: ["3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T", "3S0"],
			tailwhip: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thrash: ["4L33", "3L46"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	tyrogue: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			bulletpunch: ["4E"],
			captivate: ["4M"],
			counter: ["4E", "3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4L1"],
			foresight: ["4L1"],
			frustration: ["4M", "3M"],
			helpinghand: ["4T", "4L1", "4E", "3E"],
			hiddenpower: ["4M", "3M"],
			highjumpkick: ["4E", "3E"],
			machpunch: ["4E", "3E"],
			megakick: ["3T"],
			mimic: ["3T"],
			mindreader: ["4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rapidspin: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			vacuumwave: ["4T", "4E"],
		},
	},
	hitmonlee: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blazekick: ["4L41"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["4M", "4L17", "3M", "3L20"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			closecombat: ["4L53"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doublekick: ["4L1", "3L1"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "4L45", "3T", "3L41"],
			facade: ["4M", "3M"],
			feint: ["4L25"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L21", "3L21"],
			focuspunch: ["4M", "3M"],
			foresight: ["4L37", "3L36"],
			frustration: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			highjumpkick: ["4L29", "3L26", "3S0"],
			jumpkick: ["4L13", "3L16"],
			knockoff: ["4T"],
			meditate: ["4L5", "3L6"],
			megakick: ["4L49", "3T", "3L46", "3S0"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["4L33", "3L31", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4L1", "3L1"],
			reversal: ["4L57", "3L51"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollingkick: ["4L9", "3L11"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
		},
	},
	hitmonchan: {
		inherit: true,
		learnset: {
			agility: ["4L6", "3L7"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			bulletpunch: ["4L16"],
			captivate: ["4M"],
			closecombat: ["4L56"],
			cometpunch: ["4L1", "3L1"],
			counter: ["4L51", "3T", "3L50"],
			detect: ["4L46", "3L44"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feint: ["4L21"],
			firepunch: ["4T", "4L31", "3T", "3L26"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			helpinghand: ["4T", "3S0"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "4L31", "3T", "3L26"],
			machpunch: ["4L16", "3L20"],
			megakick: ["3T"],
			megapunch: ["4L41", "3T", "3L38", "3S0"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4L11", "3L13"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4L1", "3L1"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			skyuppercut: ["4L36", "3L32", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "4L31", "3T", "3L26"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T", "4L26"],
		},
	},
	hitmontop: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			agility: ["4L37", "3L37"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			closecombat: ["4L51"],
			counter: ["4L28", "3T", "3L31"],
			detect: ["4L46", "3L43"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T", "4L55", "3L49"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feint: ["4L33"],
			focusenergy: ["4L6", "3L7"],
			frustration: ["4M", "3M"],
			gyroball: ["4M", "4L42"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4L10", "3L13"],
			quickattack: ["4L15", "3L19"],
			raindance: ["4M", "3M"],
			rapidspin: ["4L24", "3L25"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4L1", "3L1"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rollingkick: ["4L1", "3L1"],
			rollout: ["4T"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			triplekick: ["4L19", "3L20"],
			twister: ["4T"],
			vacuumwave: ["4T"],
		},
	},
	lickitung: {
		inherit: true,
		learnset: {
			amnesia: ["4E"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			bellydrum: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4E", "3T", "3E"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			curse: ["4E", "3E"],
			cut: ["4M", "3M"],
			defensecurl: ["4L9", "3T", "3L12", "3S1"],
			dig: ["4M", "3M"],
			disable: ["4L25", "3L34"],
			doubleedge: ["3T", "3S1"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hammerarm: ["4E"],
			healbell: ["3S0"],
			helpinghand: ["3S1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T", "4L13", "3L18"],
			lick: ["4L1", "3L1"],
			magnitude: ["4E", "3E"],
			mefirst: ["4L37"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powerwhip: ["4L49"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			refresh: ["4L41", "3L51"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L33", "3T", "3S1"],
			sandstorm: ["4M", "3M"],
			screech: ["4L45", "3L45"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["4L29", "3L40"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			smellingsalts: ["4E", "3E"],
			snore: ["4T", "4E", "3T", "3E"],
			solarbeam: ["4M", "3M"],
			stomp: ["4L21", "3L23"],
			strength: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L5", "3L7"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			wish: ["3S0"],
			wrap: ["4L17", "3L29"],
			wringout: ["4L53"],
			zenheadbutt: ["4T"],
		},
	},
	lickilicky: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["4M"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			defensecurl: ["4L9"],
			dig: ["4M"],
			disable: ["4L25"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			explosion: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			firepunch: ["4T"],
			flamethrower: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			gyroball: ["4M", "4L57"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			irontail: ["4M"],
			knockoff: ["4T", "4L13"],
			lick: ["4L1"],
			mefirst: ["4L37"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			powerwhip: ["4L49"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			refresh: ["4L41"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			rollout: ["4T", "4L33"],
			sandstorm: ["4M"],
			screech: ["4L45"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			slam: ["4L29"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stomp: ["4L21"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			supersonic: ["4L5"],
			surf: ["4M"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			toxic: ["4M"],
			waterpulse: ["4M"],
			wrap: ["4L17"],
			wringout: ["4L53"],
			zenheadbutt: ["4T"],
		},
	},
	koffing: {
		inherit: true,
		learnset: {
			assurance: ["4L15"],
			attract: ["4M", "3M"],
			captivate: ["4M"],
			curse: ["4E"],
			darkpulse: ["4M"],
			destinybond: ["4L46", "4E", "3L45", "3E"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L37", "3T", "3L41"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			grudge: ["4E"],
			gyroball: ["4M", "4L33"],
			haze: ["4L28", "3L33"],
			hiddenpower: ["4M", "3M"],
			memento: ["4L51", "3L49"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			painsplit: ["4E", "3E"],
			payback: ["4M"],
			poisongas: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psybeam: ["4E", "3E"],
			psywave: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["4L19", "3T", "3L17"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["4L24", "3L21"],
			sludgebomb: ["4M", "4L42", "3M"],
			smog: ["4L6", "3L9"],
			smokescreen: ["4L10", "3L25"],
			snore: ["4T", "3T"],
			spite: ["4T", "4E"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			willowisp: ["4M", "4E", "3E"],
		},
	},
	weezing: {
		inherit: true,
		learnset: {
			assurance: ["4L15"],
			attract: ["4M", "3M"],
			captivate: ["4M"],
			darkpulse: ["4M"],
			destinybond: ["4L55", "3L51"],
			doublehit: ["4L33"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L40", "3T", "3L44"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M"],
			haze: ["4L28", "3L33"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			memento: ["4L63", "3L58"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisongas: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["4L19", "3T", "3L1"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["4L24", "3L21"],
			sludgebomb: ["4M", "4L48", "3M"],
			smog: ["4L1", "3L1"],
			smokescreen: ["4L1", "3L25"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			willowisp: ["4M"],
		},
	},
	rhyhorn: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E"],
			crunch: ["4E", "3E"],
			crushclaw: ["4E", "3E"],
			curse: ["4E", "3E"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonpulse: ["4M"],
			dragonrush: ["4E"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L49", "3M", "3L52"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4E"],
			flamethrower: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L13", "3L15"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["4L1", "3L1"],
			horndrill: ["4L37", "3L38"],
			icebeam: ["4M", "3M"],
			icefang: ["4E"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			magnitude: ["4E", "3E"],
			megahorn: ["4L57", "3L57"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4E", "3E"],
			roar: ["4M", "3M"],
			rockblast: ["4L25", "3L29"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4L21", "3L24"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["4L9", "3L10"],
			stoneedge: ["4M", "4L45"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "4E", "3T", "3E"],
			tailwhip: ["4L1", "3L1"],
			takedown: ["4L33", "3L43"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderfang: ["4E"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	rhydon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonpulse: ["4M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L49", "3M", "3L58", "3S0"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L1", "3L1"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			hammerarm: ["4L42"],
			helpinghand: ["3S0"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["4L1", "3L1"],
			horndrill: ["4L37", "3L38"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			megahorn: ["4L57", "3L66", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockblast: ["4L25", "3L29"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4L21", "3L24", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["4L1", "3L1"],
			stoneedge: ["4M", "4L45"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			tailwhip: ["4L1", "3L1"],
			takedown: ["4L33", "3L46"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	rhyperior: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["4M"],
			avalanche: ["4M"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L49"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			firepunch: ["4T"],
			flamethrower: ["4M"],
			flashcannon: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furyattack: ["4L1"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			hammerarm: ["4L42"],
			hiddenpower: ["4M"],
			hornattack: ["4L1"],
			horndrill: ["4L37"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			ironhead: ["4T"],
			irontail: ["4M"],
			megahorn: ["4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["4M"],
			poisonjab: ["4M", "4L1"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockblast: ["4L25"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			rockwrecker: ["4L61"],
			rollout: ["4T"],
			sandstorm: ["4M"],
			scaryface: ["4L21"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["4L1"],
			stoneedge: ["4M", "4L45"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superpower: ["4T"],
			surf: ["4M"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			tailwhip: ["4L1"],
			takedown: ["4L33"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			toxic: ["4M"],
			uproar: ["4T"],
		},
	},
	happiny: {
		inherit: true,
		learnset: {
			aromatherapy: ["4E"],
			attract: ["4M"],
			captivate: ["4M"],
			charm: ["4L1"],
			copycat: ["4L5"],
			counter: ["4E"],
			doubleteam: ["4M"],
			drainpunch: ["4M"],
			dreameater: ["4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			flamethrower: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			grassknot: ["4M"],
			gravity: ["4E"],
			hail: ["4M"],
			healbell: ["4E"],
			helpinghand: ["4T", "4E"],
			hiddenpower: ["4M"],
			icywind: ["4T"],
			lastresort: ["4T", "4E"],
			lightscreen: ["4M"],
			metronome: ["4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pound: ["4L1"],
			present: ["4E"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			refresh: ["4L9"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			substitute: ["4M", "4E"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			sweetkiss: ["4L12"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			uproar: ["4T"],
			waterpulse: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	chansey: {
		inherit: true,
		learnset: {
			aromatherapy: ["4E", "3E"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["4E", "3T"],
			defensecurl: ["4L31", "3T", "3L41"],
			doubleedge: ["4L46", "3T", "3L57"],
			doubleslap: ["4L16", "3L17"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			eggbomb: ["4L38", "3L35"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M", "4L27"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gravity: ["4E"],
			growl: ["4L1", "3L1", "3S1"],
			hail: ["4M", "3M"],
			healbell: ["4E", "3E"],
			healingwish: ["4L42"],
			helpinghand: ["4T", "4E"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lightscreen: ["4M", "4L34", "3M", "3L49"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["4E", "3T", "3E"],
			mimic: ["3T"],
			minimize: ["4L20", "3L23"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["4L1", "3L1", "3S1"],
			present: ["4E", "3E"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			refresh: ["4L9", "3L9", "3S1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["4L23", "3L29"],
			skillswap: ["4M", "3M", "3S2"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["4L12", "3T", "3L13", "3S2"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetkiss: ["3S2"],
			sweetscent: ["3S0"],
			tailwhip: ["4L5", "3L5", "3S1"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M", "3S2"],
			thunderpunch: ["4T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			wish: ["3S0"],
			zenheadbutt: ["4T"],
		},
	},
	blissey: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			defensecurl: ["4L31", "3T", "3L33"],
			doubleedge: ["4L46", "3T", "3L47"],
			doubleslap: ["4L16", "3L13"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			eggbomb: ["4L38", "3L28"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M", "4L27"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "3M"],
			healingwish: ["4L42"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lightscreen: ["4M", "4L34", "3M", "3L40"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			minimize: ["4L20", "3L18"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			refresh: ["4L9", "3L7"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["4L23", "3L23"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["4L12", "3T", "3L10"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tailwhip: ["4L5", "3L4"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T"],
		},
	},
	tangela: {
		inherit: true,
		learnset: {
			absorb: ["4L8", "3L10"],
			amnesia: ["4E", "3E"],
			ancientpower: ["4T", "4L33"],
			attract: ["4M", "3M"],
			bind: ["4L22", "3L28"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4E", "3E"],
			constrict: ["4L1", "3L1"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endeavor: ["4E"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growth: ["4L12", "3L13"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ingrain: ["4L1", "3L1", "3S0"],
			knockoff: ["4T", "4L36"],
			leafstorm: ["4E"],
			leechseed: ["4E", "3E"],
			megadrain: ["4L26", "4E", "3L31", "3E"],
			mimic: ["3T"],
			morningsun: ["3S0"],
			naturalgift: ["4M", "4L40"],
			naturepower: ["4E", "3E"],
			poisonpowder: ["4L15", "3L19"],
			powerwhip: ["4L54"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			reflect: ["4M", "4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shockwave: ["4M"],
			slam: ["4L43", "3L40"],
			sleeppowder: ["4L5", "3L4"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M", "3S0"],
			stunspore: ["4L29", "3L37"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M", "3S0"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thief: ["4M", "3M"],
			tickle: ["4L47", "3L46"],
			toxic: ["4M", "3M"],
			vinewhip: ["4L19", "3L22"],
			worryseed: ["4T"],
			wringout: ["4L50"],
		},
	},
	tangrowth: {
		inherit: true,
		learnset: {
			absorb: ["4L8"],
			aerialace: ["4M"],
			ancientpower: ["4T", "4L33", "4S0"],
			attract: ["4M"],
			bind: ["4L22"],
			block: ["4L57"],
			brickbreak: ["4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			constrict: ["4L1"],
			cut: ["4M"],
			doubleteam: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growth: ["4L12"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			ingrain: ["4L1"],
			knockoff: ["4T", "4L36"],
			megadrain: ["4L26"],
			morningsun: ["4S0"],
			mudslap: ["4T"],
			naturalgift: ["4M", "4L40", "4S0"],
			payback: ["4M"],
			poisonjab: ["4M"],
			poisonpowder: ["4L15"],
			powerwhip: ["4L54"],
			protect: ["4M"],
			psychup: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shockwave: ["4M"],
			slam: ["4L43"],
			sleeppowder: ["4L5"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			strength: ["4M"],
			stunspore: ["4L29"],
			substitute: ["4M"],
			sunnyday: ["4M", "4S0"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			synthesis: ["4T"],
			thief: ["4M"],
			tickle: ["4L47"],
			toxic: ["4M"],
			vinewhip: ["4L19"],
			worryseed: ["4T"],
			wringout: ["4L50"],
		},
	},
	kangaskhan: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bite: ["4L13", "3L7", "3S1"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			cometpunch: ["4L1", "3L1", "3S1"],
			counter: ["4E", "3T", "3E"],
			crunch: ["4L31"],
			crushclaw: ["4E", "3E"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			disable: ["4E", "3E"],
			dizzypunch: ["4L25", "3L43", "3S2"],
			doubleedge: ["4E", "3T"],
			doublehit: ["4L43"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M", "3S2"],
			endeavor: ["4T", "4E"],
			endure: ["4M", "4L34", "3T", "3L37"],
			facade: ["4M", "3M"],
			fakeout: ["4L7", "3L19"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4E", "3E"],
			focuspunch: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hammerarm: ["4E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1", "3S1"],
			megakick: ["3T"],
			megapunch: ["4L19", "3T", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T", "4L37"],
			protect: ["4M", "3M"],
			rage: ["4L22", "3L31"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4L49", "3L49"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			safeguard: ["4E", "3E"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sing: ["3S2"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			stomp: ["4E", "3E"],
			strength: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			suckerpunch: ["4T", "4L46"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tailwhip: ["4L10", "3L13", "3S2"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			wish: ["3S0"],
			yawn: ["3S0"],
		},
	},
	horsea: {
		inherit: true,
		learnset: {
			agility: ["4L23", "3L36"],
			attract: ["4M", "3M"],
			aurorabeam: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M", "4L30"],
			bubble: ["4L1", "3L1"],
			bubblebeam: ["4L18"],
			captivate: ["4M"],
			disable: ["4E", "3E"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonbreath: ["4E", "3E"],
			dragondance: ["4L38", "3L50"],
			dragonpulse: ["4M", "4L42"],
			dragonrage: ["4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			flashcannon: ["4M"],
			focusenergy: ["4L14"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L35", "3L43"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			leer: ["4L8", "3L15"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			octazooka: ["4E", "3E"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T", "4E"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["4L4", "3L8"],
			snore: ["4T", "3T"],
			splash: ["4E", "3E"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L26", "3L29"],
			waterfall: ["4M", "3M"],
			watergun: ["4L11", "3L22"],
			waterpulse: ["4M", "3M"],
		},
	},
	seadra: {
		inherit: true,
		learnset: {
			agility: ["4L23", "3L40", "3S0"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M", "4L30"],
			bubble: ["4L1", "3L1"],
			bubblebeam: ["4L18"],
			captivate: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragondance: ["4L48", "3L62"],
			dragonpulse: ["4M", "4L57"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flashcannon: ["4M"],
			focusenergy: ["4L14"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L40", "3L51"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			leer: ["4L1", "3L1", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["4L1", "3L1"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L26", "3L29", "3S0"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1", "3S0"],
			waterpulse: ["4M", "3M"],
		},
	},
	kingdra: {
		inherit: true,
		learnset: {
			agility: ["4L23", "3L40", "3S0"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["4M", "4L30"],
			bubble: ["4L1", "3L1"],
			bubblebeam: ["4L18"],
			captivate: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragondance: ["4L48", "3L62"],
			dragonpulse: ["4M", "4L57"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flashcannon: ["4M"],
			focusenergy: ["4L14"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L40", "3L51"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			leer: ["4L1", "3L1", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["4L1", "3L1"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L26", "3L29", "3S0"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1", "3S0"],
			waterpulse: ["4M", "3M"],
			yawn: ["4L1"],
		},
	},
	goldeen: {
		inherit: true,
		learnset: {
			agility: ["4L47", "3L52"],
			aquaring: ["4L27"],
			aquatail: ["4T", "4E"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			captivate: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4L21", "3L24"],
			frustration: ["4M", "3M"],
			furyattack: ["4L31", "3L29"],
			furycutter: ["4T"],
			hail: ["4M", "3M"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["4L11", "3L15"],
			horndrill: ["4L41", "3L43"],
			hydropump: ["4E", "3E"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			megahorn: ["4L51", "3L57"],
			mimic: ["3T"],
			mudslap: ["4T", "4E"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			peck: ["4L1", "3L1"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			psybeam: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			supersonic: ["4L7", "3L10"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "4L37", "3M", "3L38"],
			waterpulse: ["4M", "4L17", "3M"],
			watersport: ["4L1", "3L1"],
		},
	},
	seaking: {
		inherit: true,
		learnset: {
			agility: ["4L56", "3L61"],
			aquaring: ["4L27"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			captivate: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4L21", "3L24"],
			frustration: ["4M", "3M"],
			furyattack: ["4L31", "3L29"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["4L11", "3L15"],
			horndrill: ["4L47", "3L49"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			megahorn: ["4L63", "3L69"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["4L1", "3L1"],
			poisonjab: ["4M", "4L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			supersonic: ["4L1", "3L1"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "4L40", "3M", "3L41"],
			waterpulse: ["4M", "4L17", "3M"],
			watersport: ["4L1", "3L1"],
		},
	},
	staryu: {
		inherit: true,
		learnset: {
			blizzard: ["4M", "3M"],
			brine: ["4M"],
			bubblebeam: ["4L28", "3L28"],
			camouflage: ["4L19", "3L19"],
			cosmicpower: ["4L51", "3L42", "3S0"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			gyroball: ["4M", "4L37"],
			hail: ["4M", "3M"],
			harden: ["4L1", "3L1", "3S1"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L55", "3L46", "3S0"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			lightscreen: ["4M", "4L42", "3M", "3L37", "3S0"],
			mimic: ["3T"],
			minimize: ["4L33", "3L33", "3S0"],
			naturalgift: ["4M"],
			powergem: ["4L46"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rapidspin: ["4L10", "3L10", "3S1"],
			recover: ["4L15", "3L15", "3S1"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L24", "3T", "3L24"],
			tackle: ["4L1", "3L1"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			waterfall: ["4M", "3M"],
			watergun: ["4L6", "3L6", "3S1"],
			waterpulse: ["4M", "3M"],
		},
	},
	starmie: {
		inherit: true,
		learnset: {
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			brine: ["4M"],
			confuseray: ["4L28", "3L33"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gyroball: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M", "3S0"],
			icywind: ["4T", "3T"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rapidspin: ["4L1", "3L1"],
			recover: ["4L1", "3L1", "3S0"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L1", "3T", "3L1"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			twister: ["4T"],
			waterfall: ["4M", "3M", "3S0"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	mimejr: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			barrier: ["4L1"],
			batonpass: ["4L46"],
			brickbreak: ["4M"],
			calmmind: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4E"],
			confuseray: ["4E"],
			confusion: ["4L1"],
			copycat: ["4L4"],
			doubleslap: ["4L15"],
			doubleteam: ["4M"],
			drainpunch: ["4M"],
			dreameater: ["4M"],
			encore: ["4L11"],
			endure: ["4M"],
			facade: ["4M"],
			fakeout: ["4E"],
			flash: ["4M"],
			fling: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			futuresight: ["4E"],
			grassknot: ["4M"],
			healingwish: ["4E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hypnosis: ["4E"],
			lightscreen: ["4M", "4L22"],
			meditate: ["4L8"],
			mimic: ["4L18", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			psybeam: ["4L25"],
			psychic: ["4M", "4L39"],
			psychup: ["4M", "4E"],
			raindance: ["4M"],
			recycle: ["4M", "4L32"],
			reflect: ["4M", "4L22"],
			rest: ["4M"],
			return: ["4M"],
			roleplay: ["4L43"],
			safeguard: ["4M", "4L50"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			substitute: ["4M", "4L29"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			taunt: ["4M"],
			teeterdance: ["4E"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			tickle: ["4L1"],
			torment: ["4M"],
			toxic: ["4M"],
			trick: ["4T", "4L36", "4E"],
			trickroom: ["4M"],
			uproar: ["4T"],
			wakeupslap: ["4E"],
		},
	},
	mrmime: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M", "3M"],
			barrier: ["4L1", "3L1"],
			batonpass: ["4L46", "3L47"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4E"],
			confusion: ["4L1", "3L5"],
			copycat: ["4L4"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleslap: ["4L15", "3L15"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			encore: ["4L11", "3L25", "3S0"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			fakeout: ["4E", "3E"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			followme: ["3S0"],
			frustration: ["4M", "3M"],
			futuresight: ["4E", "3E"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			guardswap: ["4L1"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypnosis: ["4E", "3E"],
			icepunch: ["4T", "3T"],
			irondefense: ["4T"],
			lightscreen: ["4M", "4L22", "3M", "3L19"],
			magicalleaf: ["4L1", "3L22"],
			meditate: ["4L8", "3L12"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["4L18", "4E", "3T", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["4M"],
			powerswap: ["4L1"],
			protect: ["4M", "3M"],
			psybeam: ["4L25", "3L29"],
			psychic: ["4M", "4L39", "3M", "3L43", "3S0"],
			psychup: ["4M", "4E", "3T", "3E"],
			raindance: ["4M", "3M"],
			recycle: ["4M", "4L32", "3L33"],
			reflect: ["4M", "4L22", "3M", "3L19"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roleplay: ["4L43", "3L40"],
			safeguard: ["4M", "4L50", "3M", "3L50"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "4L29", "3T", "3L8"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			teeterdance: ["4E"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T", "3S0"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T", "4L36", "4E", "3L36", "3E"],
			trickroom: ["4M"],
			wakeupslap: ["4E"],
			zenheadbutt: ["4T"],
		},
	},
	scyther: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L17", "3L21"],
			airslash: ["4L53"],
			attract: ["4M", "3M"],
			batonpass: ["4E", "3E"],
			brickbreak: ["4M"],
			bugbuzz: ["4E"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E"],
			cut: ["4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doublehit: ["4L49"],
			doubleteam: ["4M", "4L37", "3M", "3L41"],
			endure: ["4M", "4E", "3T", "3E"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4L13", "3L16"],
			feint: ["4L61"],
			focusenergy: ["4L5", "3L6", "3S0"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L25", "3T", "3L46"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			knockoff: ["4T"],
			leer: ["4L1", "3L1", "3S0"],
			lightscreen: ["4E", "3E"],
			mimic: ["3T"],
			morningsun: ["3S1"],
			naturalgift: ["4M"],
			nightslash: ["4L45", "4E"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			pursuit: ["4L9", "3L11"],
			quickattack: ["4L1", "3L1", "3S0"],
			raindance: ["4M", "3M"],
			razorwind: ["4L33", "4E", "3E", "3S1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4E", "3E"],
			rocksmash: ["4M", "3M"],
			roost: ["4M"],
			safeguard: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M", "4E", "3E", "3S1"],
			slash: ["4L29", "3L31", "3S1"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "4L57", "3T", "3L36"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uturn: ["4M"],
			vacuumwave: ["4L1"],
			wingattack: ["4L21", "3L26"],
			xscissor: ["4M", "4L41"],
		},
	},
	scizor: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L17", "4S1", "3L21"],
			attract: ["4M", "3M"],
			brickbreak: ["4M"],
			bulletpunch: ["4L1"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doublehit: ["4L49"],
			doubleteam: ["4M", "3M", "3L41"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4L13", "3L16"],
			feint: ["4L61"],
			flashcannon: ["4M"],
			fling: ["4M"],
			focusenergy: ["4L5", "3L6"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L25", "3T", "3L46", "3S0"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irondefense: ["4T", "4L37", "4S1", "3L41"],
			ironhead: ["4T", "4L53"],
			knockoff: ["4T"],
			leer: ["4L1", "3L1"],
			metalclaw: ["4L21", "3L26", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["4L45"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			pursuit: ["4L9", "3L11"],
			quickattack: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			razorwind: ["4L33"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			roost: ["4M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M"],
			slash: ["4L29", "3L31", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "4L57", "4S1", "3T", "3L36", "3S0"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uturn: ["4M"],
			xscissor: ["4M", "4L41", "4S1"],
		},
	},
	smoochum: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			avalanche: ["4M", "4L31"],
			blizzard: ["4M", "4L45", "3M", "3L57"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L15", "3L21"],
			copycat: ["4L38"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4E", "3E"],
			faketears: ["4L25", "3L37"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			hail: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "4E", "3T", "3E"],
			icywind: ["4T", "3T"],
			lick: ["4L5", "3L1"],
			lightscreen: ["4M", "3M"],
			luckychant: ["4L28"],
			meanlook: ["4L21", "3L33"],
			meditate: ["4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["4M"],
			perishsong: ["4L41", "3L49"],
			pound: ["4L1", "3L1"],
			powdersnow: ["4L11", "3L13"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L35", "3M", "3L45"],
			psychup: ["4M", "4E", "3T", "3E"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["4L18", "3L25"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			sweetkiss: ["4L8", "3L9"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			wish: ["4E", "3E"],
			zenheadbutt: ["4T"],
		},
	},
	jynx: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			avalanche: ["4M", "4L33"],
			blizzard: ["4M", "4L55", "3M", "3L67"],
			bodyslam: ["4L39", "3T", "3L51"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleslap: ["4L15", "3L21"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			faketears: ["4L25", "3L41"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hail: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "4L18", "3T", "3L25"],
			icywind: ["4T", "3T"],
			lick: ["4L1", "3L1"],
			lightscreen: ["4M", "3M"],
			lovelykiss: ["4L1", "3L1"],
			meanlook: ["4L21", "3L35"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["4M"],
			perishsong: ["4L49", "3L57"],
			pound: ["4L1", "3L1"],
			powdersnow: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			wakeupslap: ["4L28"],
			waterpulse: ["4M", "3M"],
			wringout: ["4L44"],
			zenheadbutt: ["4T"],
		},
	},
	elekid: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			barrier: ["4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			crosschop: ["4E", "3E", "3S0"],
			discharge: ["4L34"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["4E", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "4E", "3T", "3E", "3S0"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "4E", "3T", "3E", "3S0"],
			karatechop: ["4E", "3E"],
			leer: ["4L1", "3L1"],
			lightscreen: ["4M", "4L25", "3M", "3L17"],
			lowkick: ["4L10"],
			magnetrise: ["4T"],
			meditate: ["4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			quickattack: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollingkick: ["4E", "3E"],
			screech: ["4L43", "3L33"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "4L19", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L16", "3T", "3L25"],
			thief: ["4M", "3M"],
			thunder: ["4M", "4L46", "3M", "3L49"],
			thunderbolt: ["4M", "4L37", "3M", "3L41"],
			thunderpunch: ["4T", "4L28", "3T", "3L9", "3S0"],
			thundershock: ["4L7"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	electabuzz: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			crosschop: ["3S1"],
			discharge: ["4L37"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			followme: ["3S1"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1", "3S0"],
			lightscreen: ["4M", "4L25", "4S2", "3M", "3L17"],
			lowkick: ["4L10", "4S2"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			quickattack: ["4L1", "3L1", "3S0"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			screech: ["4L52", "3L36"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "4L19", "4S2", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L16", "3T", "3L25"],
			thief: ["4M", "3M"],
			thunder: ["4M", "4L58", "3M", "3L58"],
			thunderbolt: ["4M", "4L43", "3M", "3L47", "3S1"],
			thunderpunch: ["4T", "4L28", "4S2", "3T", "3L1", "3S0"],
			thundershock: ["4L1"],
			thunderwave: ["4M", "3T", "3S1"],
			toxic: ["4M", "3M"],
		},
	},
	electivire: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			crosschop: ["4S0"],
			dig: ["4M"],
			discharge: ["4L37", "4S1"],
			doubleteam: ["4M"],
			earthquake: ["4M", "4S0"],
			endure: ["4M"],
			facade: ["4M"],
			firepunch: ["4T", "4L1"],
			flamethrower: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M", "4L67"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icepunch: ["4T", "4S0"],
			irontail: ["4M"],
			leer: ["4L1"],
			lightscreen: ["4M", "4L25", "4S1"],
			lowkick: ["4L1"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			quickattack: ["4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			screech: ["4L52"],
			secretpower: ["4M"],
			shockwave: ["4M", "4L19"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			swagger: ["4M"],
			swift: ["4T", "4L16"],
			taunt: ["4M"],
			thief: ["4M"],
			thunder: ["4M", "4L58"],
			thunderbolt: ["4M", "4L43", "4S1"],
			thunderpunch: ["4T", "4L28", "4S0", "4S1"],
			thundershock: ["4L1"],
			thunderwave: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
		},
	},
	magby: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			barrier: ["4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L25", "3L43"],
			counter: ["3T"],
			crosschop: ["4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["4E", "3T"],
			ember: ["4L7", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L16"],
			fireblast: ["4M", "4L46", "3M", "3L49"],
			firepunch: ["4T", "4L28", "3T", "3L19"],
			firespin: ["4L19"],
			flamethrower: ["4M", "4L37", "3M", "3L37"],
			flareblitz: ["4E"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			karatechop: ["4E", "3E"],
			lavaplume: ["4L34"],
			leer: ["4L1", "3L7"],
			machpunch: ["4E"],
			megakick: ["3T"],
			megapunch: ["4E", "3T", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			smog: ["4L1", "3L13"],
			smokescreen: ["4L10", "3L25"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4L43", "3M", "3L31"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "4E", "3T", "3E"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			willowisp: ["4M"],
		},
	},
	magmar: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L25", "4S2", "3L49"],
			counter: ["3T"],
			crosschop: ["3S1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			ember: ["4L1", "3L1", "3S0"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L16"],
			fireblast: ["4M", "4L54", "3M", "3L57", "3S1"],
			firepunch: ["4T", "4L28", "4S2", "3T", "3L1", "3S0"],
			firespin: ["4L19", "4S2"],
			flamethrower: ["4M", "4L41", "3M", "3L41"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			followme: ["3S1"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lavaplume: ["4L36"],
			leer: ["4L1", "3L1", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			smog: ["4L1", "3L1", "3S0"],
			smokescreen: ["4L10", "4S2", "3L25"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4L49", "3M", "3L33"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T", "3S1"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	magmortar: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			confuseray: ["4L25", "4S1"],
			doubleteam: ["4M"],
			earthquake: ["4M"],
			ember: ["4L1"],
			endure: ["4M"],
			facade: ["4M"],
			feintattack: ["4L16"],
			fireblast: ["4M", "4L58"],
			firepunch: ["4T", "4L28", "4S1"],
			firespin: ["4L19"],
			flamethrower: ["4M", "4L43", "4S0", "4S1"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M", "4L67", "4S0"],
			irontail: ["4M"],
			lavaplume: ["4L37", "4S1"],
			leer: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["4M"],
			protect: ["4M"],
			psychic: ["4M", "4S0"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			smog: ["4L1"],
			smokescreen: ["4L1"],
			snore: ["4T"],
			solarbeam: ["4M", "4S0"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M", "4L52"],
			swagger: ["4M"],
			taunt: ["4M"],
			thief: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T", "4L1"],
			torment: ["4M"],
			toxic: ["4M"],
			willowisp: ["4M"],
		},
	},
	pinsir: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bind: ["4L4", "3L7"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "4L21", "3M", "3L31"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			closecombat: ["4E"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4E", "3E", "3S0"],
			feint: ["4E"],
			feintattack: ["4E", "3E"],
			flail: ["4E", "3E"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4E", "3E"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			guillotine: ["4L47", "3L37", "3S0"],
			harden: ["4L13", "3L19"],
			helpinghand: ["3S0"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4L18", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["4L8", "3T", "3L13"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			submission: ["4L42", "3L43", "3S0"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T", "4L52"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "4L38", "3T", "3L49"],
			thief: ["4M", "3M"],
			thrash: ["4L35"],
			toxic: ["4M", "3M"],
			visegrip: ["4L1", "3L1"],
			vitalthrow: ["4L25"],
			xscissor: ["4M", "4L30"],
		},
	},
	tauros: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T", "3S2"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M", "3S2"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M", "4L55"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["4L8", "3L8", "3S0", "3S1"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["4M", "4L24"],
			protect: ["4M", "3M"],
			pursuit: ["4L15", "3L19", "3S0"],
			rage: ["4L5", "3L4", "3S0", "3S1"],
			raindance: ["4M", "3M"],
			refresh: ["3S2"],
			rest: ["4M", "4L19", "3M", "3L34"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4L11", "3L13", "3S0"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "4L41", "3T", "3L26"],
			tackle: ["4L1", "3L1", "3S1"],
			tailwhip: ["4L3", "3L1", "3S1", "3S2"],
			takedown: ["4L35", "3L53"],
			thrash: ["4L48", "3L43"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T", "4L29"],
		},
	},
	magikarp: {
		inherit: true,
		learnset: {
			bounce: ["4T"],
			flail: ["4L30", "3L30"],
			splash: ["4L1", "4S0", "4S1", "4S2", "4S3", "4S4", "3L1"],
			tackle: ["4L15", "3L15"],
		},
	},
	gyarados: {
		inherit: true,
		learnset: {
			aquatail: ["4T", "4L35"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bite: ["4L20", "3L20"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["4M"],
			captivate: ["4M"],
			darkpulse: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragondance: ["4L44", "3L50"],
			dragonpulse: ["4M"],
			dragonrage: ["4L23", "3L25"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L41", "3L40"],
			hyperbeam: ["4M", "4L47", "3M", "3L55"],
			icebeam: ["4M", "3M"],
			icefang: ["4L32"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			leer: ["4L26", "3L30"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "4L38", "3M", "3L45"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thrash: ["4L1", "3L1"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L29", "3L35"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	lapras: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4E"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M", "3S0"],
			bodyslam: ["4L18", "3T", "3L13"],
			brine: ["4M", "4L37"],
			captivate: ["4M"],
			confuseray: ["4L7", "3L19"],
			curse: ["4E", "3E"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragondance: ["4E", "3E"],
			dragonpulse: ["4M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fissure: ["4E"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "3M"],
			healbell: ["3S0"],
			hiddenpower: ["4M", "3M"],
			horndrill: ["4E", "3E"],
			hydropump: ["4L49", "3L49", "3S0"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "4L32", "3M", "3L31"],
			iceshard: ["4L10"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mist: ["4L4", "3L7"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			outrage: ["4T"],
			perishsong: ["4L27", "3L25"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			raindance: ["4M", "4L22", "3M", "3L37", "3S0"],
			refresh: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			safeguard: ["4M", "4L43", "3M", "3L43"],
			secretpower: ["4M", "3M"],
			sheercold: ["4L55", "3L55"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["4L1", "3L1"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			tickle: ["4E", "3E"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "4L14", "3M"],
			whirlpool: ["4E"],
			zenheadbutt: ["4T"],
		},
	},
	ditto: {
		inherit: true,
		learnset: {
			transform: ["4L1", "3L1"],
		},
	},
	eevee: {
		inherit: true,
		learnset: {
			attract: ["4M", "4S0", "3M"],
			batonpass: ["4L36", "3L36"],
			bite: ["4L29", "4S0", "3L30"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["4E", "3E"],
			covet: ["4E", "4S0"],
			curse: ["4E", "3E"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "4E", "3T", "3E"],
			facade: ["4M", "3M"],
			faketears: ["4E"],
			flail: ["4E", "4S1", "3E"],
			frustration: ["4M", "3M"],
			growl: ["4L15", "3L16"],
			helpinghand: ["4T", "4L1", "4S0", "3L1"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "4S1", "3M"],
			lastresort: ["4T", "4L50"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L22", "4S1", "3L23"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			sandattack: ["4L8", "3L8"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			takedown: ["4L43", "3L42"],
			tickle: ["4E", "3E"],
			toxic: ["4M", "3M"],
			trumpcard: ["4L57", "4S1"],
			wish: ["4E", "3E"],
			yawn: ["4E"],
		},
	},
	vaporeon: {
		inherit: true,
		learnset: {
			acidarmor: ["4L64", "3L47"],
			aquaring: ["4L43"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			aurorabeam: ["4L36", "3L36"],
			bite: ["4L29", "3L30"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			captivate: ["4M"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			haze: ["4L57", "3L42"],
			helpinghand: ["4T", "4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L71", "3L52"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T", "4L50"],
			mimic: ["3T"],
			muddywater: ["4L78"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L22", "3L23"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M"],
			sandattack: ["4L8", "3L8"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L15", "3L16"],
			waterpulse: ["4M", "3M"],
		},
	},
	jolteon: {
		inherit: true,
		learnset: {
			agility: ["4L64", "3L47"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			dig: ["4M", "3M"],
			discharge: ["4L78"],
			doubleedge: ["3T"],
			doublekick: ["4L29", "3L30"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			helpinghand: ["4T", "4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T", "4L50"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pinmissile: ["4L36", "3L36"],
			protect: ["4M", "3M"],
			quickattack: ["4L22", "3L23"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M"],
			sandattack: ["4L8", "3L8"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			thunder: ["4M", "4L71", "3M", "3L52"],
			thunderbolt: ["4M", "3M"],
			thunderfang: ["4L43"],
			thundershock: ["4L15", "3L16"],
			thunderwave: ["4M", "4L57", "3T", "3L42"],
			toxic: ["4M", "3M"],
		},
	},
	flareon: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bite: ["4L29", "3L30"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			ember: ["4L15", "3L16"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "4L71", "3M"],
			firefang: ["4L43"],
			firespin: ["4L36", "3L36"],
			flamethrower: ["4M", "3M", "3L52"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			heatwave: ["4T"],
			helpinghand: ["4T", "4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T", "4L50"],
			lavaplume: ["4L78"],
			leer: ["3L47"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			quickattack: ["4L22", "3L23"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M"],
			sandattack: ["4L8", "3L8"],
			scaryface: ["4L64"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smog: ["4L57", "3L42"],
			snore: ["4T", "3T"],
			strength: ["4M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	espeon: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L15", "3L16"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L43"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T", "4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T", "4L50"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			morningsun: ["4L71", "3L52", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powerswap: ["4L78"],
			protect: ["4M", "3M"],
			psybeam: ["4L36", "3L36", "3S0"],
			psychic: ["4M", "4L64", "3M", "3L47", "3S0"],
			psychup: ["4M", "4L57", "3T", "3L42", "3S0"],
			quickattack: ["4L22", "3L23"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			sandattack: ["4L8", "3L8"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L29", "3T", "3L30"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	umbreon: {
		inherit: true,
		learnset: {
			assurance: ["4L43"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confuseray: ["4L29", "3L30"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L36", "3L36", "3S0"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			guardswap: ["4L78"],
			helpinghand: ["4T", "4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T", "4L50"],
			meanlook: ["4L57", "3L42", "3S0"],
			mimic: ["3T"],
			moonlight: ["4L71", "3L52", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			pursuit: ["4L15", "3L16"],
			quickattack: ["4L22", "3L23"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			sandattack: ["4L8", "3L8"],
			screech: ["4L64", "3L47", "3S0"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
		},
	},
	leafeon: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigadrain: ["4M", "4L43"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			grasswhistle: ["4L57"],
			helpinghand: ["4T", "4L1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["4T", "4L50"],
			leafblade: ["4L71"],
			magicalleaf: ["4L36"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			quickattack: ["4L22"],
			raindance: ["4M"],
			razorleaf: ["4L15"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rocksmash: ["4M"],
			sandattack: ["4L8"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M", "4L64"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M", "4L78"],
			synthesis: ["4T", "4L29"],
			tackle: ["4L1"],
			tailwhip: ["4L1"],
			toxic: ["4M"],
			worryseed: ["4T"],
			xscissor: ["4M"],
		},
	},
	glaceon: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["4M"],
			avalanche: ["4M"],
			barrier: ["4L78"],
			bite: ["4L29"],
			blizzard: ["4M", "4L71"],
			captivate: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			hail: ["4M", "4L64"],
			helpinghand: ["4T", "4L1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icefang: ["4L43"],
			iceshard: ["4L36"],
			icywind: ["4T", "4L15"],
			irontail: ["4M"],
			lastresort: ["4T", "4L50"],
			mirrorcoat: ["4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			quickattack: ["4L22"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rocksmash: ["4M"],
			sandattack: ["4L8"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			tailwhip: ["4L1"],
			toxic: ["4M"],
			waterpulse: ["4M"],
		},
	},
	porygon: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L12", "3L9"],
			blizzard: ["4M", "3M"],
			chargebeam: ["4M"],
			conversion: ["4L1", "3L1"],
			conversion2: ["4L1", "3L1"],
			discharge: ["4L40"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lockon: ["4L45", "3L32"],
			magiccoat: ["4L56"],
			magnetrise: ["4L23"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psybeam: ["4L7", "3L12"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recover: ["4L18", "3L20"],
			recycle: ["4M", "4L34", "3L44"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sharpen: ["4L1", "3L24"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T", "4L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			triattack: ["4L51", "3L36"],
			trick: ["4T"],
			trickroom: ["4M"],
			zapcannon: ["4L62", "3L48"],
			zenheadbutt: ["4T"],
		},
	},
	porygon2: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L12", "3L9"],
			blizzard: ["4M", "3M"],
			chargebeam: ["4M"],
			conversion: ["4L1", "3L1"],
			conversion2: ["4L1", "3L1"],
			defensecurl: ["4L1", "3T", "3L24"],
			discharge: ["4L40"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L67", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lockon: ["4L45", "3L32"],
			magiccoat: ["4L56"],
			magnetrise: ["4L23"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psybeam: ["4L7", "3L12"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recover: ["4L18", "3L20"],
			recycle: ["4M", "4L34", "3L44"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T", "4L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			triattack: ["4L51", "3L36"],
			trick: ["4T"],
			trickroom: ["4M"],
			zapcannon: ["4L62", "3L48"],
			zenheadbutt: ["4T"],
		},
	},
	porygonz: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			agility: ["4L12"],
			blizzard: ["4M"],
			chargebeam: ["4M"],
			conversion: ["4L1"],
			conversion2: ["4L1"],
			darkpulse: ["4M"],
			discharge: ["4L40"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			embargo: ["4M", "4L34"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M", "4L67"],
			icebeam: ["4M"],
			icywind: ["4T"],
			irontail: ["4M"],
			lastresort: ["4T"],
			lockon: ["4L45"],
			magiccoat: ["4L56"],
			magnetrise: ["4L23"],
			nastyplot: ["4L1"],
			naturalgift: ["4M"],
			protect: ["4M"],
			psybeam: ["4L7"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recover: ["4L18"],
			recycle: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T", "4L29"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			triattack: ["4L51"],
			trick: ["4T"],
			trickroom: ["4M", "4L1"],
			uproar: ["4T"],
			zapcannon: ["4L62"],
			zenheadbutt: ["4T"],
		},
	},
	omanyte: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L37", "3L49"],
			attract: ["4M", "3M"],
			aurorabeam: ["4E", "3E"],
			bite: ["4L7", "3L13"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M", "4L28"],
			bubblebeam: ["4E", "3E"],
			captivate: ["4M"],
			constrict: ["4L1", "3L1"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gyroball: ["4M"],
			hail: ["4M", "3M"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L52", "3L55"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T", "4E"],
			leer: ["4L19", "3L31"],
			mimic: ["3T"],
			mudshot: ["4L25", "3L25"],
			naturalgift: ["4M"],
			protect: ["4M", "4L34", "3M", "3L37"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockblast: ["4L46"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L16", "3T"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			slam: ["4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikes: ["4E", "3E"],
			stealthrock: ["4M"],
			substitute: ["4M", "3T"],
			supersonic: ["4E", "3E"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			tickle: ["4L43", "3L43"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4E"],
			waterfall: ["4M", "3M"],
			watergun: ["4L10", "3L19"],
			waterpulse: ["4M", "3M"],
			withdraw: ["4L1", "3L1"],
			wringout: ["4E"],
		},
	},
	omastar: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L37", "3L55"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M", "4L28"],
			captivate: ["4M"],
			constrict: ["4L1", "3L1"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L67", "3L65"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			leer: ["4L19", "3L31"],
			mimic: ["3T"],
			mudshot: ["4L25", "3L25"],
			naturalgift: ["4M"],
			protect: ["4M", "4L34", "3M", "3L37"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockblast: ["4L56"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L16", "3T"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikecannon: ["4L40", "3L40"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			tickle: ["4L48", "3L46"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L10", "3L1"],
			waterpulse: ["4M", "3M"],
			withdraw: ["4L1", "3L1"],
		},
	},
	kabuto: {
		inherit: true,
		learnset: {
			absorb: ["4L6", "3L13"],
			aerialace: ["3M"],
			ancientpower: ["4T", "4L46", "3L55"],
			aquajet: ["4L31"],
			attract: ["4M", "3M"],
			aurorabeam: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bubblebeam: ["4E", "3E"],
			captivate: ["4M"],
			confuseray: ["4E", "3E"],
			dig: ["4M", "4E", "3M", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			endure: ["4M", "4L26", "3T", "3L37"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			hail: ["4M", "3M"],
			harden: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "4E", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T", "4E", "3E"],
			leer: ["4L11", "3L19"],
			megadrain: ["4L36", "3L49"],
			metalsound: ["4L41", "3L43"],
			mimic: ["3T"],
			mudshot: ["4L16", "4E", "3L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rapidspin: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandattack: ["4L21", "3L31"],
			sandstorm: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			screech: ["4E"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			wringout: ["4L51"],
		},
	},
	kabutops: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1"],
			aerialace: ["4M", "3M"],
			ancientpower: ["4T", "4L54", "3L65"],
			aquajet: ["4L31"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			brine: ["4M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			endure: ["4M", "4L26", "3T", "3L37"],
			facade: ["4M", "3M"],
			feint: ["4L1"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T", "3L1"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			harden: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			leer: ["4L1", "3L1"],
			megadrain: ["4L36", "3L55"],
			megakick: ["3T"],
			metalsound: ["4L45", "3L46"],
			mimic: ["3T"],
			mudshot: ["4L16", "3L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["4L72"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandattack: ["4L21", "3L31"],
			sandstorm: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			slash: ["4L40", "3L40"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			wringout: ["4L63"],
			xscissor: ["4M"],
		},
	},
	aerodactyl: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L17", "3L8"],
			aircutter: ["4T"],
			ancientpower: ["4T", "4L25", "3L29"],
			aquatail: ["4T"],
			assurance: ["4E"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L15"],
			captivate: ["4M"],
			crunch: ["4L33"],
			curse: ["4E", "3E"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonbreath: ["4E", "3E"],
			dragonclaw: ["4M", "3M"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4L1"],
			flamethrower: ["4M", "3M"],
			fly: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M", "4L73"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L57", "3M", "3L50"],
			icefang: ["4L1"],
			ironhead: ["4T", "4L49"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L9", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L65", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			roost: ["4M"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4L1", "3L36"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			steelwing: ["4M", "4E", "3M", "3E"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L1", "3L22"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["4L41", "3L43"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderfang: ["4L1"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			whirlwind: ["4E", "3E"],
			wingattack: ["4L1", "3L1"],
		},
	},
	munchlax: {
		inherit: true,
		learnset: {
			amnesia: ["4L9"],
			attract: ["4M"],
			blizzard: ["4M"],
			bodyslam: ["4L33"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			charm: ["4E"],
			curse: ["4E", "4S1"],
			defensecurl: ["4L4", "4S0"],
			doubleedge: ["4E"],
			doubleteam: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			firepunch: ["4T"],
			flamethrower: ["4M"],
			fling: ["4M", "4L36"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			gunkshot: ["4T"],
			hiddenpower: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			lastresort: ["4T", "4L49"],
			lick: ["4L12", "4E"],
			metronome: ["4L1", "4S0", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["4M", "4L44"],
			odorsleuth: ["4L1", "4S1"],
			protect: ["4M"],
			psychic: ["4M"],
			pursuit: ["4E"],
			raindance: ["4M"],
			recycle: ["4M", "4L17"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			rollout: ["4T", "4L41"],
			sandstorm: ["4M"],
			screech: ["4L20"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			selfdestruct: ["4S0"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stockpile: ["4L25"],
			strength: ["4M"],
			substitute: ["4M", "4E"],
			sunnyday: ["4M"],
			superpower: ["4T"],
			surf: ["4M"],
			swagger: ["4M"],
			swallow: ["4L28"],
			tackle: ["4L1", "4S0", "4S1"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			toxic: ["4M"],
			uproar: ["4T"],
			waterpulse: ["4M"],
			whirlwind: ["4E"],
			zenheadbutt: ["4T", "4E"],
		},
	},
	snorlax: {
		inherit: true,
		learnset: {
			amnesia: ["4L9", "3L5"],
			attract: ["4M", "3M"],
			bellydrum: ["4L17", "3L13"],
			blizzard: ["4M", "3M"],
			block: ["4L36", "3L37"],
			bodyslam: ["4L33", "3T", "3L33", "3S0"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["4E", "3E"],
			counter: ["3T"],
			covet: ["3L42"],
			crunch: ["4L44"],
			curse: ["4E", "3E", "3S0"],
			defensecurl: ["4L4", "3T", "3L9"],
			doubleedge: ["4E", "3T", "3E"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			fissure: ["4E", "3E", "3S0"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M", "4L49"],
			gunkshot: ["4T"],
			headbutt: ["3L17"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M", "3L51"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			lastresort: ["4T"],
			lick: ["4L12", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["3T"],
			pursuit: ["4E"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			refresh: ["3S0"],
			rest: ["4M", "4L25", "3M", "3L25"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L41", "3T", "3L46"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "4L28", "3T", "3L37"],
			snore: ["4T", "4L28", "3T", "3L28"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlwind: ["4E"],
			yawn: ["4L20", "3L21"],
			zenheadbutt: ["4T"],
		},
	},
	articuno: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L36", "4S3", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			ancientpower: ["4T", "4L29"],
			avalanche: ["4M"],
			blizzard: ["4M", "4L71", "3M", "3L73"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["3S2"],
			facade: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gust: ["4L1", "3L1"],
			hail: ["4M", "4L85", "3M"],
			haze: ["3S2"],
			healbell: ["3S2"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "4L43", "4S3", "4S4", "3M", "3L49", "3S0", "3S1", "3S2"],
			iceshard: ["4L15"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mindreader: ["4L22", "4S4", "3L37", "3S0", "3S1"],
			mist: ["4L8", "4S4", "3L13", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["4M"],
			powdersnow: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "4L50", "4S3", "3M", "3L61", "3S1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			roost: ["4M", "4L57", "4S3"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sheercold: ["4L78", "3L85"],
			signalbeam: ["4T"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4L64"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
		},
	},
	zapdos: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L43", "4S3", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			ancientpower: ["4T", "4L29"],
			batonpass: ["3S2"],
			charge: ["4L36", "4S3", "3L61", "3S1"],
			chargebeam: ["4M"],
			defog: ["4M"],
			detect: ["4L15", "4S4", "3L37", "3S0", "3S1"],
			discharge: ["4L50", "4S3"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drillpeck: ["4L71", "4S4", "3L49", "3S0", "3S1"],
			endure: ["4M", "3T"],
			extrasensory: ["3S2"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			lightscreen: ["4M", "4L64", "3M", "3L73"],
			metalsound: ["3S2"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["4L1", "3L1"],
			pluck: ["4M", "4L22"],
			protect: ["4M", "3M"],
			raindance: ["4M", "4L85", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			roost: ["4M", "4L57", "4S3"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["4M", "4L78", "3M", "3L85"],
			thunderbolt: ["4M", "3M", "3S2"],
			thundershock: ["4L1", "3L1"],
			thunderwave: ["4M", "4L8", "4S4", "3T", "3L13", "3S0"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
		},
	},
	moltres: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L15", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			airslash: ["4L50", "4S3"],
			ancientpower: ["4T", "4L29"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "4L22", "4S4", "3T", "3L37", "3S0", "3S1"],
			extrasensory: ["3S2"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firespin: ["4L8", "4S4", "3L13", "3S0"],
			flamethrower: ["4M", "4L36", "4S3", "4S4", "3M", "3L49", "3S0", "3S1", "3S2"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			heatwave: ["4T", "4L64", "3L73"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			mimic: ["3T"],
			morningsun: ["3S2"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["4M", "3M"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			roost: ["4M", "4L57", "4S3"],
			safeguard: ["4M", "4L43", "4S3", "3M", "3L61", "3S1"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			skyattack: ["4L78", "3T", "3L85"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L71"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4L85", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
			willowisp: ["4M", "3S2"],
			wingattack: ["4L1", "3L1"],
		},
	},
	dratini: {
		inherit: true,
		learnset: {
			agility: ["4L25", "3L36"],
			aquatail: ["4T", "4L31"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragonbreath: ["4E", "3E"],
			dragondance: ["4L45", "4E", "3E"],
			dragonpulse: ["4M"],
			dragonrage: ["4L15", "3L22"],
			dragonrush: ["4L35", "4E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L55", "3M", "3L57"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			lightscreen: ["4E", "3E"],
			mimic: ["3T"],
			mist: ["4E", "3E"],
			naturalgift: ["4M"],
			outrage: ["4T", "4L51", "3L50"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "4L41", "3M", "3L43"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["4L21", "3L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4E", "3E"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "4L5", "3T", "3L8"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L11", "3L15"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			wrap: ["4L1", "3L1"],
		},
	},
	dragonair: {
		inherit: true,
		learnset: {
			agility: ["4L25", "3L38"],
			aquatail: ["4T", "4L33"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragondance: ["4L53"],
			dragonpulse: ["4M"],
			dragonrage: ["4L15", "3L22"],
			dragonrush: ["4L39"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L67", "3M", "3L65"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T", "4L61", "3L56"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "4L47", "3M", "3L47"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["4L21", "3L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "4L1", "3T", "3L1"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L1", "3L1"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			wrap: ["4L1", "3L1"],
		},
	},
	dragonite: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L25", "3L38", "3S0"],
			aircutter: ["4T"],
			aquatail: ["4T", "4L33"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			defog: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T", "4S2"],
			dragonclaw: ["4M", "3M"],
			dragondance: ["4L53", "4S2", "3S1"],
			dragonpulse: ["4M"],
			dragonrage: ["4L15", "3L22"],
			dragonrush: ["4L39"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M", "3S1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "4L1", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			fly: ["4M", "3M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			healbell: ["3S1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L73", "3M", "3L75", "3S1"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["4T", "4L64", "4S2", "3L61", "3S0"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			roost: ["4M", "4L1"],
			safeguard: ["4M", "4L47", "3M", "3L47", "3S0"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["4L21", "3L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "4S2", "3M"],
			thunderpunch: ["4T", "4L1", "3T"],
			thunderwave: ["4M", "4L1", "3T", "3L1"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L1", "3L1"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			wingattack: ["4L55", "3L55", "3S0"],
			wrap: ["4L1", "3L1"],
		},
	},
	mewtwo: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			amnesia: ["4L57", "4S1", "3L77"],
			aquatail: ["4T"],
			aurasphere: ["4L100"],
			avalanche: ["4M"],
			barrier: ["4L8", "3L11"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L1"],
			counter: ["3T"],
			disable: ["4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L22", "3L44"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			guardswap: ["4L64", "4S1"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "3M"],
			mefirst: ["4L79"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["4L36"],
			mist: ["4L43", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poisonjab: ["4M"],
			powerswap: ["4L64", "4S1"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L71", "3M", "3L66", "3S0"],
			psychocut: ["4L50", "4S1"],
			psychup: ["4M", "4L29", "3T", "3L33"],
			raindance: ["4M", "3M"],
			recover: ["4L86", "3L44", "3S0"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			safeguard: ["4M", "4L93", "3M", "3L55", "3S0"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L15", "3T", "3L22", "3S0"],
			taunt: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			waterpulse: ["4M", "3M"],
			willowisp: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	mew: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			amnesia: ["4L60", "4S17"],
			ancientpower: ["4T", "4L50", "4S14", "3L50"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			aurasphere: ["4L100", "4S14", "4S15", "4S16", "4S17", "4S18", "4S19"],
			avalanche: ["4M"],
			barrier: ["4L40", "4S15"],
			batonpass: ["4L80"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["4M", "3M"],
			brine: ["4M"],
			bulkup: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4M", "3M"],
			dragonpulse: ["4M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			embargo: ["4M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["3S2", "3S3"],
			falseswipe: ["4M"],
			feintattack: ["3S4", "3S5"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			flashcannon: ["4M"],
			fling: ["4M"],
			fly: ["4M", "3M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gunkshot: ["4T"],
			gyroball: ["4M"],
			hail: ["4M", "3M"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypnosis: ["4S20", "3S6", "3S7"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["4M", "3M"],
			magnetrise: ["4T"],
			mefirst: ["4L70"],
			megakick: ["3T"],
			megapunch: ["4L10", "4S16", "3T", "3L20", "3S0"],
			metronome: ["4L20", "4S14", "4S15", "4S16", "4S17", "4S18", "4S19", "3T", "3L30", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L90"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["3S8", "3S9"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			overheat: ["4M", "3M"],
			payback: ["4M"],
			pluck: ["4M"],
			poisonjab: ["4M"],
			pound: ["4L1", "4S21", "3L1", "3S0", "3S1"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L30", "4S19", "3M", "3L40"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "4S20", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			roleplay: ["3S10", "3S11"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skillswap: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			stealthrock: ["4M"],
			steelwing: ["4M", "3M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4S20"],
			taunt: ["4M", "3M"],
			teleport: ["4S14", "4S15", "4S16", "4S17", "4S18", "4S19", "4S20"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			transform: ["4L1", "4S18", "3L10", "3S0", "3S1"],
			trick: ["4T"],
			trickroom: ["4M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["4M"],
			vacuumwave: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			willowisp: ["4M"],
			worryseed: ["4T"],
			xscissor: ["4M"],
			zapcannon: ["3S12", "3S13"],
			zenheadbutt: ["4T"],
		},
	},
	chikorita: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4E", "3E", "3S1"],
			aromatherapy: ["4L42", "4E"],
			attract: ["4M", "3M"],
			bodyslam: ["4L34", "3T", "3L29"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			flash: ["4M", "3M"],
			frenzyplant: ["3S1"],
			frustration: ["4M", "3M"],
			furycutter: ["4T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			grasswhistle: ["4E", "3E"],
			growl: ["4L1", "3L1", "3S0", "3S1"],
			hiddenpower: ["4M", "3M"],
			ingrain: ["4E", "3E"],
			irontail: ["4M", "3M"],
			leafstorm: ["4E"],
			leechseed: ["4E", "3E"],
			lightscreen: ["4M", "4L31", "3M", "3L36"],
			magicalleaf: ["4L20"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M", "4L23"],
			naturepower: ["4E", "3E"],
			poisonpowder: ["4L9", "3L15"],
			protect: ["4M", "3M"],
			razorleaf: ["4L6", "3L8", "3S0"],
			reflect: ["4M", "4L17", "3M", "3L12"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "4L39", "3M", "3L43"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L45", "3M", "3L50"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L28"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L12", "3L22"],
			tackle: ["4L1", "3L1", "3S0", "3S1"],
			toxic: ["4M", "3M"],
			vinewhip: ["4E", "3E"],
			worryseed: ["4T"],
			wringout: ["4E"],
		},
	},
	bayleef: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aromatherapy: ["4L50"],
			attract: ["4M", "3M"],
			bodyslam: ["4L40", "3T", "3L31"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "4L36", "3M", "3L39"],
			magicalleaf: ["4L22"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M", "4L26"],
			poisonpowder: ["4L1", "3L15"],
			protect: ["4M", "3M"],
			razorleaf: ["4L1", "3L1"],
			reflect: ["4M", "4L18", "3M", "3L1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			safeguard: ["4M", "4L46", "3M", "3L47"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L54", "3M", "3L55"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L32"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L12", "3L23"],
			tackle: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
		},
	},
	meganium: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aromatherapy: ["4L60"],
			attract: ["4M", "3M"],
			bodyslam: ["4L46", "3T", "3L31"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frenzyplant: ["4T"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "4L40", "3M", "3L41"],
			magicalleaf: ["4L22"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M", "4L26"],
			outrage: ["4T"],
			petaldance: ["4L32"],
			poisonpowder: ["4L1", "3L15"],
			protect: ["4M", "3M"],
			razorleaf: ["4L1", "3L1"],
			reflect: ["4M", "4L18", "3M", "3L1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			safeguard: ["4M", "4L54", "3M", "3L51"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L66", "3M", "3L61"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L34"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L12", "3L23"],
			tackle: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
		},
	},
	cyndaquil: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			blastburn: ["3S1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			covet: ["4E", "3E"],
			crushclaw: ["4E", "3E"],
			cut: ["4M", "3M"],
			defensecurl: ["4L22", "3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L46", "4E", "3T"],
			doublekick: ["4E"],
			doubleteam: ["4M", "3M"],
			ember: ["4L10", "3L12"],
			endure: ["4M", "3T"],
			eruption: ["4L49"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "4L37", "3M", "3L46"],
			flamewheel: ["4L19", "3L27"],
			flareblitz: ["4E"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			furyswipes: ["4E", "3E"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			howl: ["4E", "3E"],
			lavaplume: ["4L31"],
			leer: ["4L1", "3L1", "3S0", "3S1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			quickattack: ["4L13", "4E", "3L19", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4E", "3E", "3S1"],
			rollout: ["4T", "4L40", "3T"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["4L4", "3L6", "3S0"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L28", "3T", "3L36"],
			tackle: ["4L1", "3L1", "3S0", "3S1"],
			thrash: ["4E", "3E"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	quilava: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			defensecurl: ["4L24", "3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L53", "3T"],
			doubleteam: ["4M", "3M"],
			ember: ["4L10", "3L12"],
			endure: ["4M", "3T"],
			eruption: ["4L57"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "4L42", "3M", "3L54"],
			flamewheel: ["4L20", "3L31"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			lavaplume: ["4L35"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			quickattack: ["4L13", "3L21"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "4L46", "3T"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["4L1", "3L1"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L31", "3T", "3L42"],
			tackle: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	typhlosion: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			blastburn: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			defensecurl: ["4L24", "3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L53", "3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			eruption: ["4L57"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "4L42", "3M", "3L60", "3S0"],
			flamewheel: ["4L20", "3L31", "3S0"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			gyroball: ["4M", "4L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			lavaplume: ["4L35"],
			leer: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			quickattack: ["4L13", "3L21", "3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "4L46", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["4L1", "3L1"],
			snore: ["4T", "3T"],
			solarbeam: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L31", "3T", "3L45", "3S0"],
			tackle: ["4L1", "3L1"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	totodile: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T", "4E", "3E"],
			aquatail: ["4T", "4L36"],
			attract: ["4M", "3M"],
			bite: ["4L13", "3L20"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["4L27", "4E", "3E", "3S1"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4E", "3E"],
			dragondance: ["4E"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4L22"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydrocannon: ["3S1"],
			hydropump: ["4L43", "4E", "3L52", "3E"],
			icebeam: ["4M", "3M"],
			icefang: ["4L20"],
			icepunch: ["4T", "4E", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1", "3S0", "3S1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			rage: ["4L8", "3L7", "3S0"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocktomb: ["4M"],
			scaryface: ["4L15", "3L27"],
			scratch: ["4L1", "3L1", "3S0", "3S1"],
			screech: ["4L34", "3L43"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			slash: ["4L29", "3L35"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			superpower: ["4T", "4L41"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			thrash: ["4L22", "4E", "3E"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			watergun: ["4L6", "3L13"],
			waterpulse: ["4M", "3M"],
			watersport: ["4E", "3E"],
		},
	},
	croconaw: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["4L42"],
			attract: ["4M", "3M"],
			bite: ["4L13", "3L21"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["4L30"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4L24"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L51", "3L55"],
			icebeam: ["4M", "3M"],
			icefang: ["4L21"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			rage: ["4L8", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			scaryface: ["4L15", "3L28"],
			scratch: ["4L1", "3L1"],
			screech: ["4L39", "3L45"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			slash: ["4L33", "3L37"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T", "4L48"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			thrash: ["4L24"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L13"],
			waterpulse: ["4M", "3M"],
		},
	},
	feraligatr: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L30"],
			ancientpower: ["4T"],
			aquatail: ["4T", "4L50"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bite: ["4L13", "3L21"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["4L32"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4M", "3M"],
			dragonpulse: ["4M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4L24"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydrocannon: ["4T"],
			hydropump: ["4L63", "3L58"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icefang: ["4L21"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			rage: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			scaryface: ["4L15", "3L28"],
			scratch: ["4L1", "3L1"],
			screech: ["4L45", "3L47"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			slash: ["4L37", "3L38"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T", "4L58"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			thrash: ["4L24"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	sentret: {
		inherit: true,
		learnset: {
			amnesia: ["4L36", "3L49"],
			aquatail: ["4T"],
			assist: ["4E", "3E"],
			attract: ["4M", "3M"],
			batonpass: ["4L39"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4E"],
			covet: ["4E"],
			cut: ["4M", "3M"],
			defensecurl: ["4L4", "3T", "3L4"],
			dig: ["4M", "3M"],
			doubleedge: ["4E", "3T", "3E"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusenergy: ["4E", "3E"],
			focuspunch: ["4M", "3M"],
			followme: ["4L19", "3L31"],
			foresight: ["4L1"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L13", "3L12"],
			grassknot: ["4M"],
			helpinghand: ["4T", "4L16", "3L17"],
			hiddenpower: ["4M", "3M"],
			hypervoice: ["4L47"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T", "4E"],
			mefirst: ["4L42"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			quickattack: ["4L7", "3L7"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L28", "3M", "3L40"],
			return: ["4M", "3M"],
			reversal: ["4E", "3E"],
			rollout: ["4T", "3T"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slam: ["4L25", "3L24"],
			slash: ["4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			suckerpunch: ["4T", "4L31"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4E", "3E"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
		},
	},
	furret: {
		inherit: true,
		learnset: {
			amnesia: ["4L42", "3L59"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			batonpass: ["4L46"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			cut: ["4M", "3M"],
			defensecurl: ["4L1", "3T", "3L1"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			followme: ["4L21", "3L37"],
			foresight: ["4L1"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L13", "3L12"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T", "4L17", "3L19"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypervoice: ["4L56"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mefirst: ["4L50"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L32", "3M", "3L48"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slam: ["4L28", "3L28"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L36"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
		},
	},
	hoothoot: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4E"],
			aircutter: ["4T"],
			airslash: ["4L29"],
			attract: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L21", "3L34"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "4L49", "3T", "3L48"],
			endure: ["4M", "3T"],
			extrasensory: ["4L37"],
			facade: ["4M", "3M"],
			featherdance: ["4E", "3E"],
			feintattack: ["4E", "3E"],
			flash: ["3M"],
			fly: ["4M", "3M"],
			foresight: ["4L1", "3L6", "3S0"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1", "3S0"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L5", "3L16"],
			mimic: ["3T"],
			mirrormove: ["4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4E"],
			ominouswind: ["4T"],
			peck: ["4L9", "3L11"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychoshift: ["4L41"],
			psychup: ["4M"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "4L17", "3M", "3L22"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M", "4L45"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			silverwind: ["4M"],
			skyattack: ["4E", "3T", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4E", "3E"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			takedown: ["4L25", "3L28"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T", "4L13"],
			whirlwind: ["4E", "3E"],
			wingattack: ["4E", "3E"],
			zenheadbutt: ["4T", "4L33"],
		},
	},
	noctowl: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			airslash: ["4L32"],
			attract: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["4L22", "3L41"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "4L57", "3T", "3L57"],
			endure: ["4M", "3T"],
			extrasensory: ["4L42"],
			facade: ["4M", "3M"],
			flash: ["3M"],
			fly: ["4M", "3M"],
			foresight: ["4L1", "3L1"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypnosis: ["4L1", "3L16"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			peck: ["4L9", "3L1"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychoshift: ["4L47"],
			psychup: ["4M"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "4L17", "3M", "3L25"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M", "4L52"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			silverwind: ["4M"],
			skyattack: ["4L1", "3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L27", "3L33"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T", "4L13"],
			zenheadbutt: ["4T", "4L37"],
		},
	},
	ledyba: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M", "3S0"],
			agility: ["4L30", "3L43"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			batonpass: ["4L22", "3L29"],
			bide: ["4E", "3E"],
			brickbreak: ["4M", "3M"],
			bugbite: ["4E"],
			bugbuzz: ["4L41", "4E"],
			captivate: ["4M"],
			cometpunch: ["4L9", "3L15"],
			dig: ["4M", "3M"],
			doubleedge: ["4L38", "3T", "3L50"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			encore: ["4E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			knockoff: ["4T", "4E"],
			lightscreen: ["4M", "4L14", "3M", "3L22"],
			machpunch: ["4L17"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			psybeam: ["4E", "3E", "3S0"],
			reflect: ["4M", "4L14", "3M", "3L22"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			safeguard: ["4M", "4L14", "3M", "3L22"],
			screech: ["4E"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M", "4L25", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L6", "3L8", "3S0"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L33", "3T", "3L36"],
			swordsdance: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			uturn: ["4M"],
		},
	},
	ledian: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L36", "3L51"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			batonpass: ["4L24", "3L33"],
			brickbreak: ["4M", "3M"],
			bugbuzz: ["4L53"],
			captivate: ["4M"],
			cometpunch: ["4L1", "3L15"],
			dig: ["4M", "3M"],
			doubleedge: ["4L48", "3T", "3L60"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			knockoff: ["4T"],
			lightscreen: ["4M", "4L14", "3M", "3L24"],
			machpunch: ["4L17"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			reflect: ["4M", "4L14", "3M", "3L24"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			safeguard: ["4M", "4L14", "3M", "3L24"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M", "4L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L1", "3L1"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L41", "3T", "3L42"],
			swordsdance: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			uturn: ["4M"],
		},
	},
	spinarak: {
		inherit: true,
		learnset: {
			agility: ["4L33", "3L45"],
			attract: ["4M", "3M"],
			batonpass: ["4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			captivate: ["4M"],
			constrict: ["4L8", "3L11"],
			dig: ["4M", "3M", "3S0"],
			disable: ["4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L22", "3L30"],
			gigadrain: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			leechlife: ["4L12", "3L23"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightshade: ["4L15", "3L17", "3S0"],
			pinmissile: ["4L36"],
			poisonjab: ["4M", "4L43", "4E"],
			poisonsting: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psybeam: ["4E", "3E"],
			psychic: ["4M", "4L40", "3M", "3L53"],
			pursuit: ["4E", "3E"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			scaryface: ["4L5", "3L6"],
			secretpower: ["4M", "3M"],
			shadowsneak: ["4L19"],
			signalbeam: ["4T", "4E", "3E", "3S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["3T"],
			solarbeam: ["4M", "3M"],
			sonicboom: ["4E", "3E"],
			spiderweb: ["4L29", "3L37"],
			stringshot: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L26"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4E"],
		},
	},
	ariados: {
		inherit: true,
		learnset: {
			agility: ["4L37", "3L53"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			bugbite: ["4L1"],
			captivate: ["4M"],
			constrict: ["4L1", "3L1"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L23", "3L34"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leechlife: ["4L12", "3L25"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightshade: ["4L15", "3L17"],
			pinmissile: ["4L41"],
			poisonjab: ["4M", "4L50"],
			poisonsting: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L46", "3M", "3L63"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			scaryface: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowsneak: ["4L19"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["3T"],
			solarbeam: ["4M", "3M"],
			spiderweb: ["4L32", "3L43"],
			stringshot: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L28"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
		},
	},
	chinchou: {
		inherit: true,
		learnset: {
			agility: ["4E"],
			amnesia: ["4E", "3E"],
			aquaring: ["4L39"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubble: ["4L1", "3L1"],
			bubblebeam: ["4L28"],
			captivate: ["4M"],
			charge: ["4L45", "3L49"],
			chargebeam: ["4M"],
			confuseray: ["4L17", "3L29"],
			discharge: ["4L34"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4L9", "4E", "3L13", "3E"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L42", "3L41"],
			icebeam: ["4M", "3M"],
			icywind: ["4T"],
			mimic: ["3T"],
			mist: ["4E"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psybeam: ["4E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T", "4L31"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["4L20", "3L25"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			supersonic: ["4L1", "3L5"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			takedown: ["4L23", "3L37"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "4L6", "3T", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L12", "3L17"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4E"],
		},
	},
	lanturn: {
		inherit: true,
		learnset: {
			aquaring: ["4L47"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubble: ["4L1", "3L1"],
			bubblebeam: ["4L30"],
			captivate: ["4M"],
			charge: ["4L57", "3L61"],
			chargebeam: ["4M"],
			confuseray: ["4L17", "3L32"],
			discharge: ["4L40"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4L9", "3L13"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L52", "3L50"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T", "4L35"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["4L20", "3L25"],
			spitup: ["4L27"],
			stockpile: ["4L27"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			supersonic: ["4L1", "3L1"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L27"],
			takedown: ["4L23", "3L43"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "4L1", "3T", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L12", "3L17"],
			waterpulse: ["4M", "3M"],
		},
	},
	togepi: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L33", "3L21", "3S1"],
			attract: ["4M", "3M"],
			batonpass: ["4L42", "3L41"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["4L1", "3L1", "3S0"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["4L46", "3T", "3L37"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			encore: ["4L19", "3L17"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			followme: ["4L24", "3L25", "3S1"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			futuresight: ["4E", "3E"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			helpinghand: ["3S1"],
			hiddenpower: ["4M", "3M"],
			lastresort: ["4T", "4L51"],
			lightscreen: ["4M", "3M"],
			luckychant: ["4E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["4L6", "3T", "3L4", "3S0"],
			mimic: ["3T"],
			mirrormove: ["4E", "3E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4E"],
			naturalgift: ["4M"],
			peck: ["4E", "3E"],
			present: ["4E", "3E"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychoshift: ["4E"],
			psychup: ["4M", "4E", "3T", "3E"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "4L37", "3M", "3L33"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetkiss: ["4L10", "3L9", "3S0"],
			swift: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			triattack: ["3S1"],
			trick: ["4T"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			wish: ["4L28", "3L29"],
			yawn: ["4L15", "3L13", "3S0"],
			zenheadbutt: ["4T"],
		},
	},
	togetic: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			ancientpower: ["4T", "4L33", "3L21"],
			attract: ["4M", "3M"],
			batonpass: ["4L42", "3L41"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["4L1", "3L1"],
			counter: ["3T"],
			defensecurl: ["3T"],
			defog: ["4M"],
			doubleedge: ["4L46", "3T", "3L37"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			encore: ["4L19", "3L17"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			fly: ["4M", "3M"],
			focuspunch: ["4M", "3M"],
			followme: ["4L24", "3L25"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			lastresort: ["4T", "4L51"],
			lightscreen: ["4M", "3M"],
			magicalleaf: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["4L1", "3T", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			safeguard: ["4M", "4L37", "3M", "3L33"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["4M", "3M"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetkiss: ["4L1", "3L1"],
			swift: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			twister: ["4T"],
			waterpulse: ["4M", "3M"],
			wish: ["4L28", "3L29"],
			yawn: ["4L15", "3L13"],
			zenheadbutt: ["4T"],
		},
	},
	togekiss: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aircutter: ["4T"],
			airslash: ["4L1"],
			ancientpower: ["4T"],
			attract: ["4M"],
			aurasphere: ["4L1"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleteam: ["4M"],
			drainpunch: ["4M"],
			dreameater: ["4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			extremespeed: ["4L1"],
			facade: ["4M"],
			fireblast: ["4M"],
			flamethrower: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			fly: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			heatwave: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			lastresort: ["4T"],
			lightscreen: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rocksmash: ["4M"],
			rollout: ["4T"],
			roost: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skyattack: ["4L1"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			steelwing: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			twister: ["4T"],
			waterpulse: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	natu: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M", "3S0"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			batonpass: ["3S0"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L23", "3L40"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			drillpeck: ["4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			featherdance: ["4E", "3E"],
			feintattack: ["4E", "3E"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L36", "3L30", "3S0"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			guardswap: ["4L44"],
			haze: ["4E", "3E"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			lightscreen: ["4M", "3M"],
			luckychant: ["4L12"],
			mefirst: ["4L20"],
			mimic: ["3T"],
			miracleeye: ["4L17"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4L6", "3L10", "3S0"],
			ominouswind: ["4T", "4L39"],
			peck: ["4L1", "3L1"],
			pluck: ["4M"],
			powerswap: ["4L44"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L47", "3M", "3L50"],
			psychoshift: ["4L33"],
			psychup: ["4M", "4E", "3T", "3E"],
			quickattack: ["4E", "3E"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			refresh: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skillswap: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			steelwing: ["4M", "4E", "3M", "3E"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4E"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			teleport: ["4L9", "3L20"],
			thief: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			twister: ["4T"],
			uturn: ["4M"],
			wish: ["4L28", "3L30"],
			zenheadbutt: ["4T", "4E"],
		},
	},
	xatu: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L23", "3L50"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L42", "3L35"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			guardswap: ["4L54"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			lightscreen: ["4M", "3M"],
			luckychant: ["4L12"],
			mefirst: ["4L20"],
			mimic: ["3T"],
			miracleeye: ["4L17"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4L6", "3L10"],
			ominouswind: ["4T", "4L47"],
			peck: ["4L1", "3L1"],
			pluck: ["4M"],
			powerswap: ["4L54"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L59", "3M", "3L65"],
			psychoshift: ["4L37"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skillswap: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4L27"],
			teleport: ["4L9", "3L20"],
			thief: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			twister: ["4T"],
			uturn: ["4M"],
			wish: ["4L30", "3L35"],
			zenheadbutt: ["4T"],
		},
	},
	mareep: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["4E", "3T", "3E", "3S2"],
			captivate: ["4M"],
			charge: ["4L23", "4E", "3E"],
			chargebeam: ["4M"],
			cottonspore: ["4L19", "3L23", "3S0"],
			defensecurl: ["3T"],
			discharge: ["4L28"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			flatter: ["4E"],
			frustration: ["4M", "3M"],
			growl: ["4L5", "3L1", "3S1"],
			healbell: ["3S2"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "4L37", "3M", "3L30"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			odorsleuth: ["4E", "3E"],
			powergem: ["4L41"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			reflect: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4E", "3E"],
			sandattack: ["4E"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T", "4L32"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S1"],
			takedown: ["4E", "3E"],
			thunder: ["4M", "4L46", "3M", "3L37", "3S0"],
			thunderbolt: ["4M", "3M"],
			thundershock: ["4L10", "3L9", "3S0", "3S1", "3S2"],
			thunderwave: ["4M", "4L14", "3T", "3L16", "3S0", "3S2"],
			toxic: ["4M", "3M"],
		},
	},
	flaaffy: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			charge: ["4L25"],
			chargebeam: ["4M"],
			cottonspore: ["4L20", "3L27"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["4L31"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "4L42", "3M", "3L36"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			powergem: ["4L47"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T", "4L36"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thunder: ["4M", "4L53", "3M", "3L45"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thundershock: ["4L1", "3L1"],
			thunderwave: ["4M", "4L14", "3T", "3L18"],
			toxic: ["4M", "3M"],
		},
	},
	ampharos: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			charge: ["4L25"],
			chargebeam: ["4M"],
			cottonspore: ["4L20", "3L27"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["4L34"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "4L1", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "4L51", "3M", "3L42"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			powergem: ["4L59"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T", "4L42"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thunder: ["4M", "4L68", "3M", "3L57"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "4L30", "3T", "3L30"],
			thundershock: ["4L1", "3L1"],
			thunderwave: ["4M", "4L1", "3T", "3L1"],
			toxic: ["4M", "3M"],
		},
	},
	azurill: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bubble: ["4L10", "3L10"],
			captivate: ["4M"],
			charm: ["4L2", "3L3"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			encore: ["4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			faketears: ["4E"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			refresh: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			sing: ["4E", "3E"],
			slam: ["4L15", "4E", "3L15", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["4L7", "3L6"],
			tickle: ["4E", "3E"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			watergun: ["4L18", "3L21"],
			waterpulse: ["4M", "3M"],
		},
	},
	marill: {
		inherit: true,
		learnset: {
			amnesia: ["4E", "3E"],
			aquajet: ["4E"],
			aquaring: ["4L23"],
			aquatail: ["4T", "4L37"],
			attract: ["4M", "3M"],
			bellydrum: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bubblebeam: ["4L18", "3L21"],
			captivate: ["4M"],
			defensecurl: ["4L2", "3T", "3L3"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["4L27", "3T", "3L28"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4E", "3E"],
			grassknot: ["4M"],
			hail: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L42", "3L45"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lightscreen: ["4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			perishsong: ["4E", "3E"],
			present: ["4E", "3E"],
			protect: ["4M", "3M"],
			raindance: ["4M", "4L32", "3M", "3L36"],
			refresh: ["4E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "4L15", "3T", "3L15"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			superpower: ["4T", "4E"],
			supersonic: ["4E", "3E"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L7", "3L6"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L10", "3L10"],
			waterpulse: ["4M", "3M"],
		},
	},
	azumarill: {
		inherit: true,
		learnset: {
			aquaring: ["4L27"],
			aquatail: ["4T", "4L47"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bubblebeam: ["4L20", "3L24"],
			captivate: ["4M"],
			defensecurl: ["4L1", "3T", "3L1"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["4L33", "3T", "3L34"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hail: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L54", "3L57"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "4L40", "3M", "3L45"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "4L15", "3T", "3L15"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	bonsly: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			block: ["4L22"],
			brickbreak: ["4M"],
			calmmind: ["4M"],
			captivate: ["4M"],
			copycat: ["4L1"],
			defensecurl: ["4E"],
			dig: ["4M"],
			doubleedge: ["4L46"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			endure: ["4M"],
			explosion: ["4M"],
			facade: ["4M"],
			faketears: ["4L1"],
			feintattack: ["4L25"],
			flail: ["4L6"],
			frustration: ["4M"],
			harden: ["4E"],
			headbutt: ["4E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			lowkick: ["4L9"],
			mimic: ["4L17"],
			naturalgift: ["4M"],
			protect: ["4M"],
			psychup: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L33"],
			rockthrow: ["4L14"],
			rocktomb: ["4M", "4L30"],
			rollout: ["4T", "4E"],
			sandstorm: ["4M"],
			sandtomb: ["4E"],
			secretpower: ["4M"],
			selfdestruct: ["4E"],
			slam: ["4L38"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			substitute: ["4M"],
			suckerpunch: ["4T", "4L41"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			thief: ["4M"],
			toxic: ["4M"],
			uproar: ["4T"],
		},
	},
	sudowoodo: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			block: ["4L22", "3L33"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			copycat: ["4L1"],
			counter: ["3T"],
			defensecurl: ["4E", "3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L46", "3T", "3L57"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L25", "3L41"],
			firepunch: ["4T", "3T"],
			flail: ["4L1", "3L9"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hammerarm: ["4L49"],
			harden: ["4E"],
			headbutt: ["4E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			lowkick: ["4L1", "3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["4L17", "3T", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L33", "3T", "3L25"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L1", "3L1"],
			rocktomb: ["4M", "4L30", "3M"],
			rollout: ["4T", "4E", "3T"],
			sandstorm: ["4M", "3M"],
			sandtomb: ["4E"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["4E", "3T", "3E"],
			slam: ["4L38", "3L49"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L41"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M"],
			toxic: ["4M", "3M"],
			woodhammer: ["4L1"],
		},
	},
	hoppip: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			amnesia: ["4E", "3E"],
			aromatherapy: ["4E"],
			attract: ["4M", "3M"],
			bounce: ["4T", "4L40"],
			bulletseed: ["4M", "4L19", "3M"],
			captivate: ["4M"],
			confusion: ["4E", "3E"],
			cottonspore: ["4L28", "3L25"],
			defensecurl: ["3T"],
			doubleedge: ["4E", "3T", "3E"],
			doubleteam: ["4M", "3M"],
			encore: ["4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "4L37", "3M"],
			grassknot: ["4M"],
			helpinghand: ["4T", "4E", "3E"],
			hiddenpower: ["4M", "3M"],
			leechseed: ["4L22", "3L20"],
			megadrain: ["4L25", "3L30"],
			memento: ["4L43"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["4L12", "3L13"],
			protect: ["4M", "3M"],
			psychup: ["4E", "3E"],
			reflect: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			silverwind: ["4M"],
			sleeppowder: ["4L16", "3L17"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			splash: ["4L1", "3L1"],
			stunspore: ["4L14", "3L15"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L4", "3L5"],
			tackle: ["4L10", "3L10"],
			tailwhip: ["4L7", "3L5"],
			toxic: ["4M", "3M"],
			uturn: ["4M", "4L31"],
			worryseed: ["4T", "4L34", "4E"],
		},
	},
	skiploom: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bounce: ["4T", "4L48"],
			bulletseed: ["4M", "4L20", "3M"],
			captivate: ["4M"],
			cottonspore: ["4L32", "3L29"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "4L44", "3M"],
			grassknot: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			leechseed: ["4L24", "3L22"],
			megadrain: ["4L28", "3L36"],
			memento: ["4L52"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["4L12", "3L13"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			silverwind: ["4M"],
			sleeppowder: ["4L16", "3L17"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			splash: ["4L1", "3L1"],
			stunspore: ["4L14", "3L15"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L1", "3L1"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			uturn: ["4M", "4L36"],
			worryseed: ["4T", "4L40"],
		},
	},
	jumpluff: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bounce: ["4T", "4L48"],
			bulletseed: ["4M", "4L20", "3M"],
			captivate: ["4M"],
			cottonspore: ["4L32", "3L33"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "4L44", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leechseed: ["4L24", "3L22"],
			megadrain: ["4L28", "3L44"],
			memento: ["4L52"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["4L12", "3L13"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			silverwind: ["4M"],
			sleeppowder: ["4L16", "3L17"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			splash: ["4L1", "3L1"],
			stunspore: ["4L14", "3L15"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L1", "3L1"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			uturn: ["4M", "4L36"],
			worryseed: ["4T", "4L40"],
		},
	},
	aipom: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L29", "4E", "3L50", "3E"],
			astonish: ["4L8", "3L13"],
			attract: ["4M", "3M"],
			batonpass: ["4L11", "3L18"],
			beatup: ["4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["4T", "4E"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E"],
			covet: ["4E"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublehit: ["4L32"],
			doubleslap: ["4E", "3E"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4E"],
			firepunch: ["4T", "3T"],
			fling: ["4M", "4L36"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L18", "3L31"],
			grassknot: ["4M"],
			gunkshot: ["4T"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T", "4L43"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L39"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			sandattack: ["4L4", "3L6", "3S0"],
			scratch: ["4L1", "3L1", "3S0"],
			screech: ["4L25", "4E", "3L43", "3E"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slam: ["4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T", "4E", "3E"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L22", "3T", "3L38"],
			tailwhip: ["4L1", "3L1", "3S0"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			tickle: ["4L15", "3L25"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
		},
	},
	ambipom: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			agility: ["4L29"],
			astonish: ["4L1"],
			attract: ["4M"],
			batonpass: ["4L11"],
			bounce: ["4T"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			dig: ["4M"],
			doublehit: ["4L32"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			firepunch: ["4T"],
			fling: ["4M", "4L36"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			furyswipes: ["4L18"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gunkshot: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icepunch: ["4T"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["4T", "4L43"],
			mudslap: ["4T"],
			nastyplot: ["4L39"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rocksmash: ["4M"],
			sandattack: ["4L1"],
			scratch: ["4L1"],
			screech: ["4L25"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["4M"],
			shadowclaw: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			spite: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T", "4L22"],
			tailwhip: ["4L1"],
			taunt: ["4M"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			thunderwave: ["4M"],
			tickle: ["4L15"],
			toxic: ["4M"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M"],
		},
	},
	sunkern: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1", "3S0"],
			attract: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			curse: ["4E", "3E"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			encore: ["4E", "3E"],
			endeavor: ["4T", "4L21", "3L25"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "4L41", "3M", "3L42"],
			grassknot: ["4M"],
			grasswhistle: ["4L13", "4E", "3E"],
			growth: ["4L1", "3L6", "3S0"],
			helpinghand: ["4T", "4E", "3E"],
			hiddenpower: ["4M", "3M"],
			ingrain: ["4L9", "4E", "3L18"],
			leechseed: ["4L17", "4E", "3E"],
			lightscreen: ["4M", "3M"],
			megadrain: ["4L5", "3L13"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			naturepower: ["4E", "3E"],
			protect: ["4M", "3M"],
			razorleaf: ["4L29"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T", "4L45"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4L37", "3M", "3L30"],
			swagger: ["4M", "3T"],
			sweetscent: ["4E"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L33", "3L37"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			worryseed: ["4T", "4L25"],
		},
	},
	sunflora: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bulletseed: ["4M", "4L21", "3M", "3L25"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			grasswhistle: ["4L13"],
			growth: ["4L1", "3L6"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ingrain: ["4L9", "3L18"],
			leafstorm: ["4L43"],
			leechseed: ["4L17"],
			lightscreen: ["4M", "3M"],
			megadrain: ["4L5"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			petaldance: ["4L33", "3L37"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			razorleaf: ["4L29", "3L13"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L41", "3M", "3L42"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4L37", "3M", "3L30"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			worryseed: ["4T", "4L25"],
		},
	},
	yanma: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			airslash: ["4L54"],
			ancientpower: ["4T", "4L33"],
			attract: ["4M", "3M"],
			bugbuzz: ["4L57"],
			captivate: ["4M"],
			defog: ["4M"],
			detect: ["4L17", "3L25"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L11", "3M", "3L12"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feint: ["4E"],
			feintattack: ["4E"],
			flash: ["4M", "3M"],
			foresight: ["4L1", "3L1"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L38", "3L23"],
			leechlife: ["4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			pursuit: ["4L30", "4E"],
			quickattack: ["4L6", "3L6"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4E", "3E"],
			roost: ["4M"],
			screech: ["4L46", "3L49"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T", "4E", "3E"],
			silverwind: ["4M", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			sonicboom: ["4L14", "3L17"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L22", "3L31"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T", "4L27", "3L34"],
			uturn: ["4M", "4L49"],
			whirlwind: ["4E", "3E"],
			wingattack: ["4L43", "3L39"],
		},
	},
	yanmega: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aircutter: ["4T"],
			airslash: ["4L49"],
			ancientpower: ["4T", "4L33"],
			attract: ["4M"],
			bugbite: ["4L1"],
			bugbuzz: ["4L54"],
			captivate: ["4M"],
			defog: ["4M"],
			detect: ["4L17"],
			doubleteam: ["4M", "4L1"],
			dreameater: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			feint: ["4L38"],
			flash: ["4M"],
			foresight: ["4L1"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["4L1"],
			ominouswind: ["4T"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			pursuit: ["4L30"],
			quickattack: ["4L1"],
			rest: ["4M"],
			return: ["4M"],
			roost: ["4M"],
			screech: ["4L43"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			slash: ["4L38"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			sonicboom: ["4L14"],
			steelwing: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			supersonic: ["4L22"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			thief: ["4M"],
			toxic: ["4M"],
			uproar: ["4T", "4L27"],
			uturn: ["4M", "4L46"],
		},
	},
	wooper: {
		inherit: true,
		learnset: {
			amnesia: ["4L23", "3L21"],
			ancientpower: ["4T", "4E", "3E"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4E", "3T", "3E"],
			captivate: ["4M"],
			counter: ["4E"],
			curse: ["4E", "3E"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doublekick: ["4E"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L33", "3M", "3L36"],
			encore: ["4E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			haze: ["4L43", "3L51"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mist: ["4L43", "3L51"],
			mudbomb: ["4L19"],
			muddywater: ["4L47"],
			mudshot: ["4L9", "3L16"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L5", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "4L37", "3M", "3L41"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4E", "3E"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			slam: ["4L15", "3L11"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			spitup: ["4E", "3E"],
			stockpile: ["4E", "3E"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4E", "3E"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			yawn: ["4L29", "3L31"],
		},
	},
	quagsire: {
		inherit: true,
		learnset: {
			amnesia: ["4L24", "3L23"],
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L36", "3M", "3L42"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			haze: ["4L48", "3L61"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mist: ["4L48", "3L61"],
			mudbomb: ["4L19"],
			muddywater: ["4L53"],
			mudshot: ["4L9", "3L16"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L1"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "4L41", "3M", "3L49"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			slam: ["4L15", "3L11"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tailwhip: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			yawn: ["4L31", "3L35"],
		},
	},
	murkrow: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			assurance: ["4L25"],
			astonish: ["4L1", "3L9", "3S0"],
			attract: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4E", "3E"],
			darkpulse: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			drillpeck: ["4E", "3E"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			featherdance: ["4E", "3E"],
			feintattack: ["4L35", "4E", "3L35"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			haze: ["4L11", "3L22"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			icywind: ["4T", "3T"],
			meanlook: ["4L41", "3L48"],
			mimic: ["3T"],
			mirrormove: ["4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4L21", "3L27"],
			ominouswind: ["4T"],
			payback: ["4M"],
			peck: ["4L1", "3L1", "3S0"],
			perishsong: ["4E", "3E"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M"],
			psychoshift: ["4E"],
			psychup: ["4M", "3T"],
			pursuit: ["4L5", "3L14"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			screech: ["4E"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			skyattack: ["4E", "3T", "3E"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["3T"],
			spite: ["4T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L45"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "4L31", "3M", "3L40"],
			thief: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			whirlwind: ["4E", "3E"],
			wingattack: ["4L15", "4E", "3E"],
		},
	},
	honchkrow: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aircutter: ["4T"],
			astonish: ["4L1"],
			attract: ["4M"],
			calmmind: ["4M"],
			captivate: ["4M"],
			darkpulse: ["4M", "4L55"],
			defog: ["4M"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			embargo: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fly: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			haze: ["4L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			mudslap: ["4T"],
			nastyplot: ["4L35"],
			naturalgift: ["4M"],
			nightslash: ["4L45"],
			ominouswind: ["4T"],
			payback: ["4M"],
			pluck: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			pursuit: ["4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roost: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			spite: ["4T"],
			steelwing: ["4M"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			superpower: ["4T"],
			swagger: ["4M", "4L25"],
			swift: ["4T"],
			taunt: ["4M"],
			thief: ["4M"],
			thunderwave: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			twister: ["4T"],
			uproar: ["4T"],
			wingattack: ["4L1"],
		},
	},
	misdreavus: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			astonish: ["4L10", "3L11"],
			attract: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4L14", "3L17"],
			curse: ["4E"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			destinybond: ["4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1", "3S0"],
			grudge: ["4L46", "3L53"],
			hiddenpower: ["4M", "3M"],
			icywind: ["4T"],
			imprison: ["4E", "3E"],
			meanlook: ["4L19", "3L23"],
			memento: ["4E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T", "4E"],
			painsplit: ["4L28", "3L37"],
			payback: ["4M", "4L32"],
			perishsong: ["4L41", "3L45"],
			powergem: ["4L50"],
			protect: ["4M", "3M"],
			psybeam: ["4L23", "3L30"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "4E", "3T", "3E"],
			psywave: ["4L1", "3L1", "3S0"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "4L37", "3M"],
			shadowsneak: ["4E"],
			shockwave: ["4M", "3M"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T", "4L5", "4E", "3L6", "3S0"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4E"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T"],
			willowisp: ["4M"],
		},
	},
	mismagius: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			astonish: ["4L1"],
			attract: ["4M"],
			calmmind: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			darkpulse: ["4M"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			embargo: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			growl: ["4L1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icywind: ["4T"],
			luckychant: ["4L1"],
			magicalleaf: ["4L1"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			psywave: ["4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T", "4L1"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			taunt: ["4M"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T"],
			willowisp: ["4M"],
		},
	},
	unown: {
		inherit: true,
		learnset: {
			hiddenpower: ["4L1", "3L1"],
		},
	},
	wynaut: {
		inherit: true,
		learnset: {
			charm: ["4L1", "3L1", "3S0"],
			counter: ["4L15", "3L15"],
			destinybond: ["4L15", "3L15"],
			encore: ["4L1", "3L1", "3S0"],
			mirrorcoat: ["4L15", "3L15"],
			safeguard: ["4L15", "3L15"],
			splash: ["4L1", "3L1", "3S0"],
			tickle: ["3S0"],
		},
	},
	wobbuffet: {
		inherit: true,
		learnset: {
			counter: ["4L1", "3L1", "3S0", "3S1"],
			destinybond: ["4L1", "3L1", "3S0", "3S1"],
			mirrorcoat: ["4L1", "3L1", "3S0", "3S1"],
			safeguard: ["4L1", "3L1", "3S0", "3S1"],
		},
	},
	girafarig: {
		inherit: true,
		learnset: {
			agility: ["4L14", "3L31"],
			amnesia: ["4E", "3E"],
			assurance: ["4L28"],
			astonish: ["4L1", "3L7"],
			attract: ["4M", "3M"],
			batonpass: ["4L23", "3L37"],
			beatup: ["4E", "3E"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L13"],
			crunch: ["4L46", "3L49"],
			doubleedge: ["3T"],
			doublehit: ["4L32"],
			doublekick: ["4E"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			futuresight: ["4E", "3E"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			guardswap: ["4L1"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "3M"],
			magiccoat: ["4E", "3E"],
			mimic: ["3T"],
			mirrorcoat: ["4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["4L5", "3L25"],
			powerswap: ["4L1"],
			protect: ["4M", "3M"],
			psybeam: ["4L19", "3L43"],
			psychic: ["4M", "4L37", "3M"],
			psychup: ["4M", "4E", "3T", "3E"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stomp: ["4L10", "3L19"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4E", "3E"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T"],
			wish: ["4E", "3E"],
			zenheadbutt: ["4T", "4L41"],
		},
	},
	pineco: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bide: ["4L17", "3L29"],
			bodyslam: ["3T"],
			bugbite: ["4L9"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E", "3S1"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L42", "4E", "3T", "3L50"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L31", "3T", "3L36"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gyroball: ["4M", "4L39"],
			hiddenpower: ["4M", "3M"],
			irondefense: ["4T", "4L34"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M", "4L20"],
			payback: ["4M", "4L28"],
			pinmissile: ["4E", "3E", "3S1"],
			protect: ["4M", "4L1", "3M", "3L1", "3S0"],
			rapidspin: ["4L12", "3L22"],
			reflect: ["4M", "4E", "3M", "3E"],
			refresh: ["3S1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4E"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			sandtomb: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["4L6", "3T", "3L8", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spikes: ["4L23", "3L43", "3S1"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4E", "3E"],
			tackle: ["4L1", "3L1", "3S0"],
			takedown: ["4L9", "3L15"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4E"],
		},
	},
	forretress: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bide: ["4L17", "3L29"],
			bodyslam: ["3T"],
			bugbite: ["4L1"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L50", "3T", "3L59"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L33", "3T", "3L39"],
			facade: ["4M", "3M"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M", "4L45"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irondefense: ["4T", "4L38"],
			lightscreen: ["4M", "3M"],
			magnetrise: ["4T", "4L57"],
			mimic: ["3T"],
			mirrorshot: ["4L31"],
			naturalgift: ["4M", "4L20"],
			payback: ["4M", "4L28"],
			protect: ["4M", "4L1", "3M", "3L1"],
			rapidspin: ["4L12", "3L22"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["4L1", "3T", "3L1"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spikes: ["4L23", "3L49"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L1", "3L15"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L1"],
			zapcannon: ["4L62", "3L31"],
		},
	},
	dunsparce: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L41", "4E", "3E"],
			aquatail: ["4T"],
			astonish: ["4E", "3E"],
			attract: ["4M", "3M"],
			bide: ["4E", "3E"],
			bite: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			curse: ["4E", "3E"],
			defensecurl: ["4L5", "3T", "3L4"],
			dig: ["4M", "4L45", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T", "4L49", "3L41"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flail: ["4L53", "3L44"],
			flamethrower: ["4M", "3M"],
			frustration: ["4M", "3M"],
			glare: ["4L13", "3L14"],
			gyroball: ["4M"],
			headbutt: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			magiccoat: ["4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			pursuit: ["4L25", "3L24"],
			rage: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L17", "3T", "3L21"],
			roost: ["4M", "4L33"],
			screech: ["4L29", "3L31"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "4E", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T", "4L21", "3L21"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			takedown: ["4L37", "3L34"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trumpcard: ["4E"],
			waterpulse: ["4M", "3M"],
			yawn: ["4L9", "3L11"],
			zenheadbutt: ["4T"],
		},
	},
	gligar: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4E"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			batonpass: ["4E"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E"],
			crosspoison: ["4E"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["4E", "3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			feint: ["4E"],
			feintattack: ["4L23", "3L28"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L20", "3T"],
			guillotine: ["4L45", "3L52"],
			harden: ["4L9", "3L13"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T", "4L12"],
			metalclaw: ["4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["4E"],
			payback: ["4M"],
			poisonjab: ["4M"],
			poisonsting: ["4L1", "3L1", "3S0"],
			protect: ["4M", "3M"],
			quickattack: ["4L16", "3L20"],
			raindance: ["4M", "3M"],
			razorwind: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			roost: ["4M"],
			sandattack: ["4L5", "3L6", "3S0"],
			sandstorm: ["4M", "3M"],
			sandtomb: ["4E", "3E"],
			screech: ["4L27", "3L44"],
			secretpower: ["4M", "3M"],
			slash: ["4L31", "3L36"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			steelwing: ["4M", "3M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "4L34", "3T"],
			taunt: ["4M"],
			thief: ["4M", "3M"],
			torment: ["4M"],
			toxic: ["4M", "3M"],
			uturn: ["4M", "4L38"],
			wingattack: ["4E", "3E"],
			xscissor: ["4M", "4L42"],
		},
	},
	gliscor: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aquatail: ["4T"],
			attract: ["4M"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			falseswipe: ["4M"],
			feintattack: ["4L23"],
			firefang: ["4L1"],
			fling: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T", "4L20"],
			gigaimpact: ["4M"],
			guillotine: ["4L45"],
			harden: ["4L1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icefang: ["4L1"],
			irontail: ["4M"],
			knockoff: ["4T", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["4L31"],
			payback: ["4M"],
			poisonjab: ["4M", "4L1"],
			protect: ["4M"],
			quickattack: ["4L16"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			roost: ["4M"],
			sandattack: ["4L1"],
			sandstorm: ["4M"],
			screech: ["4L27"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			steelwing: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M", "4L34"],
			taunt: ["4M"],
			thief: ["4M"],
			thunderfang: ["4L1"],
			torment: ["4M"],
			toxic: ["4M"],
			uturn: ["4M", "4L38"],
			xscissor: ["4M", "4L42"],
		},
	},
	snubbull: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bite: ["4L7", "3L13"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["4L1", "3L8", "3S0"],
			closecombat: ["4E"],
			counter: ["3T"],
			crunch: ["4L49", "4E", "3L53", "3E"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4E", "3E"],
			fireblast: ["4M", "3M"],
			firefang: ["4L1", "4E"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			headbutt: ["4L19"],
			healbell: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			icefang: ["4L1", "4E"],
			icepunch: ["4T", "3T"],
			lastresort: ["4T"],
			lick: ["4L13", "3L19"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["4E", "3T", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			payback: ["4M", "4L43"],
			present: ["4E", "3E"],
			protect: ["4M", "3M"],
			rage: ["4L31", "3L34"],
			raindance: ["4M", "3M"],
			reflect: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L25", "3M", "3L26"],
			rocksmash: ["4M", "3M"],
			scaryface: ["4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			smellingsalts: ["4E", "3E"],
			snore: ["4T", "4E", "3T", "3E"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			tailwhip: ["4L1", "3L4", "3S0"],
			takedown: ["4L37", "3L43"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderfang: ["4L1", "4E"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	granbull: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bite: ["4L7", "3L13"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["4L1", "3L8"],
			counter: ["3T"],
			crunch: ["4L59", "3L61"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4L1"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			headbutt: ["4L19"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icefang: ["4L1"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lick: ["4L13", "3L19"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			payback: ["4M", "4L51"],
			protect: ["4M", "3M"],
			rage: ["4L35", "3L38"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L27", "3M", "3L28"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			scaryface: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L4"],
			takedown: ["4L43", "3L49"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderfang: ["4L1"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	qwilfish: {
		inherit: true,
		learnset: {
			aquatail: ["4T", "4L45"],
			astonish: ["4E", "3E"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M", "4L33"],
			bubblebeam: ["4E", "3E"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			destinybond: ["4L53", "3L45"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			frustration: ["4M", "3M"],
			gyroball: ["4M"],
			hail: ["4M", "3M"],
			harden: ["4L9", "3L9", "3S0"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L57", "3L37"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			minimize: ["4L9", "3L9", "3S0"],
			naturalgift: ["4M"],
			payback: ["4M"],
			pinmissile: ["4L37", "3L21"],
			poisonjab: ["4M", "4L49", "4E"],
			poisonsting: ["4L1", "3L1", "3S0"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4L29", "3L25"],
			rollout: ["4T", "4L17", "3T"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T", "4E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			spikes: ["4L1", "3L1"],
			spitup: ["4L25"],
			stockpile: ["4L25"],
			substitute: ["4M", "3T"],
			supersonic: ["4E", "3E"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["3T"],
			tackle: ["4L1", "3L1", "3S0"],
			takedown: ["4L41", "3L33"],
			taunt: ["4M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			toxicspikes: ["4L21"],
			waterfall: ["4M", "3M"],
			watergun: ["4L13", "3L13"],
			waterpulse: ["4M", "3M"],
		},
	},
	shuckle: {
		inherit: true,
		learnset: {
			acupressure: ["4E"],
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			bide: ["4L1", "3L28"],
			bodyslam: ["3T"],
			bugbite: ["4L40"],
			captivate: ["4M"],
			constrict: ["4L1", "3L1", "3S0"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			encore: ["4L9", "3L14", "3S1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T", "4L35"],
			gyroball: ["4M"],
			helpinghand: ["4T", "4E"],
			hiddenpower: ["4M", "3M"],
			knockoff: ["4E"],
			mimic: ["3T"],
			mudslap: ["4T", "4E", "3T"],
			naturalgift: ["4M"],
			powertrick: ["4L48"],
			protect: ["4M", "3M"],
			rest: ["4M", "4L27", "3M", "3L37"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "4L14", "3M", "3L23"],
			sandstorm: ["4M", "3M"],
			sandtomb: ["4E"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M", "3S1"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T", "3S1"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4E", "3E"],
			toxic: ["4M", "3M", "3S1"],
			withdraw: ["4L1", "3L1", "3S0"],
			wrap: ["4L22", "3L9", "3S0"],
		},
	},
	heracross: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L13"],
			attract: ["4M", "3M"],
			bide: ["4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "4L19", "3M", "3L23"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			closecombat: ["4L37"],
			counter: ["4L25", "3T", "3L30"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["4E", "3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "4L1", "3T", "3L11"],
			facade: ["4M", "3M"],
			falseswipe: ["4E", "3E"],
			feint: ["4L49"],
			flail: ["4E", "3E"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L7", "3L17"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			harden: ["4E", "3E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["4L1", "3L6"],
			hyperbeam: ["4M", "3M"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			leer: ["4L1", "3L1"],
			megahorn: ["4L55", "3L53"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["4L1"],
			protect: ["4M", "3M"],
			pursuit: ["4E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4E"],
			reversal: ["4L43", "3L45"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L31", "3L37"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
		},
	},
	sneasel: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L24", "3L36"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			beatup: ["4L38", "3L57"],
			bite: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E"],
			crushclaw: ["4E", "3E"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublehit: ["4E"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4E", "3E"],
			falseswipe: ["4M"],
			feintattack: ["4L14", "3L22"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L21", "3L29"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "4E", "3T"],
			iceshard: ["4L49", "4E"],
			icywind: ["4T", "4L28", "3T", "3L43"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			leer: ["4L1", "3L1", "3S0"],
			metalclaw: ["4L42", "3L64"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			punishment: ["4E"],
			pursuit: ["4E"],
			quickattack: ["4L8", "3L8", "3S0"],
			raindance: ["4M", "3M"],
			reflect: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			scratch: ["4L1", "3L1", "3S0"],
			screech: ["4L10", "3L15"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			slash: ["4L35", "3L50"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T", "4E", "3E"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			taunt: ["4M", "4L1", "3M", "3L1", "3S0"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			xscissor: ["4M"],
		},
	},
	weavile: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			assurance: ["4L1"],
			attract: ["4M"],
			avalanche: ["4M"],
			blizzard: ["4M"],
			brickbreak: ["4M", "4S0"],
			calmmind: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			darkpulse: ["4M", "4L49"],
			dig: ["4M"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			embargo: ["4M", "4L1"],
			endure: ["4M"],
			facade: ["4M"],
			fakeout: ["4S0"],
			falseswipe: ["4M"],
			feintattack: ["4L14"],
			fling: ["4M", "4L38"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			furyswipes: ["4L21"],
			gigaimpact: ["4M"],
			hail: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T"],
			iceshard: ["4S0"],
			icywind: ["4T", "4L28"],
			irontail: ["4M"],
			knockoff: ["4T"],
			leer: ["4L1"],
			metalclaw: ["4L42"],
			mudslap: ["4T"],
			nastyplot: ["4L24"],
			naturalgift: ["4M"],
			nightslash: ["4L35", "4S0"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M"],
			psychup: ["4M"],
			quickattack: ["4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			revenge: ["4L1"],
			rocksmash: ["4M"],
			scratch: ["4L1"],
			screech: ["4L10"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shadowclaw: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M"],
			taunt: ["4M", "4L1"],
			thief: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			xscissor: ["4M"],
		},
	},
	teddiursa: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["4L36"],
			closecombat: ["4E"],
			counter: ["4E", "3T", "3E"],
			covet: ["4L1"],
			crosschop: ["4E"],
			crunch: ["4E", "3E"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4E", "3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			faketears: ["4L1", "4E", "3L19", "3E"],
			feintattack: ["4L15", "3L25"],
			firepunch: ["4T", "3T"],
			fling: ["4M", "4L57"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L8", "3L13"],
			gunkshot: ["4T"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			lastresort: ["4T"],
			leer: ["4L1", "3L1", "3S0"],
			lick: ["4L1", "3L7", "3S0", "3S1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["4E", "3E", "3S1"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4E"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			refresh: ["3S1"],
			rest: ["4M", "4L43", "3M", "3L31"],
			return: ["4M", "3M", "3S1"],
			roar: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			scratch: ["4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["4E", "3T", "3E"],
			shadowclaw: ["4M"],
			slash: ["4L29", "3L37"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			snore: ["4T", "4L43", "3T", "3L43"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L22"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			takedown: ["4E", "3E"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thrash: ["4L50", "3L49"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			yawn: ["4E", "3E"],
		},
	},
	ursaring: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			covet: ["4L1"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			faketears: ["4L1", "3L19"],
			feintattack: ["4L15", "3L25"],
			firepunch: ["4T", "3T"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L8", "3L1"],
			gigaimpact: ["4M"],
			gunkshot: ["4T"],
			hammerarm: ["4L67"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			lastresort: ["4T"],
			leer: ["4L1", "3L1"],
			lick: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L47", "3M", "3L31"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			scaryface: ["4L38"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			slash: ["4L29", "3L37"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "4L49", "3T", "3L43"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L22"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thrash: ["4L58", "3L49"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	slugma: {
		inherit: true,
		learnset: {
			acidarmor: ["4E", "3E"],
			amnesia: ["4L31", "3L29"],
			ancientpower: ["4T", "4L26"],
			attract: ["4M", "3M"],
			bodyslam: ["4L46", "3T", "3L50"],
			captivate: ["4M"],
			curse: ["4E"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T", "4L56"],
			ember: ["4L8", "3L8"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "4L53", "3M", "3L36"],
			frustration: ["4M", "3M"],
			harden: ["4L16", "3L22"],
			heatwave: ["4T", "4E", "3E"],
			hiddenpower: ["4M", "3M"],
			irondefense: ["4T"],
			lavaplume: ["4L38"],
			lightscreen: ["4M", "3M"],
			memento: ["4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			recover: ["4L23"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "4L41", "3T", "3L43"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L11", "3L15"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "3T"],
			smog: ["4L1", "3L1"],
			smokescreen: ["4E"],
			snore: ["4T", "3T"],
			spitup: ["4E"],
			stockpile: ["4E"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4E"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
			yawn: ["4L1", "3L1"],
		},
	},
	magcargo: {
		inherit: true,
		learnset: {
			amnesia: ["4L31", "3L29"],
			ancientpower: ["4T", "4L26"],
			attract: ["4M", "3M"],
			bodyslam: ["4L52", "3T", "3L60"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T", "4L66"],
			earthquake: ["4M", "3M", "3S0"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			explosion: ["4M"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "4L61", "3M", "3L36", "3S0"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M"],
			harden: ["4L16", "3L22"],
			heatwave: ["4T", "3S0"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irondefense: ["4T"],
			lavaplume: ["4L40"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			recover: ["4L23"],
			reflect: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L45", "3T", "3L48"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L1", "3L1"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "3T"],
			smog: ["4L1", "3L1"],
			snore: ["4T", "3T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
			yawn: ["4L1", "3L1"],
		},
	},
	swinub: {
		inherit: true,
		learnset: {
			amnesia: ["4L49", "3L55"],
			ancientpower: ["4T", "4E", "3E", "3S0"],
			attract: ["4M", "3M"],
			bite: ["4E", "3E"],
			blizzard: ["4M", "4L44", "3M", "3L46"],
			bodyslam: ["4E", "3T", "3E"],
			captivate: ["4M"],
			charm: ["3S0"],
			curse: ["4E"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4E", "3T", "3E"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L37", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "4L16", "3T", "3L19"],
			facade: ["4M", "3M"],
			fissure: ["4E"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			iceshard: ["4L28"],
			iciclespear: ["4E", "3E"],
			icywind: ["4T", "4L25", "3T"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			mist: ["4L40", "3L37", "3S0"],
			mudbomb: ["4L20"],
			mudshot: ["4E", "3E", "3S0"],
			mudslap: ["4T", "4L13", "3T"],
			mudsport: ["4L4"],
			naturalgift: ["4M"],
			odorsleuth: ["4L1", "3L1"],
			powdersnow: ["4L8", "3L10"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L32", "4E", "3L28", "3E"],
			toxic: ["4M", "3M"],
		},
	},
	piloswine: {
		inherit: true,
		learnset: {
			amnesia: ["4L65", "3L70"],
			ancientpower: ["4T", "4L1"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "4L56", "3M", "3L56"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L40", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "4L16", "3T", "3L1"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L33", "3L33"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["3L1"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icefang: ["4L28"],
			icywind: ["4T", "4L25", "3T"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			mist: ["4L48", "3L42"],
			mudbomb: ["4L20"],
			mudslap: ["4T", "4L13", "3T"],
			mudsport: ["4L1"],
			naturalgift: ["4M"],
			odorsleuth: ["4L1", "3L1"],
			peck: ["4L1"],
			powdersnow: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			takedown: ["4L32", "3L28"],
			toxic: ["4M", "3M"],
		},
	},
	mamoswine: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L1"],
			attract: ["4M"],
			avalanche: ["4M"],
			blizzard: ["4M", "4L56"],
			captivate: ["4M"],
			dig: ["4M"],
			doublehit: ["4L33"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L40"],
			endeavor: ["4T"],
			endure: ["4M", "4L16"],
			facade: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			hail: ["4M", "4L25"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icefang: ["4L28"],
			icywind: ["4T"],
			ironhead: ["4T"],
			knockoff: ["4T"],
			lightscreen: ["4M"],
			mist: ["4L48"],
			mudbomb: ["4L20"],
			mudslap: ["4T", "4L13"],
			mudsport: ["4L1"],
			naturalgift: ["4M"],
			odorsleuth: ["4L1"],
			peck: ["4L1"],
			powdersnow: ["4L1"],
			protect: ["4M"],
			raindance: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandstorm: ["4M"],
			scaryface: ["4L65"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			superpower: ["4T"],
			swagger: ["4M"],
			takedown: ["4L32"],
			toxic: ["4M"],
		},
	},
	corsola: {
		inherit: true,
		learnset: {
			amnesia: ["4E", "3E"],
			ancientpower: ["4T", "4L32", "3L45"],
			aquaring: ["4L37", "4E"],
			attract: ["4M", "3M"],
			barrier: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bubble: ["4L8", "3L12"],
			bubblebeam: ["4L25", "3L23"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4E", "3E"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T", "4L53"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			harden: ["4L4", "3L6"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			iciclespear: ["4E", "3E"],
			icywind: ["4T"],
			ingrain: ["4E", "3E"],
			lightscreen: ["4M", "3M"],
			luckychant: ["4L28"],
			mimic: ["3T"],
			mirrorcoat: ["4L48", "3L39"],
			mist: ["4E", "3E"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S0"],
			naturalgift: ["4M"],
			naturepower: ["4E"],
			powergem: ["4L44"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			raindance: ["4M", "3M"],
			recover: ["4L13", "3L17"],
			reflect: ["4M", "3M"],
			refresh: ["4L16", "3L17"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockblast: ["4L20", "3L34"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikecannon: ["4L40", "3L28"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	remoraid: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			aurorabeam: ["4L14", "4E", "3L22", "3E"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubblebeam: ["4L19", "3L22"],
			bulletseed: ["4M", "4L27"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			defensecurl: ["3T"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flail: ["4E"],
			flamethrower: ["4M", "3M"],
			focusenergy: ["4L23", "3L33"],
			frustration: ["4M", "3M"],
			gunkshot: ["4T"],
			haze: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L45", "3M", "3L55"],
			icebeam: ["4M", "4L40", "3M", "3L44"],
			icywind: ["4T"],
			lockon: ["4L6", "3L11"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			octazooka: ["4E", "3E"],
			protect: ["4M", "3M"],
			psybeam: ["4L10", "3L22"],
			psychic: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockblast: ["4E", "3E"],
			screech: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			signalbeam: ["4T", "4L36"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "4E", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4E", "3E"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			thunderwave: ["4M", "4E", "3T", "3E"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "4L32", "3M"],
		},
	},
	octillery: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			aurorabeam: ["4L1", "3L22"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubblebeam: ["4L19", "3L22"],
			bulletseed: ["4M", "4L29", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			constrict: ["4L1", "3L11"],
			defensecurl: ["3T"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flashcannon: ["4M"],
			focusenergy: ["4L23", "3L38"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gunkshot: ["4T", "4L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L55", "4S0", "3M", "3L70"],
			icebeam: ["4M", "4L48", "4S0", "3M", "3L54"],
			icywind: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			octazooka: ["4L25", "4S0", "3L25"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			psybeam: ["4L1", "3L22"],
			psychic: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockblast: ["4L1"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			signalbeam: ["4T", "4L42", "4S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			wringout: ["4L36"],
		},
	},
	delibird: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			aurorabeam: ["4E", "3E"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			counter: ["3T"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			fly: ["4M", "3M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4E", "3E"],
			gunkshot: ["4T"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			iceball: ["4E", "3E"],
			icebeam: ["4M", "3M"],
			icepunch: ["4E"],
			iceshard: ["4E"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["4M"],
			present: ["4L1", "3L1", "3S0"],
			protect: ["4M", "3M"],
			quickattack: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rapidspin: ["4E", "3E"],
			recycle: ["4M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			signalbeam: ["4T"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["3T"],
			splash: ["4E", "3E"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	mantyke: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			agility: ["4L19"],
			aircutter: ["4T"],
			aquaring: ["4L46"],
			attract: ["4M"],
			blizzard: ["4M"],
			bounce: ["4T", "4L40"],
			bubble: ["4L1"],
			bubblebeam: ["4L10"],
			captivate: ["4M"],
			confuseray: ["4L37"],
			dive: ["4T"],
			doubleteam: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			frustration: ["4M"],
			hail: ["4M"],
			haze: ["4E"],
			headbutt: ["4L13"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hydropump: ["4L49", "4E"],
			icebeam: ["4M"],
			icywind: ["4T"],
			mirrorcoat: ["4E"],
			mudslap: ["4T"],
			mudsport: ["4E"],
			naturalgift: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockslide: ["4E"],
			secretpower: ["4M"],
			signalbeam: ["4E"],
			slam: ["4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			splash: ["4E"],
			substitute: ["4M"],
			supersonic: ["4L4"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			takedown: ["4L31"],
			toxic: ["4M"],
			twister: ["4E"],
			waterfall: ["4M"],
			waterpulse: ["4M", "4L28"],
			watersport: ["4E"],
			wingattack: ["4L22"],
		},
	},
	mantine: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L19", "3L29"],
			aircutter: ["4T"],
			aquaring: ["4L46"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T", "4L40"],
			brine: ["4M"],
			bubble: ["4L1", "3L1", "3S0"],
			bubblebeam: ["4L1", "3L15"],
			bulletseed: ["4M", "4L1"],
			captivate: ["4M"],
			confuseray: ["4L37", "3L50"],
			defog: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gunkshot: ["4T"],
			hail: ["4M", "3M"],
			haze: ["4E", "3E"],
			headbutt: ["4L13"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L49", "4E", "3E"],
			hyperbeam: ["4M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			mimic: ["3T"],
			mirrorcoat: ["4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psybeam: ["4L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "4E", "3E"],
			rocktomb: ["4M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			signalbeam: ["4T", "4L1"],
			slam: ["4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["4E"],
			substitute: ["4M", "3T"],
			supersonic: ["4L1", "3L8", "3S0"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			takedown: ["4L31", "3L22"],
			toxic: ["4M", "3M"],
			twister: ["4E", "3E"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "4L28", "3M", "3L43"],
			watersport: ["4E"],
			wingattack: ["4L22", "3L36"],
		},
	},
	skarmory: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L12", "3L16"],
			aircutter: ["4T", "4L23", "3L29"],
			airslash: ["4L39"],
			assurance: ["4E"],
			attract: ["4M", "3M"],
			bravebird: ["4E"],
			captivate: ["4M"],
			counter: ["3T"],
			curse: ["4E", "3E"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drillpeck: ["4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feint: ["4L20"],
			flash: ["4M"],
			flashcannon: ["4M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L17", "3L26"],
			furycutter: ["4T"],
			hiddenpower: ["4M", "3M"],
			icywind: ["4T"],
			irondefense: ["4T"],
			leer: ["4L1", "3L1"],
			metalsound: ["4L31", "3L45"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4L45"],
			ominouswind: ["4T"],
			payback: ["4M"],
			peck: ["4L1", "3L1"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			roost: ["4M"],
			sandattack: ["4L6", "3L10"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			skyattack: ["4E", "3T", "3E"],
			slash: ["4L42"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikes: ["4L27", "3L42"],
			stealthrock: ["4M"],
			steelwing: ["4M", "4L34", "3M", "3L32"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L9", "3T", "3L13"],
			swordsdance: ["4M"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			whirlwind: ["4E", "3E"],
			xscissor: ["4M"],
		},
	},
	houndour: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			beatup: ["4L27", "4E", "3E"],
			bite: ["4L17", "3L25"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["3S1"],
			counter: ["4E", "3T", "3E"],
			crunch: ["4L48", "3L49"],
			darkpulse: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			embargo: ["4M", "4L40"],
			ember: ["4L1", "3L1", "3S0", "3S1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L35", "3L37", "3S1"],
			fireblast: ["4M", "3M"],
			firefang: ["4L30", "4E"],
			firespin: ["4E", "3E"],
			flamethrower: ["4M", "4L43", "3M", "3L43"],
			frustration: ["4M", "3M"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			howl: ["4L4", "3L7", "3S0"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L53", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["4L22", "3L31"],
			overheat: ["4M", "3M"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			punishment: ["4E"],
			pursuit: ["4E", "3E"],
			rage: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4E", "3E"],
			roar: ["4M", "4L14", "3M", "3L19", "3S1"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			smog: ["4L9", "3L13"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T", "4E", "3E"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderfang: ["4E"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			willowisp: ["4M", "4E", "3E"],
		},
	},
	houndoom: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			beatup: ["4L28"],
			bite: ["4L17", "3L27"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["4L54", "3L59"],
			darkpulse: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			embargo: ["4M", "4L44"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L38", "3L43"],
			fireblast: ["4M", "3M"],
			firefang: ["4L32"],
			flamethrower: ["4M", "4L48", "3M", "3L51"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			howl: ["4L1", "3L1"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L60"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["4L22", "3L35"],
			overheat: ["4M", "3M"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L14", "3M", "3L19"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			smog: ["4L1", "3L13"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderfang: ["4L1"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			willowisp: ["4M"],
		},
	},
	phanpy: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4E", "3E"],
			attract: ["4M", "3M"],
			bodyslam: ["4E", "3T", "3E"],
			captivate: ["4M"],
			charm: ["4L33"],
			counter: ["4E", "3T", "3E"],
			defensecurl: ["4L1", "3T", "3L9"],
			doubleedge: ["4L42", "3T", "3L49"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T", "4E"],
			endure: ["4M", "4L28", "3T", "3L41"],
			facade: ["4M", "3M"],
			fissure: ["4E", "3E"],
			flail: ["4L6", "3L17"],
			focusenergy: ["4E", "3E"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1"],
			gunkshot: ["4T"],
			hiddenpower: ["4M", "3M"],
			iceshard: ["4E"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4L37"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M", "4L19"],
			odorsleuth: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L15", "3T", "3L33"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slam: ["4L24"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "4E", "3T", "3E"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L10", "3L25"],
			toxic: ["4M", "3M"],
		},
	},
	donphan: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			assurance: ["4L31"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["4L1", "3T", "3L9"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L46", "3M", "3L49"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firefang: ["4L1"],
			flail: ["4L1", "3L17"],
			frustration: ["4M", "3M"],
			furyattack: ["4L25", "3L25"],
			gigaimpact: ["4M", "4L54"],
			growl: ["4L1", "3L1"],
			gunkshot: ["4T"],
			gyroball: ["4M"],
			hiddenpower: ["4M", "3M"],
			hornattack: ["4L1", "3L1"],
			hyperbeam: ["4M", "3M"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T", "4L10"],
			magnitude: ["4L19"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["3L1"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			rapidspin: ["4L6", "3L41"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L15", "3T", "3L33"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4L39"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slam: ["4L24"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			thunderfang: ["4L1"],
			toxic: ["4M", "3M"],
		},
	},
	stantler: {
		inherit: true,
		learnset: {
			astonish: ["4L7", "3L11"],
			attract: ["4M", "3M"],
			bite: ["4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			calmmind: ["4M", "4L27", "3M", "3L47"],
			captivate: ["4M", "4L49"],
			chargebeam: ["4M"],
			confuseray: ["4L23", "3L41"],
			disable: ["4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["4E"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			extrasensory: ["4E", "3E"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L10", "3L17"],
			imprison: ["4L43"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			leer: ["4L3", "3L7", "3S0"],
			lightscreen: ["4M", "3M"],
			mefirst: ["4L53"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "4E", "3T", "3E"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			roleplay: ["4L33", "3L31"],
			sandattack: ["4L16", "3L27"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T", "4E", "3E"],
			stomp: ["4L13", "3L21"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			takedown: ["4L21", "3L37"],
			thief: ["4M", "3M"],
			thrash: ["4E"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trickroom: ["4M"],
			uproar: ["4T"],
			zenheadbutt: ["4T", "4L38", "4E"],
		},
	},
	smeargle: {
		inherit: true,
		learnset: {
			sketch: ["4L1", "3L1", "3S0"],
		},
	},
	miltank: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bide: ["4L15", "3L26"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4L24", "3T", "3L43"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M", "4L35"],
			counter: ["3T"],
			curse: ["4E", "3E"],
			defensecurl: ["4L5", "3T", "3L8"],
			dizzypunch: ["4E"],
			doubleedge: ["4E", "3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "4E", "3T", "3E"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L3", "3L4"],
			gyroball: ["4M", "4L41"],
			hammerarm: ["4E"],
			healbell: ["4L48", "3L53"],
			helpinghand: ["4T", "4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			milkdrink: ["4L11", "3L19"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			present: ["4E", "3E"],
			protect: ["4M", "3M"],
			psychup: ["4M", "4E", "3T", "3E"],
			punishment: ["4E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4E", "3E"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L19", "3T", "3L34"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["4E", "3T", "3E"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			stomp: ["4L8", "3L13"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			wakeupslap: ["4L55"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T", "4L29"],
		},
	},
	raikou: {
		inherit: true,
		learnset: {
			aurasphere: ["4S3"],
			bite: ["4L1", "3L1"],
			bodyslam: ["3T"],
			calmmind: ["4M", "4L78", "3M", "3L81"],
			chargebeam: ["4M"],
			crunch: ["4L43", "3L61", "3S1"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			discharge: ["4L57"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["4L64"],
			extremespeed: ["4S3"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			quickattack: ["4L22", "4S2", "3L31", "3S0", "3S1"],
			raindance: ["4M", "4L71", "3M"],
			reflect: ["4M", "4L36", "4S2", "3M", "3L51", "3S1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["4L29", "4S2", "3L41", "3S0", "3S1"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["4M", "4L71", "3M", "3L71"],
			thunderbolt: ["4M", "3M"],
			thunderfang: ["4L50"],
			thundershock: ["4L8", "3L11", "3S0"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			weatherball: ["4S3"],
			zapcannon: ["4S3"],
		},
	},
	entei: {
		inherit: true,
		learnset: {
			bite: ["4L1", "3L1"],
			bodyslam: ["3T"],
			calmmind: ["4M", "4L78", "3M", "3L81"],
			crushclaw: ["4S3"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			ember: ["4L8", "3L11", "3S0"],
			endure: ["4M", "3T"],
			eruption: ["4L85"],
			extrasensory: ["4L64"],
			extremespeed: ["4S3"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "4L71", "3M", "3L71"],
			firefang: ["4L50"],
			firespin: ["4L22", "4S2", "3L31", "3S0", "3S1"],
			flamethrower: ["4M", "4L36", "4S2", "3M", "3L51", "3S1"],
			flareblitz: ["4S3"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			howl: ["4S3"],
			hyperbeam: ["4M", "3M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			lavaplume: ["4L57"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stomp: ["4L29", "4S2", "3L41", "3S0", "3S1"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L43", "3T", "3L61", "3S1"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	suicune: {
		inherit: true,
		learnset: {
			airslash: ["4S3"],
			aquaring: ["4S3"],
			aurorabeam: ["4L29", "4S2", "3L41", "3S0", "3S1"],
			avalanche: ["4M"],
			bite: ["4L1", "3L1"],
			blizzard: ["4M", "4L85", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bubblebeam: ["4L8", "3L11", "3S0"],
			calmmind: ["4M", "4L78", "3M", "3L81"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["4L64"],
			extremespeed: ["4S3"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gust: ["4L22", "4S2", "3L31", "3S0", "3S1"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L71", "3L71"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icefang: ["4L50"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mirrorcoat: ["4L43", "3L61", "3S1"],
			mist: ["4L36", "4S2", "3L51", "3S1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M"],
			sheercold: ["4S3"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4L57"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	larvitar: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4E", "3E"],
			assurance: ["4E"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			crunch: ["4L37", "3L43"],
			curse: ["4E", "3E"],
			darkpulse: ["4M", "4L28"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragondance: ["4E", "3E", "3S0"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L41", "3M", "3L50"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			focusenergy: ["4E", "3E"],
			frustration: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L50", "3M", "3L57"],
			irondefense: ["4E"],
			ironhead: ["4T", "4E"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4E", "3E", "3S0"],
			payback: ["4M", "4L32"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L14", "3T", "3L22"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			sandstorm: ["4M", "4L5", "3M", "3L8", "3S0"],
			scaryface: ["4L19", "3L36"],
			screech: ["4L10", "3L15"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["4E", "3E"],
			stoneedge: ["4M", "4L46"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thrash: ["4L23", "3L29"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	pupitar: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			crunch: ["4L41", "3L47"],
			darkpulse: ["4M", "4L28"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L47", "3M", "3L56"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L60", "3M", "3L65"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M", "4L34"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L14", "3T", "3L22"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			sandstorm: ["4M", "4L1", "3M", "3L1"],
			scaryface: ["4L19", "3L38"],
			screech: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L54"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thrash: ["4L23", "3L29"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	tyranitar: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bite: ["4L1", "3L1"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["4L41", "3L47", "3S0"],
			cut: ["4M", "3M"],
			darkpulse: ["4M", "4L28"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4M", "3M"],
			dragonpulse: ["4M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L47", "3M", "3L61", "3S0"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4L1"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L70", "3M", "3L75"],
			icebeam: ["4M", "3M"],
			icefang: ["4L1"],
			icepunch: ["4T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			outrage: ["4T"],
			payback: ["4M", "4L34"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L14", "3T", "3L22"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "4L1", "3M", "3L1"],
			scaryface: ["4L19", "3L38", "3S0"],
			screech: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L54"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thrash: ["4L23", "3L29", "3S0"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderfang: ["4L1"],
			thunderpunch: ["4T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	lugia: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aeroblast: ["4L85", "3L77"],
			aircutter: ["4T"],
			ancientpower: ["4T", "4L57", "3L88"],
			aquatail: ["4T"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			calmmind: ["4M", "4L93", "3M"],
			chargebeam: ["4M"],
			defog: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonpulse: ["4M"],
			dreameater: ["4M", "3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M", "3S1"],
			endure: ["4M", "3T"],
			extrasensory: ["4L65"],
			facade: ["4M", "3M"],
			featherdance: ["3S1"],
			flash: ["4M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L79", "3L99"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			gust: ["4L15", "3L22"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L29", "3L44", "3S0", "3S1"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M", "4L51"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychoboost: ["3S1"],
			psychup: ["4M", "3T"],
			punishment: ["4L71"],
			raindance: ["4M", "4L37", "3M", "3L55", "3S0"],
			recover: ["4L23", "3L33", "3S0"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			roost: ["4M"],
			safeguard: ["4M", "4L9", "3M", "3L11"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			skyattack: ["4L99"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L43", "3T", "3L66", "3S0"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			twister: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlwind: ["4L1", "3L1"],
			zenheadbutt: ["4T"],
		},
	},
	hooh: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			ancientpower: ["4T", "4L57", "3L88"],
			calmmind: ["4M", "4L93", "3M"],
			chargebeam: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["4L65"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "4L29", "3M", "3L44", "3S0"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L79", "3L99"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			gust: ["4L15", "3L22"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ironhead: ["4T"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M", "4L51"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			overheat: ["4M", "3M"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			punishment: ["4L71", "4S2"],
			raindance: ["4M", "3M"],
			recover: ["4L23", "3L33", "3S0"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			roost: ["4M"],
			sacredfire: ["4L85", "3L77"],
			safeguard: ["4M", "4L9", "3M", "3L11"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skyattack: ["4L99", "3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			steelwing: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4L37", "3M", "3L55", "3S0"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L43", "3T", "3L66", "3S0"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			whirlwind: ["4L1", "3L1"],
			willowisp: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	celebi: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T", "4L28", "3L20", "3S1", "3S3"],
			batonpass: ["4L37", "3L40", "3S1"],
			calmmind: ["4M", "3M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L1", "3S0"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthpower: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L64", "3L30", "3S1", "3S3"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			healbell: ["4L1", "3L1", "3S0", "3S2", "3S3"],
			healblock: ["4L55"],
			healingwish: ["4L73", "4S4"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			lastresort: ["4T"],
			leafstorm: ["4L82", "4S4"],
			leechseed: ["4L1", "3L1", "3S2"],
			lightscreen: ["4M", "3M"],
			magicalleaf: ["4L19"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4S4"],
			naturalgift: ["4M", "4L46"],
			nightmare: ["3T"],
			perishsong: ["4L91", "3L50", "3S1"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recover: ["4L1", "4S4", "3L1", "3S0", "3S2"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "4L10", "3M", "3L10", "3S0", "3S2", "3S3"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thunderwave: ["4M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
			worryseed: ["4T"],
			zenheadbutt: ["4T"],
		},
	},
	treecko: {
		inherit: true,
		learnset: {
			absorb: ["4L6", "3L6", "3S0"],
			aerialace: ["4M", "3M"],
			agility: ["4L31", "3L31"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["4E", "3E"],
			crushclaw: ["4E", "3E"],
			cut: ["4M", "3M"],
			detect: ["4L41", "3L41"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["4E"],
			doubleteam: ["4M", "3M"],
			dragonbreath: ["4E", "3E"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endeavor: ["4T", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["4M", "4L51"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "4L46", "3M", "3L46"],
			grassknot: ["4M"],
			grasswhistle: ["4E"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leafstorm: ["4E"],
			leechseed: ["4E", "3E"],
			leer: ["4L1", "3L1", "3S0"],
			magicalleaf: ["4E"],
			megadrain: ["4L26", "3L26"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			pound: ["4L1", "3L1", "3S0"],
			protect: ["4M", "3M"],
			pursuit: ["4L16", "3L16"],
			quickattack: ["4L11", "3L11"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			screech: ["4L21", "3L21"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			slam: ["4L36", "3L36"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4E"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			worryseed: ["4T", "4E"],
		},
	},
	grovyle: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1"],
			aerialace: ["4M", "3M"],
			agility: ["4L35", "3L35"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			detect: ["4L47", "3L47"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4L53", "3L53"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L16", "3T", "3L16"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leafblade: ["4L29", "3L29"],
			leafstorm: ["4L59"],
			leer: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			pursuit: ["4L17", "3L17"],
			quickattack: ["4L1", "3L1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			screech: ["4L23", "3L23"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			slam: ["4L41", "3L41"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
			xscissor: ["4M"],
		},
	},
	sceptile: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1"],
			aerialace: ["4M", "3M"],
			agility: ["4L35", "3L35"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			detect: ["4L51", "3L51"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4M", "3M"],
			dragonpulse: ["4M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4L59", "3L59"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frenzyplant: ["4T"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T", "3L16"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leafblade: ["4L29", "3L29"],
			leafstorm: ["4L67"],
			leer: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4L1"],
			outrage: ["4T"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			pursuit: ["4L17", "3L17"],
			quickattack: ["4L1", "3L1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			screech: ["4L23", "3L23"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			slam: ["4L43", "3L43"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
			xscissor: ["4M", "4L16"],
		},
	},
	torchic: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4E"],
			attract: ["4M", "3M"],
			batonpass: ["4E"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			captivate: ["4M"],
			counter: ["4E", "3T", "3E"],
			crushclaw: ["4E"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			ember: ["4L10", "3L10", "3S0"],
			endure: ["4M", "4E", "3T", "3E"],
			facade: ["4M", "3M"],
			feint: ["4E"],
			fireblast: ["4M", "3M"],
			firespin: ["4L25", "3L25"],
			flamethrower: ["4M", "4L43", "3M", "3L43"],
			focusenergy: ["4L7", "3L7", "3S0"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1", "3S0"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			lastresort: ["4T", "4E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["4L37", "3L37"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4E"],
			overheat: ["4M", "3M"],
			peck: ["4L16", "3L16"],
			protect: ["4M", "3M"],
			quickattack: ["4L28", "3L28"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4E", "3E"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandattack: ["4L19", "3L19"],
			scratch: ["4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			slash: ["4L34", "3L34"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["4E", "3E"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	combusken: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "4L28", "3M", "3L28"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["4L16", "3L16"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			flareblitz: ["4L54"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			lastresort: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["4L43", "3L43"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			peck: ["4L17", "3L17"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L32", "3L32"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandattack: ["4L21", "3L21"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			skyuppercut: ["4L50", "3L50"],
			slash: ["4L39", "3L39"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
			willowisp: ["4M"],
		},
	},
	blaziken: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			blastburn: ["4T"],
			blazekick: ["4L36", "3L36", "3S0"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			bravebird: ["4L49"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "4L28", "3M", "3L28"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["4L16", "3L16"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "4L1", "3T", "3L1"],
			flamethrower: ["4M", "3M"],
			flareblitz: ["4L66"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["3L49", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			peck: ["4L17", "3L17"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L32", "3L32"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandattack: ["4L21", "3L21"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			skyuppercut: ["4L59", "3L59", "3S0"],
			slash: ["4L42", "3L42", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
			willowisp: ["4M"],
		},
	},
	mudkip: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4E"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			bide: ["4L15", "3L15"],
			bite: ["4E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["4E"],
			curse: ["4E", "3E"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["4E", "3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			endeavor: ["4T", "4L46", "3L46"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			foresight: ["4L19", "3L19"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1", "3S0"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L42", "3L42"],
			iceball: ["4E", "3E"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mirrorcoat: ["4E", "3E"],
			mudbomb: ["4E"],
			mudslap: ["4T", "4L6", "3T", "3L6", "3S0"],
			mudsport: ["4L24", "3L24"],
			naturalgift: ["4M"],
			protect: ["4M", "4L37", "3M", "3L37"],
			raindance: ["4M", "3M"],
			refresh: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stomp: ["4E", "3E"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			takedown: ["4L28", "3L28"],
			toxic: ["4M", "3M"],
			uproar: ["4E", "3E"],
			waterfall: ["4M", "3M"],
			watergun: ["4L10", "3L10", "3S0"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4L33", "4E", "3L33"],
		},
	},
	marshtomp: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			bide: ["4L15", "3L15"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L46", "3M", "3L46"],
			endeavor: ["4T", "4L53", "3L53"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			foresight: ["4L20", "3L20"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["4L25"],
			muddywater: ["4L37", "3L37"],
			mudshot: ["4L16", "3L16"],
			mudslap: ["4T", "4L1", "3T", "3L1"],
			mudsport: ["3L25"],
			naturalgift: ["4M"],
			protect: ["4M", "4L42", "3M", "3L42"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L31", "3L31"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	swampert: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bide: ["4L15", "3L15"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L52", "3M", "3L52"],
			endeavor: ["4T", "4L61", "3L61"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["4L20", "3L20"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "3M"],
			hammerarm: ["4L69"],
			hiddenpower: ["4M", "3M"],
			hydrocannon: ["4T"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["4L25"],
			muddywater: ["4L39", "3L39"],
			mudshot: ["4L16", "3L16"],
			mudslap: ["4T", "4L1", "3T", "3L1"],
			mudsport: ["3L25"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "4L46", "3M", "3L46"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L31", "3L31"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	poochyena: {
		inherit: true,
		learnset: {
			assurance: ["4L29"],
			astonish: ["4E", "3E"],
			attract: ["4M", "3M"],
			bite: ["4L13", "3L13"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["3T"],
			covet: ["4E", "3E"],
			crunch: ["4L53", "3L41"],
			darkpulse: ["4M"],
			dig: ["4M", "3M", "3S0"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			embargo: ["4M", "4L41"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firefang: ["4E"],
			frustration: ["4M", "3M"],
			healbell: ["3S0"],
			hiddenpower: ["4M", "3M"],
			howl: ["4L5", "3L5", "3S0"],
			icefang: ["4E"],
			irontail: ["4M", "3M"],
			leer: ["4E", "3E"],
			mefirst: ["4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["4L17", "3L17"],
			payback: ["4M"],
			poisonfang: ["4E", "3E", "3S0"],
			protect: ["4M", "3M"],
			psychup: ["3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L21", "3M", "3L21"],
			rocksmash: ["4M", "3M"],
			sandattack: ["4L9", "3L9"],
			scaryface: ["4L33", "3L29"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L49", "4E"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L25", "3T", "3L25"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L45", "3L33"],
			taunt: ["4M", "4L37", "3M", "3L37"],
			thief: ["4M", "3M", "3L45"],
			thunderfang: ["4E"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			yawn: ["4E", "3E"],
		},
	},
	mightyena: {
		inherit: true,
		learnset: {
			assurance: ["4L32"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["3L47"],
			darkpulse: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			embargo: ["4M", "4L47"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			howl: ["4L1", "3L1"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["4L17", "3L17"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L22", "3M", "3L22"],
			rocksmash: ["4M", "3M"],
			sandattack: ["4L1", "3L1"],
			scaryface: ["4L37", "3L32"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L62"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L27", "3T", "3L27"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L52", "3L37"],
			taunt: ["4M", "4L42", "3M", "3L42"],
			thief: ["4M", "4L57", "3M", "3L52"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	zigzagoon: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bellydrum: ["4L41", "3L41"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4E", "3E"],
			covet: ["4L29", "3L29"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			extremespeed: ["3S1"],
			facade: ["4M", "3M"],
			flail: ["4L33", "3L33"],
			fling: ["4M", "4L45"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1", "3S0", "3S1"],
			gunkshot: ["4T"],
			headbutt: ["4L9", "3L9"],
			helpinghand: ["4T", "4E"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "4E", "3T"],
			mudsport: ["4L21", "3L21"],
			naturalgift: ["4M"],
			odorsleuth: ["4L17", "3L17"],
			pinmissile: ["4L25", "3L25"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L37", "3M", "3L37"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandattack: ["4L13", "3L13"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "4E", "3T", "3E"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S0", "3S1"],
			tailwhip: ["4L5", "3L5", "3S0", "3S1"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			tickle: ["4E", "3E"],
			toxic: ["4M", "3M"],
			trick: ["4T", "4E", "3E"],
			waterpulse: ["4M", "3M"],
		},
	},
	linoone: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bellydrum: ["4L53", "3L53"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			covet: ["4L35", "3L35"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M", "4L59"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L29", "3L29"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			gunkshot: ["4T"],
			headbutt: ["4L1", "3L1"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L23", "3L23"],
			naturalgift: ["4M"],
			odorsleuth: ["4L17", "3L17"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L47", "3M", "3L47"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandattack: ["4L13", "3L13"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slash: ["4L41", "3L41"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			switcheroo: ["4L1"],
			tackle: ["4L1", "3L1"],
			tailwhip: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	wurmple: {
		inherit: true,
		learnset: {
			bugbite: ["4L15"],
			poisonsting: ["4L5", "3L5"],
			snore: ["4T"],
			stringshot: ["4L1", "3L1"],
			tackle: ["4L1", "3L1"],
		},
	},
	silcoon: {
		inherit: true,
		learnset: {
			harden: ["4L1", "3L1"],
			irondefense: ["4T"],
		},
	},
	beautifly: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1"],
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			attract: ["4M", "4L31", "3M", "3L31"],
			bugbuzz: ["4L41"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "4L38", "3M", "3L38"],
			gigaimpact: ["4M"],
			gust: ["4L13", "3L13"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			megadrain: ["4L24", "3L24"],
			mimic: ["3T"],
			morningsun: ["4L20", "3L20"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M", "4L34", "3L34"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stunspore: ["4L17", "3L17"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4L27", "3L27"],
		},
	},
	cascoon: {
		inherit: true,
		learnset: {
			harden: ["4L1", "3L1"],
			irondefense: ["4T"],
		},
	},
	dustox: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			bugbuzz: ["4L41"],
			captivate: ["4M"],
			confusion: ["4L1", "3L1"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			gust: ["4L13", "3L13"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			lightscreen: ["4M", "4L31", "3M", "3L31"],
			mimic: ["3T"],
			moonlight: ["4L20", "3L20"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "4L17", "3M", "3L17"],
			psybeam: ["4L24", "3L24"],
			psychic: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M", "4L34", "3L34"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "4L38", "3M", "3L38"],
			twister: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4L27", "3L27"],
		},
	},
	lotad: {
		inherit: true,
		learnset: {
			absorb: ["4L5", "3L7", "3S0"],
			astonish: ["4L1", "3L1", "3S0"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bubblebeam: ["4L25"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M", "4L43"],
			facade: ["4M", "3M"],
			flail: ["4E", "3E"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			growl: ["4L3", "3L3", "3S0"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			leechseed: ["4E", "3E"],
			megadrain: ["4L19", "3L43"],
			mimic: ["3T"],
			mist: ["4L11", "3L21"],
			naturalgift: ["4M", "4L15"],
			naturepower: ["4L7", "3L13"],
			protect: ["4M", "3M"],
			raindance: ["4M", "4L35", "3M", "3L31"],
			razorleaf: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4E", "3E"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4E", "3E"],
			thief: ["4M", "3M"],
			tickle: ["4E"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			watergun: ["4E", "3E"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T", "4L27"],
		},
	},
	lombre: {
		inherit: true,
		learnset: {
			absorb: ["4L5", "3L7"],
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bubblebeam: ["4L25"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			fakeout: ["4L11", "3L19"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			furyswipes: ["4L15", "3L25"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			growl: ["4L3", "3L3"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L43", "3L49"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["4L7", "3L13"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thief: ["4M", "3M", "3L37"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T", "4L35", "3L43"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["4L19", "3L31"],
			zenheadbutt: ["4T", "4L27"],
		},
	},
	ludicolo: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megadrain: ["4L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T"],
		},
	},
	seedot: {
		inherit: true,
		learnset: {
			amnesia: ["4E", "3E"],
			attract: ["4M", "3M"],
			bide: ["4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M", "3S1"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			explosion: ["4M", "4L43", "3T", "3L43"],
			facade: ["4M", "3M"],
			falseswipe: ["4E", "3E"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M", "3S1"],
			grassknot: ["4M"],
			growth: ["4L7", "3L7", "3S0"],
			harden: ["4L3", "3L3", "3S0"],
			hiddenpower: ["4M", "3M"],
			leechseed: ["4E", "3E"],
			mimic: ["3T"],
			nastyplot: ["4E"],
			naturalgift: ["4M"],
			naturepower: ["4L13", "3L13"],
			protect: ["4M", "3M"],
			quickattack: ["4E", "3E"],
			razorwind: ["4E", "3E"],
			refresh: ["3S1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M", "3S1"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4L31", "3M", "3L31"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L21", "3L21"],
			takedown: ["4E", "3E"],
			toxic: ["4M", "3M"],
			worryseed: ["4T", "4E"],
		},
	},
	nuzleaf: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			explosion: ["4M", "3T"],
			extrasensory: ["4L49", "3L49"],
			facade: ["4M", "3M"],
			fakeout: ["4L19", "3L19"],
			feintattack: ["4L31", "3L31"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			growth: ["4L7", "3L7"],
			harden: ["4L3", "3L3"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["4L13", "3L13"],
			payback: ["4M"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			razorleaf: ["4L1"],
			razorwind: ["4L37", "3L37"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L43", "3T", "3L43"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thief: ["4M", "3M"],
			torment: ["4M", "4L25", "3M", "3L25"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
		},
	},
	shiftry: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L1"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growth: ["3L1"],
			harden: ["3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icywind: ["4T"],
			knockoff: ["4T"],
			leafstorm: ["4L49"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L1"],
			naturalgift: ["4M"],
			naturepower: ["3L1"],
			ominouswind: ["4T"],
			payback: ["4M"],
			pound: ["3L1"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			razorleaf: ["4L1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			whirlwind: ["4L1"],
			worryseed: ["4T"],
			xscissor: ["4M"],
		},
	},
	taillow: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L34", "3M", "3L34"],
			agility: ["4L43", "3L43"],
			aircutter: ["4T"],
			airslash: ["4L53"],
			attract: ["4M", "3M"],
			bravebird: ["4E"],
			captivate: ["4M"],
			counter: ["3T"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L19", "3M", "3L19"],
			endeavor: ["4T", "4L26", "3L26"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			featherdance: ["3S0"],
			fly: ["4M", "3M"],
			focusenergy: ["4L4", "3L4", "3S0"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1", "3S0"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["4L1", "3L1", "3S0"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			quickattack: ["4L8", "3L8"],
			rage: ["4E", "3E"],
			raindance: ["4M", "3M"],
			refresh: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			skyattack: ["4E", "3T", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4E", "3E"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4E"],
			wingattack: ["4L13", "3L13"],
		},
	},
	swellow: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L38", "3M", "3L38"],
			agility: ["4L49", "3L49", "3S0"],
			aircutter: ["4T"],
			airslash: ["4L61"],
			attract: ["4M", "3M"],
			batonpass: ["3S0"],
			captivate: ["4M"],
			counter: ["3T"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L19", "3M", "3L19"],
			endeavor: ["4T", "4L28", "3L28"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M", "3S0"],
			fly: ["4M", "3M"],
			focusenergy: ["4L1", "3L1"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["4L1", "3L1"],
			pluck: ["4M", "4L1"],
			protect: ["4M", "3M"],
			quickattack: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
			wingattack: ["4L13", "3L13"],
		},
	},
	wingull: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L42", "3M"],
			agility: ["4L37", "4E", "3L55", "3E"],
			aircutter: ["4T"],
			airslash: ["4L47"],
			aquaring: ["4E"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			brine: ["4M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1"],
			gust: ["4E", "3E"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T", "4E"],
			mimic: ["3T"],
			mist: ["4L16", "4E", "3L21", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4L34", "3L43"],
			quickattack: ["4L24", "3L31"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M", "4L29"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			supersonic: ["4L6", "3L7"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4E", "3E"],
			uproar: ["4T"],
			uturn: ["4M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "4L19", "3M"],
			watersport: ["4E", "3E"],
			wingattack: ["4L11", "3L13"],
		},
	},
	pelipper: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			brine: ["4M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fling: ["4M", "4L43"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			gunkshot: ["4T"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L57", "3L61"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			mimic: ["3T"],
			mist: ["4L16", "3L21"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["4M", "4L24"],
			pluck: ["4M"],
			protect: ["4M", "4L25", "3M", "3L25"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M", "4L31"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shockwave: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spitup: ["4L38", "3L47"],
			steelwing: ["4M", "3M"],
			stockpile: ["4L38", "3L33"],
			substitute: ["4M", "3T"],
			supersonic: ["4L6", "3L7"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L38", "3L33"],
			swift: ["4T", "3T"],
			tailwind: ["4L50"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["4M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "4L19", "3M"],
			watersport: ["4L1", "3L1"],
			wingattack: ["4L1", "3L1"],
		},
	},
	ralts: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "4L23", "3M", "3L21"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L39", "3S1"],
			confuseray: ["4E"],
			confusion: ["4L6", "3L6", "3S2"],
			defensecurl: ["3T"],
			destinybond: ["4E", "3E"],
			disable: ["4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L10", "3M", "3L11"],
			dreameater: ["4M", "4L45", "3T", "3L46"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L34", "3L36"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1", "3S0", "3S1"],
			grudge: ["4E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L43", "3L41"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			imprison: ["4L32", "3L31"],
			lightscreen: ["4M", "3M"],
			luckychant: ["4L17"],
			magicalleaf: ["4L21"],
			meanlook: ["4E", "3E"],
			memento: ["4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L28", "3M", "3L26"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M", "3S2"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shadowsneak: ["4E"],
			shockwave: ["4M", "3M", "3S2"],
			signalbeam: ["4T"],
			sing: ["3S2"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T"],
			taunt: ["4M", "3M"],
			teleport: ["4L12", "3L16"],
			thief: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			willowisp: ["4E", "3E"],
			wish: ["3S0"],
			zenheadbutt: ["4T"],
		},
	},
	kirlia: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "4L25", "3M", "3L21"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L45"],
			confusion: ["4L1", "3L1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L1", "3M", "3L1"],
			dreameater: ["4M", "4L53", "3T", "3L54"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L39", "3L40"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L50", "3L47"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			imprison: ["4L36", "3L33"],
			lightscreen: ["4M", "3M"],
			luckychant: ["4L17"],
			magicalleaf: ["4L22", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L31", "3M", "3L26"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T"],
			taunt: ["4M", "3M"],
			teleport: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	gardevoir: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "4L25", "3M", "3L21"],
			captivate: ["4M", "4L53"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L1", "3M", "3L1"],
			dreameater: ["4M", "4L65", "3T", "3L60"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L45", "3L42"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1"],
			healingwish: ["4L1"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypnosis: ["4L60", "3L51"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			imprison: ["4L40", "3L33"],
			lightscreen: ["4M", "3M"],
			magicalleaf: ["4L22"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L33", "3M", "3L26"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T"],
			taunt: ["4M", "3M"],
			teleport: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			wish: ["4L17"],
			zenheadbutt: ["4T"],
		},
	},
	gallade: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M"],
			brickbreak: ["4M"],
			bulkup: ["4M"],
			calmmind: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			closecombat: ["4L53"],
			confusion: ["4L1"],
			cut: ["4M"],
			doubleteam: ["4M", "4L1"],
			drainpunch: ["4M"],
			dreameater: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			falseswipe: ["4M", "4L45"],
			feint: ["4L39"],
			firepunch: ["4T"],
			flash: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T", "4L17"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T", "4L36"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icepunch: ["4T"],
			knockoff: ["4T"],
			leafblade: ["4L1"],
			leer: ["4L1"],
			lightscreen: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["4L1"],
			poisonjab: ["4M"],
			protect: ["4M", "4L50"],
			psychic: ["4M"],
			psychocut: ["4L31"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			slash: ["4L22"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M", "4L25"],
			taunt: ["4M"],
			teleport: ["4L1"],
			thief: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			thunderwave: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			vacuumwave: ["4T"],
			xscissor: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	surskit: {
		inherit: true,
		learnset: {
			agility: ["4L31", "3L31"],
			attract: ["4M", "3M"],
			batonpass: ["4L43"],
			blizzard: ["4M", "3M"],
			bubble: ["4L1", "3L1", "3S0", "3S1"],
			bubblebeam: ["4L25", "3L25"],
			bugbite: ["4E"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			haze: ["4L37", "3L37"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4E", "3E"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mindreader: ["4E", "3E"],
			mist: ["4L37", "3L37"],
			mudshot: ["4E", "3E"],
			mudslap: ["4T"],
			mudsport: ["3S0"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psybeam: ["4E", "3E"],
			psychup: ["4M", "3T"],
			quickattack: ["4L7", "3L7", "3S1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T", "4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L13", "3L13"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["4L19", "3L19"],
		},
	},
	masquerain: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			airslash: ["4L47"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bubble: ["4L1", "3L1"],
			bugbuzz: ["4L61"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			gust: ["4L22", "3L26"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T", "4L1"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			quickattack: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			scaryface: ["4L26", "3L33"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M", "4L40", "3L47"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stunspore: ["4L33", "3L40"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L1", "3L1"],
			swift: ["4T", "3T"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
			watersport: ["4L1", "3L1"],
			whirlwind: ["4L54", "3L53"],
		},
	},
	shroomish: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			faketears: ["4E", "3E"],
			falseswipe: ["4E", "3E", "3S0"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "4L37", "3M", "3L45"],
			grassknot: ["4M"],
			growth: ["4L33", "3L36"],
			headbutt: ["4L21", "3L22"],
			helpinghand: ["4T", "4E", "3E"],
			hiddenpower: ["4M", "3M"],
			leechseed: ["4L13", "3L10"],
			megadrain: ["4L17", "3L16", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["4L25", "3L28"],
			protect: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T", "4L41", "4E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spore: ["4L45", "3L54"],
			stunspore: ["4L9", "3L7", "3S0"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4E", "3T", "3E"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			tackle: ["4L5", "3L4"],
			toxic: ["4M", "3M"],
			wakeupslap: ["4E"],
			worryseed: ["4T", "4L29", "4E"],
		},
	},
	breloom: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["4L25", "3T", "3L28"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["4L45", "3T", "3L54"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["4L29"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			headbutt: ["4L21", "3L22"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leechseed: ["4L1", "3L1"],
			machpunch: ["4L23", "3L23"],
			megadrain: ["4L17", "3L16"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mindreader: ["4L37", "3L45"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T", "4L41"],
			seismictoss: ["3T"],
			skyuppercut: ["4L33", "3L36"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			stunspore: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			tackle: ["4L1", "3L1"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
			worryseed: ["4T"],
		},
	},
	slakoth: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			amnesia: ["4L25", "3L25"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4E", "3T", "3E"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["4L37", "3T", "3L37"],
			covet: ["4L31", "3L31"],
			crushclaw: ["4E", "3E"],
			curse: ["4E", "3E"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["4L7", "3L7"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L19", "3L19"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flail: ["4L43", "3L43"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gunkshot: ["4T"],
			hammerarm: ["4E"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4E"],
			protect: ["4M", "3M"],
			pursuit: ["4E", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slackoff: ["4L13", "3L13"],
			slash: ["4E", "3E"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			snore: ["4T", "4E", "3T", "3E"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			yawn: ["4L1", "3L1"],
		},
	},
	vigoroth: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["4L37", "3T", "3L37"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			encore: ["4L1", "3L1"],
			endure: ["4M", "4L25", "3T", "3L25"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L1"],
			focuspunch: ["4M", "4L43", "3M", "3L43"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L19", "3L19"],
			gunkshot: ["4T"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4L49", "3L49"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slash: ["4L31", "3L31"],
			sleeptalk: ["4M", "3T"],
			snore: ["3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	slaking: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4S0", "3M"],
			amnesia: ["4L25", "3L25"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["4L37", "3T", "3L37"],
			covet: ["4L31", "3L31"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			encore: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L19", "3L19"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flail: ["4L43", "3L43"],
			flamethrower: ["4M", "3M"],
			fling: ["4M", "4L49"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M", "4S0"],
			gunkshot: ["4T"],
			hammerarm: ["4L61"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			punishment: ["4L55"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "4S0", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M", "4S0"],
			shockwave: ["4M", "3M"],
			slackoff: ["4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L36", "3T", "3L36"],
			taunt: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			yawn: ["4L1", "3L1"],
		},
	},
	nincada: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			bugbite: ["4E"],
			bugbuzz: ["4E"],
			cut: ["4M", "3M"],
			dig: ["4M", "4L45", "3M", "3L45"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "4E", "3T", "3E"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4L25", "3L25"],
			feintattack: ["4E", "3E"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L14", "3L14"],
			gigadrain: ["4M", "3M"],
			gust: ["4E", "3E"],
			harden: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			leechlife: ["4L5", "3L5"],
			metalclaw: ["4L38", "3L38"],
			mimic: ["3T"],
			mindreader: ["4L19", "3L19"],
			mudslap: ["4T", "4L31", "3T", "3L31"],
			naturalgift: ["4M"],
			nightslash: ["4E"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			sandattack: ["4L9", "3L9"],
			sandstorm: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			silverwind: ["4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			toxic: ["4M", "3M"],
			xscissor: ["4M"],
		},
	},
	ninjask: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L38", "3L38"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			batonpass: ["4L45", "3L45"],
			bugbite: ["4L1"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			defog: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L20", "3M", "3L20"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L20", "3T", "3L20"],
			furyswipes: ["4L14", "3L14"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			harden: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leechlife: ["4L1", "3L1"],
			mimic: ["3T"],
			mindreader: ["4L19", "3L19"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			sandattack: ["4L1", "3L1"],
			sandstorm: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			screech: ["4L20", "3L20"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			silverwind: ["4M"],
			slash: ["4L31", "3L31"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "4L25", "3T", "3L25"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			uturn: ["4M"],
			xscissor: ["4M", "4L52"],
		},
	},
	shedinja: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4R", "3R"],
			batonpass: ["4R", "3R"],
			confuseray: ["4L31", "3L31", "3S0"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L14", "3L14"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grudge: ["4L45", "3L45", "3S0"],
			harden: ["4L1", "3L1"],
			healblock: ["4L52"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leechlife: ["4L5", "3L5"],
			mimic: ["3T"],
			mindreader: ["4L19", "3L19"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			sandattack: ["4L9", "3L9"],
			sandstorm: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			screech: ["4R", "3R"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "4L59", "3M", "3L38", "3S0"],
			shadowclaw: ["4M"],
			shadowsneak: ["4L38"],
			slash: ["4R", "3R"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T", "4L25", "3L25", "3S0"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4R", "3R"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			willowisp: ["4M"],
			xscissor: ["4M"],
		},
	},
	whismur: {
		inherit: true,
		learnset: {
			astonish: ["4L11", "3L11"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			endeavor: ["4E"],
			endure: ["4M", "3T"],
			extrasensory: ["4E", "3E"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			howl: ["4L15", "3L15"],
			hypervoice: ["4L45", "3L45"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["4L1", "3L1", "3S0"],
			protect: ["4M", "3M"],
			psychup: ["3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L41", "3M", "3L41"],
			return: ["4M", "3M"],
			roar: ["4M", "4L35", "3M", "3L35"],
			rollout: ["4T", "3T"],
			screech: ["4L31", "3L31"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "4L41", "3T", "3L41"],
			smellingsalts: ["4E", "3E"],
			smokescreen: ["4E"],
			snore: ["4T", "4E", "3T", "3E"],
			solarbeam: ["4M", "3M"],
			stomp: ["4L25", "3L25"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L21", "3L21"],
			swagger: ["4M", "4E", "3T", "3E"],
			takedown: ["4E", "3E"],
			teeterdance: ["3S0"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T", "4L5", "3L5", "3S0"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T"],
		},
	},
	loudred: {
		inherit: true,
		learnset: {
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bite: ["4L20"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			howl: ["4L1", "3L1"],
			hypervoice: ["4L57", "3L57"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psychup: ["3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L51", "3M", "3L51"],
			return: ["4M", "3M"],
			roar: ["4M", "4L43", "3M", "3L43"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			screech: ["4L37", "3L37"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "4L51", "3T", "3L51"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stomp: ["4L29", "3L29"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L23", "3L23"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T"],
		},
	},
	exploud: {
		inherit: true,
		learnset: {
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bite: ["4L20"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["4L40"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4L1"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			howl: ["4L1", "3L1"],
			hyperbeam: ["4M", "4L71", "3M", "3L40", "3S1"],
			hypervoice: ["4L63", "3L63", "3S0"],
			icebeam: ["4M", "3M"],
			icefang: ["4L1"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			overheat: ["4M", "3M"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			psychup: ["3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L55", "3M", "3L55", "3S0"],
			return: ["4M", "3M"],
			roar: ["4M", "4L45", "3M", "3L45", "3S0", "3S1"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			screech: ["4L37", "3L37", "3S1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "4L55", "3T", "3L55", "3S0"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stomp: ["4L29", "3L29", "3S1"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L23", "3L23"],
			surf: ["4M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thunderfang: ["4L1"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T"],
		},
	},
	makuhita: {
		inherit: true,
		learnset: {
			armthrust: ["4L7", "3L10", "3S0"],
			attract: ["4M", "3M"],
			bellydrum: ["4L25", "3L37"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M", "3S0"],
			bulkup: ["4M", "3M"],
			bulletpunch: ["4E"],
			captivate: ["4M"],
			closecombat: ["4L40"],
			counter: ["4E", "3T", "3E"],
			crosschop: ["4E", "3E"],
			detect: ["4E", "3E"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["4E", "3T", "3E"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "4L37", "3T", "3L40"],
			facade: ["4M", "3M"],
			fakeout: ["4L13", "3L19"],
			feintattack: ["4E", "3E"],
			firepunch: ["4T", "3T"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["4L28"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			helpinghand: ["4T", "4E", "3E"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			knockoff: ["4T", "4L19", "3L28"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4E", "3E"],
			reversal: ["4L43", "3L49"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M", "3S0"],
			sandattack: ["4L4", "3L4"],
			secretpower: ["4M", "3M"],
			seismictoss: ["4L31", "3T", "3L46"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["4L22", "3L31"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["4L10", "3L13"],
			wakeupslap: ["4L34", "4E"],
			whirlwind: ["4L16", "3L22"],
		},
	},
	hariyama: {
		inherit: true,
		learnset: {
			armthrust: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bellydrum: ["4L27", "3L40"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			brine: ["4M", "4L1"],
			bulkup: ["4M", "3M"],
			captivate: ["4M"],
			closecombat: ["4L52"],
			counter: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "4L47", "3T", "3L44"],
			facade: ["4M", "3M"],
			fakeout: ["4L13", "3L19"],
			firepunch: ["4T", "3T"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["4L32"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			ironhead: ["4T"],
			knockoff: ["4T", "4L19", "3L29"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4L57", "3L55"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandattack: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["4L37", "3T", "3L51"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["4L22", "3L33"],
			snore: ["4T", "3T"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["4L10", "3L13"],
			wakeupslap: ["4L42"],
			whirlwind: ["4L16", "3L22"],
		},
	},
	nosepass: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			block: ["4L19", "4E", "3L16"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			discharge: ["4L49"],
			doubleedge: ["4E", "3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T", "4L73"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4E", "3T", "3E"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			frustration: ["4M", "3M"],
			harden: ["4L7", "3L7"],
			helpinghand: ["3S0"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			irondefense: ["4T"],
			lockon: ["4L67", "3L46"],
			magnetrise: ["4T"],
			magnitude: ["4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			powergem: ["4L49"],
			protect: ["4M", "3M"],
			rest: ["4M", "4L43", "3M", "3L37"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L31", "3T", "3L28", "3S0"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L13", "3L13"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4E", "3T", "3E"],
			sandstorm: ["4M", "4L37", "3M", "3L31"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L55"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			taunt: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M", "3S0"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "4L25", "3T", "3L22", "3S0"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			zapcannon: ["4L61", "3L43"],
		},
	},
	probopass: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["4M"],
			block: ["4L1"],
			captivate: ["4M"],
			discharge: ["4L49"],
			doubleteam: ["4M"],
			earthpower: ["4T", "4L73"],
			earthquake: ["4M"],
			endure: ["4M"],
			explosion: ["4M"],
			facade: ["4M"],
			firepunch: ["4T"],
			flashcannon: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			gravity: ["4L1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icepunch: ["4T"],
			irondefense: ["4T", "4L1"],
			ironhead: ["4T"],
			lockon: ["4L67"],
			magnetbomb: ["4L1"],
			magnetrise: ["4T", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			powergem: ["4L49"],
			protect: ["4M"],
			rest: ["4M", "4L43"],
			return: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L31"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			rollout: ["4T"],
			sandstorm: ["4M", "4L37"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L55"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			tackle: ["4L1"],
			taunt: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			thunderwave: ["4M", "4L25"],
			torment: ["4M"],
			toxic: ["4M"],
			zapcannon: ["4L61"],
		},
	},
	skitty: {
		inherit: true,
		learnset: {
			assist: ["4L18", "3L19"],
			attract: ["4M", "4L4", "3M", "3L7", "3S2"],
			batonpass: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M", "4L42"],
			chargebeam: ["4M"],
			charm: ["4L22", "3L25"],
			copycat: ["4L11"],
			covet: ["4L32", "3L31"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L39", "3T", "3L39"],
			doubleslap: ["4L15", "3L15"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4L1", "4E"],
			faketears: ["4E", "3E"],
			feintattack: ["4L25", "3L27"],
			flash: ["4M", "3M"],
			foresight: ["4L4"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1", "3S0", "3S1", "3S2"],
			healbell: ["4L36", "3L37"],
			helpinghand: ["4T", "4E", "3E"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			payday: ["3S0"],
			protect: ["4M", "3M"],
			psychup: ["4M", "4E", "3T", "3E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T", "3S1"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["4L8", "3L13"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			suckerpunch: ["4T", "4E"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S0", "3S1", "3S2"],
			tailwhip: ["4L1", "3L3", "3S0", "3S1", "3S2"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			tickle: ["4E", "3E"],
			toxic: ["4M", "3M"],
			uproar: ["4E", "3E"],
			wakeupslap: ["4L29"],
			waterpulse: ["4M", "3M"],
			wish: ["4E", "3E"],
			zenheadbutt: ["4T", "4E"],
		},
	},
	delcatty: {
		inherit: true,
		learnset: {
			attract: ["4M", "4L1", "3M", "3L1", "3S0"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["4L1", "3L1"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4L1"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["3L1"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M", "3S0"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M", "3S0"],
			sing: ["4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetkiss: ["3S0"],
			swift: ["4T", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T"],
		},
	},
	sableye: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			astonish: ["4L11", "3L13"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L46", "3L37"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			detect: ["4L22", "3L25"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4L18", "3L21"],
			feintattack: ["4L32", "3L29", "3S1"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			flatter: ["4E"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["4L4", "3L5", "3S0"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L15", "3L17"],
			helpinghand: ["3S1"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			knockoff: ["4T", "4L29", "3L33"],
			leer: ["4L1", "3L1", "3S0"],
			meanlook: ["4L57", "3L45"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["4E", "3E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4L8", "3L9", "3S0"],
			ominouswind: ["4T"],
			payback: ["4M"],
			poisonjab: ["4M"],
			powergem: ["4L43"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "4E", "3T", "3E"],
			punishment: ["4L36"],
			raindance: ["4M", "3M"],
			recover: ["4E", "3E", "3S1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			scratch: ["4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "4L53", "3M", "3L41", "3S1"],
			shadowclaw: ["4M", "4L39"],
			shadowsneak: ["4L25"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			waterpulse: ["4M", "3M"],
			willowisp: ["4M"],
			zenheadbutt: ["4T", "4L50"],
		},
	},
	mawile: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4E", "3E"],
			astonish: ["4L1", "3L1", "3S0"],
			attract: ["4M", "3M"],
			batonpass: ["4L31", "3L31"],
			bite: ["4L11", "3L11"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			crunch: ["4L36", "3L36"],
			darkpulse: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			faketears: ["4L6", "3L6", "3S0"],
			falseswipe: ["4E", "3E", "3S1"],
			feintattack: ["4L26", "3L26"],
			fireblast: ["4M", "3M"],
			firefang: ["4E"],
			flamethrower: ["4M", "3M"],
			flashcannon: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icefang: ["4E"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L41", "3L41", "3S1"],
			ironhead: ["4T", "4L56"],
			knockoff: ["4T"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonfang: ["4E", "3E"],
			protect: ["4M", "3M"],
			psychup: ["4E", "3T", "3E"],
			punishment: ["4E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M"],
			sing: ["3S1"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spitup: ["4L51", "3L46"],
			stockpile: ["4L51", "3L46"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L46", "4E"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L51", "3L46"],
			sweetscent: ["4L16", "3L16"],
			swordsdance: ["4M", "4E", "3T", "3E"],
			taunt: ["4M", "3M"],
			thunderfang: ["4E"],
			thunderpunch: ["4T", "3T"],
			tickle: ["4E", "3E"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			visegrip: ["4L21", "3L21", "3S1"],
		},
	},
	aron: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			bodyslam: ["4E", "3T", "3E"],
			captivate: ["4M"],
			curse: ["4E"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L43", "3T", "3L44"],
			doubleteam: ["4M", "3M"],
			dragonrush: ["4E"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			harden: ["4L4", "3L4"],
			headbutt: ["4L11", "3L10"],
			hiddenpower: ["4M", "3M"],
			irondefense: ["4T", "4L18", "3L17"],
			ironhead: ["4T", "4L29", "4E"],
			irontail: ["4M", "4L39", "3M", "3L29"],
			magnetrise: ["4T"],
			metalburst: ["4L46"],
			metalclaw: ["4L15", "3L13"],
			metalsound: ["4L36", "3L39"],
			mimic: ["3T"],
			mudslap: ["4T", "4L8", "3T", "3L7"],
			naturalgift: ["4M"],
			protect: ["4M", "4L32", "3M", "3L34"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L22", "3M", "3L21"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			screech: ["4E"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["4E", "3E"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["4E", "3E"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L25", "3L25"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	lairon: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L51", "3T", "3L53"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			harden: ["4L1", "3L1"],
			headbutt: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			irondefense: ["4T", "4L18", "3L17"],
			ironhead: ["4T", "4L29"],
			irontail: ["4M", "4L45", "3M", "3L29"],
			magnetrise: ["4T"],
			metalburst: ["4L56"],
			metalclaw: ["4L15", "3L13"],
			metalsound: ["4L40", "3L45"],
			mimic: ["3T"],
			mudslap: ["4T", "4L1", "3T", "3L1"],
			naturalgift: ["4M"],
			protect: ["4M", "4L34", "3M", "3L37"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L22", "3M", "3L21"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L25", "3L25"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	aggron: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["4L57", "3T", "3L63", "3S0"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4M", "3M"],
			dragonpulse: ["4M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			flashcannon: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			harden: ["4L1", "3L1"],
			headbutt: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L18", "3L17"],
			ironhead: ["4T", "4L29"],
			irontail: ["4M", "4L48", "3M", "3L29", "3S0", "3S1"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["4L65"],
			metalclaw: ["4L15", "3L13"],
			metalsound: ["4L40", "3L50", "3S0", "3S1"],
			mimic: ["3T"],
			mudslap: ["4T", "4L1", "3T", "3L1"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["4M"],
			protect: ["4M", "4L34", "3M", "3L37", "3S0", "3S1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L22", "3M", "3L21"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L25", "3L25", "3S1"],
			taunt: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	meditite: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			batonpass: ["4E", "3E"],
			bide: ["4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			bulletpunch: ["4E"],
			calmmind: ["4M", "4L25", "3M", "3L28"],
			captivate: ["4M"],
			confusion: ["4L8", "3L9", "3S0", "3S1"],
			counter: ["3T"],
			detect: ["4L11", "3L12", "3S1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["4E", "3T", "3E", "3S1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4E", "3E"],
			feint: ["4L22"],
			firepunch: ["4T", "4E", "3T", "3E"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["4L29"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			guardswap: ["4E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "4L15", "3M", "3L17"],
			highjumpkick: ["4L32", "3L32"],
			icepunch: ["4T", "4E", "3T", "3E"],
			lightscreen: ["4M", "3M"],
			meditate: ["4L4", "3L4", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["4L18", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["4M"],
			powerswap: ["4E"],
			powertrick: ["4L39"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychocut: ["4E"],
			psychup: ["4M", "4L36", "3T", "3L36"],
			raindance: ["4M", "3M"],
			recover: ["4L46", "3L44"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4L43", "3L41"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M", "3S1"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T", "3L20"],
			swift: ["4T", "3T"],
			thunderpunch: ["4T", "4E", "3T", "3E"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			vacuumwave: ["4T"],
			zenheadbutt: ["4T"],
		},
	},
	medicham: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bide: ["4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			calmmind: ["4M", "4L25", "3M", "3L28"],
			captivate: ["4M"],
			confusion: ["4L1", "3L1"],
			counter: ["3T"],
			detect: ["4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			feint: ["4L22"],
			firepunch: ["4T", "4L1", "3T", "3L1"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["4L29"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "4L15", "3M", "3L17"],
			highjumpkick: ["4L32", "3L32"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "4L1", "3T", "3L1"],
			lightscreen: ["4M", "3M"],
			meditate: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["4L18", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["4M"],
			powertrick: ["4L42"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "4L36", "3T", "3L36"],
			raindance: ["4M", "3M"],
			recover: ["4L55", "3L54"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			reversal: ["4L49", "3L46"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T", "3L20"],
			swift: ["4T", "3T"],
			thunderpunch: ["4T", "4L1", "3T", "3L1"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			vacuumwave: ["4T"],
			zenheadbutt: ["4T"],
		},
	},
	electrike: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bite: ["4L28", "3L33"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["4L44", "3L41"],
			chargebeam: ["4M"],
			crunch: ["4E", "3E"],
			curse: ["4E", "3E"],
			discharge: ["4L41", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firefang: ["4E"],
			flamethrower: ["4M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			headbutt: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			howl: ["4L12", "3L12"],
			icefang: ["4E"],
			irontail: ["4M", "3M"],
			leer: ["4L9", "3L9"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["4L25", "3L25"],
			protect: ["4M", "3M"],
			quickattack: ["4L17", "3L17"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L36", "3M", "3L28"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["4L20", "3L20"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4E", "3T", "3E"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunder: ["4M", "4L49", "3M", "3L36"],
			thunderbolt: ["4M", "3M"],
			thunderfang: ["4L33", "4E"],
			thunderwave: ["4M", "4L4", "3T", "3L4"],
			toxic: ["4M", "3M"],
			uproar: ["4E", "3E"],
		},
	},
	manectric: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bite: ["4L30", "3L39", "3S0"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["4L54", "3L53"],
			chargebeam: ["4M"],
			discharge: ["4L49"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firefang: ["4L1"],
			flamethrower: ["4M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			howl: ["4L1", "3L1"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["4L25", "3L25"],
			overheat: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L17", "3L17"],
			raindance: ["4M", "3M", "3S0"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4L42", "3M", "3L31"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["4L20", "3L20"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunder: ["4M", "4L61", "3M", "3L45", "3S0"],
			thunderbolt: ["4M", "3M"],
			thunderfang: ["4L37"],
			thunderwave: ["4M", "4L1", "3T", "3L1"],
			toxic: ["4M", "3M"],
		},
	},
	plusle: {
		inherit: true,
		learnset: {
			agility: ["4L44", "3L47"],
			attract: ["4M", "3M"],
			batonpass: ["4L42", "3L40"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["4L35", "3L31"],
			chargebeam: ["4M"],
			copycat: ["4L24"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["4L17", "3L22"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			faketears: ["4L21", "3L28"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1", "3S0", "3S1"],
			helpinghand: ["4T", "4L10", "3L13"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T", "4L48"],
			lightscreen: ["4M", "3M"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4L51"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L7", "3L10", "3S1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["4L15", "3L19"],
			substitute: ["4M", "4E", "3T", "3E"],
			swagger: ["4M", "3T"],
			sweetkiss: ["4E"],
			swift: ["4T", "4L29", "3T"],
			thunder: ["4M", "4L38", "3M", "3L37"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "4L3", "3T", "3L4", "3S0", "3S1"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			watersport: ["3S0"],
			wish: ["4E", "3E"],
		},
	},
	minun: {
		inherit: true,
		learnset: {
			agility: ["4L44", "3L47"],
			attract: ["4M", "3M"],
			batonpass: ["4L42", "3L40"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["4L35", "3L31"],
			chargebeam: ["4M"],
			charm: ["4L21", "3L28"],
			copycat: ["4L24"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["4L17", "3L22"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			faketears: ["4L31"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			growl: ["4L1", "3L1", "3S0", "3S1"],
			helpinghand: ["4T", "4L10", "3L13"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lightscreen: ["4M", "3M"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S0"],
			nastyplot: ["4L51"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4L7", "3L10", "3S1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["4L15", "3L19"],
			substitute: ["4M", "4E", "3T", "3E"],
			swagger: ["4M", "3T"],
			sweetkiss: ["4E"],
			swift: ["4T", "4L29", "3T"],
			thunder: ["4M", "4L38", "3M", "3L37"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "4L3", "3T", "3L4", "3S0", "3S1"],
			toxic: ["4M", "3M"],
			trumpcard: ["4L48"],
			uproar: ["4T"],
			wish: ["4E", "3E"],
		},
	},
	volbeat: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			batonpass: ["4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bugbuzz: ["4L41", "4E"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4L9", "3L5"],
			counter: ["3T"],
			doubleedge: ["4L45", "3T", "3L37"],
			doubleteam: ["4M", "4L5", "3M", "3L9"],
			dynamicpunch: ["3T"],
			encore: ["4E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "4L1", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			helpinghand: ["4T", "4L33", "3L33"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["4L13", "3L13"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "4L29", "3M", "3L29"],
			psychup: ["4M", "3T"],
			quickattack: ["4L17", "3L17"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T", "4L25", "3L25"],
			silverwind: ["4M", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			tailglow: ["4L21", "3L21"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4E", "3E"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T", "4L37"],
		},
	},
	illumise: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			batonpass: ["4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bugbuzz: ["4L41", "4E"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L9", "3L9"],
			counter: ["3T"],
			covet: ["4L45", "3L37"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["4L25", "4E", "3L25"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			flatter: ["4L29", "3L29"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigadrain: ["4M", "3M"],
			growth: ["4E", "3E"],
			helpinghand: ["4T", "4L33", "3L33"],
			hiddenpower: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["4L13", "3L13"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			quickattack: ["4L17", "3L17"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			silverwind: ["4M", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L5", "3L5"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
			wish: ["4L21", "3L21"],
			zenheadbutt: ["4T", "4L37"],
		},
	},
	budew: {
		inherit: true,
		learnset: {
			absorb: ["4L1"],
			attract: ["4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			cottonspore: ["4E"],
			cut: ["4M"],
			doubleteam: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			extrasensory: ["4E"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			grassknot: ["4M"],
			growth: ["4L4"],
			hiddenpower: ["4M"],
			leafstorm: ["4E"],
			megadrain: ["4L13"],
			mindreader: ["4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pinmissile: ["4E"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			razorleaf: ["4E"],
			rest: ["4M"],
			return: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["4M"],
			sleeppowder: ["4E"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			spikes: ["4E"],
			stunspore: ["4L10"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M"],
			synthesis: ["4T", "4E"],
			toxic: ["4M"],
			uproar: ["4T"],
			watersport: ["4L7"],
			worryseed: ["4T", "4L16"],
		},
	},
	roselia: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1", "3S0"],
			aromatherapy: ["4L43", "3L53"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cottonspore: ["4E", "3E"],
			cut: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "4L25", "3M", "3L33"],
			grassknot: ["4M"],
			grasswhistle: ["4L22", "3L29", "3S1"],
			growth: ["4L4", "3L5", "3S0"],
			hiddenpower: ["4M", "3M"],
			ingrain: ["4L34", "3L41"],
			leafstorm: ["4E"],
			leechseed: ["4L16", "3L21", "3S1"],
			magicalleaf: ["4L19", "3L25", "3S1"],
			megadrain: ["4L13", "3L17"],
			mimic: ["3T"],
			mindreader: ["4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			petaldance: ["4L40", "3L49"],
			pinmissile: ["4E", "3E"],
			poisonjab: ["4M"],
			poisonsting: ["4L7", "3L9", "3S0"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M"],
			razorleaf: ["4E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["4M", "3M"],
			sleeppowder: ["4E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spikes: ["4E", "3E"],
			stunspore: ["4L10", "3L13"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetkiss: ["3S1"],
			sweetscent: ["4L31", "3L37"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L46", "4E", "3L57", "3E"],
			toxic: ["4M", "4L37", "3M", "3L45"],
			toxicspikes: ["4L28"],
			worryseed: ["4T"],
		},
	},
	roserade: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			doubleteam: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			magicalleaf: ["4L1"],
			megadrain: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			poisonjab: ["4M"],
			poisonsting: ["4L1"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			sweetscent: ["4L1"],
			swift: ["4T"],
			swordsdance: ["4M"],
			synthesis: ["4T"],
			toxic: ["4M"],
			weatherball: ["4L1"],
			worryseed: ["4T"],
		},
	},
	gulpin: {
		inherit: true,
		learnset: {
			acidarmor: ["4E", "3E"],
			amnesia: ["4L17", "3L17"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			curse: ["4E"],
			defensecurl: ["3T"],
			destinybond: ["4E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "4E", "3T", "3E"],
			dynamicpunch: ["3T"],
			encore: ["4L23", "3L23"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T", "4L44"],
			gigadrain: ["4M", "3M"],
			gunkshot: ["4T", "4L54"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4E", "3E"],
			poisongas: ["4L9", "3L9"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M", "3S0"],
			sing: ["3S0"],
			sleeptalk: ["4M", "3T"],
			sludge: ["4L14", "3L14", "3S0"],
			sludgebomb: ["4M", "4L39", "3M", "3L39"],
			smog: ["4E", "3E"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spitup: ["4L34", "3L34"],
			stockpile: ["4L34", "3L34"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L34", "3L34"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "4L28", "3M", "3L28", "3S0"],
			waterpulse: ["4M", "3M"],
			wringout: ["4L49"],
			yawn: ["4L6", "3L6"],
		},
	},
	swalot: {
		inherit: true,
		learnset: {
			amnesia: ["4L17", "3L17"],
			attract: ["4M", "3M"],
			bodyslam: ["4L26", "3T", "3L26"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["4M"],
			encore: ["4L23", "3L23"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T", "4L52"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			gunkshot: ["4T", "4L66"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poisongas: ["4L1", "3L1"],
			pound: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["4L1", "3L1"],
			sludgebomb: ["4M", "4L45", "3M", "3L48"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spitup: ["4L38", "3L40"],
			stockpile: ["4L38", "3L40"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L38", "3L40"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "4L30", "3M", "3L31"],
			waterpulse: ["4M", "3M"],
			wringout: ["4L59"],
			yawn: ["4L1", "3L1"],
		},
	},
	carvanha: {
		inherit: true,
		learnset: {
			agility: ["4L36", "3L43"],
			ancientpower: ["4T", "4E"],
			aquajet: ["4L31"],
			assurance: ["4L26"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1", "3S0"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			captivate: ["4M"],
			crunch: ["4L28", "3L22"],
			darkpulse: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["4E", "3T", "3E"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			focusenergy: ["4L8", "3L13"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4E", "3E"],
			icebeam: ["4M", "3M"],
			icefang: ["4L16"],
			icywind: ["4T", "3T"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			rage: ["4L6", "3L7"],
			raindance: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			scaryface: ["4L11", "3L16", "3S0"],
			screech: ["4L18", "3L28"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "4L21", "3T", "3L37"],
			swift: ["4T", "3T"],
			takedown: ["4L38", "3L31"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thrash: ["4E", "3E"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M", "3S0"],
			zenheadbutt: ["4T"],
		},
	},
	sharpedo: {
		inherit: true,
		learnset: {
			agility: ["4L45", "3L53"],
			ancientpower: ["4T"],
			aquajet: ["4L34"],
			assurance: ["4L26"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bite: ["4L1", "3L1"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			captivate: ["4M"],
			crunch: ["4L28", "3L22"],
			darkpulse: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feint: ["4L1"],
			focusenergy: ["4L1", "3L1"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icefang: ["4L16"],
			icywind: ["4T", "3T"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4L56"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			rage: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			scaryface: ["4L11", "3L16"],
			screech: ["4L18", "3L28"],
			secretpower: ["4M", "3M"],
			skullbash: ["4L50", "3L48"],
			slash: ["4L30", "3L33"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "4L21", "3T", "3L43"],
			swift: ["4T", "3T"],
			taunt: ["4M", "4L40", "3M", "3L38"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T"],
		},
	},
	wailmer: {
		inherit: true,
		learnset: {
			amnesia: ["4L37", "3L46"],
			astonish: ["4L17", "3L23"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4E", "3T"],
			bounce: ["4T", "4L44"],
			brine: ["4M", "4L31"],
			captivate: ["4M"],
			curse: ["4E", "3E"],
			defensecurl: ["4E", "3T"],
			dive: ["4T", "4L41", "3M"],
			doubleedge: ["4E", "3T", "3E"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fissure: ["4E", "3E"],
			frustration: ["4M", "3M"],
			growl: ["4L4", "3L5"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L47", "3L50"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mist: ["4L24", "3L32"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L27", "3M", "3L37"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L11", "3T", "3L14"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			snore: ["4T", "4E", "3T", "3E"],
			splash: ["4L1", "3L1"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "4E", "3T", "3E"],
			thrash: ["4E", "3E"],
			tickle: ["4E", "3E"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L7", "3L10"],
			waterpulse: ["4M", "4L21", "3M", "3L28"],
			waterspout: ["4L34", "3L41"],
			whirlpool: ["4L14", "3L19"],
		},
	},
	wailord: {
		inherit: true,
		learnset: {
			amnesia: ["4L37", "3L52", "3S0"],
			astonish: ["4L17", "3L23"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T", "4L54"],
			brine: ["4M", "4L31"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			dive: ["4T", "4L46", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L62", "3L59", "3S0"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			mimic: ["3T"],
			mist: ["4L24", "3L32", "3S1"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L27", "3M", "3L37", "3S0", "3S1"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4L1", "3T", "3L1"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["4L1", "3L1"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "4L21", "3M", "3L28", "3S1"],
			waterspout: ["4L34", "3L44", "3S0", "3S1"],
			whirlpool: ["4L14", "3L19"],
		},
	},
	numel: {
		inherit: true,
		learnset: {
			amnesia: ["4L25", "3L31"],
			ancientpower: ["4E"],
			attract: ["4M", "3M"],
			bodyslam: ["4E", "3T", "3E"],
			captivate: ["4M"],
			charm: ["3S0"],
			defensecurl: ["4E", "3T", "3E"],
			dig: ["4M", "3M", "3S0"],
			doubleedge: ["4L51", "3T", "3L49"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T", "4L35"],
			earthquake: ["4M", "4L41", "3M", "3L35"],
			ember: ["4L5", "3L11", "3S0"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "4L45", "3M", "3L41"],
			focusenergy: ["4L15", "3L25"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T", "4E"],
			hiddenpower: ["4M", "3M"],
			howl: ["4E", "3E"],
			lavaplume: ["4L31"],
			magnitude: ["4L11", "3L19"],
			mimic: ["3T"],
			mudbomb: ["4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "4E", "3T", "3E"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4E", "3E"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stomp: ["4E", "3E"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L21", "3L29", "3S0"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
			yawn: ["4E"],
		},
	},
	camerupt: {
		inherit: true,
		learnset: {
			amnesia: ["4L25", "3L31"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T", "4L39"],
			earthquake: ["4M", "4L49", "3M", "3L37"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			eruption: ["4L57", "3L45"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			fissure: ["4L67", "3L55"],
			flamethrower: ["4M", "3M"],
			flashcannon: ["4M"],
			focusenergy: ["4L15", "3L25"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ironhead: ["4T"],
			lavaplume: ["4L31"],
			magnitude: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4L33", "3T", "3L33"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L21", "3L29"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
		},
	},
	torkoal: {
		inherit: true,
		learnset: {
			amnesia: ["4L49", "3L40"],
			attract: ["4M", "3M"],
			bodyslam: ["4L33", "3T", "3L20"],
			captivate: ["4M"],
			curse: ["4L12", "3L7"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4E"],
			ember: ["4L1", "3L1"],
			endure: ["4M", "4E", "3T", "3E"],
			eruption: ["4E", "3E"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firespin: ["4L17", "3L17"],
			fissure: ["4E"],
			flail: ["4L52", "3L43"],
			flamethrower: ["4M", "4L28", "3M", "3L30"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M"],
			heatwave: ["4T", "4L55", "3L46"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M"],
			irondefense: ["4T", "4L44", "3L33"],
			irontail: ["4M", "3M"],
			lavaplume: ["4L39"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "4L36", "3M", "3L27"],
			rapidspin: ["4L23"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			sludgebomb: ["4M", "3M"],
			smog: ["4L4", "3L4"],
			smokescreen: ["4L20", "3L14"],
			snore: ["4T", "3T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			toxic: ["4M", "3M"],
			willowisp: ["4M"],
			withdraw: ["4L7"],
			yawn: ["4E", "3E"],
		},
	},
	spoink: {
		inherit: true,
		learnset: {
			amnesia: ["4E"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T", "4L48", "3L43"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4L18", "3L25"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			extrasensory: ["4E", "3E"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4E", "3E"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "3M"],
			magiccoat: ["4L21", "3L28"],
			mimic: ["3T"],
			mirrorcoat: ["4E"],
			naturalgift: ["4M"],
			odorsleuth: ["4L10", "3L10"],
			payback: ["4M", "4L34"],
			powergem: ["4L46"],
			protect: ["4M", "3M"],
			psybeam: ["4L14", "3L16"],
			psychic: ["4M", "4L41", "3M", "3L34"],
			psychup: ["4M", "4L15", "3T", "3L19"],
			psywave: ["4L7", "3L7"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "4L29", "3M", "3L37"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "4L29", "3T", "3L37"],
			splash: ["4L1", "3L1", "3S0"],
			substitute: ["4M", "4E", "3T", "3E"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderwave: ["4M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T", "4E", "3E"],
			trickroom: ["4M"],
			uproar: ["3S0"],
			zenheadbutt: ["4T", "4L26", "4E"],
		},
	},
	grumpig: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T", "4L60", "3L55"],
			brickbreak: ["4M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4L18", "3L25"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lightscreen: ["4M", "3M"],
			magiccoat: ["4L21", "3L28"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["4L1", "3L1"],
			payback: ["4M", "4L37"],
			powergem: ["4L55"],
			protect: ["4M", "3M"],
			psybeam: ["4L1", "3L1"],
			psychic: ["4M", "4L47", "3M", "3L37"],
			psychup: ["4M", "4L15", "3T", "3L19"],
			psywave: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "4L29", "3M", "3L43"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "4L29", "3T", "3L43"],
			splash: ["4L1", "3L1"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			zenheadbutt: ["4T", "4L26"],
		},
	},
	spinda: {
		inherit: true,
		learnset: {
			assist: ["4E", "3E"],
			attract: ["4M", "3M"],
			batonpass: ["4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			copycat: ["4L10"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			disable: ["4E", "3E"],
			dizzypunch: ["4L28", "3L27"],
			doubleedge: ["4L46", "3T", "3L45"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			encore: ["4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4E"],
			feintattack: ["4L14", "3L12"],
			firepunch: ["4T", "3T"],
			flail: ["4L50", "3L49"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4L23", "3L23"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			lastresort: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psybeam: ["4L19", "3L16"],
			psychic: ["4M", "3M"],
			psychocut: ["4E"],
			psychup: ["4M", "4L41", "3T", "3L38"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			roleplay: ["4E"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["3S0"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["4E", "3E"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L32"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			teeterdance: ["4L37", "3L34"],
			thief: ["4M", "3M"],
			thrash: ["4L55", "3L56"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4E", "3E"],
			trickroom: ["4M"],
			uproar: ["4T", "4L5", "3L5", "3S0"],
			waterpulse: ["4M", "3M"],
			wish: ["4E", "3E"],
			zenheadbutt: ["4T"],
		},
	},
	trapinch: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			crunch: ["4L33", "3L33"],
			dig: ["4M", "4L41", "3M", "3L41"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T", "4L65"],
			earthquake: ["4M", "4L73", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feint: ["4L81"],
			feintattack: ["4L17", "3L17"],
			fissure: ["4L89"],
			flail: ["4E"],
			focusenergy: ["4E", "3E"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4E"],
			gigadrain: ["4M", "3M"],
			gust: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L57", "3M", "3L57"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			quickattack: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandattack: ["4L9", "3L9"],
			sandstorm: ["4M", "4L49", "3M", "3L49"],
			sandtomb: ["4L25", "3L25"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			toxic: ["4M", "3M"],
		},
	},
	vibrava: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			crunch: ["3L33"],
			defog: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L35", "3L35"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L1", "3L1"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T"],
			gigadrain: ["4M", "3M"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L57", "3M", "3L57"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			roost: ["4M"],
			sandattack: ["4L1", "3L1"],
			sandstorm: ["4M", "4L49", "3M", "3L49"],
			sandtomb: ["4L1", "3L1"],
			screech: ["4L41", "3L41"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			sonicboom: ["4L1"],
			steelwing: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L33"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M"],
		},
	},
	flygon: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aircutter: ["4T"],
			attract: ["4M", "3M"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			crunch: ["3L33", "3S0"],
			defog: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T", "4S1"],
			dragonbreath: ["4L35", "3L35", "3S0"],
			dragonclaw: ["4M", "4L45", "4S1", "3M"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4S1", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L1", "3L1"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L57", "3M", "3L65"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			roost: ["4M"],
			sandattack: ["4L1", "3L1"],
			sandstorm: ["4M", "4L49", "3M", "3L53"],
			sandtomb: ["4L1", "3L1", "3S0"],
			screech: ["4L41", "3L41", "3S0"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			sonicboom: ["4L1"],
			steelwing: ["4M", "3M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			supersonic: ["4L33"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunderpunch: ["4T"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uturn: ["4M", "4S1"],
		},
	},
	cacnea: {
		inherit: true,
		learnset: {
			absorb: ["4L5", "3L5", "3S0"],
			acid: ["4E", "3E"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cottonspore: ["4L49", "3L41"],
			counter: ["4E", "3T", "3E"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			destinybond: ["4L57", "3L49"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["4E", "3T", "3E"],
			encore: ["3S0"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			feintattack: ["4L29", "3L29"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			grasswhistle: ["4E", "3E"],
			growth: ["4L9", "3L9"],
			hiddenpower: ["4M", "3M"],
			ingrain: ["4L25", "3L25"],
			leechseed: ["4L13", "3L13"],
			leer: ["4L1", "3L1", "3S0"],
			lowkick: ["4E"],
			magicalleaf: ["4E"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			needlearm: ["4L45", "3L37"],
			payback: ["4M", "4L41"],
			pinmissile: ["4L21", "3L21"],
			poisonjab: ["4M"],
			poisonsting: ["4L1", "3L1", "3S0"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			sandattack: ["4L17", "3L17"],
			sandstorm: ["4M", "4L53", "3M", "3L45"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T", "4E"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["4E"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spikes: ["4L33", "3L33"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L37"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			teeterdance: ["4E", "3E"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
		},
	},
	cacturne: {
		inherit: true,
		learnset: {
			absorb: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cottonspore: ["4L59", "3L47"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			destinybond: ["4L71", "3L59"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			feintattack: ["4L29", "3L29", "3S0"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growth: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ingrain: ["4L25", "3L25", "3S0"],
			leechseed: ["4L13", "3L13"],
			leer: ["4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			needlearm: ["4L53", "3L41", "3S0"],
			payback: ["4M", "4L47"],
			pinmissile: ["4L21", "3L21"],
			poisonjab: ["4M"],
			poisonsting: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			revenge: ["4L1", "3L1"],
			sandattack: ["4L17", "3L17"],
			sandstorm: ["4M", "4L65", "3M", "3L53"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spikes: ["4L35", "3L35", "3S0"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L41"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
		},
	},
	swablu: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4E", "3E"],
			aircutter: ["4T"],
			astonish: ["4L5", "3L8"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonpulse: ["4M", "4L45"],
			dragonrush: ["4E"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["3S0"],
			featherdance: ["4E"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L13", "3L18"],
			growl: ["4L1", "3L1", "3S0"],
			haze: ["4E", "3E"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["4L36", "3L38"],
			mist: ["4L23", "3L28"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M", "4L32"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			peck: ["4L1", "3L1", "3S0"],
			perishsong: ["4L50", "3L48"],
			pluck: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			pursuit: ["4E", "3E"],
			rage: ["4E", "3E"],
			raindance: ["4M", "3M"],
			refresh: ["4L40", "3L41"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roost: ["4M"],
			safeguard: ["4M", "4L18", "3M", "3L21"],
			secretpower: ["4M", "3M"],
			sing: ["4L9", "3L11"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["4L28", "3L31"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
		},
	},
	altaria: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M", "3S1"],
			aircutter: ["4T"],
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L35", "3L35", "3S0", "3S1"],
			dragonclaw: ["4M", "3M"],
			dragondance: ["4L39", "3L40", "3S0"],
			dragonpulse: ["4M", "4L54"],
			dreameater: ["4M", "3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furyattack: ["4L13", "3L18"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			healbell: ["3S1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mist: ["4L23", "3L28"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M", "4L32"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			peck: ["4L1", "3L1"],
			perishsong: ["4L62", "3L54"],
			pluck: ["4M", "4L1"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			refresh: ["4L46", "3L45", "3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			roost: ["4M"],
			safeguard: ["4M", "4L18", "3M", "3L21"],
			secretpower: ["4M", "3M"],
			sing: ["4L1", "3L1"],
			skyattack: ["4L70", "3T", "3L59"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M", "3S1"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["4L28", "3L31", "3S0"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
		},
	},
	zangoose: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M", "3S2"],
			captivate: ["4M"],
			closecombat: ["4L53"],
			counter: ["4E", "3T", "3E", "3S2"],
			crushclaw: ["4L31", "3L31", "3S2"],
			curse: ["4E", "3E"],
			defensecurl: ["3T"],
			detect: ["4L40", "3L46"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doublehit: ["4E"],
			doublekick: ["4E", "3E"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			embargo: ["4M", "4L27"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M", "4L44", "3L55"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flail: ["4E", "3E"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L14", "3T", "3L13", "3S0"],
			furyswipes: ["4E"],
			gigadrain: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			leer: ["4L1", "3L4", "3S0", "3S1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4E"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			pursuit: ["4L22", "3L25"],
			quickattack: ["4L5", "3L7", "3S0", "3S1"],
			raindance: ["4M", "3M"],
			razorwind: ["4E", "3E"],
			refresh: ["3S2"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "4E", "3M", "3E"],
			rockclimb: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			scratch: ["4L1", "3L1", "3S1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slash: ["4L18", "3L19"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "4L9", "3T", "3L10", "3S0", "3S1"],
			taunt: ["4M", "4L35", "3M", "3L37"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			xscissor: ["4M", "4L48"],
		},
	},
	seviper: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			assurance: ["4E"],
			attract: ["4M", "3M"],
			bite: ["4L10", "3L10", "3S0", "3S2"],
			bodyslam: ["4E", "3T", "3E"],
			captivate: ["4M"],
			crunch: ["4L28", "3L28", "3S1"],
			darkpulse: ["4M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			glare: ["4L25", "3L25", "3S1"],
			haze: ["4L43", "3L43"],
			hiddenpower: ["4M", "3M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lick: ["4L7", "3L7", "3S0", "3S2"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4L46", "4E"],
			payback: ["4M"],
			poisonfang: ["4L34", "3L34"],
			poisonjab: ["4M", "4L52"],
			poisontail: ["4L16", "3L16", "3S0", "3S1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			scaryface: ["4E"],
			screech: ["4L19", "3L19", "3S1"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spitup: ["4E", "3E"],
			stockpile: ["4E", "3E"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "4L37", "3T", "3L37"],
			swallow: ["4E", "3E"],
			swift: ["4T", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			toxic: ["4M", "3M"],
			wrap: ["4L1", "3L1", "3S0", "3S2"],
			wringout: ["4L55"],
			xscissor: ["4M"],
		},
	},
	lunatone: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			batonpass: ["3S1"],
			blizzard: ["4M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L7", "3S0"],
			cosmicpower: ["4L34", "3L31"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			embargo: ["4M", "4L31"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L56", "3T", "3L49"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L53", "3L43"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gyroball: ["4M"],
			harden: ["4L1", "3L1", "3S0"],
			healblock: ["4L42"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			hypnosis: ["4L12", "3L19"],
			icebeam: ["4M", "3M"],
			ironhead: ["4T"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L45", "3M", "3L37", "3S1"],
			psychup: ["4M", "3T"],
			psywave: ["4L23", "3L25"],
			raindance: ["4M", "3M", "3S1"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M", "4L20"],
			rockslide: ["4M", "3T"],
			rockthrow: ["4L9", "3L13"],
			rocktomb: ["4M", "3M", "3S1"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			toxic: ["4M", "3M"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	solrock: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			batonpass: ["3S1"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L7", "3S0"],
			cosmicpower: ["4L34", "3L31", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			embargo: ["4M", "4L31"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L56", "3T", "3L49"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firespin: ["4L12", "3L19"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gyroball: ["4M"],
			harden: ["4L1", "3L1", "3S0"],
			healblock: ["4L42"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M", "3S1"],
			psychup: ["4M", "3T"],
			psywave: ["4L23", "3L25"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M", "4L20"],
			rockslide: ["4M", "4L45", "3T", "3L37"],
			rockthrow: ["4L9", "3L13"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L53", "3M", "3L43"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M", "3S1"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1", "3S0"],
			toxic: ["4M", "3M"],
			trickroom: ["4M"],
			willowisp: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	barboach: {
		inherit: true,
		learnset: {
			amnesia: ["4L18", "3L21"],
			aquatail: ["4T", "4L35"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			captivate: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L39", "3M", "3L31"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fissure: ["4L47", "3L41"],
			flail: ["4E"],
			frustration: ["4M", "3M"],
			futuresight: ["4L43", "3L36"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4E"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			magnitude: ["4L26", "3L16"],
			mimic: ["3T"],
			mudbomb: ["4L14"],
			mudslap: ["4T", "4L1", "3T", "3L1"],
			mudsport: ["4L6", "3L6"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L31", "3M", "3L26"],
			return: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "4L31", "3T", "3L26"],
			spark: ["4E", "3E"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			takedown: ["4E"],
			thrash: ["4E", "3E"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L10", "3L11"],
			waterpulse: ["4M", "4L22", "3M"],
			watersport: ["4L6", "3L6"],
			whirlpool: ["4E", "3E"],
		},
	},
	whiscash: {
		inherit: true,
		learnset: {
			amnesia: ["4L18", "3L21"],
			aquatail: ["4T", "4L39", "4S0"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			captivate: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L45", "4S0", "3M", "3L36"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fissure: ["4L57", "3L56"],
			frustration: ["4M", "3M"],
			futuresight: ["4L51", "3L46"],
			gigaimpact: ["4M", "4S0"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			magnitude: ["4L26", "3L16"],
			mimic: ["3T"],
			mudbomb: ["4L14"],
			mudslap: ["4T", "4L1", "3T", "3L1"],
			mudsport: ["4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L33", "3M", "3L26"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "4L33", "3T", "3L26"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tickle: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L10", "3L11"],
			waterpulse: ["4M", "4L22", "3M"],
			watersport: ["4L1", "3L1"],
			zenheadbutt: ["4T", "4L1", "4S0"],
		},
	},
	corphish: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T", "4E", "3E"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4E", "3T", "3E"],
			brickbreak: ["4M", "3M"],
			bubble: ["4L1", "3L1", "3S0"],
			bubblebeam: ["4L20", "3L19"],
			captivate: ["4M"],
			counter: ["3T"],
			crabhammer: ["4L38", "3L34"],
			crunch: ["4L47", "3L43"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endeavor: ["4T", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			guillotine: ["4L53", "3L44"],
			hail: ["4M", "3M"],
			harden: ["4L7", "3L7"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T", "4L26", "4E", "3L25"],
			leer: ["4L13", "3L13"],
			metalclaw: ["4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			nightslash: ["4L35"],
			payback: ["4M"],
			protect: ["4M", "4L23", "3M", "3L22"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T", "4E"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "4L44", "3T", "3L37"],
			taunt: ["4M", "4L32", "3M", "3L31"],
			toxic: ["4M", "3M"],
			visegrip: ["4L10", "3L10"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["3S0"],
			xscissor: ["4M"],
		},
	},
	crawdaunt: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bubble: ["4L1", "3L1"],
			bubblebeam: ["4L20", "3L19"],
			captivate: ["4M"],
			counter: ["3T"],
			crabhammer: ["4L44", "3L38", "3S0", "3S1"],
			crunch: ["4L57", "3L51"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			dig: ["4M", "3M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			guillotine: ["4L65", "3L52", "3S0"],
			hail: ["4M", "3M"],
			harden: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T", "4L26", "3L25", "3S1"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["4L39"],
			payback: ["4M"],
			protect: ["4M", "4L23", "3M", "3L22"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L30", "3T"],
			swordsdance: ["4M", "4L52", "3T", "3L43", "3S0", "3S1"],
			taunt: ["4M", "4L34", "3M", "3L33", "3S0", "3S1"],
			toxic: ["4M", "3M"],
			visegrip: ["4L1", "3L1"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			xscissor: ["4M"],
		},
	},
	baltoy: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L25", "3L25"],
			calmmind: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L1"],
			cosmicpower: ["4L45", "3L37"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthpower: ["4T", "4L53"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L71", "3T", "3L45"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			grassknot: ["4M"],
			gyroball: ["4M"],
			harden: ["4L3", "3L3"],
			healblock: ["4L61"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "4L7", "3T", "3L7", "3S0"],
			naturalgift: ["4M"],
			powertrick: ["4L31"],
			protect: ["4M", "3M"],
			psybeam: ["4L11", "3L11", "3S0"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rapidspin: ["4L5", "3L5"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocktomb: ["4M", "4L15", "3M", "3L15", "3S0"],
			safeguard: ["4M"],
			sandstorm: ["4M", "4L37", "3M", "3L31"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["4L19", "3T", "3L19"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	claydol: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L25", "3L25"],
			calmmind: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "3L1"],
			cosmicpower: ["4L51", "3L42"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			earthpower: ["4T", "4L62"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L86", "3T", "3L55"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gyroball: ["4M"],
			harden: ["4L1", "3L1"],
			healblock: ["4L73"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L36", "3M", "3L36"],
			icebeam: ["4M", "3M"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "4L7", "3T", "3L7"],
			naturalgift: ["4M"],
			powertrick: ["4L31"],
			protect: ["4M", "3M"],
			psybeam: ["4L11", "3L11"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rapidspin: ["4L1", "3L1"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "4L15", "3M", "3L15"],
			safeguard: ["4M"],
			sandstorm: ["4M", "4L40", "3M", "3L31"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["4L19", "3T", "3L19"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			teleport: ["4L1", "3L1"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	lileep: {
		inherit: true,
		learnset: {
			acid: ["4L8", "3L15"],
			amnesia: ["4L29", "3L36"],
			ancientpower: ["4T", "4L43", "3L43"],
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			barrier: ["4E", "3E"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L22", "3L29"],
			constrict: ["4L1", "3L8"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["4M", "4L50"],
			facade: ["4M", "3M"],
			flash: ["4M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T", "4L36"],
			gigadrain: ["4M", "3M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			ingrain: ["4L15", "3L22"],
			mimic: ["3T"],
			mirrorcoat: ["4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["3T"],
			recover: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocktomb: ["4M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spitup: ["4L57", "3L50"],
			stealthrock: ["4M"],
			stockpile: ["4L57", "3L50"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L57", "3L50"],
			swordsdance: ["4M"],
			synthesis: ["4T"],
			tickle: ["4E"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
			wringout: ["4L64", "4E"],
		},
	},
	cradily: {
		inherit: true,
		learnset: {
			acid: ["4L1", "3L1"],
			amnesia: ["4L29", "3L36"],
			ancientpower: ["4T", "4L36", "3L48"],
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4L22", "3L29"],
			constrict: ["4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M", "4L56"],
			facade: ["4M", "3M"],
			flash: ["4M"],
			frustration: ["4M", "3M"],
			gastroacid: ["4T", "4L46"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ingrain: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["3T"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spitup: ["4L66", "3L60"],
			stealthrock: ["4M"],
			stockpile: ["4L66", "3L60"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4L66", "3L60"],
			swordsdance: ["4M"],
			synthesis: ["4T"],
			toxic: ["4M", "3M"],
			worryseed: ["4T"],
			wringout: ["4L76"],
		},
	},
	anorith: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T", "4L31", "3L37"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			crosspoison: ["4E"],
			crushclaw: ["4L55"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L37", "3T", "3L43"],
			harden: ["4L1", "3L7"],
			hiddenpower: ["4M", "3M"],
			irondefense: ["4T"],
			knockoff: ["4T", "4E", "3E"],
			metalclaw: ["4L19", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L7", "3L13"],
			naturalgift: ["4M"],
			protect: ["4M", "4L25", "3M", "3L31"],
			rapidspin: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockblast: ["4L49", "3L55"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandattack: ["4E"],
			sandstorm: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			screech: ["4E"],
			secretpower: ["4M", "3M"],
			slash: ["4L43", "3L49"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "4E", "3T", "3E"],
			toxic: ["4M", "3M"],
			watergun: ["4L13", "3L19"],
			waterpulse: ["4M", "3M"],
			xscissor: ["4M", "4L61"],
		},
	},
	armaldo: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T", "4L31", "3L37"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			crushclaw: ["4L67"],
			cut: ["4M", "3M"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "4L37", "3T", "3L46"],
			gigaimpact: ["4M"],
			harden: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			metalclaw: ["4L19", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["4M", "4L25", "3M", "3L31"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockblast: ["4L55", "3L64"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			scratch: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			slash: ["4L46", "3L55"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			swordsdance: ["4M", "3T"],
			toxic: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			xscissor: ["4M", "4L73"],
		},
	},
	feebas: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["4E", "3E"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonbreath: ["4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4L30", "3L30"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			haze: ["4E"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4E", "3E"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			lightscreen: ["4E", "3E"],
			mimic: ["3T"],
			mirrorcoat: ["4E", "4S0", "3E"],
			mist: ["4E"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["4L1", "4S0", "3L1"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L15", "3L15"],
			tickle: ["4E"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	milotic: {
		inherit: true,
		learnset: {
			aquaring: ["4L49"],
			aquatail: ["4T", "4L29"],
			attract: ["4M", "4L41", "3M", "3L45"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M", "4L25"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonpulse: ["4M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L37", "4S1", "4S2", "3L40"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "4S1", "3M"],
			icywind: ["4T", "4S2", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "4L33", "4S1", "4S2", "3M", "3L35", "3S0"],
			recover: ["4L21", "4S1", "4S2", "3L30", "3S0"],
			refresh: ["4L9", "3L15"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "4L45", "3M", "3L50"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L17", "3L25", "3S0"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "4L13", "3M", "3L20", "3S0"],
			watersport: ["4L5", "3L10"],
			wrap: ["4L1", "3L5"],
		},
	},
	castform: {
		inherit: true,
		learnset: {
			amnesia: ["4E"],
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			disable: ["4E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			ember: ["4L10", "3L10"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4E", "3E"],
			hail: ["4M", "4L20", "3M", "3L20"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			lastresort: ["4T"],
			luckychant: ["4E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T", "4E"],
			powdersnow: ["4L10", "3L10"],
			protect: ["4M", "3M"],
			psychup: ["4M", "4E", "3T", "3E"],
			raindance: ["4M", "4L20", "3M", "3L20"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4L20", "3M", "3L20"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			watergun: ["4L10", "3L10"],
			waterpulse: ["4M", "3M"],
			weatherball: ["4L30", "3L30"],
		},
	},
	kecleon: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T", "4L55", "3L49"],
			aquatail: ["4T"],
			astonish: ["4L1", "3L1"],
			attract: ["4M", "3M"],
			bind: ["4L4", "3L4"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			disable: ["4E", "3E"],
			dizzypunch: ["4E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fakeout: ["4E"],
			feint: ["4L14"],
			feintattack: ["4L7", "3L7"],
			fireblast: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["4L10", "3L12"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lick: ["4L1", "3L1"],
			magiccoat: ["4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4E"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psybeam: ["4L15", "3L17"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			scratch: ["4L1", "3L1"],
			screech: ["4L32", "3L24"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M", "4L49"],
			shadowsneak: ["4L20"],
			shockwave: ["4M", "3M"],
			skillswap: ["4M", "3M"],
			slash: ["4L25", "3L31"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "4L37", "3T", "3L40"],
			suckerpunch: ["4T", "4L43"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["4L1", "3L1"],
			thief: ["4M", "4L1", "3M", "3L1"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T", "4E", "3E"],
			trickroom: ["4M"],
			waterpulse: ["4M", "3M"],
		},
	},
	shuppet: {
		inherit: true,
		learnset: {
			astonish: ["4E", "3E"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4E"],
			curse: ["4L13", "3L20"],
			darkpulse: ["4M"],
			destinybond: ["4E", "3E"],
			disable: ["4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			embargo: ["4M", "4L38"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L28", "3L37", "3S0"],
			flash: ["4M", "3M"],
			foresight: ["4E", "3E"],
			frustration: ["4M", "3M"],
			grudge: ["4L46", "3L56"],
			hiddenpower: ["4M", "3M"],
			icywind: ["4T", "3T"],
			imprison: ["4E", "3E"],
			knockoff: ["4T", "4L1", "3L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4L8", "3L13"],
			ominouswind: ["4T"],
			payback: ["4M", "4E"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			pursuit: ["4E"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			screech: ["4L5", "3L8"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "4L31", "3M", "3L44", "3S0"],
			shadowsneak: ["4L20", "4E"],
			shockwave: ["4M", "3M"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "4L43", "3M", "3L49"],
			snore: ["3T"],
			spite: ["4T", "4L16", "3L25", "3S0"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L35"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T", "4L50"],
			trickroom: ["4M"],
			willowisp: ["4M", "4L23", "3L32", "3S0"],
		},
	},
	banette: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			curse: ["4L1", "3L1", "3S0"],
			darkpulse: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			embargo: ["4M", "4L42"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4L28", "3L39", "3S0"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grudge: ["4L58", "3L64"],
			helpinghand: ["3S0"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T", "4L1", "3L1"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4L1", "3L1"],
			ominouswind: ["4T"],
			payback: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			screech: ["4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "4L31", "3M", "3L48", "3S0"],
			shadowclaw: ["4M"],
			shadowsneak: ["4L20"],
			shockwave: ["4M", "3M"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "4L51", "3M", "3L55"],
			snore: ["3T"],
			spite: ["4T", "4L16", "3L25"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T", "4L35"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T", "4L66"],
			trickroom: ["4M"],
			willowisp: ["4M", "4L23", "3L32"],
		},
	},
	duskull: {
		inherit: true,
		learnset: {
			astonish: ["4L14", "3L16", "3S1"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4L17", "3L23", "3S1"],
			curse: ["4L30", "3L34", "3S0"],
			darkpulse: ["4M"],
			destinybond: ["4E", "3E"],
			disable: ["4L6", "3L5"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			feintattack: ["4E", "3E"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			foresight: ["4L9", "3L12"],
			frustration: ["4M", "3M"],
			futuresight: ["4L46", "3L49"],
			grudge: ["4E", "3E"],
			helpinghand: ["3S1"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			imprison: ["4E", "3E"],
			leer: ["4L1", "3L1"],
			meanlook: ["4L38", "3L45", "3S0"],
			memento: ["4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4L1", "3L1"],
			ominouswind: ["4T", "4E"],
			painsplit: ["4E", "3E"],
			payback: ["4M", "4L41"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			pursuit: ["4L25", "3L27", "3S0"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M", "3S1"],
			shadowsneak: ["4L22"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			willowisp: ["4M", "4L33", "3L38", "3S0"],
		},
	},
	dusclops: {
		inherit: true,
		learnset: {
			astonish: ["4L14", "3L16"],
			attract: ["4M", "3M"],
			bind: ["4L1", "3L1"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4L17", "3L23"],
			counter: ["3T"],
			curse: ["4L30", "3L34"],
			darkpulse: ["4M"],
			disable: ["4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			embargo: ["4M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "4L1", "3T"],
			flash: ["4M", "3M"],
			fling: ["4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["4L9", "3L12"],
			frustration: ["4M", "3M"],
			futuresight: ["4L61", "3L58"],
			gigaimpact: ["4M"],
			gravity: ["4L1"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "4L1", "3T"],
			icywind: ["4T", "3T"],
			leer: ["4L1", "3L1"],
			meanlook: ["4L43", "3L51"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4L1", "3L1"],
			ominouswind: ["4T"],
			payback: ["4M", "4L51"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M"],
			psychup: ["4M", "3T"],
			pursuit: ["4L25", "3L27"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shadowpunch: ["4L37", "3L37"],
			shadowsneak: ["4L22"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			thief: ["4M", "3M"],
			thunderpunch: ["4T", "4L1", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			willowisp: ["4M", "4L33", "3L41"],
		},
	},
	dusknoir: {
		inherit: true,
		learnset: {
			astonish: ["4L14"],
			attract: ["4M"],
			bind: ["4L1"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			calmmind: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4L17"],
			curse: ["4L30"],
			darkpulse: ["4M"],
			disable: ["4L1"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			earthquake: ["4M"],
			embargo: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			firepunch: ["4T", "4L1"],
			flash: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			foresight: ["4L9"],
			frustration: ["4M"],
			futuresight: ["4L61"],
			gigaimpact: ["4M"],
			gravity: ["4L1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T", "4L1"],
			icywind: ["4T"],
			leer: ["4L1"],
			meanlook: ["4L43"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightshade: ["4L1"],
			ominouswind: ["4T"],
			payback: ["4M", "4L51"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			pursuit: ["4L25"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shadowpunch: ["4L37"],
			shadowsneak: ["4L22"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			taunt: ["4M"],
			thief: ["4M"],
			thunderpunch: ["4T", "4L1"],
			torment: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			willowisp: ["4M", "4L33"],
		},
	},
	tropius: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			aircutter: ["4T"],
			airslash: ["4L47", "4S0"],
			attract: ["4M", "3M"],
			bodyslam: ["4L37", "3T", "3L37"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			curse: ["4E"],
			cut: ["4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growth: ["4L7", "3L7"],
			gust: ["4L1", "3L1"],
			headbutt: ["4E", "3E"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			leafblade: ["4E"],
			leafstorm: ["4L61", "4E"],
			leechseed: ["4E", "3E"],
			leer: ["4L1", "3L1"],
			magicalleaf: ["4L31", "3L31"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M", "4L57"],
			naturepower: ["4E", "3E"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			razorleaf: ["4L11", "3L11"],
			razorwind: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rocksmash: ["4M", "3M"],
			roost: ["4M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M"],
			slam: ["4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L51", "4S0", "3M", "3L41"],
			steelwing: ["4M", "3M"],
			stomp: ["4L17", "3L17"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "4S0", "3M"],
			swagger: ["4M", "3T"],
			sweetscent: ["4L21", "3L21"],
			swordsdance: ["4M", "3T"],
			synthesis: ["4T", "4L41", "4E", "4S0", "3L47"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			whirlwind: ["4L27", "3L27"],
			worryseed: ["4T"],
		},
	},
	chingling: {
		inherit: true,
		learnset: {
			astonish: ["4L9"],
			attract: ["4M"],
			calmmind: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L14"],
			curse: ["4E"],
			disable: ["4E"],
			doubleteam: ["4M"],
			dreameater: ["4M", "4E"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			futuresight: ["4E"],
			grassknot: ["4M"],
			growl: ["4L6"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hypnosis: ["4E"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lastresort: ["4T", "4L22"],
			lightscreen: ["4M"],
			naturalgift: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recover: ["4E"],
			recycle: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			taunt: ["4M"],
			thunderwave: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T", "4L17"],
			wish: ["4E"],
			wrap: ["4L1"],
			zenheadbutt: ["4T"],
		},
	},
	chimecho: {
		inherit: true,
		learnset: {
			astonish: ["4L9", "3L9", "3S0"],
			attract: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L14", "3L14"],
			curse: ["4E", "3E"],
			defensecurl: ["3T"],
			disable: ["4E", "3E"],
			doubleedge: ["4L33", "3T", "3L33"],
			doubleteam: ["4M", "3M"],
			dreameater: ["4M", "4E", "3T", "3E"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			extrasensory: ["4L46"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			futuresight: ["4E"],
			grassknot: ["4M"],
			growl: ["4L6", "3L6", "3S0"],
			healbell: ["4L38", "3L38"],
			healingwish: ["4L49"],
			helpinghand: ["4T"],
			hiddenpower: ["4M", "3M"],
			hypnosis: ["4E", "3E"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "3M", "3L46"],
			psychup: ["4M", "3T"],
			psywave: ["4L30", "3L30"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "4L41", "3M", "3L41"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			takedown: ["4L22", "3L17"],
			taunt: ["4M", "3M"],
			thunderwave: ["4M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T", "4L17", "3L22"],
			wish: ["4E"],
			wrap: ["4L1", "3L1", "3S0"],
			yawn: ["4L25", "3L25"],
			zenheadbutt: ["4T"],
		},
	},
	absol: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			assurance: ["4E"],
			attract: ["4M", "3M"],
			batonpass: ["4E", "3E"],
			bite: ["4L28", "3L21", "3S2"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			counter: ["3T"],
			curse: ["4E", "3E"],
			cut: ["4M", "3M"],
			darkpulse: ["4M"],
			detect: ["4L49"],
			doubleedge: ["4E", "3T", "3E"],
			doubleteam: ["4M", "4L33", "3M", "3L31", "3S3"],
			dreameater: ["4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			falseswipe: ["4M"],
			feint: ["4L1"],
			feintattack: ["4E", "3E"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			futuresight: ["4L41", "3L41", "3S3"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			leer: ["4L4", "3L5", "3S0", "3S1"],
			magiccoat: ["4E", "3E"],
			meanlook: ["4E"],
			mefirst: ["4L57", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["4L52"],
			payback: ["4M"],
			perishsong: ["4L65", "3L46", "3S3"],
			protect: ["4M", "3M"],
			psychocut: ["4L60"],
			psychup: ["4M", "3T"],
			punishment: ["4E"],
			pursuit: ["4L20"],
			quickattack: ["4L12", "3L13"],
			raindance: ["4M", "3M"],
			razorwind: ["4L17", "3L17", "3S2"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			sandstorm: ["4M", "3M"],
			scratch: ["4L1", "3L1", "3S0", "3S1"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slash: ["4L36", "3L36", "3S3"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T", "3S1", "3S2"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "4E", "3T", "3E"],
			suckerpunch: ["4T", "4L44", "4E"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "4L25", "3T", "3L26", "3S2"],
			taunt: ["4M", "4L9", "3M", "3L9"],
			thief: ["4M", "3M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			willowisp: ["4M"],
			wish: ["3S0"],
			xscissor: ["4M"],
			zenheadbutt: ["4T", "4E"],
		},
	},
	snorunt: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bide: ["4E"],
			bite: ["4L10", "3L10", "3S0"],
			blizzard: ["4M", "4L46", "3M", "3L43"],
			block: ["4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			crunch: ["4L31", "3L28"],
			disable: ["4E"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L4", "3M", "3L7"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "4L40", "3M", "3L37"],
			headbutt: ["4L19", "3L19"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M", "3L34"],
			icefang: ["4L28"],
			iceshard: ["4L37"],
			icywind: ["4T", "4L13", "3T", "3L16", "3S0"],
			leer: ["4L1", "3L1"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			powdersnow: ["4L1", "3L1"],
			protect: ["4M", "4L22", "3M", "3L25"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "4E"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			sing: ["3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikes: ["4E", "3E"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M", "3S0"],
		},
	},
	glalie: {
		inherit: true,
		learnset: {
			attract: ["4M", "3M"],
			avalanche: ["4M"],
			bite: ["4L1", "3L1"],
			blizzard: ["4M", "4L51", "3M", "3L53"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			crunch: ["4L31", "3L28"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L1", "3M", "3L1"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			gyroball: ["4M"],
			hail: ["4M", "4L40", "3M", "3L42"],
			headbutt: ["4L19", "3L19"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "4L37", "3M", "3L34"],
			icefang: ["4L28"],
			icywind: ["4T", "4L13", "3T", "3L16"],
			ironhead: ["4T"],
			leer: ["4L1", "3L1"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			powdersnow: ["4L1", "3L1"],
			protect: ["4M", "4L22", "3M", "3L25"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			sheercold: ["4L59", "3L61"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["4M", "3T"],
			swagger: ["4M", "3T"],
			taunt: ["4M", "3M"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	froslass: {
		inherit: true,
		learnset: {
			astonish: ["4L1"],
			attract: ["4M"],
			avalanche: ["4M"],
			blizzard: ["4M", "4L51"],
			captivate: ["4M", "4L31"],
			confuseray: ["4L19"],
			destinybond: ["4L59"],
			doubleteam: ["4M", "4L1"],
			dreameater: ["4M"],
			embargo: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			hail: ["4M", "4L40"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T"],
			iceshard: ["4L37"],
			icywind: ["4T", "4L13"],
			leer: ["4L1"],
			lightscreen: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T", "4L22"],
			payback: ["4M"],
			powdersnow: ["4L1"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			swagger: ["4M"],
			taunt: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			wakeupslap: ["4L28"],
			waterpulse: ["4M"],
		},
	},
	spheal: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			aurorabeam: ["4L25", "3L25", "3S0"],
			blizzard: ["4M", "4L43", "3M", "3L43"],
			bodyslam: ["4L19", "3T", "3L19"],
			brine: ["4M"],
			captivate: ["4M"],
			charm: ["3S0"],
			curse: ["4E", "3E"],
			defensecurl: ["4L1", "3T", "3L1"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			encore: ["4L7", "3L7"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fissure: ["4E", "3E"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "4L31", "3M", "3L31"],
			hiddenpower: ["4M", "3M"],
			iceball: ["4L13", "3L13"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T", "3S0"],
			naturalgift: ["4M"],
			powdersnow: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L37", "3M", "3L37"],
			return: ["4M", "3M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			sheercold: ["4L49", "3L49"],
			signalbeam: ["4T", "4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "4L37", "3T", "3L37"],
			spitup: ["4E", "3E"],
			stockpile: ["4E", "3E"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swallow: ["4E", "3E"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1", "3S0"],
			waterpulse: ["4M", "3M"],
			watersport: ["4E", "3E"],
			yawn: ["4E", "3E"],
		},
	},
	sealeo: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			aurorabeam: ["4L25", "3L25"],
			blizzard: ["4M", "4L47", "3M", "3L47"],
			bodyslam: ["4L19", "3T", "3L19"],
			brine: ["4M"],
			captivate: ["4M"],
			defensecurl: ["3T", "3L1"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			encore: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "4L31", "3M", "3L31"],
			hiddenpower: ["4M", "3M"],
			iceball: ["4L13", "3L13"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			powdersnow: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L39", "3M", "3L39"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			sheercold: ["4L55", "3L55"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "4L39", "3T", "3L39"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "4L32", "3T"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	walrein: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			aurorabeam: ["4L25", "3L25"],
			avalanche: ["4M"],
			blizzard: ["4M", "4L52", "3M", "3L50"],
			bodyslam: ["4L19", "3T", "3L19"],
			brine: ["4M"],
			captivate: ["4M"],
			crunch: ["4L1"],
			defensecurl: ["3T", "3L1"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			encore: ["4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			growl: ["4L1", "3L1"],
			hail: ["4M", "4L31", "3M", "3L31"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			iceball: ["4L13", "3L13"],
			icebeam: ["4M", "3M"],
			icefang: ["4L44"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			powdersnow: ["4L1", "3L1"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L39", "3M", "3L39"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			secretpower: ["4M", "3M"],
			sheercold: ["4L65", "3L61"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "4L39", "3T", "3L39"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "4L32", "3T"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
		},
	},
	clamperl: {
		inherit: true,
		learnset: {
			aquaring: ["4E"],
			attract: ["4M", "3M"],
			barrier: ["4E", "3E"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4E", "3T", "3E"],
			brine: ["4M"],
			captivate: ["4M"],
			clamp: ["4L1", "3L1"],
			confuseray: ["4E", "3E"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L1", "3L1"],
			mimic: ["3T"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			refresh: ["4E", "3E"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			supersonic: ["4E", "3E"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4L1", "3L1"],
		},
	},
	huntail: {
		inherit: true,
		learnset: {
			aquatail: ["4T", "4L46"],
			attract: ["4M", "3M"],
			batonpass: ["4L33", "3L43"],
			bite: ["4L6", "3L8"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["4M", "4L28"],
			captivate: ["4M"],
			crunch: ["4L42", "3L36"],
			dive: ["4T", "4L37", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L51", "3L50"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icefang: ["4L24"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			scaryface: ["4L19", "3L29"],
			screech: ["4L10", "3L15"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "4L15", "3M", "3L22"],
			whirlpool: ["4L1", "3L1"],
		},
	},
	gorebyss: {
		inherit: true,
		learnset: {
			agility: ["4L10", "3L15"],
			amnesia: ["4L19", "3L29"],
			aquaring: ["4L24"],
			aquatail: ["4T", "4L46"],
			attract: ["4M", "3M"],
			batonpass: ["4L33", "3L43"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["4M"],
			captivate: ["4M", "4L28"],
			confusion: ["4L6", "3L8"],
			dive: ["4T", "4L37", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L51", "3L50"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L42", "3M", "3L36"],
			psychup: ["4M"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "4L15", "3M", "3L22"],
			whirlpool: ["4L1", "3L1"],
		},
	},
	relicanth: {
		inherit: true,
		learnset: {
			amnesia: ["4E", "3E"],
			ancientpower: ["4T", "4L43", "3L43"],
			aquatail: ["4T", "4E"],
			attract: ["4M", "3M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["4M"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			dive: ["4T", "4L57", "3M"],
			doubleedge: ["4L50", "3T", "3L57"],
			doubleteam: ["4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			harden: ["4L1", "3L1"],
			headsmash: ["4L78"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L71", "3L64"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			magnitude: ["4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "4E", "3T"],
			mudsport: ["4L36", "3L36"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L64", "3M", "3L50"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4E", "3T", "3E"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "4L15", "3M", "3L15"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			skullbash: ["4E", "3E"],
			sleeptalk: ["4M", "4E", "3T", "3E"],
			snore: ["4T", "4E", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L29", "3L29"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L8", "3L8"],
			waterpulse: ["4M", "3M"],
			watersport: ["4E", "3E"],
			yawn: ["4L22", "3L22"],
		},
	},
	luvdisc: {
		inherit: true,
		learnset: {
			agility: ["4L9", "3L16"],
			aquaring: ["4L37", "4E"],
			attract: ["4M", "4L22", "3M", "3L28"],
			blizzard: ["4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			captivate: ["4M", "4L40", "4E"],
			charm: ["4L4", "3L4"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			flail: ["4L46", "3L40"],
			frustration: ["4M", "3M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			luckychant: ["4L17"],
			mimic: ["3T"],
			mudsport: ["4E", "3E"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			safeguard: ["4M", "4L51", "3M", "3L48"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["4E", "3E"],
			substitute: ["4M", "3T"],
			supersonic: ["4E", "3E"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			sweetkiss: ["4L27", "3L36"],
			swift: ["4T", "3T"],
			tackle: ["4L1", "3L1"],
			takedown: ["4L14", "3L24"],
			toxic: ["4M", "3M"],
			waterfall: ["4M", "3M"],
			watergun: ["4L7", "3L12"],
			waterpulse: ["4M", "4L31", "3M"],
			watersport: ["4E", "3E"],
		},
	},
	bagon: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bite: ["4L5", "3L5", "3S0", "3S1"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			crunch: ["4L46", "3L41"],
			cut: ["4M", "3M"],
			doubleedge: ["4L55", "3T", "3L53"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L31", "3L33"],
			dragonclaw: ["4M", "4L50", "3M", "3L49"],
			dragondance: ["4E", "3E"],
			dragonpulse: ["4M"],
			dragonrage: ["4E", "3E"],
			dragonrush: ["4E"],
			ember: ["4L25", "3L25"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			firefang: ["4E"],
			flamethrower: ["4M", "3M"],
			focusenergy: ["4L20", "3L21"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["4L16", "3L17"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4E", "3E"],
			irondefense: ["3S1"],
			leer: ["4L10", "3L9"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			rage: ["4L1", "3L1", "3S0", "3S1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			scaryface: ["4L40", "3L37"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M", "4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			thrash: ["4E", "3E"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4E", "3E"],
			wish: ["3S0"],
			zenheadbutt: ["4T", "4L35"],
		},
	},
	shelgon: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			crunch: ["4L50", "3L56"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["4L61", "3T", "3L78"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L32", "3L38"],
			dragonclaw: ["4M", "4L55", "3M", "3L69"],
			dragonpulse: ["4M"],
			ember: ["4L25", "3L25"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			focusenergy: ["4L20", "3L21"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["4L1", "3L1"],
			hiddenpower: ["4M", "3M"],
			irondefense: ["4T"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "4L30", "3M", "3L30"],
			rage: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			scaryface: ["4L43", "3L47"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			zenheadbutt: ["4T", "4L37"],
		},
	},
	salamence: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M", "3S1"],
			aircutter: ["4T"],
			aquatail: ["4T"],
			attract: ["4M", "3M"],
			bite: ["4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			captivate: ["4M"],
			crunch: ["4L53", "3L61"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			doubleedge: ["4L70", "3T", "3L93"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L32", "3L38", "3S0"],
			dragonclaw: ["4M", "4L61", "4S2", "3M", "3L79", "3S1"],
			dragondance: ["3S1"],
			dragonpulse: ["4M"],
			earthquake: ["4M", "3M"],
			ember: ["4L25", "3L25"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "4S2", "3M"],
			firefang: ["4L1"],
			flamethrower: ["4M", "3M"],
			fly: ["4M", "4L50", "3M", "3L50", "3S0"],
			focusenergy: ["4L20", "3L21"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			headbutt: ["4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4S2"],
			hyperbeam: ["4M", "3M"],
			irontail: ["4M", "3M"],
			leer: ["4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			protect: ["4M", "4L30", "3M", "3L30", "3S0"],
			rage: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			refresh: ["3S1"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			scaryface: ["4L43", "3L47", "3S0"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			stoneedge: ["4M", "4S2"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunderfang: ["4L1"],
			toxic: ["4M", "3M"],
			twister: ["4T"],
			zenheadbutt: ["4T", "4L37"],
		},
	},
	beldum: {
		inherit: true,
		learnset: {
			irondefense: ["4T"],
			ironhead: ["4T"],
			takedown: ["4L1", "3L1"],
			zenheadbutt: ["4T"],
		},
	},
	metang: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L44", "3L56"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulletpunch: ["4L32"],
			confusion: ["4L1", "3L20", "3S0"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			grassknot: ["4M"],
			gyroball: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L56", "3M", "3L62"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L40", "3L44"],
			ironhead: ["4T"],
			lightscreen: ["4M", "3M"],
			magnetrise: ["4T", "4L1"],
			metalclaw: ["4L1", "3L20", "3S0"],
			meteormash: ["4L48", "3L50"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L36", "3M", "3L38"],
			psychup: ["4M", "3T"],
			pursuit: ["4L28", "3L32"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			refresh: ["3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4L24", "3L26"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["4L1", "3L1", "3S0"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			zenheadbutt: ["4T", "4L52"],
		},
	},
	metagross: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L44", "3L66"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulletpunch: ["4L32", "4S0"],
			confusion: ["4L1", "3L1"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "3T"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			flashcannon: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gyroball: ["4M"],
			hammerarm: ["4L45", "4S0"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L71", "3M", "3L77"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L40", "3L44"],
			ironhead: ["4T"],
			lightscreen: ["4M", "3M"],
			magnetrise: ["4T", "4L1"],
			metalclaw: ["4L1", "3L1"],
			meteormash: ["4L53", "4S0", "3L55"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L36", "3M", "3L38"],
			psychup: ["4M", "3T"],
			pursuit: ["4L28", "3L32"],
			raindance: ["4M", "3M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4L24", "3L1"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["4L1", "3L1"],
			thunderpunch: ["4T", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			zenheadbutt: ["4T", "4L62", "4S0"],
		},
	},
	regirock: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L33", "3L33", "3S0", "3S1"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			chargebeam: ["4M", "4L49"],
			counter: ["3T"],
			curse: ["4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L1", "3T", "3L1"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hammerarm: ["4L81"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L89", "3M", "3L65", "3S1"],
			icepunch: ["4T", "3T"],
			irondefense: ["4L41", "3L41"],
			ironhead: ["4T"],
			lockon: ["4L57", "3L57"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rockthrow: ["4L9", "4S2", "3L9", "3S0"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stomp: ["4L1", "4S2"],
			stoneedge: ["4M", "4L73"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			zapcannon: ["4L65", "3L49"],
		},
	},
	regice: {
		inherit: true,
		learnset: {
			amnesia: ["4L41", "3L41"],
			ancientpower: ["4T", "4L33", "3L33", "3S0", "3S1"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			chargebeam: ["4M", "4L49"],
			counter: ["3T"],
			curse: ["4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L1", "3T", "3L1"],
			facade: ["4M", "3M"],
			flashcannon: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hammerarm: ["4L81"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L89", "3M", "3L65", "3S1"],
			icebeam: ["4M", "4L73", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "4L9", "4S2", "3T", "3L9", "3S0"],
			ironhead: ["4T"],
			lockon: ["4L57", "3L57"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stomp: ["4L1", "4S2"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			superpower: ["4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			zapcannon: ["4L65", "3L49"],
		},
	},
	registeel: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			amnesia: ["4L41", "3L41"],
			ancientpower: ["4T", "4L33", "3L33", "3S0", "3S1"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			chargebeam: ["4M", "4L49"],
			counter: ["3T"],
			curse: ["4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["4M", "4L1", "3T", "3L1"],
			facade: ["4M", "3M"],
			flashcannon: ["4M", "4L73"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hammerarm: ["4L81"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L89", "3M", "3L65", "3S1"],
			icepunch: ["4T", "3T"],
			irondefense: ["4T", "4L41", "3L41"],
			ironhead: ["4T", "4L73"],
			lockon: ["4L57", "3L57"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["4L9", "4S2", "3L9", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stomp: ["4L1", "4S2"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			zapcannon: ["4L65", "3L49"],
		},
	},
	latias: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L55", "3L50", "3S1", "3S2"],
			cut: ["4M", "3M"],
			defog: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L20", "4S3", "3L20"],
			dragonclaw: ["4M", "3M"],
			dragonpulse: ["4M", "4L70"],
			dreameater: ["4M", "3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			healingwish: ["4L60"],
			helpinghand: ["4T", "4L10", "3L10"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			lastresort: ["4T"],
			lightscreen: ["4M", "3M"],
			mimic: ["3T"],
			mistball: ["4L35", "4S3", "4S4", "3L35", "3S0", "3S1", "3S2"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L65", "3M", "3L40", "3S0", "3S1", "3S2"],
			psychoshift: ["4L50"],
			psychup: ["4M", "3T"],
			psywave: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			recover: ["4L45", "3L45", "3S1", "3S2"],
			reflect: ["4M", "3M"],
			refresh: ["4L30", "4S3", "4S4", "3L30", "3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			roost: ["4M"],
			safeguard: ["4M", "4L15", "3M", "3L15"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			twister: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["4L25", "4S3", "4S4", "3L25", "3S0"],
			wish: ["4L5", "3L5"],
			zenheadbutt: ["4T", "4L40", "4S4"],
		},
	},
	latios: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			attract: ["4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			cut: ["4M", "3M"],
			defog: ["4M"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L20", "4S3", "3L20"],
			dragonclaw: ["4M", "3M"],
			dragondance: ["4L55", "3L50", "3S1", "3S2"],
			dragonpulse: ["4M", "4L70"],
			dreameater: ["4M", "3T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			flash: ["4M", "3M"],
			fly: ["4M", "3M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			healblock: ["4L5"],
			helpinghand: ["4T", "4L10", "3L10"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			lastresort: ["4T"],
			lightscreen: ["4M", "3M"],
			lusterpurge: ["4L35", "4S3", "4S4", "3L35", "3S0", "3S1", "3S2"],
			memento: ["4L60", "3L5"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "4L25", "4S3", "4S4", "3M", "3L25", "3S0"],
			psychic: ["4M", "4L65", "3M", "3L40", "3S0", "3S1", "3S2"],
			psychoshift: ["4L50"],
			psychup: ["4M", "3T"],
			psywave: ["4L1", "3L1"],
			raindance: ["4M", "3M"],
			recover: ["4L45", "3L45", "3S1", "3S2"],
			reflect: ["4M", "3M"],
			refresh: ["4L30", "4S3", "4S4", "3L30", "3S0"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			roost: ["4M"],
			safeguard: ["4M", "4L15", "3M", "3L15"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			steelwing: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			twister: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["4T", "4L40", "4S4"],
		},
	},
	kyogre: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L15", "3L15"],
			aquatail: ["4T", "4L75"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["4L20", "3T", "3L20", "3S0"],
			brickbreak: ["4M", "3M"],
			brine: ["4M"],
			calmmind: ["4M", "4L30", "3M", "3L30", "3S0"],
			defensecurl: ["3T"],
			dive: ["4T", "3M"],
			doubleedge: ["4L65", "3T", "3L65", "3S1"],
			doubleteam: ["4M", "3M"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			hail: ["4M", "3M"],
			hiddenpower: ["4M", "3M"],
			hydropump: ["4L45", "3L45", "3S0", "3S1"],
			hyperbeam: ["4M", "3M"],
			icebeam: ["4M", "4L35", "3M", "3L35", "3S0"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L50", "3M", "3L50", "3S1"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			scaryface: ["4L5", "3L5"],
			secretpower: ["4M", "3M"],
			sheercold: ["4L60", "3L60", "3S1"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "4L1", "3M", "3L1"],
			waterspout: ["4L80", "3L75"],
		},
	},
	groudon: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T", "4L15", "3L15"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "4L30", "3M", "3L30", "3S0"],
			counter: ["3T"],
			cut: ["4M", "3M"],
			defensecurl: ["3T"],
			dig: ["4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dragonclaw: ["4M", "3M"],
			dragonpulse: ["4M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T", "4L75"],
			earthquake: ["4M", "4L35", "3M", "3L35", "3S0"],
			endure: ["4M", "3T"],
			eruption: ["4L80", "3L75"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "4L45", "3M", "3L45", "3S0", "3S1"],
			firepunch: ["4T", "3T"],
			fissure: ["4L60", "3L60", "3S1"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			focusblast: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudshot: ["4L1", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			rest: ["4M", "4L50", "3M", "3L50", "3S1"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			rollout: ["4T", "3T"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4L5", "3L5"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			slash: ["4L20", "3L20", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "4L65", "3M", "3L65", "3S1"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M", "3T"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			uproar: ["4T"],
		},
	},
	rayquaza: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T", "4L15", "3L15"],
			aquatail: ["4T"],
			avalanche: ["4M"],
			blizzard: ["4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			bulkup: ["4M", "3M"],
			crunch: ["4L35", "3L35"],
			dive: ["4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4T"],
			dragonclaw: ["4M", "4L20", "3M", "3L20"],
			dragondance: ["4L30", "3L30"],
			dragonpulse: ["4M", "4L75"],
			earthpower: ["4T"],
			earthquake: ["4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			extremespeed: ["4L60", "3L60", "3S0"],
			facade: ["4M", "3M"],
			fireblast: ["4M", "3M"],
			flamethrower: ["4M", "3M"],
			fling: ["4M"],
			fly: ["4M", "4L45", "3M", "3L45", "3S0"],
			focusblast: ["4M"],
			frustration: ["4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["4M"],
			gyroball: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L65", "3M", "3L75"],
			icebeam: ["4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T", "4L50", "3L65", "3S0"],
			overheat: ["4M", "3M"],
			protect: ["4M", "3M"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			rest: ["4M", "4L50", "3M", "3L50", "3S0"],
			return: ["4M", "3M"],
			roar: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M"],
			sandstorm: ["4M", "3M"],
			scaryface: ["4L5", "3L5"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			stoneedge: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			surf: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["4M"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			twister: ["4T", "4L1", "3L1"],
			uproar: ["4T"],
			waterfall: ["4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	jirachi: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			ancientpower: ["4T"],
			bodyslam: ["3T"],
			calmmind: ["4M", "3M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "4S11", "4S12", "3L1", "3S0", "3S1", "3S2", "3S3", "3S4", "3S5", "3S6", "3S7", "3S8", "3S9"],
			cosmicpower: ["4L60", "3L45"],
			defensecurl: ["3T"],
			doomdesire: ["4L70", "3L50"],
			doubleedge: ["4L40", "3T", "3L35"],
			doubleteam: ["4M", "3M"],
			dracometeor: ["4S12"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			flashcannon: ["4M"],
			fling: ["4M"],
			frustration: ["4M", "3M"],
			futuresight: ["4L55", "3L40"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gravity: ["4L45"],
			healingwish: ["4L50"],
			helpinghand: ["4T", "4L15", "3L15", "3S10"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			lastresort: ["4T", "4L65"],
			lightscreen: ["4M", "3M"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L20", "3M", "3L20", "3S10"],
			psychup: ["4M", "3T"],
			raindance: ["4M", "3M"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			refresh: ["4L25", "3L25", "3S10"],
			rest: ["4M", "4L5", "4S11", "4S12", "3M", "3L5", "3S0", "3S1", "3S2", "3S3", "3S4", "3S5", "3S6", "3S7", "3S8", "3S9", "3S10"],
			return: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			sandstorm: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L10", "3T", "3L10"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterpulse: ["4M", "3M"],
			wish: ["4L1", "4S11", "4S12", "3L1", "3S0", "3S1", "3S2", "3S3", "3S4", "3S5", "3S6", "3S7", "3S8", "3S9"],
			zenheadbutt: ["4T", "4L35"],
		},
	},
	deoxys: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "3M"],
			agility: ["4L73", "3L35"],
			amnesia: ["4L73", "3L35"],
			avalanche: ["4M"],
			bodyslam: ["3T"],
			brickbreak: ["4M", "3M"],
			calmmind: ["4M", "3M"],
			chargebeam: ["4M"],
			cosmicpower: ["4L73", "3L35", "3S3"],
			counter: ["4L97", "4S6", "3T", "3L50"],
			cut: ["4M", "3M"],
			detect: ["4S6"],
			doubleedge: ["3T"],
			doubleteam: ["4M", "4L17", "4S5", "3M", "3L10"],
			drainpunch: ["4M"],
			dreameater: ["4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["4M"],
			extremespeed: ["4L97", "4S4", "4S5", "3L50"],
			facade: ["4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["4M", "3M"],
			flashcannon: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["4M", "3M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M", "3M"],
			hyperbeam: ["4M", "4L97", "4S7", "3M", "3L50", "3S3"],
			icebeam: ["4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T", "4L73", "4S4", "3L35"],
			knockoff: ["4T", "4L25", "3L15", "3S1", "3S2"],
			leer: ["4L1", "4S8", "3L1"],
			lightscreen: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			meteormash: ["4S7"],
			mimic: ["3T"],
			mirrorcoat: ["4L97", "4S6", "3L50"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["4L9", "4S8", "3L5"],
			poisonjab: ["4M"],
			protect: ["4M", "3M"],
			psychic: ["4M", "4L41", "3M", "3L25", "3S0", "3S1", "3S2"],
			psychoboost: ["4L89", "4S4", "4S5", "4S6", "4S7", "4S8", "3L45", "3S3"],
			psychoshift: ["4L57"],
			psychup: ["4M", "3T"],
			pursuit: ["4L33", "3L20", "3S0", "3S2"],
			raindance: ["4M", "3M"],
			recover: ["4L81", "3L40", "3S3"],
			recycle: ["4M"],
			reflect: ["4M", "3M"],
			rest: ["4M", "3M"],
			return: ["4M", "3M"],
			rockslide: ["4M", "3T"],
			rocksmash: ["4M", "3M"],
			rocktomb: ["4M", "3M"],
			safeguard: ["4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "4L49", "3M", "3L30", "3S1"],
			snore: ["4T", "3T"],
			solarbeam: ["4M", "3M"],
			spikes: ["4L33", "3L20", "3S1"],
			stealthrock: ["4M"],
			strength: ["4M", "3M"],
			substitute: ["4M", "3T"],
			sunnyday: ["4M", "3M"],
			superpower: ["4T", "4L49", "4S7", "3S0"],
			swagger: ["4M", "3T"],
			swift: ["4T", "4L49", "4S5", "3T", "3L30", "3S2"],
			taunt: ["4M", "4L25", "3M", "3L15", "3S0"],
			teleport: ["4L17", "3L10"],
			thunder: ["4M", "3M"],
			thunderbolt: ["4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["4M", "3T"],
			torment: ["4M", "3M"],
			toxic: ["4M", "3M"],
			trick: ["4T"],
			trickroom: ["4M"],
			waterpulse: ["4M", "3M"],
			wrap: ["4L1", "4S8", "3L1"],
			zapcannon: ["4L81", "4S4", "3L40"],
			zenheadbutt: ["4T", "4L65"],
		},
	},
	turtwig: {
		inherit: true,
		learnset: {
			absorb: ["4L9"],
			amnesia: ["4E"],
			attract: ["4M"],
			bite: ["4L21"],
			bodyslam: ["4E"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			crunch: ["4L37"],
			curse: ["4L17"],
			cut: ["4M"],
			doubleedge: ["4E"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M", "4L41"],
			grassknot: ["4M"],
			growth: ["4E"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			leafstorm: ["4L45"],
			leechseed: ["4L29"],
			lightscreen: ["4M"],
			megadrain: ["4L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			razorleaf: ["4L13"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rocksmash: ["4M"],
			safeguard: ["4M"],
			sandtomb: ["4E"],
			secretpower: ["4M"],
			seedbomb: ["4T", "4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superpower: ["4T", "4E"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			synthesis: ["4T", "4L33"],
			tackle: ["4L1"],
			thrash: ["4E"],
			tickle: ["4E"],
			toxic: ["4M"],
			withdraw: ["4L5"],
			worryseed: ["4T", "4E"],
		},
	},
	grotle: {
		inherit: true,
		learnset: {
			absorb: ["4L9"],
			attract: ["4M"],
			bite: ["4L22"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			crunch: ["4L42"],
			curse: ["4L17"],
			cut: ["4M"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M", "4L47"],
			grassknot: ["4M"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			leafstorm: ["4L52"],
			leechseed: ["4L32"],
			lightscreen: ["4M"],
			megadrain: ["4L27"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			razorleaf: ["4L13"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rocksmash: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superpower: ["4T"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			synthesis: ["4T", "4L37"],
			tackle: ["4L1"],
			toxic: ["4M"],
			withdraw: ["4L1"],
			worryseed: ["4T"],
		},
	},
	torterra: {
		inherit: true,
		learnset: {
			absorb: ["4L1"],
			attract: ["4M"],
			bite: ["4L22"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			crunch: ["4L45"],
			curse: ["4L17"],
			cut: ["4M"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L32"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frenzyplant: ["4T"],
			frustration: ["4M"],
			gigadrain: ["4M", "4L51"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			leafstorm: ["4L57"],
			leechseed: ["4L33"],
			lightscreen: ["4M"],
			megadrain: ["4L27"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M"],
			razorleaf: ["4L1"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			safeguard: ["4M"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superpower: ["4T"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			synthesis: ["4T", "4L39"],
			tackle: ["4L1"],
			toxic: ["4M"],
			withdraw: ["4L1"],
			woodhammer: ["4L1"],
			worryseed: ["4T"],
		},
	},
	chimchar: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M"],
			blazekick: ["4E"],
			brickbreak: ["4M"],
			bulkup: ["4M"],
			captivate: ["4M"],
			counter: ["4E"],
			cut: ["4M"],
			dig: ["4M"],
			doublekick: ["4E"],
			doubleteam: ["4M"],
			ember: ["4L7"],
			encore: ["4E"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M", "4L31"],
			fakeout: ["4E"],
			fireblast: ["4M"],
			firepunch: ["4T", "4E"],
			firespin: ["4L33"],
			flamethrower: ["4M", "4L41", "4S0", "4S2"],
			flamewheel: ["4L17"],
			fling: ["4M"],
			focusenergy: ["4E"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furyswipes: ["4L15"],
			grassknot: ["4M", "4S0", "4S2"],
			gunkshot: ["4T"],
			heatwave: ["4T", "4E"],
			helpinghand: ["4T", "4E", "4S0", "4S2"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			leer: ["4L1"],
			mudslap: ["4T"],
			nastyplot: ["4L23"],
			naturalgift: ["4M"],
			overheat: ["4M"],
			protect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rocksmash: ["4M"],
			rollout: ["4T"],
			scratch: ["4L1"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			slackoff: ["4L39"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M"],
			taunt: ["4M", "4L9"],
			thunderpunch: ["4T", "4E", "4S0", "4S2"],
			torment: ["4M", "4L25"],
			toxic: ["4M"],
			uproar: ["4T"],
			uturn: ["4M"],
			vacuumwave: ["4T"],
			willowisp: ["4M"],
		},
	},
	monferno: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M"],
			brickbreak: ["4M"],
			bulkup: ["4M"],
			captivate: ["4M"],
			closecombat: ["4L36"],
			cut: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			ember: ["4L1"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			feint: ["4L26"],
			fireblast: ["4M"],
			firepunch: ["4T"],
			firespin: ["4L39"],
			flamethrower: ["4M"],
			flamewheel: ["4L19"],
			flareblitz: ["4L49"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furyswipes: ["4L16"],
			grassknot: ["4M"],
			gunkshot: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			leer: ["4L1"],
			machpunch: ["4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			rollout: ["4T"],
			scratch: ["4L1"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			slackoff: ["4L46"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M"],
			taunt: ["4M", "4L9"],
			thunderpunch: ["4T"],
			torment: ["4M", "4L29"],
			toxic: ["4M"],
			uturn: ["4M"],
			vacuumwave: ["4T"],
			willowisp: ["4M"],
		},
	},
	infernape: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M"],
			blastburn: ["4T"],
			brickbreak: ["4M"],
			bulkup: ["4M"],
			calmmind: ["4M", "4L53"],
			captivate: ["4M"],
			closecombat: ["4L41"],
			cut: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			earthquake: ["4M"],
			ember: ["4L1"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			feint: ["4L29"],
			fireblast: ["4M"],
			firepunch: ["4T"],
			firespin: ["4L45"],
			flamethrower: ["4M"],
			flamewheel: ["4L21"],
			flareblitz: ["4L57"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furyswipes: ["4L17"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gunkshot: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			irontail: ["4M"],
			leer: ["4L1"],
			machpunch: ["4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M"],
			punishment: ["4L33"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			rollout: ["4T"],
			scratch: ["4L1"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M"],
			taunt: ["4M", "4L1"],
			thunderpunch: ["4T"],
			torment: ["4M"],
			toxic: ["4M"],
			uturn: ["4M"],
			vacuumwave: ["4T"],
			willowisp: ["4M"],
		},
	},
	piplup: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			agility: ["4E"],
			aquaring: ["4E"],
			attract: ["4M"],
			bide: ["4L18"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			brine: ["4M", "4L29"],
			bubble: ["4L8"],
			bubblebeam: ["4L18"],
			captivate: ["4M"],
			cut: ["4M"],
			defog: ["4M"],
			dig: ["4M"],
			dive: ["4T"],
			doublehit: ["4E"],
			doubleteam: ["4M"],
			drillpeck: ["4L39"],
			endure: ["4M"],
			facade: ["4M"],
			flail: ["4E"],
			fling: ["4M"],
			frustration: ["4M"],
			furyattack: ["4L25"],
			grassknot: ["4M"],
			growl: ["4L4"],
			hail: ["4M"],
			hiddenpower: ["4M"],
			hydropump: ["4L43", "4E"],
			icebeam: ["4M"],
			icywind: ["4T"],
			mist: ["4L36"],
			mudslap: ["4T", "4E"],
			mudsport: ["4E"],
			naturalgift: ["4M"],
			peck: ["4L15"],
			pluck: ["4M"],
			pound: ["4L1"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T", "4E"],
			stealthrock: ["4M"],
			substitute: ["4M"],
			supersonic: ["4E"],
			surf: ["4M"],
			swagger: ["4M"],
			toxic: ["4M"],
			waterfall: ["4M"],
			waterpulse: ["4M"],
			watersport: ["4L11"],
			whirlpool: ["4L32"],
			yawn: ["4E"],
		},
	},
	prinplup: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M"],
			bide: ["4L19"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			brine: ["4M", "4L33"],
			bubble: ["4L8"],
			bubblebeam: ["4L19"],
			captivate: ["4M"],
			cut: ["4M"],
			defog: ["4M"],
			dig: ["4M"],
			dive: ["4T"],
			doubleteam: ["4M"],
			drillpeck: ["4L46"],
			endure: ["4M"],
			facade: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			furyattack: ["4L28"],
			grassknot: ["4M"],
			growl: ["4L1"],
			hail: ["4M"],
			hiddenpower: ["4M"],
			hydropump: ["4L51"],
			icebeam: ["4M"],
			icywind: ["4T"],
			metalclaw: ["4L16"],
			mist: ["4L42"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["4L15"],
			pluck: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			tackle: ["4L1"],
			toxic: ["4M"],
			waterfall: ["4M"],
			waterpulse: ["4M"],
			watersport: ["4L11"],
			whirlpool: ["4L37"],
		},
	},
	empoleon: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aquajet: ["4L36"],
			attract: ["4M"],
			avalanche: ["4M"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			brine: ["4M", "4L33"],
			bubble: ["4L1"],
			bubblebeam: ["4L19"],
			captivate: ["4M"],
			cut: ["4M"],
			defog: ["4M"],
			dig: ["4M"],
			dive: ["4T"],
			doubleteam: ["4M"],
			drillpeck: ["4L52"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flashcannon: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			furyattack: ["4L28"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1"],
			hail: ["4M"],
			hiddenpower: ["4M"],
			hydrocannon: ["4T"],
			hydropump: ["4L59"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icywind: ["4T"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			metalclaw: ["4L16"],
			mist: ["4L46"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["4L15"],
			pluck: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			steelwing: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			surf: ["4M"],
			swagger: ["4M", "4L19"],
			swordsdance: ["4M", "4L11"],
			tackle: ["4L1"],
			toxic: ["4M"],
			waterfall: ["4M"],
			waterpulse: ["4M"],
			whirlpool: ["4L39"],
		},
	},
	starly: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L25"],
			agility: ["4L33"],
			aircutter: ["4T"],
			astonish: ["4E"],
			attract: ["4M"],
			bravebird: ["4L37"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["4E"],
			doubleteam: ["4M", "4L13"],
			endeavor: ["4T", "4L17"],
			endure: ["4M"],
			facade: ["4M"],
			featherdance: ["4E"],
			fly: ["4M"],
			foresight: ["4E"],
			frustration: ["4M"],
			furyattack: ["4E"],
			growl: ["4L1", "4S0"],
			heatwave: ["4T"],
			hiddenpower: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["4M"],
			protect: ["4M"],
			pursuit: ["4E"],
			quickattack: ["4L5"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roost: ["4M"],
			sandattack: ["4E"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			steelwing: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1", "4S0"],
			takedown: ["4L29"],
			thief: ["4M"],
			toxic: ["4M"],
			twister: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4L21"],
			wingattack: ["4L9"],
		},
	},
	staravia: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L28"],
			agility: ["4L38"],
			aircutter: ["4T"],
			attract: ["4M"],
			bravebird: ["4L43"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleteam: ["4M", "4L13"],
			endeavor: ["4T", "4L18"],
			endure: ["4M"],
			facade: ["4M"],
			fly: ["4M"],
			frustration: ["4M"],
			growl: ["4L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["4M"],
			protect: ["4M"],
			quickattack: ["4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roost: ["4M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			steelwing: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			takedown: ["4L33"],
			thief: ["4M"],
			toxic: ["4M"],
			twister: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4L23"],
			wingattack: ["4L9"],
		},
	},
	staraptor: {
		inherit: true,
		learnset: {
			aerialace: ["4M", "4L28"],
			agility: ["4L41"],
			aircutter: ["4T"],
			attract: ["4M"],
			bravebird: ["4L49"],
			captivate: ["4M"],
			closecombat: ["4L34"],
			defog: ["4M"],
			doubleteam: ["4M", "4L13"],
			endeavor: ["4T", "4L18"],
			endure: ["4M"],
			facade: ["4M"],
			fly: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			growl: ["4L1"],
			heatwave: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["4M"],
			protect: ["4M"],
			quickattack: ["4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roost: ["4M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			steelwing: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			takedown: ["4L33"],
			thief: ["4M"],
			toxic: ["4M"],
			twister: ["4T"],
			uturn: ["4M"],
			whirlwind: ["4L23"],
			wingattack: ["4L1"],
		},
	},
	bidoof: {
		inherit: true,
		learnset: {
			amnesia: ["4L29"],
			aquatail: ["4T", "4E"],
			attract: ["4M"],
			blizzard: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			curse: ["4L45"],
			cut: ["4M"],
			defensecurl: ["4L9", "4E"],
			dig: ["4M"],
			doubleedge: ["4E"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			furyswipes: ["4E"],
			grassknot: ["4M"],
			growl: ["4L5"],
			headbutt: ["4L17"],
			hiddenpower: ["4M"],
			hyperfang: ["4L21"],
			icebeam: ["4M"],
			icywind: ["4T"],
			irontail: ["4M"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["4E"],
			pluck: ["4M"],
			protect: ["4M"],
			quickattack: ["4E"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rocksmash: ["4M"],
			rollout: ["4T", "4L13", "4E"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superfang: ["4L37"],
			superpower: ["4T", "4L41"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1", "4S0"],
			takedown: ["4L33"],
			taunt: ["4M"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			watersport: ["4E"],
			yawn: ["4L25"],
		},
	},
	bibarel: {
		inherit: true,
		learnset: {
			amnesia: ["4L33"],
			aquatail: ["4T"],
			attract: ["4M"],
			blizzard: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			curse: ["4L53"],
			cut: ["4M"],
			defensecurl: ["4L9"],
			dig: ["4M"],
			dive: ["4T"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fling: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1"],
			headbutt: ["4L18"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			hyperfang: ["4L23"],
			icebeam: ["4M"],
			icywind: ["4T"],
			irontail: ["4M"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pluck: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rocksmash: ["4M"],
			rollout: ["4T", "4L13"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superfang: ["4L43"],
			superpower: ["4T", "4L48"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			takedown: ["4L38"],
			taunt: ["4M"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			waterfall: ["4M"],
			watergun: ["4L15"],
			waterpulse: ["4M"],
			yawn: ["4L28"],
		},
	},
	kricketot: {
		inherit: true,
		learnset: {
			bide: ["4L1"],
			bugbite: ["4L16"],
			endeavor: ["4T"],
			growl: ["4L1"],
			mudslap: ["4T"],
			snore: ["4T"],
			uproar: ["4T"],
		},
	},
	kricketune: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M"],
			bide: ["4L1"],
			brickbreak: ["4M"],
			bugbuzz: ["4L34"],
			captivate: ["4M"],
			cut: ["4M"],
			doubleteam: ["4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			falseswipe: ["4M"],
			flash: ["4M"],
			focusenergy: ["4L22"],
			frustration: ["4M"],
			furycutter: ["4T", "4L10"],
			gigaimpact: ["4M"],
			growl: ["4L1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			knockoff: ["4T"],
			leechlife: ["4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["4L42"],
			perishsong: ["4L38"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rocksmash: ["4M"],
			screech: ["4L30"],
			secretpower: ["4M"],
			silverwind: ["4M"],
			sing: ["4L18"],
			slash: ["4L26"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			taunt: ["4M", "4L38"],
			toxic: ["4M"],
			uproar: ["4T"],
			xscissor: ["4M", "4L26"],
		},
	},
	shinx: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			bite: ["4L13"],
			captivate: ["4M"],
			charge: ["4L9"],
			chargebeam: ["4M"],
			crunch: ["4L29"],
			discharge: ["4L41"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			firefang: ["4E"],
			flash: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			hiddenpower: ["4M"],
			howl: ["4E"],
			icefang: ["4E"],
			irontail: ["4M"],
			leer: ["4L5"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			quickattack: ["4E"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M", "4L21"],
			scaryface: ["4L37"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spark: ["4L13"],
			strength: ["4M"],
			substitute: ["4M"],
			swagger: ["4M", "4L25"],
			swift: ["4T"],
			tackle: ["4L1"],
			takedown: ["4E"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderfang: ["4L29", "4E"],
			thunderwave: ["4M"],
			toxic: ["4M"],
		},
	},
	luxio: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			bite: ["4L13"],
			captivate: ["4M"],
			charge: ["4L9"],
			chargebeam: ["4M"],
			crunch: ["4L33"],
			discharge: ["4L48"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			leer: ["4L1"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M", "4L23"],
			scaryface: ["4L43"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spark: ["4L13"],
			strength: ["4M"],
			substitute: ["4M"],
			swagger: ["4M", "4L28"],
			swift: ["4T"],
			tackle: ["4L1"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderfang: ["4L33"],
			thunderwave: ["4M"],
			toxic: ["4M"],
		},
	},
	luxray: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			bite: ["4L13"],
			captivate: ["4M"],
			charge: ["4L1"],
			chargebeam: ["4M"],
			crunch: ["4L35"],
			discharge: ["4L56"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			irontail: ["4M"],
			leer: ["4L1"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M", "4L23"],
			scaryface: ["4L49"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spark: ["4L13"],
			strength: ["4M"],
			substitute: ["4M"],
			superpower: ["4T"],
			swagger: ["4M", "4L28"],
			swift: ["4T"],
			tackle: ["4L1"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderfang: ["4L35"],
			thunderwave: ["4M"],
			toxic: ["4M"],
		},
	},
	cranidos: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L28"],
			assurance: ["4L24"],
			attract: ["4M"],
			blizzard: ["4M"],
			captivate: ["4M"],
			crunch: ["4E"],
			dig: ["4M"],
			doubleedge: ["4E"],
			doubleteam: ["4M"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			firepunch: ["4T"],
			flamethrower: ["4M"],
			fling: ["4M"],
			focusenergy: ["4L6"],
			frustration: ["4M"],
			hammerarm: ["4E"],
			headbutt: ["4L1"],
			headsmash: ["4L43"],
			hiddenpower: ["4M"],
			icebeam: ["4M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			leer: ["4L1", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M"],
			pursuit: ["4L10"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandstorm: ["4M"],
			scaryface: ["4L19"],
			screech: ["4L37"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			slam: ["4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["4E"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superpower: ["4T"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			takedown: ["4L15"],
			thief: ["4M"],
			thrash: ["4E"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			toxic: ["4M"],
			uproar: ["4T"],
			whirlwind: ["4E"],
			zenheadbutt: ["4T", "4L33"],
		},
	},
	rampardos: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L28"],
			assurance: ["4L24"],
			attract: ["4M"],
			avalanche: ["4M"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endeavor: ["4T", "4L30"],
			endure: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			firepunch: ["4T"],
			flamethrower: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focusenergy: ["4L6"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			headbutt: ["4L1"],
			headsmash: ["4L52"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			leer: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["4M"],
			protect: ["4M"],
			pursuit: ["4L10"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandstorm: ["4M"],
			scaryface: ["4L19"],
			screech: ["4L43"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superpower: ["4T"],
			surf: ["4M"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			takedown: ["4L15"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			toxic: ["4M"],
			uproar: ["4T"],
			zenheadbutt: ["4T", "4L36"],
		},
	},
	shieldon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L28"],
			attract: ["4M"],
			blizzard: ["4M"],
			bodyslam: ["4E"],
			captivate: ["4M"],
			curse: ["4E"],
			dig: ["4M"],
			doubleedge: ["4E"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endure: ["4M", "4L33"],
			facade: ["4M"],
			fireblast: ["4M"],
			fissure: ["4E"],
			flamethrower: ["4M"],
			flashcannon: ["4M"],
			focusenergy: ["4E"],
			frustration: ["4M"],
			headbutt: ["4E"],
			hiddenpower: ["4M"],
			icebeam: ["4M"],
			irondefense: ["4T", "4L19"],
			ironhead: ["4T", "4L43"],
			irontail: ["4M"],
			magnetrise: ["4T"],
			metalburst: ["4L37"],
			metalsound: ["4L10"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M", "4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockblast: ["4E"],
			rockpolish: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandstorm: ["4M"],
			scaryface: ["4E"],
			screech: ["4E"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M", "4L24"],
			tackle: ["4L1"],
			takedown: ["4L15"],
			taunt: ["4M", "4L6"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
		},
	},
	bastiodon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L28"],
			attract: ["4M"],
			avalanche: ["4M"],
			blizzard: ["4M"],
			block: ["4L30"],
			captivate: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endure: ["4M", "4L36"],
			facade: ["4M"],
			fireblast: ["4M"],
			flamethrower: ["4M"],
			flashcannon: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			irondefense: ["4T", "4L19"],
			ironhead: ["4T", "4L52"],
			irontail: ["4M"],
			magnetrise: ["4T"],
			metalburst: ["4L43"],
			metalsound: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M", "4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M", "4L24"],
			tackle: ["4L1"],
			takedown: ["4L15"],
			taunt: ["4M", "4L1"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
		},
	},
	burmy: {
		inherit: true,
		learnset: {
			bugbite: ["4L15"],
			hiddenpower: ["4L20"],
			protect: ["4L1"],
			snore: ["4T"],
			tackle: ["4L10"],
		},
	},
	wormadam: {
		inherit: true,
		learnset: {
			attract: ["4M", "4L41"],
			bugbite: ["4L15"],
			bulletseed: ["4M"],
			captivate: ["4M", "4L35"],
			confusion: ["4L23"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flail: ["4L38"],
			flash: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growth: ["4L29"],
			hiddenpower: ["4M", "4L20"],
			hyperbeam: ["4M"],
			leafstorm: ["4L47"],
			naturalgift: ["4M"],
			protect: ["4M", "4L10"],
			psybeam: ["4L32"],
			psychic: ["4M", "4L44"],
			psychup: ["4M"],
			raindance: ["4M"],
			razorleaf: ["4L26"],
			rest: ["4M"],
			return: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			synthesis: ["4T"],
			tackle: ["4L1"],
			thief: ["4M"],
			toxic: ["4M"],
			uproar: ["4T"],
			worryseed: ["4T"],
		},
	},
	wormadamsandy: {
		inherit: true,
		learnset: {
			attract: ["4M", "4L41"],
			bugbite: ["4L15"],
			captivate: ["4M", "4L35"],
			confusion: ["4L23"],
			dig: ["4M"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			fissure: ["4L47"],
			flail: ["4L38"],
			flash: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			harden: ["4L29"],
			hiddenpower: ["4M", "4L20"],
			hyperbeam: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M", "4L10"],
			psybeam: ["4L32"],
			psychic: ["4M", "4L44"],
			psychup: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockblast: ["4L26"],
			rocktomb: ["4M"],
			rollout: ["4T"],
			safeguard: ["4M"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			tackle: ["4L1"],
			thief: ["4M"],
			toxic: ["4M"],
			uproar: ["4T"],
		},
	},
	wormadamtrash: {
		inherit: true,
		learnset: {
			attract: ["4M", "4L41"],
			bugbite: ["4L15"],
			captivate: ["4M", "4L35"],
			confusion: ["4L23"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			flail: ["4L38"],
			flash: ["4M"],
			flashcannon: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			gunkshot: ["4T"],
			gyroball: ["4M"],
			hiddenpower: ["4M", "4L20"],
			hyperbeam: ["4M"],
			irondefense: ["4T"],
			ironhead: ["4T", "4L47"],
			magnetrise: ["4T"],
			metalsound: ["4L29"],
			mirrorshot: ["4L26"],
			naturalgift: ["4M"],
			protect: ["4M", "4L10"],
			psybeam: ["4L32"],
			psychic: ["4M", "4L44"],
			psychup: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			tackle: ["4L1"],
			thief: ["4M"],
			toxic: ["4M"],
			uproar: ["4T"],
		},
	},
	mothim: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aircutter: ["4T"],
			airslash: ["4L41"],
			attract: ["4M"],
			bugbite: ["4L15"],
			bugbuzz: ["4L47"],
			camouflage: ["4L35"],
			captivate: ["4M"],
			confusion: ["4L23"],
			defog: ["4M"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			gust: ["4L26"],
			hiddenpower: ["4M", "4L20"],
			hyperbeam: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonpowder: ["4L29"],
			protect: ["4M", "4L10"],
			psybeam: ["4L32"],
			psychic: ["4M", "4L44"],
			psychup: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roost: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			silverwind: ["4M", "4L38"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			thief: ["4M"],
			toxic: ["4M"],
			twister: ["4T"],
			uturn: ["4M"],
		},
	},
	combee: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			bugbite: ["4L13"],
			endeavor: ["4T"],
			gust: ["4L1"],
			mudslap: ["4T"],
			ominouswind: ["4T"],
			snore: ["4T"],
			sweetscent: ["4L1"],
			swift: ["4T"],
		},
	},
	vespiquen: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aircutter: ["4T"],
			attackorder: ["4L37"],
			attract: ["4M"],
			captivate: ["4M", "4L33"],
			confuseray: ["4L7"],
			cut: ["4M"],
			defendorder: ["4L13"],
			defog: ["4M"],
			destinybond: ["4L43"],
			doubleteam: ["4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T", "4L9"],
			furyswipes: ["4L19"],
			gigaimpact: ["4M"],
			gust: ["4L1"],
			healorder: ["4L25"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonsting: ["4L3"],
			powergem: ["4L21"],
			protect: ["4M"],
			pursuit: ["4L15"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roost: ["4M"],
			secretpower: ["4M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			slash: ["4L31"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M", "4L39"],
			sweetscent: ["4L1"],
			swift: ["4T"],
			thief: ["4M"],
			toxic: ["4M", "4L27"],
			uturn: ["4M"],
			xscissor: ["4M"],
		},
	},
	pachirisu: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			bide: ["4L1"],
			bite: ["4E"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L9"],
			covet: ["4E"],
			cut: ["4M"],
			defensecurl: ["4E"],
			dig: ["4M"],
			discharge: ["4L29"],
			doubleteam: ["4M"],
			endure: ["4M", "4L17"],
			facade: ["4M"],
			faketears: ["4E"],
			flail: ["4E"],
			flash: ["4M"],
			flatter: ["4E"],
			fling: ["4M"],
			frustration: ["4M"],
			grassknot: ["4M"],
			growl: ["4L1"],
			gunkshot: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			lastresort: ["4T", "4L37"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			quickattack: ["4L5"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T", "4E"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spark: ["4L13"],
			substitute: ["4M"],
			superfang: ["4L33"],
			swagger: ["4M"],
			sweetkiss: ["4L25"],
			swift: ["4T", "4L21"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			uproar: ["4T"],
			uturn: ["4M"],
		},
	},
	buizel: {
		inherit: true,
		learnset: {
			agility: ["4L28"],
			aquajet: ["4L21"],
			attract: ["4M"],
			batonpass: ["4E"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			brine: ["4M"],
			bulkup: ["4M"],
			captivate: ["4M"],
			dig: ["4M"],
			dive: ["4T"],
			doubleslap: ["4E"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furycutter: ["4E"],
			furyswipes: ["4E"],
			growl: ["4L1"],
			hail: ["4M"],
			headbutt: ["4E"],
			hiddenpower: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			irontail: ["4M"],
			mudslap: ["4T", "4E"],
			naturalgift: ["4M"],
			odorsleuth: ["4E"],
			protect: ["4M"],
			pursuit: ["4L10"],
			quickattack: ["4L3"],
			raindance: ["4M"],
			razorwind: ["4L45"],
			rest: ["4M"],
			return: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			slash: ["4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			sonicboom: ["4L1"],
			strength: ["4M"],
			substitute: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T", "4L15"],
			toxic: ["4M"],
			waterfall: ["4M"],
			watergun: ["4L6"],
			waterpulse: ["4M"],
			watersport: ["4L1"],
			whirlpool: ["4L36"],
		},
	},
	floatzel: {
		inherit: true,
		learnset: {
			agility: ["4L29"],
			aquajet: ["4L21"],
			aquatail: ["4T"],
			attract: ["4M"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			brine: ["4M"],
			bulkup: ["4M"],
			captivate: ["4M"],
			crunch: ["4L26"],
			dig: ["4M"],
			dive: ["4T"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			growl: ["4L1"],
			hail: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icefang: ["4L1"],
			icepunch: ["4T"],
			icywind: ["4T"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M"],
			pursuit: ["4L10"],
			quickattack: ["4L1"],
			raindance: ["4M"],
			razorwind: ["4L50"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			sonicboom: ["4L1"],
			strength: ["4M"],
			substitute: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T", "4L15"],
			taunt: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			waterfall: ["4M"],
			watergun: ["4L6"],
			waterpulse: ["4M"],
			watersport: ["4L1"],
			whirlpool: ["4L39"],
		},
	},
	cherubi: {
		inherit: true,
		learnset: {
			aromatherapy: ["4E"],
			attract: ["4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			doubleteam: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			grassknot: ["4M"],
			grasswhistle: ["4E"],
			growth: ["4L7"],
			helpinghand: ["4T", "4L13"],
			hiddenpower: ["4M"],
			leechseed: ["4L10"],
			luckychant: ["4L40"],
			magicalleaf: ["4L19"],
			naturalgift: ["4M"],
			naturepower: ["4E"],
			protect: ["4M"],
			razorleaf: ["4E"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M", "4L37"],
			substitute: ["4M"],
			sunnyday: ["4M", "4L22"],
			swagger: ["4M"],
			sweetscent: ["4E"],
			swordsdance: ["4M"],
			synthesis: ["4T"],
			tackle: ["4L1"],
			takedown: ["4L31"],
			tickle: ["4E"],
			toxic: ["4M"],
			worryseed: ["4T", "4L28"],
		},
	},
	cherrim: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			doubleteam: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growth: ["4L1"],
			helpinghand: ["4T", "4L13"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			leechseed: ["4L10"],
			luckychant: ["4L48"],
			magicalleaf: ["4L19"],
			naturalgift: ["4M"],
			petaldance: ["4L25"],
			protect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M", "4L43"],
			substitute: ["4M"],
			sunnyday: ["4M", "4L22"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			synthesis: ["4T"],
			tackle: ["4L1"],
			takedown: ["4L35"],
			toxic: ["4M"],
			worryseed: ["4T", "4L30"],
		},
	},
	shellos: {
		inherit: true,
		learnset: {
			amnesia: ["4E"],
			ancientpower: ["4T"],
			attract: ["4M"],
			blizzard: ["4M"],
			bodyslam: ["4L29"],
			brine: ["4M"],
			captivate: ["4M"],
			counter: ["4E"],
			curse: ["4E"],
			dive: ["4T"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			endure: ["4M"],
			facade: ["4M"],
			fissure: ["4E"],
			frustration: ["4M"],
			hail: ["4M"],
			harden: ["4L4"],
			hiddenpower: ["4M", "4L16"],
			icebeam: ["4M"],
			icywind: ["4T"],
			memento: ["4E"],
			mirrorcoat: ["4E"],
			mudbomb: ["4L11"],
			muddywater: ["4L37"],
			mudslap: ["4T", "4L1"],
			mudsport: ["4L2"],
			naturalgift: ["4M"],
			protect: ["4M"],
			raindance: ["4M", "4L22"],
			recover: ["4L46"],
			rest: ["4M"],
			return: ["4M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spitup: ["4E"],
			stockpile: ["4E"],
			substitute: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			swallow: ["4E"],
			toxic: ["4M"],
			waterpulse: ["4M", "4L7"],
			yawn: ["4E"],
		},
	},
	gastrodon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["4M"],
			blizzard: ["4M"],
			bodyslam: ["4L29"],
			brine: ["4M"],
			captivate: ["4M"],
			dig: ["4M"],
			dive: ["4T"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			hail: ["4M"],
			harden: ["4L1"],
			hiddenpower: ["4M", "4L16"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icywind: ["4T"],
			mudbomb: ["4L11"],
			muddywater: ["4L41"],
			mudslap: ["4T", "4L1"],
			mudsport: ["4L1"],
			naturalgift: ["4M"],
			protect: ["4M"],
			raindance: ["4M", "4L22"],
			recover: ["4L54"],
			rest: ["4M"],
			return: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			toxic: ["4M"],
			waterfall: ["4M"],
			waterpulse: ["4M", "4L1"],
		},
	},
	gastrodoneast: {
		inherit: true,
		learnset: {},
	},
	drifloon: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			astonish: ["4L6"],
			attract: ["4M"],
			batonpass: ["4L33"],
			bodyslam: ["4E"],
			calmmind: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			constrict: ["4L1"],
			cut: ["4M"],
			defog: ["4M"],
			destinybond: ["4E"],
			disable: ["4E"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			embargo: ["4M"],
			endure: ["4M"],
			explosion: ["4M", "4L43"],
			facade: ["4M"],
			flash: ["4M"],
			focusenergy: ["4L14"],
			frustration: ["4M"],
			gust: ["4L11"],
			gyroball: ["4M"],
			haze: ["4E"],
			hiddenpower: ["4M"],
			hypnosis: ["4E"],
			icywind: ["4T"],
			knockoff: ["4T"],
			memento: ["4E"],
			minimize: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T", "4L30"],
			payback: ["4M", "4L17"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			secretpower: ["4M"],
			shadowball: ["4M", "4L38"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			spitup: ["4L27"],
			stockpile: ["4L22"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swallow: ["4L27"],
			swift: ["4T"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			willowisp: ["4M"],
		},
	},
	drifblim: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			astonish: ["4L1"],
			attract: ["4M"],
			batonpass: ["4L37"],
			calmmind: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			constrict: ["4L1"],
			cut: ["4M"],
			defog: ["4M"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			embargo: ["4M"],
			endure: ["4M"],
			explosion: ["4M", "4L51"],
			facade: ["4M"],
			flash: ["4M"],
			fly: ["4M"],
			focusenergy: ["4L14"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			gust: ["4L1"],
			gyroball: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icywind: ["4T"],
			knockoff: ["4T"],
			minimize: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T", "4L32"],
			payback: ["4M", "4L17"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			secretpower: ["4M"],
			shadowball: ["4M", "4L44"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			spitup: ["4L27"],
			stockpile: ["4L22"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swallow: ["4L27"],
			swift: ["4T"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			willowisp: ["4M"],
		},
	},
	buneary: {
		inherit: true,
		learnset: {
			agility: ["4L33"],
			attract: ["4M", "4E"],
			batonpass: ["4L26"],
			bounce: ["4T", "4L46"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L43"],
			cut: ["4M"],
			defensecurl: ["4L1"],
			dig: ["4M"],
			dizzypunch: ["4L36"],
			doublehit: ["4E"],
			doubleteam: ["4M"],
			drainpunch: ["4M"],
			encore: ["4E"],
			endeavor: ["4T"],
			endure: ["4M", "4L6"],
			facade: ["4M"],
			fakeout: ["4E"],
			faketears: ["4E"],
			firepunch: ["4E"],
			fling: ["4M"],
			focuspunch: ["4M"],
			foresight: ["4L1"],
			frustration: ["4M", "4L13"],
			grassknot: ["4M"],
			healingwish: ["4L53"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4E"],
			irontail: ["4M"],
			jumpkick: ["4L23"],
			lastresort: ["4T"],
			lowkick: ["4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pound: ["4L1"],
			protect: ["4M"],
			quickattack: ["4L16"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rocksmash: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			skyuppercut: ["4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			splash: ["4L1"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			sweetkiss: ["4E"],
			swift: ["4T"],
			switcheroo: ["4E"],
			thunderbolt: ["4M"],
			thunderpunch: ["4E"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			uproar: ["4T"],
			waterpulse: ["4M"],
		},
	},
	lopunny: {
		inherit: true,
		learnset: {
			agility: ["4L33"],
			attract: ["4M"],
			batonpass: ["4L26"],
			blizzard: ["4M"],
			bounce: ["4T", "4L46"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L43"],
			cut: ["4M"],
			defensecurl: ["4L1"],
			dig: ["4M"],
			dizzypunch: ["4L36"],
			doubleteam: ["4M"],
			drainpunch: ["4M"],
			endeavor: ["4T"],
			endure: ["4M", "4L6"],
			facade: ["4M"],
			firepunch: ["4T"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			foresight: ["4L1"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			healingwish: ["4L53"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T"],
			irontail: ["4M"],
			jumpkick: ["4L23"],
			lastresort: ["4T"],
			magiccoat: ["4L1"],
			mirrorcoat: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pound: ["4L1"],
			protect: ["4M"],
			quickattack: ["4L16"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M", "4L13"],
			rocksmash: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			splash: ["4L1"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			uproar: ["4T"],
			waterpulse: ["4M"],
		},
	},
	glameow: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			assist: ["4L29"],
			assurance: ["4E"],
			attract: ["4M", "4L45"],
			bite: ["4E"],
			captivate: ["4M", "4L32"],
			charm: ["4L25"],
			cut: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fakeout: ["4L1"],
			faketears: ["4E"],
			feintattack: ["4L17"],
			flash: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			furyswipes: ["4L20"],
			growl: ["4L8"],
			hiddenpower: ["4M"],
			hypnosis: ["4L13"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M"],
			psychup: ["4M"],
			quickattack: ["4E"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			sandattack: ["4E"],
			scratch: ["4L5"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shadowclaw: ["4M"],
			shockwave: ["4M"],
			slash: ["4L37"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			suckerpunch: ["4T", "4L41"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tailwhip: ["4E"],
			taunt: ["4M"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			uturn: ["4M"],
			waterpulse: ["4M"],
		},
	},
	purugly: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			assist: ["4L29"],
			attract: ["4M", "4L53"],
			bodyslam: ["4L45"],
			captivate: ["4M", "4L32"],
			charm: ["4L25"],
			cut: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fakeout: ["4L1"],
			feintattack: ["4L17"],
			flash: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			furyswipes: ["4L20"],
			gigaimpact: ["4M"],
			growl: ["4L1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			hypnosis: ["4L13"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rollout: ["4T"],
			scratch: ["4L1"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shadowclaw: ["4M"],
			shockwave: ["4M"],
			slash: ["4L37"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M", "4L38"],
			swift: ["4T"],
			taunt: ["4M"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			uturn: ["4M"],
			waterpulse: ["4M"],
		},
	},
	stunky: {
		inherit: true,
		learnset: {
			astonish: ["4E"],
			attract: ["4M"],
			captivate: ["4M"],
			crunch: ["4E"],
			cut: ["4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dig: ["4M"],
			doubleedge: ["4E"],
			doubleteam: ["4M"],
			endure: ["4M"],
			explosion: ["4M", "4L44"],
			facade: ["4M"],
			feint: ["4L18"],
			fireblast: ["4M"],
			flamethrower: ["4M"],
			focusenergy: ["4L1"],
			frustration: ["4M"],
			furycutter: ["4T"],
			furyswipes: ["4L10"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			leer: ["4E"],
			memento: ["4L37"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["4L31"],
			payback: ["4M"],
			poisongas: ["4L4"],
			protect: ["4M"],
			punishment: ["4E"],
			pursuit: ["4E"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rocksmash: ["4M"],
			scaryface: ["4E"],
			scratch: ["4L1"],
			screech: ["4L7"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shadowclaw: ["4M"],
			slash: ["4L22"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			smog: ["4E"],
			smokescreen: ["4L14"],
			snatch: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			taunt: ["4M"],
			thief: ["4M"],
			torment: ["4M"],
			toxic: ["4M", "4L20"],
		},
	},
	skuntank: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			endure: ["4M"],
			explosion: ["4M", "4L52"],
			facade: ["4M"],
			feint: ["4L18"],
			fireblast: ["4M"],
			flamethrower: ["4M", "4L34"],
			focusenergy: ["4L1"],
			frustration: ["4M"],
			furycutter: ["4T"],
			furyswipes: ["4L10"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			irontail: ["4M"],
			memento: ["4L41"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["4L31"],
			payback: ["4M"],
			poisongas: ["4L1"],
			poisonjab: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rocksmash: ["4M"],
			scratch: ["4L1"],
			screech: ["4L7"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shadowclaw: ["4M"],
			slash: ["4L22"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			smokescreen: ["4L14"],
			snatch: ["4M"],
			snore: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			taunt: ["4M"],
			thief: ["4M"],
			torment: ["4M"],
			toxic: ["4M", "4L20"],
		},
	},
	bronzor: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			calmmind: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4L14"],
			confusion: ["4L1"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			extrasensory: ["4L19"],
			facade: ["4M"],
			feintattack: ["4L41"],
			flash: ["4M"],
			flashcannon: ["4M"],
			frustration: ["4M"],
			futuresight: ["4L37"],
			grassknot: ["4M"],
			gyroball: ["4M", "4L35"],
			healblock: ["4L52"],
			hiddenpower: ["4M"],
			hypnosis: ["4L7"],
			imprison: ["4L12"],
			irondefense: ["4L26"],
			lightscreen: ["4M"],
			naturalgift: ["4M"],
			payback: ["4M", "4L49"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M"],
			rocktomb: ["4M"],
			rollout: ["4T"],
			safeguard: ["4M", "4L30"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			tackle: ["4L1"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
		},
	},
	bronzong: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			block: ["4L33"],
			calmmind: ["4M"],
			chargebeam: ["4M"],
			confuseray: ["4L14"],
			confusion: ["4L1"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			explosion: ["4M"],
			extrasensory: ["4L19"],
			facade: ["4M"],
			feintattack: ["4L50"],
			flash: ["4M"],
			flashcannon: ["4M"],
			frustration: ["4M"],
			futuresight: ["4L43"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gyroball: ["4M", "4L38"],
			healblock: ["4L67"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			hypnosis: ["4L1"],
			imprison: ["4L1"],
			irondefense: ["4L26"],
			ironhead: ["4T"],
			lightscreen: ["4M"],
			naturalgift: ["4M"],
			payback: ["4M", "4L61"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M", "4L1"],
			recycle: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			rollout: ["4T"],
			safeguard: ["4M", "4L30"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M", "4L1"],
			swagger: ["4M"],
			tackle: ["4L1"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	chatot: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			agility: ["4E"],
			aircutter: ["4T"],
			attract: ["4M"],
			captivate: ["4M"],
			chatter: ["4L21", "4S0"],
			defog: ["4M"],
			doubleteam: ["4M"],
			encore: ["4E"],
			endure: ["4M"],
			facade: ["4M"],
			featherdance: ["4L41"],
			fly: ["4M"],
			frustration: ["4M"],
			furyattack: ["4L17", "4S0"],
			growl: ["4L5"],
			heatwave: ["4T"],
			hiddenpower: ["4M"],
			hypervoice: ["4L45"],
			mimic: ["4L29"],
			mirrormove: ["4L9", "4S0"],
			mudslap: ["4T"],
			nastyplot: ["4E"],
			naturalgift: ["4M"],
			nightshade: ["4E"],
			ominouswind: ["4T"],
			peck: ["4L1"],
			pluck: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roost: ["4M", "4L33"],
			secretpower: ["4M"],
			sing: ["4L13"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			steelwing: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			supersonic: ["4E"],
			swagger: ["4M"],
			swift: ["4T"],
			taunt: ["4M", "4L25", "4S0"],
			thief: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			twister: ["4T"],
			uproar: ["4T", "4L37"],
			uturn: ["4M"],
		},
	},
	spiritomb: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			calmmind: ["4M"],
			captivate: ["4M"],
			confuseray: ["4L1"],
			curse: ["4L1"],
			darkpulse: ["4M", "4L49"],
			destinybond: ["4E"],
			doubleteam: ["4M"],
			dreameater: ["4M", "4L19"],
			embargo: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			feintattack: ["4L7"],
			flash: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			grudge: ["4E"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			hypnosis: ["4L13"],
			icywind: ["4T"],
			imprison: ["4E"],
			memento: ["4L43"],
			nastyplot: ["4L37"],
			naturalgift: ["4M"],
			ominouswind: ["4T", "4L25"],
			painsplit: ["4E"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			pursuit: ["4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shadowsneak: ["4L1", "4E"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			sleeptalk: ["4M"],
			smokescreen: ["4E"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T", "4L1"],
			substitute: ["4M"],
			suckerpunch: ["4T", "4L31"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			taunt: ["4M"],
			thief: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			uproar: ["4T"],
			waterpulse: ["4M"],
			willowisp: ["4M"],
		},
	},
	gible: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M"],
			bodyslam: ["4E"],
			captivate: ["4M"],
			cut: ["4M"],
			dig: ["4M", "4L31"],
			doubleedge: ["4E"],
			doubleteam: ["4M"],
			dracometeor: ["4T"],
			dragonbreath: ["4E"],
			dragonclaw: ["4M", "4L27"],
			dragonpulse: ["4M"],
			dragonrage: ["4L7"],
			dragonrush: ["4L37"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			flamethrower: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			hiddenpower: ["4M"],
			ironhead: ["4T", "4E"],
			metalclaw: ["4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T", "4E"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandattack: ["4L3"],
			sandstorm: ["4M", "4L13"],
			sandtomb: ["4L19", "4E"],
			scaryface: ["4E"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			slash: ["4L25"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			takedown: ["4L15"],
			thrash: ["4E"],
			toxic: ["4M"],
			twister: ["4T", "4E"],
		},
	},
	gabite: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			attract: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			dig: ["4M", "4L40"],
			doubleteam: ["4M"],
			dracometeor: ["4T"],
			dragonclaw: ["4M", "4L33"],
			dragonpulse: ["4M"],
			dragonrage: ["4L7"],
			dragonrush: ["4L49"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			flamethrower: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			hiddenpower: ["4M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandattack: ["4L1"],
			sandstorm: ["4M", "4L13"],
			sandtomb: ["4L19"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			slash: ["4L28"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tackle: ["4L1"],
			takedown: ["4L15"],
			toxic: ["4M"],
			twister: ["4T"],
		},
	},
	garchomp: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aquatail: ["4T"],
			attract: ["4M"],
			brickbreak: ["4M"],
			captivate: ["4M"],
			crunch: ["4L48"],
			cut: ["4M"],
			dig: ["4M", "4L40"],
			doubleteam: ["4M"],
			dracometeor: ["4T"],
			dragonclaw: ["4M", "4L33"],
			dragonpulse: ["4M"],
			dragonrage: ["4L1"],
			dragonrush: ["4L55"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			falseswipe: ["4M"],
			fireblast: ["4M"],
			firefang: ["4L1"],
			flamethrower: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			poisonjab: ["4M"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandattack: ["4L1"],
			sandstorm: ["4M", "4L1"],
			sandtomb: ["4L19"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			slash: ["4L28"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M"],
			tackle: ["4L1"],
			takedown: ["4L15"],
			toxic: ["4M"],
			twister: ["4T"],
		},
	},
	riolu: {
		inherit: true,
		learnset: {
			agility: ["4E"],
			attract: ["4M"],
			aurasphere: ["4S0"],
			bite: ["4E"],
			blazekick: ["4E"],
			brickbreak: ["4M"],
			bulkup: ["4M"],
			bulletpunch: ["4E", "4S0"],
			captivate: ["4M"],
			copycat: ["4L29"],
			counter: ["4L6"],
			crosschop: ["4E"],
			crunch: ["4E"],
			detect: ["4E"],
			dig: ["4M"],
			doubleteam: ["4M"],
			drainpunch: ["4M", "4S0"],
			earthquake: ["4M"],
			endure: ["4M", "4L1"],
			facade: ["4M"],
			feint: ["4L15"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			forcepalm: ["4L11"],
			foresight: ["4L1"],
			frustration: ["4M"],
			furycutter: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			highjumpkick: ["4E"],
			icepunch: ["4T"],
			irondefense: ["4T", "4E"],
			irontail: ["4M"],
			lowkick: ["4E"],
			magnetrise: ["4T"],
			mindreader: ["4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M"],
			quickattack: ["4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			reversal: ["4L19"],
			roar: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			screech: ["4L24"],
			secretpower: ["4M"],
			shadowclaw: ["4M", "4S0"],
			skyuppercut: ["4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M"],
			thunderpunch: ["4T"],
			toxic: ["4M"],
			vacuumwave: ["4T", "4E"],
			zenheadbutt: ["4T"],
		},
	},
	lucario: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			aurasphere: ["4L37", "4S0"],
			blazekick: ["4S1"],
			bonerush: ["4L19", "4S1"],
			brickbreak: ["4M"],
			bulkup: ["4M"],
			calmmind: ["4M"],
			captivate: ["4M"],
			closecombat: ["4L42"],
			counter: ["4L6"],
			darkpulse: ["4M", "4L1", "4S0"],
			detect: ["4L1"],
			dig: ["4M"],
			doubleteam: ["4M"],
			dragonpulse: ["4M", "4L47", "4S0"],
			drainpunch: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			extremespeed: ["4L51"],
			facade: ["4M"],
			feint: ["4L15"],
			flashcannon: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			forcepalm: ["4L11", "4S1"],
			foresight: ["4L1"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icepunch: ["4T"],
			irondefense: ["4T"],
			irontail: ["4M"],
			magnetrise: ["4T"],
			mefirst: ["4L29"],
			metalclaw: ["4L1"],
			metalsound: ["4L24"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			quickattack: ["4L1"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shadowclaw: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M", "4S1"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M", "4L33"],
			thunderpunch: ["4T"],
			toxic: ["4M"],
			vacuumwave: ["4T"],
			waterpulse: ["4M", "4S0"],
			zenheadbutt: ["4T"],
		},
	},
	hippopotas: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			bite: ["4L7"],
			bodyslam: ["4E"],
			captivate: ["4M"],
			crunch: ["4L31"],
			curse: ["4E"],
			dig: ["4M"],
			doubleedge: ["4L44"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L37"],
			endure: ["4M"],
			facade: ["4M"],
			fissure: ["4L50"],
			frustration: ["4M"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandattack: ["4L1"],
			sandstorm: ["4M"],
			sandtomb: ["4L25", "4E"],
			secretpower: ["4M"],
			slackoff: ["4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spitup: ["4E"],
			stealthrock: ["4M"],
			stockpile: ["4E"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superpower: ["4T"],
			swagger: ["4M"],
			swallow: ["4E"],
			tackle: ["4L1"],
			takedown: ["4L19"],
			toxic: ["4M"],
			waterpulse: ["4M"],
			yawn: ["4L13"],
		},
	},
	hippowdon: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			bite: ["4L1"],
			captivate: ["4M"],
			crunch: ["4L31"],
			dig: ["4M"],
			doubleedge: ["4L50"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M", "4L40"],
			endure: ["4M"],
			facade: ["4M"],
			firefang: ["4L1"],
			fissure: ["4L60"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icefang: ["4L1"],
			ironhead: ["4T"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandattack: ["4L1"],
			sandstorm: ["4M"],
			sandtomb: ["4L25"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superpower: ["4T"],
			swagger: ["4M"],
			tackle: ["4L1"],
			takedown: ["4L19"],
			thunderfang: ["4L1"],
			toxic: ["4M"],
			waterpulse: ["4M"],
			yawn: ["4L1"],
		},
	},
	skorupi: {
		inherit: true,
		learnset: {
			acupressure: ["4L17"],
			aerialace: ["4M"],
			agility: ["4E"],
			aquatail: ["4T"],
			attract: ["4M"],
			bite: ["4L1"],
			brickbreak: ["4M"],
			bugbite: ["4L34"],
			captivate: ["4M"],
			confuseray: ["4E"],
			crosspoison: ["4L50"],
			crunch: ["4L45"],
			cut: ["4M"],
			darkpulse: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			falseswipe: ["4M"],
			feintattack: ["4E"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			knockoff: ["4T", "4L6"],
			leer: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["4E"],
			payback: ["4M"],
			pinmissile: ["4L12"],
			poisonfang: ["4L39"],
			poisonjab: ["4M"],
			poisonsting: ["4L1"],
			protect: ["4M"],
			pursuit: ["4E"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			sandattack: ["4E"],
			scaryface: ["4L23"],
			screech: ["4E"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			slash: ["4E"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			taunt: ["4M"],
			thief: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			toxicspikes: ["4L28"],
			whirlwind: ["4E"],
			xscissor: ["4M"],
		},
	},
	drapion: {
		inherit: true,
		learnset: {
			acupressure: ["4L17"],
			aerialace: ["4M"],
			aquatail: ["4T"],
			attract: ["4M"],
			bite: ["4L1"],
			brickbreak: ["4M"],
			bugbite: ["4L34"],
			captivate: ["4M"],
			crosspoison: ["4L58"],
			crunch: ["4L49"],
			cut: ["4M"],
			darkpulse: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			falseswipe: ["4M"],
			firefang: ["4L1"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icefang: ["4L1"],
			irontail: ["4M"],
			knockoff: ["4T", "4L1"],
			leer: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			pinmissile: ["4L1"],
			poisonfang: ["4L39"],
			poisonjab: ["4M"],
			poisonsting: ["4L1"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			scaryface: ["4L23"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swordsdance: ["4M"],
			taunt: ["4M"],
			thief: ["4M"],
			thunderfang: ["4L1"],
			torment: ["4M"],
			toxic: ["4M"],
			toxicspikes: ["4L28"],
			xscissor: ["4M"],
		},
	},
	croagunk: {
		inherit: true,
		learnset: {
			astonish: ["4L1"],
			attract: ["4M"],
			bounce: ["4T"],
			brickbreak: ["4M"],
			bulkup: ["4M"],
			bulletpunch: ["4E"],
			captivate: ["4M"],
			crosschop: ["4E"],
			darkpulse: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			dynamicpunch: ["4E"],
			earthquake: ["4M"],
			embargo: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fakeout: ["4E"],
			feint: ["4E"],
			feintattack: ["4L17"],
			flatter: ["4L45"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gunkshot: ["4T"],
			headbutt: ["4E"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			meditate: ["4E"],
			mefirst: ["4E"],
			mudbomb: ["4L29"],
			mudslap: ["4T", "4L3"],
			nastyplot: ["4L36"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M", "4L38"],
			poisonsting: ["4L8"],
			protect: ["4M"],
			pursuit: ["4L15"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			revenge: ["4L22"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M", "4L43"],
			smellingsalts: ["4E"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			suckerpunch: ["4T", "4L31"],
			sunnyday: ["4M"],
			swagger: ["4M", "4L24"],
			taunt: ["4M", "4L10"],
			thief: ["4M"],
			thunderpunch: ["4T"],
			torment: ["4M"],
			toxic: ["4M"],
			vacuumwave: ["4T", "4E"],
			wakeupslap: ["4E"],
			xscissor: ["4M"],
		},
	},
	toxicroak: {
		inherit: true,
		learnset: {
			astonish: ["4L1"],
			attract: ["4M"],
			bounce: ["4T"],
			brickbreak: ["4M"],
			bulkup: ["4M"],
			captivate: ["4M"],
			cut: ["4M"],
			darkpulse: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			earthquake: ["4M"],
			embargo: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			feintattack: ["4L17"],
			flatter: ["4L54"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			gunkshot: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			mudbomb: ["4L29"],
			mudslap: ["4T", "4L1"],
			nastyplot: ["4L36"],
			naturalgift: ["4M"],
			payback: ["4M"],
			poisonjab: ["4M", "4L41"],
			poisonsting: ["4L1"],
			protect: ["4M"],
			pursuit: ["4L15"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			revenge: ["4L22"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M", "4L49"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			stoneedge: ["4M"],
			strength: ["4M"],
			suckerpunch: ["4T", "4L31"],
			sunnyday: ["4M"],
			swagger: ["4M", "4L24"],
			swordsdance: ["4M"],
			taunt: ["4M", "4L10"],
			thief: ["4M"],
			thunderpunch: ["4T"],
			torment: ["4M"],
			toxic: ["4M"],
			vacuumwave: ["4T"],
			xscissor: ["4M"],
		},
	},
	carnivine: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			bind: ["4L1"],
			bite: ["4L7"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			crunch: ["4L37"],
			cut: ["4M"],
			doubleteam: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			feintattack: ["4L27"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gastroacid: ["4T"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			growth: ["4L1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			ingrain: ["4L21"],
			knockoff: ["4T"],
			leechseed: ["4E"],
			magicalleaf: ["4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["4M"],
			powerwhip: ["4L47"],
			protect: ["4M"],
			razorleaf: ["4E"],
			rest: ["4M"],
			return: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			slam: ["4E"],
			sleeppowder: ["4E"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			spitup: ["4L31"],
			stockpile: ["4L31"],
			stunspore: ["4E"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swallow: ["4L31"],
			sweetscent: ["4L17"],
			swordsdance: ["4M"],
			synthesis: ["4T", "4E"],
			thief: ["4M"],
			toxic: ["4M"],
			vinewhip: ["4L11"],
			worryseed: ["4T", "4E"],
			wringout: ["4L41"],
		},
	},
	finneon: {
		inherit: true,
		learnset: {
			agility: ["4E"],
			aircutter: ["4T"],
			aquaring: ["4L33"],
			aquatail: ["4T", "4E"],
			attract: ["4M", "4L10"],
			blizzard: ["4M"],
			bounce: ["4T", "4L45"],
			brine: ["4M"],
			captivate: ["4M", "4L26"],
			charm: ["4E"],
			defog: ["4M"],
			dive: ["4T"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flail: ["4E"],
			flash: ["4M"],
			frustration: ["4M"],
			gust: ["4L17"],
			hail: ["4M"],
			hiddenpower: ["4M"],
			icebeam: ["4M"],
			icywind: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["4M"],
			pound: ["4L1"],
			protect: ["4M"],
			psybeam: ["4E"],
			psychup: ["4M"],
			raindance: ["4M", "4L13"],
			rest: ["4M"],
			return: ["4M"],
			safeguard: ["4M", "4L29"],
			secretpower: ["4M"],
			silverwind: ["4M", "4L49"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			splash: ["4E"],
			substitute: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			sweetkiss: ["4E"],
			swift: ["4T"],
			tickle: ["4E"],
			toxic: ["4M"],
			twister: ["4T"],
			uturn: ["4M", "4L42"],
			waterfall: ["4M"],
			watergun: ["4L6"],
			waterpulse: ["4M", "4L22"],
			whirlpool: ["4L38"],
		},
	},
	lumineon: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			aquaring: ["4L35"],
			aquatail: ["4T"],
			attract: ["4M", "4L1"],
			blizzard: ["4M"],
			bounce: ["4T", "4L53"],
			brine: ["4M"],
			captivate: ["4M", "4L26"],
			defog: ["4M"],
			dive: ["4T"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			gust: ["4L17"],
			hail: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icywind: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["4M"],
			pound: ["4L1"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M", "4L13"],
			rest: ["4M"],
			return: ["4M"],
			safeguard: ["4M", "4L29"],
			secretpower: ["4M"],
			silverwind: ["4M", "4L59"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			toxic: ["4M"],
			twister: ["4T"],
			uturn: ["4M", "4L48"],
			waterfall: ["4M"],
			watergun: ["4L1"],
			waterpulse: ["4M", "4L22"],
			whirlpool: ["4L42"],
		},
	},
	snover: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			avalanche: ["4M"],
			blizzard: ["4M", "4L41"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			doubleedge: ["4E"],
			doubleteam: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			grassknot: ["4M"],
			grasswhistle: ["4L13"],
			growth: ["4E"],
			hail: ["4M"],
			hiddenpower: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T"],
			iceshard: ["4L26"],
			icywind: ["4T", "4L9"],
			ingrain: ["4L31"],
			irontail: ["4M"],
			leechseed: ["4E"],
			leer: ["4L1"],
			lightscreen: ["4M"],
			magicalleaf: ["4E"],
			mist: ["4L21", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			powdersnow: ["4L1"],
			protect: ["4M"],
			raindance: ["4M"],
			razorleaf: ["4L5"],
			rest: ["4M"],
			return: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T", "4E"],
			shadowball: ["4M"],
			sheercold: ["4L46"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stomp: ["4E"],
			substitute: ["4M"],
			swagger: ["4M", "4L17"],
			swordsdance: ["4M"],
			synthesis: ["4T"],
			toxic: ["4M"],
			waterpulse: ["4M"],
			woodhammer: ["4L36"],
			worryseed: ["4T"],
		},
	},
	abomasnow: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			avalanche: ["4M"],
			blizzard: ["4M", "4L47"],
			brickbreak: ["4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			doubleteam: ["4M"],
			earthquake: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			grasswhistle: ["4L13"],
			hail: ["4M"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T", "4L1"],
			iceshard: ["4L26"],
			icywind: ["4T", "4L1"],
			ingrain: ["4L31"],
			irontail: ["4M"],
			leer: ["4L1"],
			lightscreen: ["4M"],
			mist: ["4L21"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			powdersnow: ["4L1"],
			protect: ["4M"],
			raindance: ["4M"],
			razorleaf: ["4L1"],
			rest: ["4M"],
			return: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["4M"],
			sheercold: ["4L58"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			swagger: ["4M", "4L17"],
			swordsdance: ["4M"],
			synthesis: ["4T"],
			toxic: ["4M"],
			waterpulse: ["4M"],
			woodhammer: ["4L36"],
			worryseed: ["4T"],
		},
	},
	rotom: {
		inherit: true,
		learnset: {
			astonish: ["4L1"],
			charge: ["4L43"],
			chargebeam: ["4M"],
			confuseray: ["4L1"],
			darkpulse: ["4M"],
			discharge: ["4L50"],
			doubleteam: ["4M", "4L15"],
			dreameater: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			hiddenpower: ["4M"],
			lightscreen: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T", "4L29"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M", "4L22"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			substitute: ["4M", "4L36"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thundershock: ["4T", "4L1"],
			thunderwave: ["4M", "4L1"],
			toxic: ["4M"],
			trick: ["4T", "4L1"],
			uproar: ["4T", "4L8"],
			willowisp: ["4M"],
		},
	},
	rotomheat: {
		inherit: true,
		learnset: {
			overheat: ["4R"],
		},
	},
	rotomwash: {
		inherit: true,
		learnset: {
			hydropump: ["4R"],
		},
	},
	rotomfrost: {
		inherit: true,
		learnset: {
			blizzard: ["4R"],
		},
	},
	rotomfan: {
		inherit: true,
		learnset: {
			airslash: ["4R"],
		},
	},
	rotommow: {
		inherit: true,
		learnset: {
			leafstorm: ["4R"],
		},
	},
	uxie: {
		inherit: true,
		learnset: {
			amnesia: ["4L46", "4S0", "4S1"],
			calmmind: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "4S0"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			endure: ["4M", "4L16"],
			energyball: ["4M"],
			extrasensory: ["4L51"],
			facade: ["4M"],
			firepunch: ["4T"],
			flail: ["4L61"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			futuresight: ["4L36", "4S0", "4S1"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icepunch: ["4T"],
			imprison: ["4L6"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lightscreen: ["4M"],
			memento: ["4L76"],
			mudslap: ["4T"],
			naturalgift: ["4M", "4L66"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			reflect: ["4M"],
			rest: ["4M", "4L1"],
			return: ["4M"],
			safeguard: ["4M"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T", "4L21", "4S1"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uturn: ["4M"],
			waterpulse: ["4M"],
			yawn: ["4L31", "4S0", "4S1"],
			zenheadbutt: ["4T"],
		},
	},
	mesprit: {
		inherit: true,
		learnset: {
			blizzard: ["4M"],
			calmmind: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L46", "4S0", "4S1"],
			confusion: ["4L1", "4S0"],
			copycat: ["4L61"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			extrasensory: ["4L51"],
			facade: ["4M"],
			firepunch: ["4T"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			futuresight: ["4L36", "4S0", "4S1"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			healingwish: ["4L76"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icepunch: ["4T"],
			imprison: ["4L6"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lightscreen: ["4M"],
			luckychant: ["4L31", "4S0", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["4M", "4L66"],
			protect: ["4M", "4L16"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			reflect: ["4M"],
			rest: ["4M", "4L1"],
			return: ["4M"],
			safeguard: ["4M"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T", "4L21", "4S1"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uturn: ["4M"],
			waterpulse: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	azelf: {
		inherit: true,
		learnset: {
			calmmind: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L1", "4S0"],
			detect: ["4L16"],
			doubleteam: ["4M"],
			dreameater: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			explosion: ["4M", "4L76"],
			extrasensory: ["4L51"],
			facade: ["4M"],
			fireblast: ["4M"],
			firepunch: ["4T"],
			flamethrower: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			futuresight: ["4L36", "4S0", "4S1"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icepunch: ["4T"],
			imprison: ["4L6"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["4T", "4L61"],
			lightscreen: ["4M"],
			mudslap: ["4T"],
			nastyplot: ["4L46", "4S0", "4S1"],
			naturalgift: ["4M", "4L66"],
			payback: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			reflect: ["4M"],
			rest: ["4M", "4L1"],
			return: ["4M"],
			safeguard: ["4M"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T", "4L21", "4S1"],
			taunt: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T"],
			thunderwave: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			uproar: ["4T", "4L31", "4S0", "4S1"],
			uturn: ["4M"],
			waterpulse: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	dialga: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			ancientpower: ["4T", "4L20", "4S0"],
			aurasphere: ["4L90"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			bulkup: ["4M"],
			cut: ["4M"],
			doubleteam: ["4M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L1", "4S2"],
			dragonclaw: ["4M", "4L30", "4S0"],
			dragonpulse: ["4M"],
			earthpower: ["4T", "4L60", "4S1"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			flamethrower: ["4M"],
			flash: ["4M"],
			flashcannon: ["4M", "4L80"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			healblock: ["4L50", "4S1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			irontail: ["4M"],
			magnetrise: ["4T"],
			metalclaw: ["4L10", "4S0"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			overheat: ["4M"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			roaroftime: ["4L40", "4S0", "4S1"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			safeguard: ["4M"],
			sandstorm: ["4M"],
			scaryface: ["4L1", "4S2"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			shockwave: ["4M"],
			slash: ["4L70", "4S1"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			trickroom: ["4M"],
			twister: ["4T"],
		},
	},
	palkia: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			ancientpower: ["4T", "4L20", "4S0"],
			aquatail: ["4T", "4L80"],
			aurasphere: ["4L90"],
			avalanche: ["4M"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			brine: ["4M"],
			bulkup: ["4M"],
			cut: ["4M"],
			dive: ["4T"],
			doubleteam: ["4M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L1", "4S2"],
			dragonclaw: ["4M", "4L30", "4S0"],
			dragonpulse: ["4M"],
			earthpower: ["4T", "4L60", "4S1"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			flamethrower: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			hail: ["4M"],
			healblock: ["4L50", "4S1"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			safeguard: ["4M"],
			sandstorm: ["4M"],
			scaryface: ["4L1", "4S2"],
			secretpower: ["4M"],
			shadowclaw: ["4M"],
			shockwave: ["4M"],
			slash: ["4L70", "4S1"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spacialrend: ["4L40", "4S0", "4S1"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			trickroom: ["4M"],
			twister: ["4T"],
			waterpulse: ["4M", "4L10", "4S0"],
		},
	},
	heatran: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "4L1", "4S2"],
			attract: ["4M"],
			captivate: ["4M"],
			crunch: ["4L33", "4S1"],
			darkpulse: ["4M"],
			dig: ["4M"],
			doubleteam: ["4M"],
			dragonpulse: ["4M"],
			earthpower: ["4T", "4L73", "4S2"],
			earthquake: ["4M"],
			endure: ["4M"],
			eruption: ["4S2"],
			explosion: ["4M"],
			facade: ["4M"],
			fireblast: ["4M"],
			firefang: ["4L17"],
			firespin: ["4L57", "4S0"],
			flamethrower: ["4M"],
			flashcannon: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			heatwave: ["4T", "4L81"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			irondefense: ["4T"],
			ironhead: ["4T", "4L65", "4S0"],
			lavaplume: ["4L49", "4S0", "4S1"],
			leer: ["4L9"],
			magmastorm: ["4L96", "4S2"],
			metalsound: ["4L25", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["4M"],
			payback: ["4M"],
			protect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			scaryface: ["4L41", "4S0", "4S1"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			stealthrock: ["4M"],
			stoneedge: ["4M", "4L88"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			taunt: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			uproar: ["4T"],
			willowisp: ["4M"],
		},
	},
	regigigas: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			ancientpower: ["4T"],
			avalanche: ["4M"],
			brickbreak: ["4M"],
			confuseray: ["4L1", "4S0", "4S1"],
			crushgrip: ["4L75", "4S2"],
			dizzypunch: ["4L1", "4S1"],
			doubleteam: ["4M"],
			drainpunch: ["4M"],
			earthpower: ["4T"],
			earthquake: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			firepunch: ["4T", "4L1"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			foresight: ["4L1", "4S1"],
			frustration: ["4M"],
			gigaimpact: ["4M", "4L100"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icepunch: ["4T", "4L1"],
			icywind: ["4T", "4S2"],
			ironhead: ["4T", "4S2"],
			knockoff: ["4L1", "4S1"],
			megapunch: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			return: ["4M"],
			revenge: ["4L25"],
			rockclimb: ["4M"],
			rockpolish: ["4M"],
			rockslide: ["4M", "4S2"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stomp: ["4L1", "4S0"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			superpower: ["4T", "4L25", "4S0"],
			swagger: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderpunch: ["4T", "4L1"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			zenheadbutt: ["4T", "4L50", "4S0"],
		},
	},
	giratina: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			aircutter: ["4T"],
			ancientpower: ["4T", "4L20", "4S1"],
			aquatail: ["4T"],
			aurasphere: ["4L90"],
			calmmind: ["4M"],
			chargebeam: ["4M"],
			cut: ["4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			doubleteam: ["4M"],
			dracometeor: ["4T"],
			dragonbreath: ["4L1", "4S2"],
			dragonclaw: ["4M", "4L30", "4S1"],
			dragonpulse: ["4M"],
			dreameater: ["4M"],
			earthpower: ["4T", "4L60", "4S0"],
			earthquake: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			fly: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			gigaimpact: ["4M"],
			healblock: ["4L50", "4S0"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icywind: ["4T"],
			ironhead: ["4T"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T", "4L10", "4S1"],
			outrage: ["4T"],
			payback: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			rockclimb: ["4M"],
			rocksmash: ["4M"],
			safeguard: ["4M"],
			scaryface: ["4L1", "4S2"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			shadowclaw: ["4M", "4L80"],
			shadowforce: ["4L40", "4S0", "4S1"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			slash: ["4L70", "4S0"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			steelwing: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			twister: ["4T"],
			willowisp: ["4M"],
		},
	},
	cresselia: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			aurorabeam: ["4L29", "4S0"],
			calmmind: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			confusion: ["4L1"],
			doubleteam: ["4M", "4L1"],
			dreameater: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			futuresight: ["4L38", "4S0"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icywind: ["4T"],
			lightscreen: ["4M"],
			lunardance: ["4L84"],
			mist: ["4L20", "4S0"],
			moonlight: ["4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			psychic: ["4M", "4L93"],
			psychocut: ["4L66"],
			psychoshift: ["4L75"],
			psychup: ["4M"],
			raindance: ["4M"],
			recycle: ["4M"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			safeguard: ["4M", "4L11"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			slash: ["4L47", "4S0"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	phione: {
		inherit: true,
		learnset: {
			acidarmor: ["4L31"],
			ancientpower: ["4T"],
			aquaring: ["4L54"],
			blizzard: ["4M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubble: ["4L1"],
			bubblebeam: ["4L24"],
			charm: ["4L9"],
			dive: ["4T", "4L61"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			grassknot: ["4M", "4S0"],
			hail: ["4M"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			icebeam: ["4M"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			psychup: ["4M"],
			raindance: ["4M", "4L69", "4S0"],
			rest: ["4M", "4S0"],
			return: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			supersonic: ["4L16"],
			surf: ["4M", "4S0"],
			swagger: ["4M"],
			swift: ["4T"],
			toxic: ["4M"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterfall: ["4M"],
			waterpulse: ["4M", "4L46"],
			watersport: ["4L1"],
			whirlpool: ["4L39"],
		},
	},
	manaphy: {
		inherit: true,
		learnset: {
			acidarmor: ["4L31", "4S2"],
			ancientpower: ["4T"],
			aquaring: ["4L54", "4S3"],
			blizzard: ["4M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubble: ["4L1", "4S0", "4S1"],
			bubblebeam: ["4L24"],
			calmmind: ["4M"],
			charm: ["4L9"],
			dive: ["4T", "4L61"],
			doubleteam: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			hail: ["4M"],
			heartswap: ["4L76", "4S2", "4S3"],
			helpinghand: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			icebeam: ["4M"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			raindance: ["4M", "4L69"],
			reflect: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			supersonic: ["4L16"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			tailglow: ["4L1", "4S0", "4S1"],
			toxic: ["4M"],
			uproar: ["4T"],
			uturn: ["4M"],
			waterfall: ["4M"],
			waterpulse: ["4M", "4L46", "4S2", "4S3"],
			watersport: ["4L1", "4S0", "4S1", "4S3"],
			whirlpool: ["4L39", "4S2"],
		},
	},
	darkrai: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			calmmind: ["4M"],
			chargebeam: ["4M"],
			cut: ["4M"],
			darkpulse: ["4M", "4L93", "4S2"],
			darkvoid: ["4L66", "4S2"],
			disable: ["4L1"],
			doubleteam: ["4M", "4L47", "4S2", "4S3"],
			drainpunch: ["4M"],
			dreameater: ["4M", "4L84"],
			embargo: ["4M", "4L75"],
			endure: ["4M"],
			facade: ["4M"],
			feintattack: ["4L29", "4S3"],
			flash: ["4M"],
			fling: ["4M"],
			focusblast: ["4M"],
			focuspunch: ["4M"],
			frustration: ["4M"],
			gigaimpact: ["4M"],
			haze: ["4L57"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			hypnosis: ["4L20", "4S0", "4S1", "4S3"],
			icebeam: ["4M"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			nastyplot: ["4L75"],
			naturalgift: ["4M"],
			nightmare: ["4L38", "4S0", "4S1", "4S3"],
			nightshade: ["4L1"],
			ominouswind: ["4T", "4L1"],
			payback: ["4M"],
			poisonjab: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			pursuit: ["4L29", "4S0"],
			quickattack: ["4L11", "4S0"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			roaroftime: ["4S1"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			secretpower: ["4M"],
			shadowball: ["4M", "4S2"],
			shadowclaw: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spacialrend: ["4S1"],
			spite: ["4T"],
			strength: ["4M"],
			substitute: ["4M"],
			suckerpunch: ["4T"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M"],
			taunt: ["4M"],
			thief: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			torment: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			willowisp: ["4M"],
			xscissor: ["4M"],
		},
	},
	shaymin: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			airslash: ["4L64"],
			aromatherapy: ["4L64", "4S0"],
			bulletseed: ["4M"],
			defensecurl: ["4L1"],
			doubleteam: ["4M"],
			earthpower: ["4T"],
			endeavor: ["4T"],
			endure: ["4M"],
			energyball: ["4M", "4L73", "4S0"],
			facade: ["4M"],
			flash: ["4M"],
			frustration: ["4M"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			grasswhistle: ["4L82"],
			growth: ["4L1", "4S1"],
			healingwish: ["4L91"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M"],
			lastresort: ["4T"],
			leafstorm: ["4L91"],
			leechseed: ["4L19", "4S1"],
			luckychant: ["4L91"],
			magicalleaf: ["4L10", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["4M", "4L46"],
			ominouswind: ["4T"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			quickattack: ["4L28"],
			rest: ["4M"],
			return: ["4M"],
			safeguard: ["4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			seedflare: ["4L100", "4S0"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			substitute: ["4M", "4S0"],
			sunnyday: ["4M"],
			swagger: ["4M"],
			sweetkiss: ["4L82"],
			sweetscent: ["4L37"],
			swift: ["4T"],
			swordsdance: ["4M"],
			synthesis: ["4T", "4L28", "4S1"],
			toxic: ["4M"],
			worryseed: ["4T", "4L55"],
			zenheadbutt: ["4T"],
		},
	},
	arceus: {
		inherit: true,
		learnset: {
			aerialace: ["4M"],
			ancientpower: ["4T"],
			aquatail: ["4T"],
			avalanche: ["4M"],
			blizzard: ["4M"],
			brickbreak: ["4M"],
			brine: ["4M"],
			bulletseed: ["4M"],
			calmmind: ["4M"],
			chargebeam: ["4M"],
			cosmicpower: ["4L1"],
			cut: ["4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dive: ["4T"],
			doubleteam: ["4M"],
			dracometeor: ["4T"],
			dragonclaw: ["4M"],
			dragonpulse: ["4M"],
			dreameater: ["4M"],
			earthpower: ["4T", "4L20"],
			earthquake: ["4M"],
			endure: ["4M"],
			energyball: ["4M"],
			extremespeed: ["4L40"],
			facade: ["4M"],
			fireblast: ["4M"],
			flamethrower: ["4M"],
			flash: ["4M"],
			flashcannon: ["4M"],
			fly: ["4M"],
			focusblast: ["4M"],
			frustration: ["4M"],
			furycutter: ["4T"],
			futuresight: ["4L60"],
			gigadrain: ["4M"],
			gigaimpact: ["4M"],
			grassknot: ["4M"],
			gravity: ["4L10"],
			hail: ["4M"],
			heatwave: ["4T"],
			hiddenpower: ["4M"],
			hyperbeam: ["4M", "4L80"],
			hypervoice: ["4L30"],
			icebeam: ["4M"],
			icywind: ["4T"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			irontail: ["4M"],
			judgment: ["4L100", "4S0"],
			lastresort: ["4T"],
			lightscreen: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M", "4L1"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			overheat: ["4M"],
			payback: ["4M"],
			perishsong: ["4L90"],
			poisonjab: ["4M"],
			protect: ["4M"],
			psychic: ["4M"],
			psychup: ["4M"],
			punishment: ["4L1"],
			raindance: ["4M"],
			recover: ["4L70"],
			recycle: ["4M"],
			reflect: ["4M"],
			refresh: ["4L50"],
			rest: ["4M"],
			return: ["4M"],
			roar: ["4M"],
			roaroftime: ["4S0"],
			rockclimb: ["4M"],
			rockslide: ["4M"],
			rocksmash: ["4M"],
			rocktomb: ["4M"],
			safeguard: ["4M"],
			sandstorm: ["4M"],
			secretpower: ["4M"],
			seismictoss: ["4L1"],
			shadowball: ["4M"],
			shadowclaw: ["4M"],
			shadowforce: ["4S0"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["4M"],
			snore: ["4T"],
			solarbeam: ["4M"],
			spacialrend: ["4S0"],
			stealthrock: ["4M"],
			stoneedge: ["4M"],
			strength: ["4M"],
			substitute: ["4M"],
			sunnyday: ["4M"],
			surf: ["4M"],
			swagger: ["4M"],
			swift: ["4T"],
			swordsdance: ["4M"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thunderwave: ["4M"],
			toxic: ["4M"],
			trick: ["4T"],
			trickroom: ["4M"],
			twister: ["4T"],
			waterfall: ["4M"],
			waterpulse: ["4M"],
			willowisp: ["4M"],
			xscissor: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
};
